define('viewmodels/survey/SurveyResponsePage',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'viewmodels/landing', 'viewmodels/survey/SurveyTracking', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, app, appsecurity, navigation, system, logger, DashboardVM, SurveyTrackingVM, utils, ObjGeneralSettings) {
        var SrViewModel = {
            app: app,
            appsecurity: appsecurity,
            detached: detached,
            navigation: navigation,
            system: system,
            logger: logger,
            utils: utils,
            activate: activate,
            attached: attached,
            DashboardVM: DashboardVM,
            SurveyTrackingVM: SurveyTrackingVM,
            BUTitle: ko.observable('Business Unit'),
            ValuesChanged: ko.observable(),
            SurveyProfileId: ko.observable(),
            SurveyTypeId: ko.observable(),
            SurveyProfileName: ko.observable(),
            RoleId: ko.observable(),
            SurveyId: ko.observable(),
            Role: ko.observable(),
            DueDate: ko.observable(),
            BusinessUnitName: ko.observable(),
            BusinessUnitType: ko.observable(),
            BusinessUnitDescription: ko.observable(),
            BusinessUnitId: ko.observable(),
            SurveyStatus: ko.observable(),
            SurveyName: ko.observable(),
            IsInternalSurvey: ko.observable(),
            IsExternalSurvey: ko.observable(),
            IsOtherQualSurvey: ko.observable(),
            IsSharedControlSurvey: ko.observable(),
            PushbackComment: ko.observable(),
            SurveySummaryComment: ko.observable(),
            SurveySummaryCommentId: ko.observable(),
            SummaryDocumentsList: ko.observableArray([]),
            DisableControl: ko.observable(),
            NavigateToDashboardBoolean: ko.observable(false),
            SaveResponse: SaveResponse,
            ResetResponse: ResetResponse,
            ResetSearch: ResetSearch,
            searchResults: ko.observableArray([]),
            SearchResult: SearchResult,
            SavechangedvalueTab: ko.observable(null),
            SavechangedvalueSubTab: ko.observable(false),
            Query: ko.observable(''),
            NavigateToDashboard: NavigateToDashboard,
            ImportSurveyType: ko.observable(),
            User: ko.observable(),
            MaxCount: ko.observable(),
            Difference: ko.observable(),
            InfoClickType: ko.observable(),
            SubCategoryInfoClick: SubCategoryInfoClick,
            showOverallSummaryDiv: showOverallSummaryDiv,
            SaveSurveySummary: SaveSurveySummary,
            Instructions: ko.observable(),
            showMoreInstructions: showMoreInstructions,
            HistoricalResponseList: ko.observableArray([]),
            DocumentListFinal: ko.observableArray([]),
            QualColumnDetailsDropDown: ko.observableArray([]),
            CurrentCommentID: ko.observableArray([]),
            ResponseComment: ko.observable(),
            PopOverCommentList: ko.observableArray([]),
            ResponseCommentsList: ko.observableArray([]),
            UploadDocumentsList: ko.observable([]),
            SelectedFullQuestion: ko.observable(),
            CommentType: ko.observable(''),
            SelectedQuestion: ko.observable(),
            SelectedQuestionId: ko.observable(),
            EditQuestionComment: EditQuestionComment,
            DeleteQuestionComment: DeleteQuestionComment,
            ShowExtraSubContent: ShowExtraSubContent,
            HistoricalCommentList: ko.observableArray([]),
            CopyResponse: CopyResponse,
            CopyComment: CopyComment,
            SaveComment: SaveComment,
            CancelComment: CancelComment,
            SaveCommentButtonName: ko.observable('Save'),
            CQBadge: ko.observable(),
            CQBadgeTitle: ko.observable(),
            SelectedCommentType: ko.observable(''),
            UploadDocument: UploadDocument,
            UploadComment: ko.observable(''),
            ProgressMessage: ko.observable(''),
            ProgressPercent: ko.observable(),
            SummaryUploadProgressMessage: ko.observable(''),
            SummaryCommentCreatedDate: ko.observable(),
            SummaryCommentBy: ko.observable(),
            DownloadDocument: DownloadDocument,
            DeleteDocument: DeleteDocument,
            ExportSurveyToExcel: ExportSurveyToExcel,
            ImportExcelPopUp: ImportExcelPopUp,
            UploadExcelDocument: UploadExcelDocument,
            ViewSelectedReport: ViewSelectedReport,
            LocaleCheckFlag: ko.observable(false),
            //Controls
            ControlColumnDetails: ko.observableArray([]),
            ControlColumnDetailsDropDown: ko.observableArray([]),
            SelectedColumnId: ko.observable(),
            ControlsResponseData: ko.observableArray([]),
            ConditionQuestionchangeControl: ConditionQuestionchangeControl,
            MultiselectResponsechangeCtrl: MultiselectResponsechangeCtrl,
            //tree node variables
            AreaLeveljstree: ko.observable(),
            selectedTreeNode: ko.observable(),
            IsRefreshProfileGlobalFlag: ko.observable(false),
            isSaveResponseClick: ko.observable(false),
            ClickedRiskArea: ko.observable(),
            ClickedRiskAreaId: ko.observable(0),
            PreClickedRiskAreaId: ko.observable(0),
            TreeView_ParentAreaId: ko.observable(0),
            TreeView_ParentAreaName: ko.observable(''),
            TreeView_ParentAreaGuidelines: ko.observable(''),
            ClickedRiskFactorId: ko.observable(),
            ClickedRiskFactorName: ko.observable(),
            ClickedRiskFactorGuidelines: ko.observable(''),
            ClickedRiskAreaName: ko.observable(),
            ClickedRiskAreaCategoryGuidelines: ko.observable(),
            ClickedRiskSubFactorName: ko.observable(),
            Is_RefreshEnable: ko.observable(true),
            MCILevel: ko.observable(false),
            CollapseAllTreeView: CollapseAllTreeView,
            ToggleNavigation: ToggleNavigation,
            hasChildNodes: ko.observable(false),
            SelectedNode: ko.observable(''),
            ColumnDetails: ko.observableArray([]),
            Quesitonidtemp: ko.observable(),
            QualResponseListData: ko.observableArray([]),
            BarWidth: ko.observable(0),
            ShowExtraContent: ShowExtraContent,
            HideExtraContent: HideExtraContent,
            cmtResponseTypeSelected: ko.observable(),
            DrpDwnRender: DrpDwnRender,
            ConditionQuestionchangeQual: ConditionQuestionchangeQual,
            MultiselectResponsechangeQual: MultiselectResponsechangeQual,
            IsReadOnlyQuestion: ko.observable(0),
            IsConditionalQuestion: ko.observable(0),
            ShowBookmarkFlags: ko.observable(false),
            SruveyLevelBookmarkFlag: ko.observable(false),
            BookmarkFlagChangeEvent: BookmarkFlagChangeEvent,
            BreadCrumbArray: ko.observableArray([]),
            //Areas of change
            Is_RefreshCopyProfile: ko.observable(false),
            ResetMCIContent: ResetMCIContent,
            ResetSearchMCI: ResetSearchMCI,
            MCILevels: ko.observableArray([]),
            MCIMaxLevel: ko.observable(0),
            CheckMCILevel: CheckMCILevel,
            MCIRawLevels: ko.observableArray([]),
            SearchResultMCI: SearchResultMCI,
            QueryMCI: ko.observable(''),
            MCILevelsDup: ko.observableArray([]),
            AoCHeaderMessage: ko.observable(''),
            AoCInstructions: ko.observable(''),
            saveEventId: ko.observable(),
            SurveyStateName: ko.observable(),
            SaveSelectionResponse: SaveSelectionResponse,
            ValuesChangeEvent: ValuesChangeEvent,
            showSurveyInfoClick: showSurveyInfoClick,
            SurveyPendingWith: ko.observable(),
            SurveyCompletionPercentage: ko.observable(),
            SurveyClassification: ko.observable(),
            BUList: ko.observable(),
            BUListString: ko.observable(),
            UserList: ko.observable(),
            SurveyIconClass: ko.observable(),
            SurveyStateColor: ko.observable(),
            IsSurveyCompleted: ko.observable(),
            IsSurveyReadOnly: ko.observable(),
            IsSurveyPending: ko.observable(),
            CurrentProfileOfAssessmentId: ko.observable(),
            ComponentName_Survey: ko.observable(),
            ProfileName_Survey: ko.observable(),
            SurveyActionsList: ko.observableArray([]),
            SurveyTimelineComments: ko.observableArray([]),
            UsersRoleWFList: ko.observableArray([]),
            finalizeQuestionnaire: finalizeQuestionnaire,
            PerformFinalizeAction: PerformFinalizeAction,
            showWFDescription: showWFDescription,
            showTimelineComments: showTimelineComments,
            TimelineCommentsFlag: ko.observable(true),
            SelectedActionEventId: ko.observable(),
            FinalizeValidationList: ko.observableArray([]),
            Tick_Flag: ko.observable(false),
            EnableMandatoryFlags: ko.observable(false),
            SurveyLevelMandatoryList: ko.observableArray([]),
            CollapseAllQuestions: CollapseAllQuestions,
            hasHeaderQuestions: ko.observable(false),
            RemovePlugins: ko.observable('liststyle,tabletools,scayt,menubutton,contextmenu,Styles,Format,Outdent,Indent,RemoveFormat,Subscript,Superscript,elementspath,save,image,flash,iframe,link,smiley,find,pagebreak,templates,about,maximize,showblocks,newpage,language,scayt,HorizontalRule,SpecialChar,Source,blockquote,wsc,Superscript, Subscript, Outdent, Indent,Strike'),//tabletools
            RemoveButtons: ko.observable('Styles,Format,Outdent,Indent,RemoveFormat,Subscript,Superscript,Copy,Cut,Paste,Undo,Redo,Print,Form,TextField,Textarea,Button,SelectAll,CreateDiv,Table,PasteText,PasteFromWord,Select,HiddenField,HorizontalRule,SpecialChar,Source,Superscript, Subscript, Outdent, Indent,Strike'),
            RemainingChars: ko.observable(4000),
            CommentCharsLimit: ko.observable(4000),
            OcKeypress: OcKeypress,
            OcKeyUp: OcKeyUp,
            AccessFlagSyncRatingsInherent: ko.observable(false),
            AccessFlagSyncRatingsControls: ko.observable(false),
            SyncRatings: SyncRatings,
            //Quant
            ValidateResponse: ValidateResponse,
            ShowCommentsPopUp: ShowCommentsPopUp,
            ShowUploadDocumentsPopUp: ShowUploadDocumentsPopUp,
            ShowHistroyPopUp: ShowHistroyPopUp,
            ShowGuidelinesPopUp: ShowGuidelinesPopUp,
            QuanColumnDetails: ko.observableArray([]),
            QuanResponseObject: ko.observableArray([]),
            SaveResponseList: ko.observableArray([]),
            IsCommentPopUp: ko.observable(false),
            IsDocumentPopUp: ko.observable(false),
            IsHistoryPopUp: ko.observable(false),
            GuidelineCommentPopUp: ko.observable(),
            // Previous Page
            PreviousPage: ko.observable(),
            ObjGeneralSettings: ObjGeneralSettings,
            // SyncRatings
            RunSyncRatings: RunSyncRatings,
            //SyncRatingsButtonDisable: ko.observable(false),
            SyncRatingsStatus: SyncRatingsStatus,
            ScheduledJobStatusList: ko.observableArray([]),
            firstLoad: ko.observable(),
            SummaryPopUpFlag: ko.observable(false),
            FinalizePopUpFlag: ko.observable(false)
        };
        return SrViewModel;

        // #region PageLoad Methods

        function detached() {
            try {
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function activate(activationData) {
            try {
                SrViewModel.SurveyLevelMandatoryList([]);
                SrViewModel.EnableMandatoryFlags(true);
                SrViewModel.ValuesChanged(false);

                SrViewModel.AccessFlagSyncRatingsInherent((SrViewModel.appsecurity.PageList() == undefined) ? false : (SrViewModel.appsecurity.PageList().indexOf('CalculateResultsInherent') >= 0) ? true : false);
                SrViewModel.AccessFlagSyncRatingsControls((SrViewModel.appsecurity.PageList() == undefined) ? false : (SrViewModel.appsecurity.PageList().indexOf('CalculateResultsControls') >= 0) ? true : false);

                if (SrViewModel.ObjGeneralSettings === undefined || SrViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((SrViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || SrViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && SrViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    SrViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (SrViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || SrViewModel.ObjGeneralSettings.LocalizedTextList() == null || SrViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || SrViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || SrViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            SrViewModel.LocaleCheckFlag(false);
                        else
                            SrViewModel.LocaleCheckFlag(true);
                    });
                }
                else {
                    if (SrViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || SrViewModel.ObjGeneralSettings.LocalizedTextList() == null || SrViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || SrViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || SrViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        SrViewModel.LocaleCheckFlag(false);
                    else
                        SrViewModel.LocaleCheckFlag(true);
                }

                if (SrViewModel.SurveyTrackingVM.RoutedFrom().toLowerCase() == 'tracking') {
                    //coming from tracking screen
                    if ((SrViewModel.SurveyTrackingVM.ResponseMoveArray() == undefined || SrViewModel.SurveyTrackingVM.ResponseMoveArray().length == 0) && (activationData == undefined || activationData == null)) {
                        router.navigate("survey/SurveyTracking", true);
                    }
                    else {
                        SrViewModel.appsecurity.ReadAccess(true);
                        SrViewModel.SurveyProfileId(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyProfileId());
                        SrViewModel.SurveyTypeId(SrViewModel.SurveyTrackingVM.ResponseMoveArray().GroupShortName());
                        SrViewModel.SurveyName(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyName());
                        SrViewModel.SurveyId(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyId());
                        SrViewModel.DueDate(SrViewModel.SurveyTrackingVM.ResponseMoveArray().DueDate());
                        SrViewModel.BusinessUnitName(SrViewModel.SurveyTrackingVM.ResponseMoveArray().BusinessUnitName());
                        SrViewModel.BusinessUnitId(SrViewModel.SurveyTrackingVM.ResponseMoveArray().BusinessUnitId());
                        SrViewModel.SurveyStatus(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyStatus());
                        SrViewModel.SurveyPendingWith(SrViewModel.SurveyTrackingVM.ResponseMoveArray().PendingAt());
                        SrViewModel.SurveyCompletionPercentage(SrViewModel.SurveyTrackingVM.ResponseMoveArray().CompletionPercentage());
                        SrViewModel.BUList(SrViewModel.SurveyTrackingVM.ResponseMoveArray().BUList());
                        SrViewModel.BUListString(SrViewModel.SurveyTrackingVM.ResponseMoveArray().BUListString());
                        SrViewModel.RoleId(SrViewModel.SurveyTrackingVM.RoleId());
                        SrViewModel.SurveyIconClass(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyIconClass());
                        SrViewModel.CurrentProfileOfAssessmentId(SurveyTrackingVM.CurrentProfileOfAssessmentId());
                        SrViewModel.UserList(SrViewModel.SurveyTrackingVM.ResponseMoveArray().UserList());
                        SrViewModel.SurveyClassification(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyType());     // SUR, SOC, ACT
                        SrViewModel.IsSurveyCompleted(SrViewModel.SurveyTrackingVM.ResponseMoveArray().IsCompletedFlag());
                        SrViewModel.IsSurveyPending(SrViewModel.SurveyTrackingVM.ResponseMoveArray().IsPendingFlag());
                        SrViewModel.BUTitle(SrViewModel.SurveyTrackingVM.BUTitle());
                        SrViewModel.RoleId(SrViewModel.SurveyTrackingVM.ResponseMoveArray().RoleId())
                        SrViewModel.SurveyStateName(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyStateName());
                        SrViewModel.ComponentName_Survey(SrViewModel.SurveyTrackingVM.ResponseMoveArray().ComponentName());
                        SrViewModel.ProfileName_Survey(SrViewModel.SurveyTrackingVM.ResponseMoveArray().ProfileName());
                        SrViewModel.ShowBookmarkFlags((SrViewModel.appsecurity.PageList() == undefined) ? false : (SrViewModel.appsecurity.PageList().indexOf('SurveyReviewFlags') >= 0) ? true : false);
                    }

                    SrViewModel.DisableControl(true);
                    SrViewModel.appsecurity.WriteAccess(false);
                    SrViewModel.PushbackComment("");
                }

                else if (SrViewModel.DashboardVM.RoutedFrom().toLowerCase() == 'dashboard') {
                    if ((SrViewModel.DashboardVM.ResponseMoveArray() == undefined || SrViewModel.DashboardVM.ResponseMoveArray().length == 0) && (activationData == undefined || activationData == null)) {
                        SrViewModel.DashboardVM.NavigatedFrom('Response');
                        router.navigate("landing", true);
                    }

                    else {
                        SrViewModel.SurveyProfileId(SrViewModel.DashboardVM.ResponseMoveArray().SurveyProfileId());
                        SrViewModel.SurveyTypeId(SrViewModel.DashboardVM.ResponseMoveArray().SurveyTypeId());
                        SrViewModel.SurveyName(SrViewModel.DashboardVM.ResponseMoveArray().SurveyName());
                        SrViewModel.SurveyProfileName(SrViewModel.DashboardVM.ResponseMoveArray().SurveyProfileName());
                        SrViewModel.RoleId(SrViewModel.DashboardVM.ResponseMoveArray().RoleId());
                        SrViewModel.SurveyId(SrViewModel.DashboardVM.ResponseMoveArray().SurveyId());
                        SrViewModel.Role(SrViewModel.DashboardVM.ResponseMoveArray().RoleName());
                        SrViewModel.DueDate(SrViewModel.DashboardVM.ResponseMoveArray().DueDate());
                        SrViewModel.BusinessUnitName(SrViewModel.DashboardVM.ResponseMoveArray().BusinessUnitName());
                        SrViewModel.BusinessUnitType(SrViewModel.DashboardVM.ResponseMoveArray().BusinessType());
                        SrViewModel.BusinessUnitDescription(SrViewModel.DashboardVM.ResponseMoveArray().BusinessUnitDescription());
                        SrViewModel.BusinessUnitId(SrViewModel.DashboardVM.ResponseMoveArray().BusinessUnitId());
                        SrViewModel.SurveyStatus(SrViewModel.DashboardVM.ResponseMoveArray().SurveyStatus());
                        SrViewModel.SurveyPendingWith(SrViewModel.DashboardVM.ResponseMoveArray().PendingWith());
                        SrViewModel.SurveyCompletionPercentage(SrViewModel.DashboardVM.ResponseMoveArray().CompletionPercentage());
                        SrViewModel.SurveyClassification(SrViewModel.DashboardVM.ResponseMoveArray().SurveyType());     // SUR, SOC, ACT
                        SrViewModel.BUList(SrViewModel.DashboardVM.ResponseMoveArray().BUList());
                        SrViewModel.BUListString(SrViewModel.DashboardVM.ResponseMoveArray().BUListString());
                        SrViewModel.UserList(SrViewModel.DashboardVM.ResponseMoveArray().UserList());
                        SrViewModel.SurveyIconClass(SrViewModel.DashboardVM.ResponseMoveArray().SurveyIconClass());
                        SrViewModel.SurveyStateColor(SrViewModel.DashboardVM.ResponseMoveArray().SurveyStateColor());
                        SrViewModel.IsSurveyCompleted(SrViewModel.DashboardVM.ResponseMoveArray().IsCompletedFlag());
                        SrViewModel.IsSurveyPending(SrViewModel.DashboardVM.ResponseMoveArray().IsPendingFlag());
                        SrViewModel.BUTitle(SrViewModel.DashboardVM.BUTitle());
                        SrViewModel.ComponentName_Survey(SrViewModel.DashboardVM.ResponseMoveArray().ComponentName_Survey());
                        SrViewModel.ProfileName_Survey(SrViewModel.DashboardVM.ResponseMoveArray().ProfileName_Survey());
                        SrViewModel.CurrentProfileOfAssessmentId(DashboardVM.CurrentProfileOfAssessmentId());
                        SrViewModel.SurveyStateName(SrViewModel.DashboardVM.ResponseMoveArray().SurveyStateName());
                        SrViewModel.IsSurveyReadOnly(SrViewModel.DashboardVM.ResponseMoveArray().IsSurveyReadOnly());
                        SrViewModel.ShowBookmarkFlags((SrViewModel.appsecurity.PageList() == undefined) ? false : (SrViewModel.appsecurity.PageList().indexOf('SurveyReviewFlags') >= 0) ? true : false);
                    }

                    var RoleWriteAccess = true;
                    // fetching WriteAccess from PageList for SurveyResponse page using appsecurity.userInfo()
                    ko.utils.arrayFilter(appsecurity.userInfo().moduleList(), function (arr) {
                        if (arr.ModuleCodeName() == "survey") {
                            ko.utils.arrayFilter(arr.PageList(), function (arrInner) {
                                if (arrInner.PageCodeName() == "SurveyResponse") {
                                    RoleWriteAccess = arrInner.WriteAccess();
                                    return;
                                }
                            })
                        }
                    });

                    if (SrViewModel.IsSurveyCompleted()) {
                        SrViewModel.DisableControl(true);
                        SrViewModel.appsecurity.WriteAccess(false);
                    }
                    else if (!SrViewModel.IsSurveyPending() && !SrViewModel.IsSurveyCompleted()) {
                        if (RoleWriteAccess) {
                            SrViewModel.DisableControl(false);
                            SrViewModel.appsecurity.WriteAccess(true);
                        }
                        else {
                            // handle if User have no write access given in Role managment
                            SrViewModel.DisableControl(true);
                            SrViewModel.appsecurity.WriteAccess(false);
                        }
                    }
                    else if (SrViewModel.IsSurveyReadOnly()) {
                        SrViewModel.DisableControl(true);
                        SrViewModel.appsecurity.WriteAccess(false);
                    }
                    else {
                        SrViewModel.DisableControl(true);
                        SrViewModel.appsecurity.WriteAccess(false);
                        SrViewModel.PushbackComment("");
                    }
                }
                SrViewModel.SaveCommentButtonName((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name);
                SrViewModel.CQBadge((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CQBadge') == -1) ? 'Common Question' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CQBadge')].Name());
                SrViewModel.CQBadgeTitle((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CQBadgeTitle') == -1) ? 'Response for this question to be filled in the Common Questions tab' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CQBadgeTitle')].Name());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                GetUser();
                if (SrViewModel.SurveyTrackingVM.RoutedFrom().toLowerCase() == "tracking") {
                    SrViewModel.PreviousPage(SrViewModel.SurveyTrackingVM.RoutedFrom()); // To store the previous page
                    if (SrViewModel.SurveyTrackingVM.ResponseMoveArray() == undefined) {
                        router.navigate("survey/SurveyTracking", true);
                    }
                    else {
                        $('#lblResponseError1').hide();
                        $('#lblResponseError2').hide();
                        SrViewModel.ImportSurveyType(SrViewModel.SurveyTypeId());
                        SegregatorBasedOnSurveyType();
                        $("#divNavSwitch2").hide();
                        SrViewModel.SurveyTrackingVM.RoutedFrom(""); // So that it is empty for next iteration
                    }
                }
                else if (SrViewModel.DashboardVM.RoutedFrom().toLowerCase() == "dashboard") {
                    SrViewModel.PreviousPage(SrViewModel.DashboardVM.RoutedFrom()); // To store the previous page
                    if (SrViewModel.DashboardVM.ResponseMoveArray() == undefined) {
                        SrViewModel.DashboardVM.NavigatedFrom('Response');
                        router.navigate("#Landing", true);
                    }
                    else {
                        $('#lblResponseError1').hide();
                        $('#lblResponseError2').hide();
                        SrViewModel.ImportSurveyType(SrViewModel.SurveyTypeId());
                        SegregatorBasedOnSurveyType();
                        $("#divNavSwitch2").hide();
                        SrViewModel.firstLoad(true);
                    }
                }
                SrViewModel.ValuesChanged(false);
                SrViewModel.NavigateToDashboardBoolean(false);
                SrViewModel.SummaryPopUpFlag(false);
                SrViewModel.FinalizePopUpFlag(false);
                window.onscroll = function () { pageScroll() };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        // #endregion

        // #region Page level stylings

        $(".nav-tabs a").click(function () {
            $(this).tab('show');
        });

        function pageScroll() {
            try {
                var header = document.getElementById("surveyHeader");
                if (header != null)
                    var sticky = header.offsetTop;

                var header1 = document.getElementById("surveyContent");
                if (header1 != null)
                    var sticky1 = surveyContent.offsetTop;

                var header2 = document.getElementById("surveyNav");
                if (header2 != null)
                    var sticky2 = surveyNav.offsetTop;

                if (header != null) {
                    if (window.pageYOffset > sticky) {
                        header.classList.add("surveyHeader-sticky");
                        if ($('#divContent').hasClass('col-md-9 sq-box'))
                            surveyContent.classList.add("surveyContent-sticky");
                        else
                            surveyContent.classList.add("surveyContent-sticky-exp");

                        surveyNav.classList.add("surveyNav-sticky");
                    } else {
                        header.classList.remove("surveyHeader-sticky");
                        surveyContent.classList.remove("surveyContent-sticky");
                        surveyContent.classList.remove("surveyContent-sticky-exp");
                        surveyNav.classList.remove("surveyNav-sticky");
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: pageScroll() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ToggleNavigation() {
            if ($('#btnHideNavigation').is(':visible')) {
                $('#divNavigation').hide();
                $('#divContent').removeClass("col-md-9 sq-box");
                $('#divContent').addClass("col-md-12");
                $('#btnShowNavigation').show();

                //Scroll hide/show code
                var header1 = document.getElementById("surveyContent");
                var sticky1 = surveyContent.offsetTop;
                surveyContent.classList.add("surveyContent-sticky-exp");
                surveyContent.classList.remove("surveyContent-sticky");
            }
            else {
                $('#btnShowNavigation').hide();
                $('#divContent').removeClass("col-md-12");
                $('#divContent').addClass("col-md-9 sq-box");
                $('#divNavigation').show();

                //Scroll hide/show code
                var header1 = document.getElementById("surveyContent");
                var sticky1 = surveyContent.offsetTop;
                surveyContent.classList.remove("surveyContent-sticky-exp");
            }
            if (SrViewModel.SurveyTypeId() === 'QTDR') {
                RestructureQuan();
            }
        }

        function RestructureQuan() {
            try {
                var ValidationTblObj = $('#tblQuanResponseResponse').DataTable();
                ValidationTblObj.destroy();

                var Dtable = $("#tblQuanResponseResponse").DataTable({
                    "aLengthMenu": false,
                    "aLengthChange": false,
                    "bResponsive": true,
                    "searching": false,
                    "bPaginate": false,
                    "paging": false,
                    "stateSave": true,
                    "order": [],
                    "aaSorting": [],
                    "ordering": false,
                    "info": false,
                    "stripeClasses": []
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RestructureQuan() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        // #endregion

        //#region Common Methods, Models for all types of survey

        function SegregatorBasedOnSurveyType() {
            try {
                switch (SrViewModel.SurveyTypeId()) {
                    case 'QTDR':
                        InitiateQuantitativeLevelTree();
                        break;
                    case 'QLDR':
                        InitiateQualitativeLevelTree();
                        break;
                    case 'CDR':
                        InitiateControlsLevelTree();
                        break;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SegregatorBasedOnSurveyType() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function GetUser() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Reporting/GetUser",
                    type: "GET",
                    headers: headers,
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetUser() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    SrViewModel.User(jsonResult);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetUser() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUser() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetUser() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetSurveyCardDetails(SurveyId) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/GetSurveyCardDetails",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: SurveyId, SurveyType: SrViewModel.SurveyClassification(), AssessmentProfileId: parseInt(SrViewModel.CurrentProfileOfAssessmentId()), WFFlag: 0 })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyCardDetails() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== "") {
                        var convertedObj = JSON.parse(jsonResult);
                        var mappedList = ko.mapping.fromJS(convertedObj.SurveyDetails)();

                        var userListVar = mappedList[0].UserList();
                        var buListVar = mappedList[0].BUList();
                        var BUlistStringHTML = "";
                        var BUListString = "";

                        // to add title to sub-org level names
                        if (buListVar != null || buListVar != "") {
                            var BUListSplit = buListVar.split("<span class='bu-lbl'><strong class='lbl-space'>");
                            for (var n = 1; n < BUListSplit.length; n++) {
                                var BUListSplitInner = BUListSplit[n].toString().split(":</strong><span class='bu-val'>");
                                BUlistStringHTML += "<span class='bu-lbl'><strong class='lbl-space'>" + BUListSplitInner[0] + ":</strong><span class='bu-val' title='" + BUListSplitInner[1].split("</span></span>")[0].toString().trim() + "'>" + BUListSplitInner[1];
                                BUListString += BUListSplitInner[0] + ":" + BUListSplitInner[1];
                                if (n < BUListSplit.length - 1)
                                    BUListString += "`";
                            }
                            if (BUListString != null || BUListString != "")
                                BUListString = BUListString.replace(/(<p>|<\/p>|<strong class='lbl-space'>|<span class='bu-lbl'>|<\/span>|<strong>|<\/strong>|<em>|<\/em>|<u>|<\/u>|<ol>|<\/ol>|<ul>|<\/ul>|<li>|<\/li>)/gi, "").replace(/(\r\n|\n|\r)/gm, " ");
                        }

                        SrViewModel.BUList(BUlistStringHTML);
                        SrViewModel.BUListString(BUListString);
                        SrViewModel.UserList(userListVar);
                    }
                    else {
                        // user and org details are null
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetSurveyCardDetails() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminFetchErrorMessage') == -1) ? 'An error occurred while getting Comment. Please contact your Application Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminFetchErrorMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSurveyCardDetails() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }

        function NavigateToDashboard(data) {
            try {
                if (SrViewModel.PreviousPage().toLowerCase() == "tracking") {
                    SrViewModel.ObjGeneralSettings.NavPillIdSurveyTracking(SrViewModel.SurveyTrackingVM.NavPillId());
                    SrViewModel.ObjGeneralSettings.isNavigatedBackFromSurveyResponsePage(true);
                    router.navigate('survey/SurveyTracking', true);
                }
                else if (SrViewModel.PreviousPage().toLowerCase() == "dashboard" && SrViewModel.SurveyStatus() != 'Survey Review - Pending' && SrViewModel.SurveyStatus() != 'Completed' && SrViewModel.ValuesChanged()) {
                    app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyDataCheckDashboard') == -1) ? 'Please save the data before moving back to Dashboard, otherwise the changes made will be lost.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyDataCheckDashboard')].Name, "Warning", [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name], true, { buttonClass: "fa fa-check btn", primaryButtonClass: "primary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                        .then(function (option) {
                            SrViewModel.ValuesChanged(false);
                            SrViewModel.isSaveResponseClick(false);
                            if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name)()) {
                                SrViewModel.SavechangedvalueTab(null);
                                SrViewModel.SavechangedvalueSubTab(null);
                                SrViewModel.NavigateToDashboardBoolean(true);
                                if (SrViewModel.MCILevel() == true) {
                                    SetMCI_LevelDetails();
                                } else {
                                    SaveResponse(data);
                                }
                            }
                            else {
                                SrViewModel.DashboardVM.NavigatedFrom('Response');
                                router.navigate('Landing', true);
                            }
                        })
                }
                else if (SrViewModel.PreviousPage().toLowerCase() == "dashboard") {
                    SrViewModel.DashboardVM.NavigatedFrom('Response');
                    router.navigate('Landing', true);
                }
                else
                    router.navigate('survey/SurveyTracking', true);

                SrViewModel.ValuesChanged(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToDashboard() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function MakePipeDelimited(Response) {
            try {
                var profileId = "";
                if (Response.length == undefined || Response.length == 0) {
                    return profileId;
                }
                else {
                    for (var i = 0; i < Response.length; i++) {
                        if (i == 0)
                            profileId = Response[i];
                        else
                            profileId = profileId + "|" + Response[i];
                    }
                }
                return profileId;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: MakePipeDelimited() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function DecodePipeDelimited(Response) {
            try {
                var profileId = ko.observableArray([]);
                if (Response == null || Response == undefined || Response == "") {
                    return profileId;
                }
                else {
                    var options = Response.split('|');
                    for (i = 0; i < options.length; i++) {
                        profileId.push(parseInt(options[i]));
                    }
                }
                return profileId;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DecodePipeDelimited() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function RefreshSession() {
            try {
                var minutes = getMinutesAndHours();

                if (minutes < 10) {
                    SrViewModel.appsecurity.RefreshTokenSession();
                    $('#sessionTimer').modal('hide');
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RefreshSession() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function getMinutesAndHours() {
            try {
                var now = new Date().getTime(),
                    distance = new Date(SrViewModel.appsecurity.CountDownTime()).getTime() - now,
                    hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                    minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                if (hours == 0)
                    return minutes;
                else
                    return 11;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: getMinutesAndHours() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#region Common Click events

        function CollapseAllTreeView() {
            if ($('#spanExpandAll').text() == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())) {
                $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
                $("#spanExpandAll").text((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
                $("#arrowSpan").addClass("fa-caret-down").removeClass("fa-caret-right");
            }
            else {
                $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
                $("#spanExpandAll").text((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name());
                $("#arrowSpan").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
        }

        function CollapseAllQuestions() {
            try {
                if ($('#spanExpandAllQuestions').text() === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())) {
                    $("#spanExpandAllQuestions").text((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
                    $("#arrowSpanQuestions").addClass("fa-caret-down").removeClass("fa-caret-right");
                    if (SrViewModel.SurveyTypeId() === 'QLDR') {
                        for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                            if (SrViewModel.QualResponseListData()[i].IsHeader() === 1) {
                                $('#accQualHeader_' + SrViewModel.QualResponseListData()[i].FactorId()).addClass("show");
                                $('#accQualHeaderID_' + SrViewModel.QualResponseListData()[i].FactorId()).removeClass("collapsed");
                            }
                        }
                    }
                    else if (SrViewModel.SurveyTypeId() === 'CDR') {
                        for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                            if (SrViewModel.ControlsResponseData()[i].IsHeader() === 1) {
                                $('#accControlHeader_' + SrViewModel.ControlsResponseData()[i].FactorId()).addClass("show");
                                $('#accControlHeaderID_' + SrViewModel.ControlsResponseData()[i].FactorId()).removeClass("collapsed");
                            }
                        }
                    }
                    else if (SrViewModel.SurveyTypeId() === 'QTDR') {
                        $('#accHeader_' + SrViewModel.ClickedRiskFactorId()).addClass("show");
                        $('#accHeaderMain_' + SrViewModel.ClickedRiskFactorId()).removeClass("collapsed");
                        for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                            if (SrViewModel.QuanResponseObject()[i].QuestionType() == 'TH') {
                                $('#accNQHeader_' + SrViewModel.QuanResponseObject()[i].HeaderUID()).addClass("show");
                                $('#accNQHeaderMain_' + SrViewModel.QuanResponseObject()[i].HeaderUID()).removeClass("collapsed");
                            }
                        }
                    }
                }
                else {
                    $("#spanExpandAllQuestions").text((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name());
                    $("#arrowSpanQuestions").addClass("fa-caret-right").removeClass("fa-caret-down");
                    if (SrViewModel.SurveyTypeId() === 'QLDR') {
                        for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                            if (SrViewModel.QualResponseListData()[i].IsHeader() === 1) {
                                $('#accQualHeader_' + SrViewModel.QualResponseListData()[i].FactorId()).removeClass("show");
                                $('#accQualHeaderID_' + SrViewModel.QualResponseListData()[i].FactorId()).addClass("collapsed");
                            }
                        }
                    }
                    else if (SrViewModel.SurveyTypeId() === 'CDR') {
                        for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                            if (SrViewModel.ControlsResponseData()[i].IsHeader() === 1) {
                                $('#accControlHeader_' + SrViewModel.ControlsResponseData()[i].FactorId()).removeClass("show");
                                $('#accControlHeaderID_' + SrViewModel.ControlsResponseData()[i].FactorId()).addClass("collapsed");
                            }
                        }
                    }
                    else if (SrViewModel.SurveyTypeId() === 'QTDR') {
                        $('#accHeader_' + SrViewModel.ClickedRiskFactorId()).removeClass("show");
                        $('#accHeaderMain_' + SrViewModel.ClickedRiskFactorId()).addClass("collapsed");
                        for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                            if (SrViewModel.QuanResponseObject()[i].QuestionType() == 'TH') {
                                $('#accNQHeader_' + SrViewModel.QuanResponseObject()[i].HeaderUID()).removeClass("show");
                                $('#accNQHeaderMain_' + SrViewModel.QuanResponseObject()[i].HeaderUID()).addClass("collapsed");
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CollapseAllQuestions() Event in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function BookmarkFlagChangeEvent(data, event) {
            try {
                SrViewModel.ValuesChanged(true);
                if (SrViewModel.SurveyTypeId() === 'QLDR') {
                    for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                        if (data.QuestionId() == SrViewModel.QualResponseListData()[i].QuestionId()) {
                            for (var h = 0; h < SrViewModel.QualResponseListData()[i].ResponseList.length; h++) {
                                SrViewModel.QualResponseListData()[i].ResponseList[h].BookmarkFlag(SrViewModel.QualResponseListData()[i].BookmarkFlagQuestion());
                            }
                            break;
                        }
                    }
                }
                else if (SrViewModel.SurveyTypeId() === 'CDR') {
                    for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                        if (data.QuestionId() == SrViewModel.ControlsResponseData()[i].QuestionId()) {
                            for (var h = 0; h < SrViewModel.ControlsResponseData()[i].ResponseList.length; h++) {
                                SrViewModel.ControlsResponseData()[i].ResponseList[h].BookmarkFlag(SrViewModel.ControlsResponseData()[i].BookmarkFlagQuestion());
                            }
                            break;
                        }
                    }
                }
                else if (SrViewModel.SurveyTypeId() === 'QTDR') {
                    for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                        if (data.QuestionId() == SrViewModel.QuanResponseObject()[i].QuestionId()) {
                            for (var h = 0; h < SrViewModel.QuanResponseObject()[i].ResponseList.length; h++) {
                                SrViewModel.QuanResponseObject()[i].ResponseList[h].BookmarkFlag(SrViewModel.QuanResponseObject()[i].BookmarkFlagQuestion());
                            }
                            break;
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BookmarkFlagChangeEvent() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ValuesChangeEvent(data, event, QuestionId) {
            try {
                SrViewModel.ValuesChanged(true);
                RefreshSession();
                return true;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValuesChangeEvent() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SubCategoryInfoClick(data) {
            try {
                SrViewModel.InfoClickType(data);
                $('#CategroyGuidelinesPopUp').modal('show');
                $('#lblAreaNarrationError').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubCategoryInfoClick() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function showSurveyInfoClick(SurveyId, ProfileId) {
            try {
                if (SrViewModel.BUList() == "" && SrViewModel.UserList() == "") {
                    GetSurveyCardDetails(SurveyId);
                }
                if ($('#surveyInfoDiv_' + SurveyId + '_' + ProfileId).is(':visible')) {
                    $('#surveyInfoDiv_' + SurveyId + '_' + ProfileId).hide(500);
                    $('#surveyInfoDivMore_' + SurveyId + '_' + ProfileId).show();
                    $('#surveyInfoDivLess_' + SurveyId + '_' + ProfileId).hide();
                }
                else {
                    $('#surveyInfoDiv_' + SurveyId + '_' + ProfileId).show(500);
                    $('#surveyInfoDivLess_' + SurveyId + '_' + ProfileId).show();
                    $('#surveyInfoDivMore_' + SurveyId + '_' + ProfileId).hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showSurveyInfoClick() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function OcKeypress(data, event) {
            try {
                if (event.which === 16 || event.which === 17 || event.which === 18 || event.which === 35 || event.which === 36 || event.which === 46 || event.which === 8 || (event.which >= 112 && event.which <= 123))
                    return true;
                else {
                    if (event.currentTarget.value.length >= SrViewModel.CommentCharsLimit()) {
                        return false;
                    }
                    return true;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OcKeypress() in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function OcKeyUp(data, event) {
            try {
                SrViewModel.RemainingChars(SrViewModel.CommentCharsLimit() - event.currentTarget.value.length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OcKeyUp() in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Search related events

        function SearchResult() {
            try {
                if (SrViewModel.SurveyTypeId() == "QLDR") {
                    $("#spanExpandAllQuestions").text((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
                    $("#arrowSpanQuestions").addClass("fa-caret-down").removeClass("fa-caret-right");

                    for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                        if (SrViewModel.QualResponseListData()[i].IsHeader() === 1) {
                            $('#accQualHeader_' + SrViewModel.QualResponseListData()[i].FactorId()).addClass("show");
                            $('#accQualHeaderID_' + SrViewModel.QualResponseListData()[i].FactorId()).removeClass("collapsed");
                        }
                    }

                    var searchedList = ko.computed(function () {
                        var q = SrViewModel.Query();
                        if (q != "") {
                            return SrViewModel.QualResponseListData().filter(function (i) {
                                return i.QuestionTextPlain().toLowerCase().indexOf(q.toLowerCase()) >= 0;
                            });
                        }
                    });

                    for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                        SrViewModel.QualResponseListData()[i].IsVisibleforSearch(false);
                        $('#question-Section_' + SrViewModel.QualResponseListData()[i].QuestionId()).removeClass("card");
                    }

                    if (SrViewModel.Query() != undefined && SrViewModel.Query() == "") {
                        //for empty keyboard input
                        for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                            SrViewModel.QualResponseListData()[i].IsVisibleforSearch(true);
                            $('#question-Section_' + SrViewModel.QualResponseListData()[i].QuestionId()).addClass("card");
                        }
                    }
                    if (searchedList() != undefined) {
                        for (var j = 0; j < searchedList().length; j++) {
                            for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                                if (SrViewModel.QualResponseListData()[i].QuestionId() == searchedList()[j].QuestionId()) {
                                    SrViewModel.QualResponseListData()[i].IsVisibleforSearch(true);
                                    $('#question-Section_' + SrViewModel.QualResponseListData()[i].QuestionId()).addClass("card");
                                }
                            }
                        }
                    }
                    //rich text box
                    for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                        if (SrViewModel.QualResponseListData()[i].ResponseList != undefined) {
                            for (var k = 0; k < SrViewModel.QualResponseListData()[i].ResponseList.length; k++) {
                                if (SrViewModel.QualResponseListData()[i].ResponseList[k].Applicability() == true && SrViewModel.QualResponseListData()[i].ResponseList[k].ResponseOptionType() === 'R')
                                    showResponseRichText(SrViewModel.QualResponseListData()[i].QuestionId() + '_' + SrViewModel.QualResponseListData()[i].ResponseList[k].ResponseId(), SrViewModel.QualResponseListData()[i].ResponseList[k].ResponseInputValue());
                            }
                        }
                    }
                }

                else if (SrViewModel.SurveyTypeId() == "CDR") {
                    $("#spanExpandAllQuestions").text((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
                    $("#arrowSpanQuestions").addClass("fa-caret-down").removeClass("fa-caret-right");
                    for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                        if (SrViewModel.ControlsResponseData()[i].IsHeader() === 1) {
                            $('#accControlHeader_' + SrViewModel.ControlsResponseData()[i].FactorId()).addClass("show");
                            $('#accControlHeaderID_' + SrViewModel.ControlsResponseData()[i].FactorId()).removeClass("collapsed");
                        }
                    }

                    var searchedList = ko.computed(function () {
                        var q = SrViewModel.Query();
                        if (q != "") {
                            return SrViewModel.ControlsResponseData().filter(function (i) {
                                return i.QuestionTextPlain().toLowerCase().indexOf(q.toLowerCase()) >= 0;
                            });
                        }
                    });

                    for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                        SrViewModel.ControlsResponseData()[i].IsVisibleforSearch(false);
                        $('#question-Section_' + SrViewModel.ControlsResponseData()[i].QuestionId()).removeClass("card");
                    }

                    if (SrViewModel.Query() != undefined && SrViewModel.Query() == "") {
                        //for empty keyboard input
                        for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                            SrViewModel.ControlsResponseData()[i].IsVisibleforSearch(true);
                            $('#question-Section_' + SrViewModel.ControlsResponseData()[i].QuestionId()).addClass("card");
                        }
                    }
                    if (searchedList() != undefined) {
                        for (var j = 0; j < searchedList().length; j++) {
                            for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                                if (SrViewModel.ControlsResponseData()[i].QuestionId() == searchedList()[j].QuestionId()) {
                                    SrViewModel.ControlsResponseData()[i].IsVisibleforSearch(true);
                                    $('#question-Section_' + SrViewModel.ControlsResponseData()[i].QuestionId()).addClass("card");
                                }
                            }
                        }
                    }
                    //rich text box
                    for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                        if (SrViewModel.ControlsResponseData()[i].ResponseList != undefined) {
                            for (var k = 0; k < SrViewModel.ControlsResponseData()[i].ResponseList.length; k++) {
                                if (SrViewModel.ControlsResponseData()[i].ResponseList[k].ResponseApplicability() == true && SrViewModel.ControlsResponseData()[i].ResponseList[k].ResponseOptionType() === 'R')
                                    showResponseRichText(SrViewModel.ControlsResponseData()[i].QuestionId() + '_' + SrViewModel.ControlsResponseData()[i].ResponseList[k].ResponseId(), SrViewModel.ControlsResponseData()[i].ResponseList[k].ResponseInputValue());
                            }
                        }
                    }
                }
                // Quantitative
                else {
                    for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                        $('#accHeader_' + SrViewModel.ClickedRiskFactorId()).addClass("collapse show").removeClass("collapsed");
                        $('#accHeaderMain_' + SrViewModel.ClickedRiskFactorId()).removeClass("collapsed");
                    }

                    var searchedList = ko.computed(function () {
                        var q = SrViewModel.Query();
                        if (q != "") {
                            return SrViewModel.QuanResponseObject().filter(function (i) {
                                return (i.QuestionTextPlain().toLowerCase().indexOf(q.toLowerCase()) >= 0 || i.DisplayRank().toLowerCase().indexOf(q.toLowerCase()) >= 0);
                            });
                        }
                    });

                    for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                        SrViewModel.QuanResponseObject()[i].IsVisibleforSearch(false);
                    }

                    if (SrViewModel.Query() != undefined && SrViewModel.Query() == "") {
                        //for empty keyboard input
                        for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                            SrViewModel.QuanResponseObject()[i].IsVisibleforSearch(true);
                        }
                    }
                    if (searchedList() != undefined) {
                        for (var j = 0; j < searchedList().length; j++) {
                            for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                                if (SrViewModel.QuanResponseObject()[i].QuestionId() == searchedList()[j].QuestionId()) {
                                    SrViewModel.QuanResponseObject()[i].IsVisibleforSearch(true);
                                }
                            }
                        }
                    }
                    // rich text box
                    for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                        if (SrViewModel.QuanResponseObject()[i].ResponseList !== undefined) {
                            if (SrViewModel.QuanResponseObject()[i].QuestionType() == 'T') {
                                for (var k = 0; k < SrViewModel.QuanResponseObject()[i].ResponseList.length; k++) {
                                    if (SrViewModel.QuanResponseObject()[i].ResponseList[k].ResponseOptionType() === 'T')
                                        showResponseRichText(SrViewModel.QuanResponseObject()[i].QuestionId() + '_' + SrViewModel.QuanResponseObject()[i].ResponseList[k].ResponseId(), SrViewModel.QuanResponseObject()[i].ResponseList[k].ResponseValue());
                                }
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResult() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ClearSearchText() {
            $('#searchFeature').val('');
        }

        function ResetSearch() {
            try {
                $('#searchFeature').val('');
                SrViewModel.Query('');
                SearchResult();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetSearch() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Instructions events

        function GetInstructions(TableId) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                getAllInstructions = {
                    url: "/api/Configuration/GetInstructions",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({
                        "AreaId": TableId,
                        "AreaType": SrViewModel.SurveyTypeId(),
                        "Type": "SB",
                        "Draft": SrViewModel.SurveyId(),
                        "ZATId": -1 // -1 as this param is not required for survey response screen - config screens will send ZATId
                    })
                };
                return $.ajax(getAllInstructions)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: GetInstructions() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                SrViewModel.Instructions('');
                $('#AocInstructionsDiv').hide();
                $('#AreaInstructionsDiv').hide();
                if (jsonResult != null && jsonResult.AreaId == -99) {
                    logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                        ? jsonResult.AreaType + " - An error has occured. Please contact your Administrator."
                        : jsonResult.AreaType + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                        [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                            (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                            ? jsonResult.AreaType + " - Please contact your Administrator."
                            : jsonResult.AreaType + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                }
                if (jsonResult !== null && jsonResult.Instruction != "") {
                    SrViewModel.Instructions(jsonResult.Instruction);
                    $('#AreaInstructionsDiv').show();
                }
                else {
                    $('#AreaInstructionsDiv').hide();
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetInstructions method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetInstructions method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function showMoreInstructions() {
            try {
                if ($('#InstructionsMoreBtn').is(':visible')) {
                    $('#InstructionsMoreBtn').hide();
                    $('#InstructionsLessBtn').show();
                    $('#AreaInstructionsInnerDiv').removeClass("text-truncate-inst");
                    $('#AreaInstructionsInnerDiv').attr("style", "max-height:");
                }
                else {
                    $('#InstructionsLessBtn').hide();
                    $('#InstructionsMoreBtn').show();
                    $('#AreaInstructionsInnerDiv').addClass("text-truncate-inst");
                    $('#AreaInstructionsInnerDiv').attr("style", "max-height:10vh !important;");
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showMoreInstructions() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region RTB-CKE Editor events

        function ckeCharCheck() {
            try {
                var comment = CKEDITOR.instances["NarrationTextArea"].getData(),
                    textLength = comment.replace(/(<p>|<\/p>|<strong>|<\/strong>|<em>|<\/em>|<u>|<\/u>|<ol>|<\/ol>|<ul>|<\/ul>|<li>|<\/li>)/gi, "").replace(/(\r\n|\n|\r)/gm, " ").length,
                    remainingChars = 4000 - textLength;

                if (remainingChars < 0)
                    remainingChars = 0;

                SrViewModel.RemainingChars(remainingChars);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ckeCharCheck() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function showCommentsRichText(questionId, type) {
            try {
                var text = "";
                if (type == 'cmt')
                    text = "ResponseTextArea_";
                else if (type == 'atch')
                    text = "UploadTextArea_";

                var selector = text + questionId;
                var editor = CKEDITOR.instances[selector];
                if (editor) {
                    editor.destroy(true);
                }
                CKEDITOR.replace(selector, {
                    removePlugins: SrViewModel.RemovePlugins(),
                    removeButtons: SrViewModel.RemoveButtons(),
                    disableNativeSpellChecker: false
                });
                $('#' + selector).val('');
                CKEDITOR.config.height = '100px';
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showCommentsRichText() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function showResponseRichText(questionId, value) {
            try {
                var selector = "ResponseType_" + questionId;
                var editor = CKEDITOR.instances[selector];
                if (editor) {
                    editor.destroy(true);
                }
                CKEDITOR.replace(selector, {
                    removePlugins: SrViewModel.RemovePlugins(),
                    removeButtons: SrViewModel.RemoveButtons(),
                    disableNativeSpellChecker: false,
                    on: {
                        change: function () {
                            SrViewModel.ValuesChanged(true);
                        }
                    }
                });
                $('#' + selector).html(value);
                CKEDITOR.config.height = '100px';
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showResponseRichText() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function FillRTBInputValues() {
            try {
                if (SrViewModel.SurveyTypeId() == 'CDR') {
                    for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                        for (var j = 0; j < SrViewModel.ControlsResponseData()[i].ResponseList.length; j++) {
                            if (SrViewModel.ControlsResponseData()[i].ResponseList[j].ResponseOptionType() === "R" && SrViewModel.ControlsResponseData()[i].IsConditional() === 0) // Rick Text Box Response
                                SrViewModel.ControlsResponseData()[i].ResponseList[j].ResponseInputValue(CKEDITOR.instances["ResponseType_" + SrViewModel.ControlsResponseData()[i].QuestionId() + '_' + SrViewModel.ControlsResponseData()[i].ResponseList[j].ResponseId()].getData());
                        }
                    }
                }
                else if (SrViewModel.SurveyTypeId() == 'QLDR') {
                    for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                        for (var j = 0; j < SrViewModel.QualResponseListData()[i].ResponseList.length; j++) {
                            if (SrViewModel.QualResponseListData()[i].ResponseList[j].ResponseOptionType() === "R" && SrViewModel.QualResponseListData()[i].IsConditional() === 0) // Rick Text Box Response
                                SrViewModel.QualResponseListData()[i].ResponseList[j].ResponseInputValue(CKEDITOR.instances["ResponseType_" + SrViewModel.QualResponseListData()[i].QuestionId() + '_' + SrViewModel.QualResponseListData()[i].ResponseList[j].ResponseId()].getData());
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'exception' + e + 'source in FillRTBInputValues() in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Common Models

        function BreadCrumbsModel(item) {
            try {
                var self = this;
                self.LevelId = item.level_id;
                self.AreaName = $('<div/>').html(item.area_name).text();
                self.SelectedLevel = item.selected_level;
                self.ScoreDescription = (item.ScoreDescription != undefined) ? item.ScoreDescription : "";
                self.ScoreCSS = (item.ScoreCSS != undefined) ? item.ScoreCSS : "";
                self.Score = (item.Score != undefined) ? item.Score : "";
                self.ShowFlag = (item.ShowFlag != undefined) ? item.ShowFlag : 0;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BreadCrumbsModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function jsTreeModel(item) {
            var self = this;
            self.id = item.AreaLevelId.toString();
            self.isComplete = item.CompletionPercentage;
            self.Is_RefreshEnable = item.Is_RefreshEnable;
            self.Tick_Flag = item.Tick_Flag;
            if (SrViewModel.AreaLeveljstree()[self.id].length > 0) {
                SrViewModel.TreeView_ParentAreaId(item.AreaLevelId.toString());
                SrViewModel.TreeView_ParentAreaName(item.AreaLevelName.toString());
                SrViewModel.TreeView_ParentAreaGuidelines(item.CategoryGuidelines.toString());
                self.nodes = $.map(SrViewModel.AreaLeveljstree()[self.id], function (result) {
                    if (result.DeadNode == 0) {
                        return new jsTreeModel(result);
                    } else {
                        if (result.AvailableLowestLevel == 1)
                            return new jsTreeModel(result);
                    }
                });
            }

            self.ParentAreaId = SrViewModel.TreeView_ParentAreaId();
            self.ParentAreaName = SrViewModel.TreeView_ParentAreaName();
            self.ParentGuidelines = SrViewModel.TreeView_ParentAreaGuidelines();

            self.showLevel = item.AvailableLowestLevel;
            if (self.showLevel == 0 && self.nodes != undefined && self.nodes != undefined && ko.utils.arrayFilter(self.nodes, function (i) { if (i.showLevel == 1) { return i; } }).length > 0) {
                self.showLevel = 1;
            }
            self.text = '<span>' + item.AreaLevelName + '</span>';

            if (item.Tick_Flag == true) {
                var titleTextCompleted = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Completed') == -1) ? 'Completed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Completed')].Name();
                self.showPercentageComplete = 1;
                self.text = '<div>' + item.AreaLevelName + '</div> <i class="fa fa-check-circle fa-shadow" aria-hidden="true" title="' + titleTextCompleted + '" style="color:#41ae2c; margin-left: auto;"></i>';
            }
            else if (item.Is_RefreshEnable == true && item.Tick_Flag == false) {
                var titleTextPending = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Pending') == -1) ? 'Pending' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Pending')].Name();
                self.text = '<div>' + item.AreaLevelName + '</div>';
                //< i class="fa fa-check-circle" aria - hidden="true" title = "' + titleTextPending + '" style = "color:gray; margin-left: auto;" ></i > ';
            }

            if (item.CompletionPercentage == false) {
                self.showPercentageComplete = 0;
            }
            if (item.Is_RefreshEnable == false) {
                var titleTextViewOnly = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ViewOnly') == -1) ? 'View Only' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ViewOnly')].Name();
                self.text = '<div>' + item.AreaLevelName + '</div> <i class="fa fa-lock fa-lg" aria-hidden="true" title="' + titleTextViewOnly + '" style="padding-top: 0.3rem; margin-left: auto;"></i>';
            }
            self.state = { expanded: false };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.categoryGuidelines = item.CategoryGuidelines;
            self.Is_RefreshProfile = item.Is_RefreshProfile;

            self.Is_LevelChecked = item.Is_LevelChecked;
            self.Level = item.AreaLevel;
        }

        function ColumnDetailsModel(item) {
            try {
                var self = this,
                    ColumnName = "";

                self.ColumnId = ko.observable(item.ColumnId);
                ColumnName = item.ColumnName;

                if (item.ColumnName == undefined)//to support controls, to-do
                    ColumnName = item.Columntext;

                self.ColumnName = ko.observable($('<div/>').html(ColumnName).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ColumnDetailsModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        // #endregion

        // #endregion

        //#region Sync-ratings

        function RunSyncRatings() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/SyncRatingsCalcsSimultaneousCheck",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: SrViewModel.SurveyId(), JobType: "CALCULATION-SR-SYNC", AssessmentProfile: appsecurity.CurrentProfileOfAssessmentId() })
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != null) {
                            if (jsonResult == "1") {
                                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RunSyncRatingsCalcsSimultaneousCheckMessage') == -1) ? 'The Calculation Engine is currently in progress. Please retry sync-ratings after some time or contact your administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RunSyncRatingsCalcsSimultaneousCheckMessage')].Name
                                    , (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RunCalculationsButton') == -1) ? 'Alert' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RunCalculationsButton')].Name
                                    , [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OKKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OKKeyword')].Name()).toString()]
                                    , true, { buttonClass: "btn primary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                            }
                            else if (jsonResult == "2") {
                                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RunSyncRatingsCalcsSimultaneousCheckMessage') == -1) ? 'Sync Ratings for this survey is currently in progress. Please retry sync-ratings after some time or contact your administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RunSyncRatingsCalcsSimultaneousCheckMessage')].Name
                                    , (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RunCalculationsButton') == -1) ? 'Alert' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RunCalculationsButton')].Name
                                    , [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OKKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OKKeyword')].Name()).toString()]
                                    , true, { buttonClass: "btn primary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                            }
                            else if (jsonResult == "0") {
                                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RunSyncRatingsMessage') == -1) ? 'Do you want to initiate the calculations to determine the ratings?' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RunSyncRatingsMessage')].Name
                                    , (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RunCalculationsButton') == -1) ? 'Run Calculations' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RunCalculationsButton')].Name
                                    , [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('YesKeyword') == -1) ? 'Yes' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('YesKeyword')].Name()).toString(), " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoKeyword') == -1) ? 'No' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoKeyword')].Name()).toString()]
                                    , true, { buttonClass: "btn primary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                                    .then(function (option) {
                                        if (option == " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('YesKeyword') == -1) ? 'Yes' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('YesKeyword')].Name()).toString()) {
                                            SyncRatings();
                                        }
                                        // Else we don't do anything
                                    });
                            }

                            else if (jsonResult.substring(0, 3) == "INC")
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                    ? jsonResult + " - An error has occurred while showing the sync rating popup."
                                    : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                        (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                        ? jsonResult + " - " + "Please contact your Administrator."
                                        : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        //SrViewModel.SyncRatingsButtonDisable(false);
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                            ? jsonResult + " - " + "An error has occurred while showing the sync rating popup."
                            : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                            [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                ? jsonResult + " - " + "Please contact your Administrator."
                                : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        //SrViewModel.SyncRatingsButtonDisable(false);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RunSyncRatings() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SyncRatingsStatus(data, event) {
            try {
                //$('#syncRatingsBtn').prop('disabled', true);
                $('#loadingImgUser').show().addClass("d-inline-flex");
                var FirstLoad = SrViewModel.firstLoad();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/SyncRatingsStatus",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: SrViewModel.SurveyId(), JobType: "CALCULATION-SR-SYNC" })
                }).success(function (jsonResult, error) {
                    if (jsonResult != null) {
                        if (jsonResult.length > 0 && jsonResult[0].ErrorId == -99) {
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                ? jsonResult[0].ErrorName + " - An error has occured. Please contact your Administrator."
                                : jsonResult[0].ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                    (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? jsonResult[0].ErrorName + " - Please contact your Administrator."
                                    : jsonResult[0].ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            // Use this after the get call if the json result = 1
                            var MappedScheduledJobStatus = $.map(jsonResult, function (result) {
                                return new JobStatusModel(result);
                            });
                            SrViewModel.ScheduledJobStatusList(MappedScheduledJobStatus);
                            if (SrViewModel.ScheduledJobStatusList()[0].JobRunStatus() === "In-Progress") {
                                //SrViewModel.SyncRatingsButtonDisable(true);
                                logger.logWarning((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalcsInProgressMessage') == -1) ? 'Sync Ratings are still in progress' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalcsInProgressMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                                $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                                //$('#syncRatingsBtn').prop('disabled', false);
                            }
                            else if (SrViewModel.ScheduledJobStatusList()[0].JobRunStatus() === "Failed") {
                                //SrViewModel.SyncRatingsButtonDisable(true);
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SyncCalcsFailedMessage') == -1) ? 'Sync-Ratings are not successful. Please re-run or contact your Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SyncCalcsFailedMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                                $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                                //$('#syncRatingsBtn').prop('disabled', false);
                            }
                            else if (SrViewModel.ScheduledJobStatusList()[0].JobRunStatus() === "Not Initiated") {
                                //SrViewModel.SyncRatingsButtonDisable(true);
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SyncCalcsFailedMessage') == -1) ? 'Calculations are in progress. Please try to re-run Sync Ratings in some time.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SyncCalcsFailedMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                                $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                                //$('#syncRatingsBtn').prop('disabled', false);
                            }
                            else {
                                //SrViewModel.SyncRatingsButtonDisable(false);
                                if (FirstLoad != true) {
                                    logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SyncCalcsCompletedMessage') == -1) ? 'Sync Ratings have been completed.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SyncCalcsCompletedMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);

                                    if (SrViewModel.DashboardVM.RoutedFrom() === "Dashboard" && !SrViewModel.IsSurveyPending() && !SrViewModel.IsSurveyCompleted() && SrViewModel.ValuesChanged()) {
                                        CheckForDirtyDataTreeVw(SrViewModel.SelectedNode(), event);
                                    }
                                    else {
                                        SrViewModel.isSaveResponseClick(true);
                                        SrViewModel.saveEventId(event.currentTarget.id);
                                        SrViewModel.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                                        if ((SrViewModel.ClickedRiskAreaId() !== -1000 && SrViewModel.ClickedRiskAreaId() !== -998)) {
                                            // refreshing the treeview along with new data load
                                            $('#QualContDynamicHTMLDiv').html("");
                                            $('#DynamicHTMLDiv').html("");
                                            if (SrViewModel.SurveyTypeId() == "QTDR") {
                                                SrViewModel.ClickedRiskArea(data);
                                                if (SrViewModel.SavechangedvalueTab() != null) {
                                                    SrViewModel.ClickedRiskAreaId(SrViewModel.SavechangedvalueTab());
                                                    SrViewModel.ClickedRiskArea(data);
                                                }
                                                SrViewModel.MCILevel(false);
                                                GetQuanColumnDetails().then(function () {
                                                    BindQuantiativeTable();

                                                    InitiateQuantitativeLevelTree();
                                                });
                                            }
                                            else if (SrViewModel.SurveyTypeId() == "QLDR") {
                                                $('#DynamicHTMLDiv').html("");
                                                SrViewModel.ClickedRiskArea(data);
                                                if (SrViewModel.SavechangedvalueTab() != null) {
                                                    SrViewModel.ClickedRiskAreaId(SrViewModel.SavechangedvalueTab());
                                                }
                                                SrViewModel.MCILevel(false);
                                                GetQualColumnDetails().then(function () {
                                                    GetQualResponseDetails();

                                                    InitiateQualitativeLevelTree();
                                                });
                                            }
                                            else {
                                                $('#DynamicHTMLDiv').html("");
                                                SrViewModel.ClickedRiskArea(data);
                                                if (SrViewModel.SavechangedvalueTab() != null) {
                                                    SrViewModel.ClickedRiskAreaId(SrViewModel.SavechangedvalueTab());
                                                }
                                                GetControlColumnDetails().then(function () {
                                                    GetControlResponseData();

                                                    InitiateControlsLevelTree();
                                                });
                                            }
                                        }
                                    }
                                }
                                else
                                    SrViewModel.firstLoad(false);
                            }
                        }
                    }
                    else if (jsonResult == null) {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? 'An error has occurred while fetching the status of the calculations. Please contact your Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                        //$('#syncRatingsBtn').prop('disabled', false);
                    }
                    $('#LoadingGIFSRDiv').modal('hide');
                }).fail(function (jsonResult, error) {
                    $('#LoadingGIFSRDiv').modal('hide');
                    logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? 'An error has occurred while syncing the ratings. Please contact your Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                    //$('#syncRatingsBtn').prop('disabled', false);
                });
            }
            catch (e) {
                $('#LoadingGIFSRDiv').modal('hide');
                var msg = 'Exception: ' + e + ' | Source: SyncRatingsStatus() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SyncRatings() {
            try {
                //SrViewModel.SyncRatingsButtonDisable(true);
                logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalcsInitiatedMessage') == -1) ? 'Sync Ratings have been initiated. Please click refresh button to know the calculation status.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalcsInitiatedMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/SyncRatings",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: SrViewModel.SurveyId(), JobType: "CALCULATION-SR-SYNC", AssessmentProfile: appsecurity.CurrentProfileOfAssessmentId() })
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != null) {
                            if (jsonResult.substring(0, 3) == "INC")
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                    ? jsonResult + " - An error has occurred while syncing the ratings."
                                    : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                        (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                        ? jsonResult + " - " + "Please contact your Administrator."
                                        : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        //SrViewModel.SyncRatingsButtonDisable(false);
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                            ? jsonResult + " - " + "An error has occurred while syncing the ratings."
                            : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                            [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                ? jsonResult + " - " + "Please contact your Administrator."
                                : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        //SrViewModel.SyncRatingsButtonDisable(false);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SyncRatings() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function JobStatusModel(item) {
            try {
                var self = this;
                self.JobId = ko.observable(item.JobId);
                self.JobRunDate = ko.observable(item.JobRunDate);
                self.JobRunBy = ko.observable(item.JobRunBy);
                self.JobType = ko.observable(item.JobType);
                self.JobRunStatus = ko.observable(item.JobStatus);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: JobStatusModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Qualitative - Methods

        function InitiateQualitativeLevelTree() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/GetAllSurveyRiskAreasNLevel",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ "SurveyProfile": SrViewModel.SurveyProfileId(), "AreaType": SrViewModel.SurveyTypeId(), "BusinessUnitId": SrViewModel.BusinessUnitId(), "ParentId": 0 })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateQualitativeLevelTree() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            //Qualitative
            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    if (jsonResult.ErrorID == -99) {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                            ? jsonResult.Incident_Description + " - An error has occured. Please contact your Administrator."
                            : jsonResult.Incident_Description + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                            [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                ? jsonResult.Incident_Description + " - Please contact your Administrator."
                                : jsonResult.Incident_Description + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    }
                    else {
                        //implement js tree logic here
                        SrViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);
                        var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                            return new jsTreeModel(result);
                        });

                        for (var i = 0; i < MappedJsTreeList.length; i++) {
                            if (MappedJsTreeList[i].id === '-1000') {
                                SrViewModel.IsRefreshProfileGlobalFlag(true);
                                break;
                            }
                        }

                        var NewMappedTreeSturcture = filterJsTree(MappedJsTreeList);
                        $('#jsTreeAreaLevel').treeview({
                            data: NewMappedTreeSturcture,
                            onNodeSelected: nodeClickEvent
                        });

                        var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0;
                        SrViewModel.hasChildNodes(hasChildNodes);

                        if (!SrViewModel.isSaveResponseClick()) {
                            $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                        }
                        else {
                            if (SrViewModel.selectedTreeNode() != undefined && SrViewModel.selectedTreeNode().length > 0) {
                                $('#jsTreeAreaLevel').treeview('selectNode', [SrViewModel.selectedTreeNode()[0].nodeId, { silent: true }]);
                                $('#jsTreeAreaLevel').treeview('revealNode', [SrViewModel.selectedTreeNode()[0].nodeId, { silent: true }]);
                            }
                            SrViewModel.isSaveResponseClick(false);
                        }
                        if (!SrViewModel.IsSurveyCompleted() && SrViewModel.AccessFlagSyncRatingsInherent() && SrViewModel.DashboardVM.RoutedFrom().toLowerCase() == 'dashboard' && SrViewModel.firstLoad())
                            SyncRatingsStatus();
                    }
                }
            }
            //Qualitative
            function filterJsTree(TreeStructure) {
                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes != undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }
                        if (item.showLevel == 1)
                            return true;
                        else
                            return false;
                    }
                );
            }
            //Qualitative
            function nodeClickEvent(event, node) {
                if (SrViewModel.DashboardVM.RoutedFrom() === "Dashboard" && !SrViewModel.IsSurveyPending() && !SrViewModel.IsSurveyCompleted() && SrViewModel.ValuesChanged()) {
                    SrViewModel.PreClickedRiskAreaId(SrViewModel.ClickedRiskAreaId());
                    CheckForDirtyDataTreeVw(node, event);
                }
                else {
                    if (node.dead_node == 1) {
                        //select node explicitly in case of recursive calling activity.
                        $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);
                        $('#DynamicHTMLDiv').html("");
                        $('#QualContDynamicHTMLDiv').html("");
                        $('#MCI_DynamicHTML').html("");
                        SrViewModel.ClickedRiskAreaId(parseInt(node.id));
                        SrViewModel.PreClickedRiskAreaId(parseInt(node.id));
                        SrViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());
                        SrViewModel.ClickedRiskAreaCategoryGuidelines(node.categoryGuidelines);
                        SrViewModel.Is_RefreshCopyProfile(node.Is_RefreshProfile);
                        SrViewModel.Is_RefreshEnable(node.Is_RefreshEnable);
                        SrViewModel.Tick_Flag(node.Tick_Flag);
                        SrViewModel.SelectedNode(node);
                        $('#LoadingGIFSRDiv').modal('show');
                        if (node.nodeId === 0 && (parseInt(node.id) === -1000 || parseInt(node.id) === -998)) {
                            SrViewModel.MCILevel(true);
                            GetMCI_LevelDetails();
                        } else {
                            SrViewModel.MCILevel(false);
                            GetQualColumnDetails().then(function () {
                                GetQualResponseDetails();
                            });
                            GetInstructions(SrViewModel.ClickedRiskAreaId());
                            $("#spanExpandAllQuestions").text((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
                            $("#arrowSpanQuestions").addClass("fa-caret-down").removeClass("fa-caret-right");
                        }
                        $(window).scrollTop(0);
                    } else {
                        //recursively opening until the dead_node arrives.
                        if (!(node.state.expanded)) {
                            if (node.nodeId === node.Level - 1)
                                nodeClickEvent(event, node.nodes[0]);
                        }
                        $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                        $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);
                    }
                }
            }
            //Qualitative
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateQualitativeLevelTree() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateQualitativeLevelTree() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }

        function GetQualColumnDetails() {
            try {
                return $.ajax({
                    url: "/api/Survey/GetQualColumnDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult != null) {
                            if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                                logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                            }
                            else {
                                SrViewModel.ColumnDetails([]);
                                var mappedcolumndetails = $.map(jsonResult, function (result) {
                                    return new ColumnDetailsModel(result);
                                })
                                SrViewModel.ColumnDetails(mappedcolumndetails);
                            }
                        }
                    })
                    .fail(function (fail, error) {
                        var msg = 'Exception: ' + fail.statusText + ' | Source: GetQualColumnDetails() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQualColumnDetails() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function GetQualResponseDetails() {
            try {
                SrViewModel.BreadCrumbArray([]);
                $('#LoadingGIFSRDiv').modal('show');
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/GetQualitativeResponseData",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: SrViewModel.SurveyId(), AreaId: SrViewModel.ClickedRiskAreaId(), RoleId: SrViewModel.RoleId() })
                })
                    .success(function (JsonResult, Success) {
                        if (JsonResult != null && JsonResult.ErrorId == -99) {
                            $('#LoadingGIFSRDiv').modal('hide');
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                ? JsonResult.ErrorName + " - An error has occured. Please contact your Administrator."
                                : JsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                    (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? JsonResult.ErrorName + " - Please contact your Administrator."
                                    : JsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            if (JsonResult != null && JsonResult.lstAreaLevelModel != undefined) {
                                var mappeedBreadCrums = $.map(JsonResult.lstAreaLevelModel, function (result) {
                                    return new BreadCrumbsModel(result);
                                })
                                SrViewModel.BreadCrumbArray(mappeedBreadCrums);
                            }
                            if (JsonResult != null && undefined != JsonResult.QualResponseModel) {
                                SrViewModel.QualResponseListData([]);
                                //have to write the dynamic html logic
                                var mappedResponseList = $.map(JsonResult.QualResponseModel, function (result) {
                                    return new QualResponseModel(result);
                                })
                                SrViewModel.QualResponseListData(mappedResponseList);
                                SrViewModel.SurveyCompletionPercentage(JsonResult.SurveyTotalCompletionPercentage);
                                SrViewModel.Query('');
                                setSurveyLevelMandatoryList();
                                BindDynamicHtmlQualitative();
                            }
                            //disable all responses if node is readonly
                            if (SrViewModel.Is_RefreshEnable() == false) {
                                for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                                    SrViewModel.QualResponseListData()[i].IsReadOnly(true);
                                }
                            }
                            $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                            //$('#syncRatingsBtn').prop('disabled', false);
                        }
                    })
                    .fail(function (error, fail) {
                        $('#LoadingGIFSRDiv').modal('hide');
                        $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                        //$('#syncRatingsBtn').prop('disabled', false);

                        var msg = 'Exception: ' + error + ' | Source: GetQualResponseDetails() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    });
            }
            catch (e) {
                $('#LoadingGIFSRDiv').modal('hide');
                var msg = 'Exception: ' + e + ' | Source: GetQualResponseDetails() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function DrpDwnRender(option, data) {
            try {
                if (option.innerText != (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SelectKeyowrd') == -1) ? 'Select' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SelectKeyowrd')].Name) {
                    var titleText = data.SelectResposneOptionTitle();
                    ko.applyBindingsToNode(option, { attr: { title: titleText }, 'title': titleText, 'class': "" }, data);
                }
            }
            catch (e) {
            }
        }

        function CheckConditionalQualitative(isCheckforBind) {
            try {
                for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                    if (SrViewModel.QualResponseListData()[i].ParentQuestionId() != 0 && SrViewModel.QualResponseListData()[i].ParentQuestionId() != null) {
                        for (var g = 0; g < SrViewModel.QualResponseListData().length; g++) {
                            if (SrViewModel.QualResponseListData()[g].FactorId() == SrViewModel.QualResponseListData()[i].ParentQuestionId()) {
                                for (var h = 0; h < SrViewModel.QualResponseListData()[g].ResponseList.length; h++) {
                                    var resp = SrViewModel.QualResponseListData()[i].ParentResponseId().split("|");
                                    for (var k = 0; k < resp.length; k++) {
                                        if (resp[k] == SrViewModel.QualResponseListData()[g].ResponseList[h].ResponseValue()) {
                                            SrViewModel.QualResponseListData()[i].IsConditional(0);
                                            break;
                                        }
                                    }

                                    if (SrViewModel.QualResponseListData()[g].ResponseList[h].ResponseOptionType() == 'C') {
                                        if (SrViewModel.QualResponseListData()[g].ResponseList[h].SelectedQualResponse().length == 0) { //No option is selected
                                            SrViewModel.QualResponseListData()[i].IsConditional(1);
                                            SrViewModel.QualResponseListData()[i].BookmarkFlagQuestion(false);
                                            if (!isCheckforBind) { // true for normal binding call and false for checkbox conditional related call
                                                for (var cl = 0; cl < SrViewModel.QualResponseListData()[i].ResponseList.length; cl++) {
                                                    SrViewModel.QualResponseListData()[i].ResponseList[cl].ResponseValue(0);
                                                    SrViewModel.QualResponseListData()[i].ResponseList[cl].BookmarkFlag(false);
                                                    SrViewModel.QualResponseListData()[i].ResponseList[cl].ResponseInputValue("");
                                                    if (SrViewModel.QualResponseListData()[i].ResponseList[cl].ResponseOptionType() == 'C') {
                                                        SrViewModel.QualResponseListData()[i].ResponseList[cl].SelectedQualResponse('');
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            var responsesSelected = SrViewModel.QualResponseListData()[g].ResponseList[h].SelectedQualResponse().map(String);
                                            for (m = 0; m < responsesSelected.length; m++) {
                                                let respParent = SrViewModel.QualResponseListData()[i].ParentResponseId().split("|");
                                                if (respParent.filter(x => !responsesSelected.includes(x)).length == 0) {
                                                    SrViewModel.QualResponseListData()[i].IsConditional(0);
                                                    if (!isCheckforBind) { // true for normal binding call and false for checkbox conditional related call
                                                        // call to construct child RTB type of responses
                                                        for (var rl = 0; rl < SrViewModel.QualResponseListData()[i].ResponseList.length; rl++) {
                                                            if (SrViewModel.QualResponseListData()[i].IsConditional() == 0 && SrViewModel.QualResponseListData()[i].ResponseList[rl].Applicability() == true && SrViewModel.QualResponseListData()[i].ResponseList[rl].ResponseOptionType() === 'R')
                                                                showResponseRichText(SrViewModel.QualResponseListData()[i].QuestionId() + '_' + SrViewModel.QualResponseListData()[i].ResponseList[rl].ResponseId(), SrViewModel.QualResponseListData()[i].ResponseList[rl].ResponseInputValue());
                                                        }
                                                    }
                                                }
                                                else {
                                                    SrViewModel.QualResponseListData()[i].IsConditional(1);
                                                    SrViewModel.QualResponseListData()[i].BookmarkFlagQuestion(false);
                                                    if (!isCheckforBind) { // true for normal binding call and false for checkbox conditional related call
                                                        for (var cl = 0; cl < SrViewModel.QualResponseListData()[i].ResponseList.length; cl++) {
                                                            SrViewModel.QualResponseListData()[i].ResponseList[cl].ResponseValue(0);
                                                            SrViewModel.QualResponseListData()[i].ResponseList[cl].BookmarkFlag(false);
                                                            SrViewModel.QualResponseListData()[i].ResponseList[cl].ResponseInputValue("");
                                                            if (SrViewModel.QualResponseListData()[i].ResponseList[cl].ResponseOptionType() == 'C') {
                                                                SrViewModel.QualResponseListData()[i].ResponseList[cl].SelectedQualResponse('');
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CheckConditionalQualitative() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function BindDynamicHtmlQualitative() {
            try {
                CheckConditionalQualitative(true);

                var QualDynamicHTML = "";
                if (SrViewModel.QualResponseListData().length === 0) {
                    QualDynamicHTML += '<span id="lblNoResponseComment" class="nodatamessage" style="display:block;" data-bind="html: (!$root.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoQuestionsMessage\') == -1) ? \'There are no Questions available\' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoQuestionsMessage\')].Name"></span>';
                }
                else {
                    QualDynamicHTML += '<div id="accordion">';
                    QualDynamicHTML += '<div class="header-card">';

                    for (var ol = 0; ol < SrViewModel.QualResponseListData().length; ol++) {
                        //dead node - last question with no headers
                        if (SrViewModel.QualResponseListData()[ol].IsHeader() === 0 && SrViewModel.QualResponseListData()[ol].hFactorId() === SrViewModel.QualResponseListData()[ol].FactorId()) {
                            QualDynamicHTML += BuildQualQuestionsHTML(ol);
                        }
                        //main headers
                        else if (SrViewModel.QualResponseListData()[ol].IsHeader() === 1 && SrViewModel.QualResponseListData()[ol].hFactorId() === SrViewModel.QualResponseListData()[ol].FactorId()) {
                            QualDynamicHTML += '<div data-bind="if: $root.QualResponseListData()[' + ol + '].IsVisibleforSearch">';
                            QualDynamicHTML += '<div  class="card-header">';
                            QualDynamicHTML += '<span class="cp_assessment">';
                            QualDynamicHTML += '<a id= "accQualHeaderID_' + SrViewModel.QualResponseListData()[ol].FactorId() + '" href= "#accQualHeader_' + SrViewModel.QualResponseListData()[ol].FactorId() + '" data-toggle="collapse" data-parent="#accordion" aria-expanded="true" class="arrow-switch">';
                            QualDynamicHTML += '<i class="fa fa-fw fa-caret-accordion"></i> <span data-bind="html: $root.QualResponseListData()[' + ol + '].QuestionText"></span>';

                            // Headers Sync Ratings Code
                            QualDynamicHTML += '<!-- ko if: ($root.AccessFlagSyncRatingsInherent()) -->'
                            QualDynamicHTML += '<!-- ko if: ($root.QualResponseListData()[' + ol + '].ShowFlag == 1) -->'
                            QualDynamicHTML += '<span class="threshold-cell hsync-rat" data-bind="html: $root.QualResponseListData()[' + ol + '].ScoreDescription, css: $root.QualResponseListData()[' + ol + '].ScoreCSS, attr: {' + 'title: $root.QualResponseListData()[' + ol + '].Score}"></span>';
                            QualDynamicHTML += '<!-- /ko  -->'
                            QualDynamicHTML += '<!-- /ko  -->'

                            QualDynamicHTML += '</a>';
                            QualDynamicHTML += '</span>';
                            QualDynamicHTML += '</div>';
                            QualDynamicHTML += '</div>';
                        }
                        //sub headers
                        else if (SrViewModel.QualResponseListData()[ol].IsHeader() === 1 && SrViewModel.QualResponseListData()[ol].hFactorId() !== SrViewModel.QualResponseListData()[ol].FactorId()) {
                            if (SrViewModel.QualResponseListData()[ol].hFactorId() === SrViewModel.QualResponseListData()[ol - 1].FactorId()) {
                                QualDynamicHTML += '<div class="collapse show pl-header" id="accQualHeader_' + SrViewModel.QualResponseListData()[ol].hFactorId() + '">';
                            }
                            QualDynamicHTML += '<div data-bind="if: $root.QualResponseListData()[' + ol + '].IsVisibleforSearch">';
                            QualDynamicHTML += '<div  class="card-header">';
                            QualDynamicHTML += '<span class="cp_assessment">';
                            QualDynamicHTML += '<a id= "accQualHeaderID_' + SrViewModel.QualResponseListData()[ol].FactorId() + '" href= "#accQualHeader_' + SrViewModel.QualResponseListData()[ol].FactorId() + '" data-toggle="collapse" data-parent="#accordion" aria-expanded="true" class="arrow-switch">';
                            QualDynamicHTML += '<i class="fa fa-fw fa-caret-accordion"></i> <span data-bind="html: $root.QualResponseListData()[' + ol + '].QuestionText"></span>';

                            // Sub-Headers Sync Ratings Code
                            QualDynamicHTML += '<!-- ko if: ($root.AccessFlagSyncRatingsInherent()) -->';
                            QualDynamicHTML += '<!-- ko if: ($root.QualResponseListData()[' + ol + '].ShowFlag == 1) -->'
                            QualDynamicHTML += '<span class="threshold-cell hsync-rat" data-bind="html: $root.QualResponseListData()[' + ol + '].ScoreDescription, css: $root.QualResponseListData()[' + ol + '].ScoreCSS, attr: {' + 'title: $root.QualResponseListData()[' + ol + '].Score}"></span>';
                            QualDynamicHTML += '<!-- /ko -->';
                            QualDynamicHTML += '<!-- /ko -->';

                            QualDynamicHTML += '</a>';
                            QualDynamicHTML += '</span>';
                            QualDynamicHTML += '</div>';
                            QualDynamicHTML += '</div>';

                            //logic to close divs if no child questions exists
                            var childCheck = ko.utils.arrayFilter(SrViewModel.QualResponseListData(), function (arr) {
                                if (arr.hFactorId() === SrViewModel.QualResponseListData()[ol].FactorId())
                                    return arr;
                            });

                            if (childCheck.length === 0) {
                                QualDynamicHTML += '</div>';
                                // loop to add div close tags
                                var headerIdVar_sh = SrViewModel.QualResponseListData()[ol].hFactorId();
                                subHeaderGoto:
                                for (var sh = 0; sh < SrViewModel.QualResponseListData().length; sh++) {
                                    if (SrViewModel.QualResponseListData()[sh].IsHeader() === 1 && SrViewModel.QualResponseListData()[sh].FactorId() === headerIdVar_sh && SrViewModel.QualResponseListData()[sh].FactorId() !== SrViewModel.QualResponseListData()[sh].hFactorId()) {
                                        QualDynamicHTML += '</div>';
                                        headerIdVar_sh = SrViewModel.QualResponseListData()[sh].hFactorId();
                                        sh = -1;
                                        continue subHeaderGoto;
                                    }
                                }
                            }
                        }
                        //dead node - last question with headers
                        else if (SrViewModel.QualResponseListData()[ol].IsHeader() === 0 && SrViewModel.QualResponseListData()[ol].hFactorId() !== SrViewModel.QualResponseListData()[ol].FactorId()) {
                            if (SrViewModel.QualResponseListData()[ol].hFactorId() === SrViewModel.QualResponseListData()[ol - 1].FactorId()) {
                                QualDynamicHTML += '<div class="collapse show" id="accQualHeader_' + SrViewModel.QualResponseListData()[ol].hFactorId() + '">';
                            }
                            QualDynamicHTML += '<div class="question-card">';
                            QualDynamicHTML += BuildQualQuestionsHTML(ol);
                            QualDynamicHTML += '</div>';

                            // assuming the questions are sent in order from backend
                            if ((ol === SrViewModel.QualResponseListData().length - 1) || (ol < SrViewModel.QualResponseListData().length - 1 && SrViewModel.QualResponseListData()[ol].hFactorId() !== SrViewModel.QualResponseListData()[ol + 1].hFactorId())) {
                                QualDynamicHTML += '</div>';  // closing dead/child questions div

                                // header of current question
                                var headerIdVar = SrViewModel.QualResponseListData()[ol].hFactorId();

                                // header of current question's header
                                for (var dq = 0; dq < SrViewModel.QualResponseListData().length; dq++) {
                                    if (SrViewModel.QualResponseListData()[dq].IsHeader() === 1 && SrViewModel.QualResponseListData()[dq].FactorId() === headerIdVar) {
                                        headerIdVar = SrViewModel.QualResponseListData()[dq].hFactorId();
                                        break;
                                    }
                                }
                                // logic to loop till hFactoId = FactorId and adding div close tags
                                childQuestionGoto:
                                for (var cq = 0; cq < SrViewModel.QualResponseListData().length; cq++) {
                                    if (SrViewModel.QualResponseListData()[cq].IsHeader() === 1 && SrViewModel.QualResponseListData()[cq].FactorId() === headerIdVar) {
                                        headerIdVar = SrViewModel.QualResponseListData()[cq].hFactorId();
                                        if ((ol === SrViewModel.QualResponseListData().length - 1) || (ol < SrViewModel.QualResponseListData().length - 1 && SrViewModel.QualResponseListData()[ol + 1].hFactorId() !== headerIdVar)) {
                                            QualDynamicHTML += '</div>';
                                            if (SrViewModel.QualResponseListData()[cq].FactorId() !== SrViewModel.QualResponseListData()[cq].hFactorId()) {
                                                cq = -1;
                                                continue childQuestionGoto;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    QualDynamicHTML += '</div>'; //card header - for loop
                    QualDynamicHTML += '</div>'; //accordian close
                }

                $('#QualContDynamicHTMLDiv').html("");
                $('#QualContDynamicHTMLDiv').html(QualDynamicHTML);
                var element = $('#QualContDynamicHTMLDiv')[0];
                ko.cleanNode(element);
                ko.applyBindings(SrViewModel, document.getElementById('QualContDynamicHTMLDiv'));
                $('#QualContDynamicHTMLDiv').show();
                $('#TabDataDiv').show();
                $('#RfTabResponse').show();
                $('#DynamicHTMLDiv').show();
                $('#MCI_DynamicHTML').html("");
                $('#LoadingGIFSRDiv').modal('hide');

                //rich text box and collapse button show/hide
                var showCollapseQBtn = 0;
                for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                    if (SrViewModel.QualResponseListData()[i].IsHeader() == 1) {
                        showCollapseQBtn++;
                    }
                    if (SrViewModel.QualResponseListData()[i].ResponseList != undefined) {
                        for (var k = 0; k < SrViewModel.QualResponseListData()[i].ResponseList.length; k++) {
                            if (SrViewModel.QualResponseListData()[i].IsConditional() == 0 && SrViewModel.QualResponseListData()[i].ResponseList[k].Applicability() == true && SrViewModel.QualResponseListData()[i].ResponseList[k].ResponseOptionType() === 'R')
                                showResponseRichText(SrViewModel.QualResponseListData()[i].QuestionId() + '_' + SrViewModel.QualResponseListData()[i].ResponseList[k].ResponseId(), SrViewModel.QualResponseListData()[i].ResponseList[k].ResponseInputValue());
                        }
                    }
                }
                if (showCollapseQBtn > 0) {
                    SrViewModel.hasHeaderQuestions(true);
                    $('#QualContDynamicHTMLDiv').removeClass("mt-2");
                }
                else {
                    SrViewModel.hasHeaderQuestions(false);
                    $('#QualContDynamicHTMLDiv').addClass("mt-2");
                }
            }
            catch (e) {
                $('#LoadingGIFSRDiv').modal('hide');
                var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlQualitative() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function BuildQualQuestionsHTML(countVar) {
            try {
                var qualQuestionBox = "";
                var data = '$root.QualResponseListData()[' + countVar + ']';

                qualQuestionBox += '<div id= "question-Section_' + SrViewModel.QualResponseListData()[countVar].QuestionId() + '" class="card">'; //question_section div open
                qualQuestionBox += '<div data-bind="if: $root.QualResponseListData()[' + countVar + '].IsVisibleforSearch">';  // IsVisibleforSearch div open
                qualQuestionBox += '<div class="card-body">';  // card-body div open

                qualQuestionBox += '<div class="pl-4 row" data-bind="visible: $root.QualResponseListData()[' + countVar + '].IsHeader() == 0">'; // responses div open
                var qlistCount = 0;
                for (var i = 0; i < SrViewModel.ColumnDetails().length; i++) {
                    var QQRespList = SrViewModel.QualResponseListData()[countVar].ResponseList[i];
                    if (QQRespList != undefined && QQRespList.Applicability() == true) {
                        var ID = '$root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].SelectedOptionsList()';
                        var valueId = '$root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].ResponseValue';
                        var UniqueID = '$root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].UniqueID()';
                        var ValueInputId = '$root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].ResponseInputValue';
                        var MultiPreselectedValue = '$root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].SelectedQualResponse';

                        var IsReadOnly = '$root.QualResponseListData()[' + countVar + '].IsReadOnly()';
                        var IsConditional = '$root.QualResponseListData()[' + countVar + '].IsConditional()';
                        var IsHeader = '$root.QualResponseListData()[' + countVar + '].IsHeader()';
                        var IsParentQuestion = '$root.QualResponseListData()[' + countVar + '].IsParentQuestion()';
                        var QuestionId = '$root.QualResponseListData()[' + countVar + '].QuestionId()';
                        var QuestionIdVM = SrViewModel.QualResponseListData()[countVar].QuestionId();

                        if (qlistCount == 0) {
                            qualQuestionBox += '<div class="col-md-11 pr-0">';
                            qualQuestionBox += '<sup><i class="text-danger fa fa-asterisk mr-2 font-xsmall" data-bind="visible: $root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].Is_ResponseMandatory_RT() && $root.QualResponseListData()[' + countVar + '].IsSaveClicked_Response() && $root.QualResponseListData()[' + countVar + '].IsConditional() == 0 && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup>';
                            qualQuestionBox += '<span class="card-title question-text" data-bind="html: $root.QualResponseListData()[' + countVar + '].QuestionsList()[' + qlistCount + ']"></span>';
                            qualQuestionBox += '</div>';
                            qualQuestionBox += '<div class="col-md-1"><label for="bmFlag_' + QuestionIdVM + '" class="pull-right" data-bind="visible: $root.ShowBookmarkFlags(), event: {change: function(data,event) {$root.BookmarkFlagChangeEvent(' + data + ', event)} }"> <input id="bmFlag_' + QuestionIdVM + '" type="checkbox" class="flagbox" data-bind="checked: $root.QualResponseListData()[' + countVar + '].BookmarkFlagQuestion, disable: ' + IsReadOnly + ' == 1 || ' + IsConditional + ' == 1 || $root.DisableControl() || !$root.appsecurity.WriteAccess()"><span class="flag"><i class="fa fa-flag"></i></span></label></div>';
                        }
                        else {
                            qualQuestionBox += '<div class="col-md-11 pr-0">';
                            qualQuestionBox += '<sup><i class="text-danger fa fa-asterisk mr-2 font-xsmall" data-bind="visible: $root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].Is_ResponseMandatory_RT() && $root.QualResponseListData()[' + countVar + '].IsSaveClicked_Response() && $root.QualResponseListData()[' + countVar + '].IsConditional() == 0 && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup>';
                            qualQuestionBox += '<span class="card-title question-text" data-bind="html: $root.QualResponseListData()[' + countVar + '].QuestionsList()[' + qlistCount + ']"></span>';
                            qualQuestionBox += '</div>';
                        }
                        qlistCount++;

                        // responses div col-11 start
                        if (qlistCount == 0) {
                            qualQuestionBox += '<div class="col-md-11 pr-0 mt-1">';
                        }

                        else {
                            qualQuestionBox += '<div class="col-md-11 pr-0 mt-2">';
                        }

                        if (SrViewModel.ColumnDetails().length > 1) {
                            var columnName = '';
                            ko.utils.arrayFilter(SrViewModel.ColumnDetails(), function (arr) {
                                if (arr.ColumnId() === QQRespList.ResponseId()) {
                                    columnName = $('<div/>').html(arr.ColumnName()).text();
                                }
                            });
                            qualQuestionBox += '<h6 class="card-subtitle text-muted mb-1">' + columnName + '</h6>';
                        }

                        // this block of code should be removed after implementing set functionality of all response-option types
                        if (QQRespList.ResponseOptionType() == '-') {
                            if (QQRespList.SelectedOptionsList().length > 0) {
                                qualQuestionBox += '<select class="form-control" data-bind="options:' + ID + ', value: ' + valueId + ',optionsCaption:\'Select\',optionsText :\'SelectResposneOption\',optionsValue:\'SelectResponseId\', optionsAfterRender: $root.DrpDwnRender,disable: ' + IsConditional + '==1 || ' + IsReadOnly + '==1 || $root.DisableControl()  || !$root.appsecurity.WriteAccess(),event: {change: ' + IsParentQuestion + '== 1 ? function(data,event) {$root.ConditionQuestionchangeQual(' + data + ', event, ' + QuestionId + ')} :  function(data,event) {$root.ValuesChangeEvent(' + data + ', event, ' + QuestionId + ')}  },attr:{\'id\':' + UniqueID + ' }"></select>';
                            }

                            else if (QQRespList.SelectedOptionsList().length === 0) {
                                qualQuestionBox += '<input class="form-control" type="text" data-bind="attr:{placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\') == -1 )? \'Type Response\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\')].Name}, value:' + ValueInputId + ',disable: ' + IsConditional + '==1 || ' + IsReadOnly + '==1 || $root.DisableControl()  || !$root.appsecurity.WriteAccess(), event: {change: function(data,event) {$root.ValuesChangeEvent(' + data + ', event, ' + QuestionId + ')}  }"></input>';
                            }
                        }
                        // this block of code should be removed after implementing set functionality of all response-option types

                        // For OptionType - Single Dropdown
                        else if (QQRespList.ResponseOptionType() == 'D') {
                            qualQuestionBox += '<select class="form-control" data-bind="options:' + ID + ', value: ' + valueId + ',optionsCaption:\'Select\',optionsText :\'SelectResposneOption\',optionsValue:\'SelectResponseId\', optionsAfterRender: $root.DrpDwnRender,disable:' + IsConditional + '==1 || ' + IsReadOnly + '==1 || $root.DisableControl()  || !$root.appsecurity.WriteAccess(),event: {change: ' + IsParentQuestion + '== 1 ? function(data,event) {$root.ConditionQuestionchangeQual(' + data + ', event, ' + QuestionId + ')} :  function(data,event) {$root.ValuesChangeEvent(' + data + ', event, ' + QuestionId + ')}  },attr:{\'id\':' + UniqueID + ' }"></select>';
                        }

                        // For OptionType - Multiple Checkbox
                        else if (QQRespList.ResponseOptionType() == 'C') {
                            qualQuestionBox += '<div>';
                            qualQuestionBox += '<!--ko foreach: ' + ID + ' -->';
                            qualQuestionBox += '<div class="control-label">';
                            qualQuestionBox += '<input type="checkbox" data-bind="attr:{\'id\':' + UniqueID + ' }, checkedValue: SelectResponseId, checked: ' + MultiPreselectedValue + ', disable: ' + IsConditional + '==1 || ' + IsReadOnly + '== 1 || $root.DisableControl()  || !$root.appsecurity.WriteAccess(), event: {change: function(data,event) { $root.MultiselectResponsechangeQual(' + data + ', event, ' + QuestionId + ')} }">';
                            qualQuestionBox += '<span data-bind="html: SelectResposneOption"></span>';
                            qualQuestionBox += '</div>';
                            qualQuestionBox += '<!--/ko-->';
                            qualQuestionBox += '</div>';
                        }

                        // For OptionType - Radio Buttons
                        else if (QQRespList.ResponseOptionType() == 'B') {
                            qualQuestionBox += '<div>';
                            qualQuestionBox += '<!--ko foreach: ' + ID + ' -->';
                            qualQuestionBox += '<div class="control-label">';
                            qualQuestionBox += '<input type="radio" data-bind="attr:{\'id\':' + UniqueID + ' }, checkedValue: SelectResponseId, checked: $root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].ResponseValue, disable:  ' + IsConditional + '==1 || ' + IsReadOnly + '== 1 || $root.DisableControl()  || !$root.appsecurity.WriteAccess(),  event: {change: ' + IsParentQuestion + '== 1 ? function(data,event) {$root.ConditionQuestionchangeQual(' + data + ', event, ' + QuestionId + ')} :  function(data,event) {$root.ValuesChangeEvent(' + data + ', event, ' + QuestionId + ')} } ">';
                            qualQuestionBox += '<span data-bind="html: SelectResposneOption"></span>';
                            qualQuestionBox += '</div>';
                            qualQuestionBox += '<!--/ko-->';
                            qualQuestionBox += '</div>';
                        }

                        // For OptionType - Horizontal Radio Buttons
                        else if (QQRespList.ResponseOptionType() == 'HB') {
                            qualQuestionBox += '<div>';
                            for (var hb = 0; hb < SrViewModel.QualResponseListData()[countVar].ResponseList[i].SelectedOptionsList().length; hb++) {
                                var SelectResponseId = '$root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].SelectedOptionsList()[' + hb + '].SelectResponseId';
                                var SelectResposneOption = '$root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].SelectedOptionsList()[' + hb + '].SelectResposneOption';
                                var ResponseValue = '$root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].ResponseValue';
                                if (hb % 2 === 0) {
                                    qualQuestionBox += '<div class="col-12 nd-flex pl-0 pr-0">';
                                }
                                qualQuestionBox += '<div class="control-label col-6 pl-0 pr-0">';
                                qualQuestionBox += '<input type="radio" data-bind="attr:{\'id\':' + UniqueID + ' }, checkedValue: ' + SelectResponseId + ', checked: ' + ResponseValue + ', disable:  ' + IsConditional + '==1 || ' + IsReadOnly + '== 1 || $root.DisableControl()  || !$root.appsecurity.WriteAccess(),  event: {change:' + IsParentQuestion + '== 1 ? function(data,event) {$root.ConditionQuestionchangeQual(' + data + ', event, ' + QuestionId + ')} :  function(data,event) {$root.ValuesChangeEvent(' + data + ', event, ' + QuestionId + ')}} ">';
                                qualQuestionBox += '<span data-bind="html: ' + SelectResposneOption + '"></span>';
                                qualQuestionBox += '</div>';
                                if (hb % 2 === 1 || hb === SrViewModel.QualResponseListData()[countVar].ResponseList[i].SelectedOptionsList().length - 1) {
                                    qualQuestionBox += '</div>';
                                }
                            }
                            qualQuestionBox += '</div>';
                        }

                        // For OptionType - Text Box
                        else if (QQRespList.ResponseOptionType() == 'T') {
                            qualQuestionBox += '<input class="form-control" type="text" data-bind="attr:{placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\') == -1 )? \'Type Response\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\')].Name}, value:' + ValueInputId + ',disable:' + IsConditional + ' == 1 || ' + IsReadOnly + '==1 || $root.DisableControl()  || !$root.appsecurity.WriteAccess(), event: {change: function(data,event) {$root.ValuesChangeEvent(' + data + ', event, ' + QuestionId + ')}  }"></input>';
                        }

                        // For OptionType - Rich Text Box
                        else if (QQRespList.ResponseOptionType() == 'R') {
                            qualQuestionBox += '<!-- ko if: (' + IsConditional + ' == 1 || ' + IsReadOnly + '== 1 || $root.DisableControl()  || !$root.appsecurity.WriteAccess())-->';
                            qualQuestionBox += '<div class="card-body commentSubBox rtb-disabled" data-bind="html:' + ValueInputId + '"></div>';
                            qualQuestionBox += '<!--/ko-->';
                            qualQuestionBox += '<!-- ko if: (' + IsConditional + ' == 0 && ' + IsReadOnly + ' == 0) && (!$root.DisableControl()  || $root.appsecurity.WriteAccess())-->';
                            qualQuestionBox += '<textarea id="ResponseType_' + QuestionIdVM + '_' + QQRespList.ResponseId() + '" data-bind="attr:{placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\') == -1 )? \'Type Response\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\')].Name}, html: ' + ValueInputId + '" class="form-control w-100"></textarea>';
                            qualQuestionBox += '<!--/ko-->';
                        }
                        qualQuestionBox += '</div>';
                        // responses div col-11 end

                        // Response Level - Sync Ratings code start
                        qualQuestionBox += '<!-- ko if: ($root.AccessFlagSyncRatingsInherent()) -->';
                        qualQuestionBox += '<!-- ko if: ($root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].ShowFlag == 1) -->'
                        qualQuestionBox += '<div class="col-md-1"><div class="threshold-cell rsync-rat" data-bind="html: $root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].ScoreDescription, css: $root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].ScoreCSS, attr: {' + 'title: $root.QualResponseListData()[' + countVar + '].ResponseList[' + i + '].Score}"></div>';
                        qualQuestionBox += '</div>';
                        qualQuestionBox += '<!-- /ko -->';
                        qualQuestionBox += '<!-- /ko -->';
                        // Response Level - Sync Ratings code end

                        var iInc = i + 1;
                        if (iInc < SrViewModel.ColumnDetails().length && SrViewModel.QualResponseListData()[countVar].ResponseList[iInc] != undefined && SrViewModel.QualResponseListData()[countVar].ResponseList[iInc].Applicability() == true)
                            qualQuestionBox += '<div style="margin-top:10vh;"></div>';
                    }
                }

                qualQuestionBox += '</div>'; // responses div close
                qualQuestionBox += '</div>'; // card-body div close

                qualQuestionBox += '<div data-bind="visible: ' + IsHeader + ' == 0">'; // menu items div open
                qualQuestionBox += '<ul class="float-right nav nav-tabs">';
                qualQuestionBox += '<li class="nav-item">';
                qualQuestionBox += '<a class="nav-link" data-bind="attr:{ id: \'cmt_Q_Id' + QuestionIdVM + '\', href: $root.QualResponseListData()[' + countVar + '].cmt_hrefId() }, click:function(data, event) {$root.ShowExtraContent($root.QualResponseListData()[' + countVar + '].cmtId(),' + data + ', ' + QuestionId + ')}">';
                qualQuestionBox += '<i class="demo-icon icon-commenting_special"></i>';
                qualQuestionBox += '<span data-bind="if: $root.QualResponseListData()[' + countVar + '].CommentCount() > 0">';
                qualQuestionBox += '<span class="qqount" data-bind="text:$root.QualResponseListData()[' + countVar + '].CommentCount">0</span>';
                qualQuestionBox += '</span>';
                qualQuestionBox += '<span data-bind="visible: $root.QualResponseListData()[' + countVar + '].IsSaveClicked_Comment() && ' + IsConditional + ' == 0 && $root.Is_RefreshEnable() && !($root.Tick_Flag())">';
                qualQuestionBox += '<sup><i class="text-danger fa fa-asterisk font-xxsmall"></i></sup>';
                qualQuestionBox += '</span>';
                qualQuestionBox += '<span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\') == -1) ? \'Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\')].Name"></span></a></li>';
                qualQuestionBox += '<li class="nav-item">';
                qualQuestionBox += '<a class="nav-link" data-bind="attr:{ id: \'atch_Q_Id' + QuestionIdVM + '\', href: $root.QualResponseListData()[' + countVar + '].attachment_hrefId() }, click:function(data, event) {$root.ShowExtraContent($root.QualResponseListData()[' + countVar + '].attachmentId(),' + data + ', ' + QuestionId + ')}">';
                qualQuestionBox += '<i class="demo-icon icon-paperclip_special"></i>';
                qualQuestionBox += '<span data-bind="if: $root.QualResponseListData()[' + countVar + '].DocumentCount() > 0">';
                qualQuestionBox += '<span class="qqount" data-bind="text:$root.QualResponseListData()[' + countVar + '].DocumentCount">0</span>';
                qualQuestionBox += '</span>';
                qualQuestionBox += '<span data-bind="visible: $root.QualResponseListData()[' + countVar + '].IsSaveClicked_Document() && ' + IsConditional + ' == 0 && $root.Is_RefreshEnable() && !($root.Tick_Flag())"">';
                qualQuestionBox += '<sup><i class="text-danger fa fa-asterisk font-xxsmall"></i></sup>';
                qualQuestionBox += '</span>';
                qualQuestionBox += '<span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Attachments\') == -1) ? \'Attachments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Attachments\')].Name"></span></a></li>';
                qualQuestionBox += '<li class="nav-item">';
                qualQuestionBox += '<a class="nav-link" data-bind="attr:{ id: \'hist_Q_Id' + QuestionIdVM + '\', href: $root.QualResponseListData()[' + countVar + '].hist_hrefId() }, click:function(data, event) {$root.ShowExtraContent($root.QualResponseListData()[' + countVar + '].histId(),' + data + ', ' + QuestionId + ')}">';
                qualQuestionBox += '<i class="demo-icon icon-backup_special"></i><span data-bind="html: ((!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoryHeading\') == -1) ? \'History\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoryHeading\')].Name)"></span></a>';
                qualQuestionBox += '</li>';
                qualQuestionBox += '<li class="nav-item">';
                qualQuestionBox += '<a class="nav-link" data-bind="attr:{ id: \'gui_Q_Id' + QuestionIdVM + '\', href: $root.QualResponseListData()[' + countVar + '].guideline_hrefId() }, click:function(data, event) {$root.ShowExtraContent($root.QualResponseListData()[' + countVar + '].guidelineId(),' + data + ', ' + QuestionId + ')}">';
                qualQuestionBox += '<i class="demo-icon icon-document_1_special"></i><span data-bind="html: ((!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesHeading\') == -1) ? \'Guidelines\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesHeading\')].Name)"></span></a>';
                qualQuestionBox += '</li>';
                qualQuestionBox += '</ul>';
                qualQuestionBox += '</div>'; // menu items div close

                ///comments box open
                qualQuestionBox += '<div  id="' + SrViewModel.QualResponseListData()[countVar].cmtId() + '" class="actions-box col-lg-12 p-0" style="display:none;">'; // comments box div open
                qualQuestionBox += '<div class="title"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\') == -1) ? \'Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\')].Name"></span> <button type="button" class="btn float-right" data-bind="click: function(data, event) { $root.HideExtraContent(' + QuestionId + ') }"><span><i class="demo-icon icon-cross_special"></i></span></button></div>';
                qualQuestionBox += '<div class="card-body">'; // card body inside comments div open
                qualQuestionBox += '<div data-bind="if: ' + IsReadOnly + '==0 && ' + IsConditional + ' == 0 && ($root.DisableControl() == false || $root.appsecurity.WriteAccess())">'; // conditions binding div open
                qualQuestionBox += '<h6 class="card-title" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AddCommentHeading\') == -1) ? \'Add Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AddCommentHeading\')].Name"></h6>';
                qualQuestionBox += '<div class="col-lg-4 pl-0 pb-1">'; // inner comments div open
                qualQuestionBox += '<select class="form-control h-auto" name="ApplicableQual" id="ResponseId' + QuestionIdVM + '" data-bind="options: $root.QualResponseListData()[' + countVar + '].QualColumnsList, optionsText: \'ColumnName\', optionsValue: \'ColumnId\'"></select>';
                qualQuestionBox += '</div>'; // inner comments div close
                qualQuestionBox += '<div class="chars-left"> <span class="chars-left-lbl mr-1" data-bind="text: $root.RemainingChars()"></span><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'RemainingCharactersleft\') == -1) ? \'Characters left\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'RemainingCharactersleft\')].Name"></span></div>';
                qualQuestionBox += '<textarea id="ResponseTextArea_' + QuestionIdVM + '" data-bind="event: {keydown: $root.OcKeypress, keyup: $root.OcKeyUp}, attr:{placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EnterCommentsPlaceholder\') == -1 )? \'Your Comments\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EnterCommentsPlaceholder\')].Name}" rows="6" class="w-100"></textarea>';
                qualQuestionBox += '<span class="field-validation-error" id="lblRCError_' + QuestionIdVM + '"></span>';
                qualQuestionBox += '</div>'; // conditions binding div close

                qualQuestionBox += '<div>';  // comments secondary div open
                qualQuestionBox += '<div data-bind="if: ' + IsReadOnly + '==0 && ' + IsConditional + '== 0 && ($root.DisableControl() == false || $root.appsecurity.WriteAccess())">';
                qualQuestionBox += '<button class="primary-btn" type="submit" data-bind="html: $root.SaveCommentButtonName(), click:function(data, event) { $root.SaveComment(' + QuestionId + ',' + data + ', event)}, disable: ' + IsConditional + ' == 1 || ' + IsReadOnly + ' == 1 || $root.DisableControl() || !$root.appsecurity.WriteAccess()"></button>';
                qualQuestionBox += '<button class="secondary-btn ml-2" type="submit" data-bind="html:(!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'CancelButton\') == -1) ? \'Cancel\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'CancelButton\')].Name, click:function(data, event) { $root.CancelComment(' + QuestionId + ',' + data + ', event)}, disable: ' + IsConditional + ' == 1 || ' + IsReadOnly + ' == 1 || $root.DisableControl() || !$root.appsecurity.WriteAccess()"></button>';
                qualQuestionBox += '</div>';
                //sub-nav list - comments open
                qualQuestionBox += '<div class="hactions">';
                qualQuestionBox += '<ul class="float-right nav nav-tabs" style="margin-top: -1.4rem !important;">';
                qualQuestionBox += '<li class="nav-item">';
                qualQuestionBox += '<a class="nav-link" data-bind="attr:{ href: \'#cmt_Sub_hrefId' + QuestionIdVM + '\', id: \'cmt_Sub_Id' + QuestionIdVM + '\'}, click:function(data, event) { $root.ShowExtraSubContent(' + QuestionId + ', \'cmt_Sub_hrefId' + QuestionIdVM + '\', \'cmt\')}">';
                qualQuestionBox += '<i class="demo-icon icon-commenting_special"></i>';
                qualQuestionBox += '<span data-bind="if: $root.QualResponseListData()[' + countVar + '].CommentCount() > 0">';
                qualQuestionBox += '<span class="qqount" data-bind="text:$root.QualResponseListData()[' + countVar + '].CommentCount">0</span>';
                qualQuestionBox += '</span>';
                qualQuestionBox += '<span data-bind=" html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\') == -1) ? \'Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\')].Name"></span></a></li>';
                qualQuestionBox += '</li>';
                qualQuestionBox += '<li class="nav-item">';
                qualQuestionBox += '<a class="nav-link" data-bind="attr:{ href: \'#cmt_Sub_Hist_hrefId' + QuestionIdVM + '\', id: \'cmt_Sub_Hist_Id' + QuestionIdVM + '\'}, click:function(data, event) { $root.ShowExtraSubContent(' + QuestionId + ', \'cmt_Sub_Hist_hrefId' + QuestionIdVM + '\', \'hist\')}">';
                qualQuestionBox += '<i class="demo-icon icon-backup_special"></i><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoricalCommentsHeading\') == -1) ? \'Historical Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoricalCommentsHeading\')].Name"></span></a>';
                qualQuestionBox += '</li>';
                qualQuestionBox += '</ul>';
                qualQuestionBox += '</div>';
                //sub-nav list - comments close

                //sub-comments box - comments open
                qualQuestionBox += '<div id="cmt_Sub_hrefId' + QuestionIdVM + '" class="commentSubBox" style="display:none;">';
                qualQuestionBox += '<div class="" id="cmt_List_' + QuestionIdVM + '"></div>';
                qualQuestionBox += '</div>';
                //sub-comments box - comments close
                //sub-comments box - Historical comments open
                qualQuestionBox += '<div id="cmt_Sub_Hist_hrefId' + QuestionIdVM + '" class="commentSubBox" style="display:none;">';
                qualQuestionBox += '<span class="" id="Hist_cmt_List_' + QuestionIdVM + '"></span>';
                qualQuestionBox += '</div>';
                //sub-comments box - Historical comments close

                qualQuestionBox += '</div>';  // comments secondary div close
                qualQuestionBox += '</div>';  // card body inside comments div close
                qualQuestionBox += '</div>'; // comments box div close
                ///comments box close

                ///attahement box open
                qualQuestionBox += '<div id="' + SrViewModel.QualResponseListData()[countVar].attachmentId() + '" class="actions-box col-lg-12 p-0" style="display:none;">'; // attachement box div open
                qualQuestionBox += '<div class="title"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Attachments\') == -1) ? \'Attachments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Attachments\')].Name"></span> <button type="button" class="btn float-right" data-bind="click:function(data, event) { $root.HideExtraContent(' + QuestionId + ') }"><span>';
                qualQuestionBox += '<i class="demo-icon icon-cross_special"></i></span></button></div>';

                qualQuestionBox += '<div data-bind="if: ' + IsReadOnly + '==0 && ' + IsConditional + '== 0 && ($root.DisableControl() == false || $root.appsecurity.WriteAccess())">'; // conditions binding attachements div open
                qualQuestionBox += ' <div class="card-body">'; // card body inside attachements div open
                qualQuestionBox += ' <h6 class="card-title" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadDocumentsHeading\') == -1) ? \'Upload Documents\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadDocumentsHeading\')].Name"></h6>';
                qualQuestionBox += ' <div class="col-lg-4 pl-0 pb-1">';
                qualQuestionBox += ' <input type="file" class="form-control" id="FileUploaderForDocuments_' + QuestionIdVM + '" data-bind="disable: ' + IsConditional + ' == 1 || ' + IsReadOnly + ' == 1 || $root.DisableControl() || !$root.appsecurity.WriteAccess()" placeholder="Select File(s)" />';
                qualQuestionBox += ' </div>';
                qualQuestionBox += ' <div class="chars-left"> <span class="chars-left-lbl mr-1" data-bind="text: $root.RemainingChars()"></span><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'RemainingCharactersleft\') == -1) ? \'Characters left\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'RemainingCharactersleft\')].Name"></span></div>';
                qualQuestionBox += ' <textarea class="w-100" id="UploadTextArea_' + QuestionIdVM + '" data-bind="event: {keydown: $root.OcKeypress, keyup: $root.OcKeyUp}, attr:{placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EnterCommentsPlaceholder\') == -1 )? \'Your Comments\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EnterCommentsPlaceholder\')].Name}" rows="6"></textarea>';
                qualQuestionBox += ' <div id="ProgressBarMainDiv_' + QuestionIdVM + '" class="col-md-5" style="display:none">';
                qualQuestionBox += '<div id="ProgressBarDiv" class="progressbar-control">';
                qualQuestionBox += '<span id="ProgressBar" class="item-bar blue" data-bind="style:{width: $root.ProgressPercent}, text: $root.ProgressPercent"></span>';
                qualQuestionBox += '</div>';
                qualQuestionBox += '<p id="lblProgressMsg_' + QuestionIdVM + '" text: $root.ProgressMessage"></p>';
                qualQuestionBox += '</div>';
                qualQuestionBox += '<div class="col-lg-12 field-validation-error" id="lblRDError_' + QuestionIdVM + '"></div>';

                qualQuestionBox += ' <button class="secondary-btn" type="submit" data-bind="attr: {title: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadDocumentPlacholder\') == -1 )? \'Upload Document\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadDocumentPlacholder\')].Name}, click:function(data, event) { $root.UploadDocument(' + data + ')}, disable: ' + IsConditional + ' == 1 || ' + IsReadOnly + ' == 1 || $root.DisableControl() || !$root.appsecurity.WriteAccess()">';
                qualQuestionBox += ' <i class="fa fa-upload"></i><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadButton\') == -1) ? \'Upload\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadButton\')].Name"></span></button>';

                qualQuestionBox += ' </div>'; // card body inside attachements div close
                qualQuestionBox += '</div>'; // conditions binding attachements div close

                //subDoccomments
                qualQuestionBox += ' <div class="card-footer text-muted">';
                qualQuestionBox += '<div id="doc_cmt_sec_' + QuestionIdVM + '" }">';
                qualQuestionBox += '<div class="" id="doc_cmt_List_' + QuestionIdVM + '" }"></div>';
                qualQuestionBox += ' </div>';
                qualQuestionBox += ' </div>';
                //subDoccomments
                qualQuestionBox += ' </div>'; // attachement box div close
                ///attachments box close

                //history & guidelines
                qualQuestionBox += '<div data-bind="attr:{ id: $root.QualResponseListData()[' + countVar + '].histId() }" class="card card col-lg-12 p-0" style="display:none;">';
                qualQuestionBox += '<div class="box user-content pt-0 pb-0">';
                qualQuestionBox += '<div class="title"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoryHeading\') == -1) ? \'History\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoryHeading\')].Name"></span><button type="button" class="btn float-right" data-bind="click:function(data, event) { $root.HideExtraContent(' + QuestionId + ') }"><span>';
                qualQuestionBox += '<i class="demo-icon icon-cross_special"></i></span></button></div>';
                qualQuestionBox += '</div>';
                qualQuestionBox += '<div class="card-body text-muted">';
                qualQuestionBox += '<span data-bind="attr:{id: \'htmlHist_\' + $root.QualResponseListData()[' + countVar + '].histId() }"></span>';
                qualQuestionBox += '</div>';
                qualQuestionBox += '</div>';
                qualQuestionBox += '<div data-bind="attr:{ id: $root.QualResponseListData()[' + countVar + '].guidelineId() }" class="card card col-lg-12 p-0" style="display:none;">';
                qualQuestionBox += '<div class="box user-content pt-0 pb-0">';
                qualQuestionBox += '<div class="title"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesHeading\') == -1) ? \'Guidelines\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesHeading\')].Name"></span> <button type="button" class="btn float-right" data-bind="click:function(data, event) { $root.HideExtraContent(' + QuestionId + ') }"><span>';
                qualQuestionBox += '<i class="demo-icon icon-cross_special"></i></span></button></div>';
                qualQuestionBox += '</div>';
                qualQuestionBox += '<div class="card-body">';
                if (SrViewModel.QualResponseListData()[countVar].InfoGuidelineComment() === '')
                    qualQuestionBox += '<span class="nodatamessage" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoGuidelinesMessage\') == -1) ? \'There are no Guidelines available\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoGuidelinesMessage\')].Name"></span>';
                else if (SrViewModel.QualResponseListData()[countVar].InfoGuidelineComment() !== '')
                    qualQuestionBox += '<span>' + SrViewModel.QualResponseListData()[countVar].InfoGuidelineComment() + '</span>';
                qualQuestionBox += '</div>';
                qualQuestionBox += '</div>';
                //history & guidelines

                qualQuestionBox += '</div>'; // IsVisibleforSearch div close
                qualQuestionBox += '</div>'; //question_section div close

                return qualQuestionBox;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BuildQualQuestionsHTML() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ConditionQuestionchangeQual(data, event, questionId) {
            try {
                //var scroll = $(window).scrollTop();
                FillRTBInputValues();
                var element = $('#QualContDynamicHTMLDiv')[0];
                ko.cleanNode(element);
                var selectedvalue = "";

                var columnId = "",
                    splitColumnId = "";
                if (event != undefined) {
                    columnId = event.currentTarget.id;
                }
                if (columnId != undefined && columnId != "") {
                    splitColumnId = columnId.split("_");
                }
                var responseId = "",
                    currentQuestionId = "";
                if (splitColumnId != undefined && splitColumnId.length > 1) {
                    responseId = splitColumnId[1];
                    currentQuestionId = splitColumnId[0];
                }
                if (questionId != undefined && questionId != "") {
                    currentQuestionId = questionId;
                }

                for (var j = 0; j < data.ResponseList.length; j++) {
                    if (parseInt(responseId) == data.ResponseList[j].ResponseId()) {
                        selectedvalue = data.ResponseList[j].ResponseValue()
                        break;
                    }
                }

                SrViewModel.ValuesChanged(true);
                for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                    var splitResponseID = SrViewModel.QualResponseListData()[i].ParentResponseId().split("|");
                    var splitcolumnid = SrViewModel.QualResponseListData()[i].ParentResponseType().split("|");
                    for (var j = 0; j < splitcolumnid.length; j++) {
                        for (var g = 0; g < splitResponseID.length; g++) {
                            //if (SrViewModel.QualResponseListData()[i].ParentQuestionId() == data.QuestionId() && splitcolumnid[j] == columnId) {
                            if (SrViewModel.QualResponseListData()[i].ParentQuestionId() == data.FactorId()) {
                                if (splitResponseID[g] == selectedvalue) {
                                    SrViewModel.QualResponseListData()[i].IsConditional(0);
                                    break;
                                }
                                else {
                                    SrViewModel.QualResponseListData()[i].IsConditional(1);
                                    SrViewModel.QualResponseListData()[i].BookmarkFlagQuestion(false);
                                    for (var h = 0; h < SrViewModel.QualResponseListData()[i].ResponseList.length; h++) {
                                        SrViewModel.QualResponseListData()[i].ResponseList[h].ResponseValue(0);
                                        SrViewModel.QualResponseListData()[i].ResponseList[h].BookmarkFlag(false);
                                        SrViewModel.QualResponseListData()[i].ResponseList[h].ResponseInputValue("");
                                        if (SrViewModel.QualResponseListData()[i].ResponseList[h].ResponseOptionType() == 'C') {
                                            SrViewModel.QualResponseListData()[i].ResponseList[h].SelectedQualResponse('');
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                BindDynamicHtmlQualitative();
                //$(window).scrollTop(scroll);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ConditionQuestionchangeQual() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function MultiselectResponsechangeQual(data, event, questionId) {
            try {
                FillRTBInputValues();
                var columnId = "",
                    splitColumnId = "";
                if (event != undefined) {
                    columnId = event.currentTarget.id;
                }
                if (columnId != undefined && columnId != "") {
                    splitColumnId = columnId.split("_");
                }
                var responseId = "",
                    prevResponseOptionValue = $('#' + columnId).val(),
                    currentQuestionId = "";
                if (splitColumnId != undefined && splitColumnId.length > 1) {
                    responseId = splitColumnId[1];
                    currentQuestionId = splitColumnId[0];
                }

                var SeparateResponse;
                for (var i = 0; i < data.ResponseList.length; i++) {
                    if (data.ResponseList[i].ResponseId().toString() === responseId) {
                        SeparateResponse = data.ResponseList[i].SelectedQualResponse();
                    }
                }
                var updatedResponseId = MakePipeDelimited(SeparateResponse);

                SrViewModel.ValuesChanged(true);

                if (SrViewModel.SurveyTypeId() == 'QLDR') {
                    for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                        if (SrViewModel.QualResponseListData()[i].QuestionId() == currentQuestionId) {
                            for (var j = 0; j < SrViewModel.QualResponseListData()[i].ResponseList.length; j++) {
                                if (SrViewModel.QualResponseListData()[i].ResponseList[j].ResponseId() == responseId) {
                                    SrViewModel.QualResponseListData()[i].ResponseList[j].ResponseInputValue(updatedResponseId);
                                    break;
                                }
                            }
                        }
                    }
                }
                if (data.IsParentQuestion() == 1)
                    CheckConditionalQualitative(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: MultiselectResponsechangeQual() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function QualResponseModel(item) {
            try {
                var self = this;
                self.DisplayRank = ko.observable(item.DisplayRank);
                self.QuestionId = ko.observable(item.QuestionId);
                self.FactorId = ko.observable(item.FactorId);
                self.QuestionText = ko.observable(item.QuestionText);
                self.QuestionTextPlain = ko.observable($('<div/>').html(item.QuestionText).text());
                self.SerialNo = ko.observable(item.SerialNo);
                self.CommentCount = ko.observable(item.CommentCount);
                self.DocumentCount = ko.observable(item.DocumentCount);
                self.ShowQuestionMandatoryFlag = ko.observable(item.ShowQuestionMandatoryFlag);
                self.IsHeader = ko.observable(item.IsHeader);
                self.IsReadOnly = ko.observable(item.IsReadOnly);
                self.IsConditional = ko.observable(item.IsConditional);
                self.ParentQuestionId = ko.observable(item.ParentQuestionId);

                self.hFactorId = ko.observable(item.HeaderFactorId);

                self.cmt_hrefId = ko.observable('#cmt_' + item.QuestionId);
                self.attachment_hrefId = ko.observable('#atch_' + item.QuestionId);
                self.guideline_hrefId = ko.observable('#gui_' + item.QuestionId);
                self.hist_hrefId = ko.observable('#hist_' + item.QuestionId);

                self.cmtId = ko.observable('cmt_' + item.QuestionId);
                self.attachmentId = ko.observable('atch_' + item.QuestionId);
                self.guidelineId = ko.observable('gui_' + item.QuestionId);
                self.histId = ko.observable('hist_' + item.QuestionId);

                self.ParentResponseId = ko.observable(item.ParentResponseId);
                self.ParentResponseType = ko.observable(item.ParentResponseType);
                self.IsParentQuestion = ko.observable(item.IsParentQuestion);
                self.Is_CommentMandatory = ko.observable(item.Is_CommentMandatory);
                self.Is_DocumentMandatory = ko.observable(item.Is_DocumentMandatory);
                self.Is_ResponseMandatory = ko.observable(item.Is_ResponseMandatory);
                self.Has_HistoricalComments = ko.observable(item.Has_HistoricalComments);
                self.Has_HistoricalResponses = ko.observable(item.Has_HistoricalResponses);
                self.Is_MultiselectQuestion = ko.observable(item.Is_MultiselectQuestion);
                self.IsVisibleforSearch = ko.observable(true);
                self.InfoGuidelineComment = ko.observable(item.InfoGuidelineComment);
                self.BarPercentage = ko.observable(item.BarPercentage);
                SrViewModel.Quesitonidtemp(item.QuestionId);

                if (item.Score != undefined)
                    self.Score = item.Score
                else
                    self.Score = "";

                if (item.ScoreDescription != undefined) {
                    self.ScoreDescription = item.ScoreDescription;
                }
                else
                    self.ScoreDescription = "";

                if (item.ScoreCSS != undefined)
                    self.ScoreCSS = item.ScoreCSS;
                else
                    self.ScoreCSS = "";

                self.ShowFlag = item.ShowFlag != undefined ? item.ShowFlag : 0;

                var mappedResposneList = $.map(item.QualResponseObject, function (result) {
                    return ResponseObject = new QualResponseObject(result);
                });
                self.ResponseList = mappedResposneList;

                SrViewModel.BarWidth(item.BarPercentage);
                self.QuesionLevel = ko.observable(item.QuesionLevel);
                self.IsSaveClicked_Response = ko.observable(false);
                self.IsSaveClicked_Comment = ko.observable(false);
                self.IsSaveClicked_Document = ko.observable(false);
                var QuestionsArray = [];
                var QuestionSplit = self.QuestionText().split("<br/>");
                for (var i = 0; i < QuestionSplit.length; i++) {
                    QuestionsArray.push(QuestionSplit[i]);
                }
                self.QuestionsList = ko.observableArray(QuestionsArray);
                self.QualColumnsList = ko.observableArray(item.QualColumnsList);
                self.BookmarkFlagQuestion = ko.observable(item.BookmarkFlagQuestion);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QualResponseModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function QualResponseObject(item) {
            try {
                var self = this;
                self.ResponseId = ko.observable(item.ResponseId);
                self.ResponseValue = ko.observable(parseInt(item.ResponseValue));
                if (item.ResponseOptionType === 'R')
                    self.ResponseInputValue = ko.observable(item.ResponseInputValue);
                else
                    self.ResponseInputValue = ko.observable($('<div/>').html(item.ResponseInputValue).text());

                self.Applicability = ko.observable(item.Applicability);
                self.CommentCount = ko.observable(item.CommentCount);
                self.DocumentCount = ko.observable(item.DocumentCount);
                self.ResponseOptionType = ko.observable(item.ResponseOptionType);
                self.SelectedQualResponse = DecodePipeDelimited(item.ResponseInputValue);
                var mappedResposneList = $.map(item.ModelObject, function (result) {
                    return ResponseObject = new QualResposneSelectObject(result);
                });
                self.SelectedOptionsList = ko.observableArray(mappedResposneList);
                self.UniqueID = ko.observable(SrViewModel.Quesitonidtemp() + '_' + item.ResponseId);
                self.BookmarkFlag = ko.observable(item.BookmarkFlag);
                self.Is_ResponseMandatory_RT = ko.observable(item.Is_ResponseMandatory_RT);
                if (item.Score != undefined)
                    self.Score = item.Score
                else
                    self.Score = "";

                if (item.ScoreDescription != undefined) {
                    self.ScoreDescription = item.ScoreDescription;
                }
                else
                    self.ScoreDescription = "";

                if (item.ScoreCSS != undefined)
                    self.ScoreCSS = item.ScoreCSS;
                else
                    self.ScoreCSS = "";

                self.ShowFlag = item.ShowFlag != undefined ? item.ShowFlag : 0;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QualResponseObject() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function QualResposneSelectObject(item) {
            try {
                var self = this;
                self.SelectResponseId = ko.observable(item.SelectResponseId);
                self.SelectResposneOption = ko.observable($('<div/>').html(item.SelectResposneOption).text());
                self.SelectResposneOptionTitle = ko.observable($('<div/>').html(item.SelectResposneOption).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QualResposneSelectObject() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Controls - Methods

        function InitiateControlsLevelTree() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/ControlArea/GetAllControlAreaSurveyNLevel",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ SurveyProfileId: SrViewModel.SurveyProfileId(), BusinessUnitId: SrViewModel.BusinessUnitId(), ParentId: 0 })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateControlsLevelTree() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            //Controls
            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    if (jsonResult.ErrorID == -99) {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                            ? jsonResult.Incident_Description + " - An error has occured. Please contact your Administrator."
                            : jsonResult.Incident_Description + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                            [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                ? jsonResult.Incident_Description + " - Please contact your Administrator."
                                : jsonResult.Incident_Description + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    }
                    else {
                        //implement js tree logic here //Controls
                        SrViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);
                        var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                            return new jsTreeModel(result);
                        });

                        for (var i = 0; i < MappedJsTreeList.length; i++) {
                            if (MappedJsTreeList[i].id === '-1000') {
                                SrViewModel.IsRefreshProfileGlobalFlag(true);
                                break;
                            }
                        }
                        var NewMappedTreeSturcture = filterJsTree(MappedJsTreeList);

                        $('#jsTreeAreaLevel').treeview({
                            data: NewMappedTreeSturcture,
                            onNodeSelected: nodeClickEvent
                        });

                        var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0;
                        SrViewModel.hasChildNodes(hasChildNodes);

                        if (!SrViewModel.isSaveResponseClick()) {
                            $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                        }
                        else {
                            if (SrViewModel.selectedTreeNode() != undefined && SrViewModel.selectedTreeNode().length > 0) {
                                $('#jsTreeAreaLevel').treeview('selectNode', [SrViewModel.selectedTreeNode()[0].nodeId, { silent: true }]);
                                $('#jsTreeAreaLevel').treeview('revealNode', [SrViewModel.selectedTreeNode()[0].nodeId, { silent: true }]);
                            }
                            SrViewModel.isSaveResponseClick(false);
                        }
                        if (!SrViewModel.IsSurveyCompleted() && SrViewModel.AccessFlagSyncRatingsControls() && SrViewModel.DashboardVM.RoutedFrom().toLowerCase() == 'dashboard' && SrViewModel.firstLoad())
                            SyncRatingsStatus();
                    }
                }
            }
            //Controls
            function filterJsTree(TreeStructure) {
                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes != undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }
                        if (item.showLevel == 1)
                            return true;
                        else
                            return false;
                    }
                );
            }
            //Controls
            function nodeClickEvent(event, node) {
                if (SrViewModel.DashboardVM.RoutedFrom() === "Dashboard" && !SrViewModel.IsSurveyPending() && !SrViewModel.IsSurveyCompleted() && SrViewModel.ValuesChanged()) {
                    SrViewModel.PreClickedRiskAreaId(SrViewModel.ClickedRiskAreaId());
                    CheckForDirtyDataTreeVw(node, event);
                }
                else {
                    if (node.dead_node == 1) {
                        //select node explicitly in case of recursive calling activity.
                        $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);
                        $('#DynamicHTMLDiv').html("");
                        $('#QualContDynamicHTMLDiv').html("");
                        $('#MCI_DynamicHTML').html("");

                        SrViewModel.ClickedRiskAreaId(parseInt(node.id));
                        SrViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());
                        SrViewModel.ClickedRiskAreaCategoryGuidelines(node.categoryGuidelines);

                        SrViewModel.Is_RefreshCopyProfile(node.Is_RefreshProfile);
                        SrViewModel.Is_RefreshEnable(node.Is_RefreshEnable);
                        SrViewModel.Tick_Flag(node.Tick_Flag);
                        SrViewModel.SelectedNode(node);
                        $('#LoadingGIFSRDiv').modal('show');
                        if (node.nodeId === 0 && (parseInt(node.id) === -1000 || parseInt(node.id) === -998)) {
                            SrViewModel.MCILevel(true);
                            GetMCI_LevelDetails();
                        } else {
                            SrViewModel.MCILevel(false);

                            GetControlColumnDetails().then(function () {
                                GetControlResponseData();
                            });
                            GetInstructions(SrViewModel.ClickedRiskAreaId());
                            $("#spanExpandAllQuestions").text((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
                            $("#arrowSpanQuestions").addClass("fa-caret-down").removeClass("fa-caret-right");
                        }
                        $(window).scrollTop(0);
                    } else {
                        //recursively opening until the dead_node arrives.
                        if (!(node.state.expanded)) {
                            if (node.nodeId === node.Level - 1)
                                nodeClickEvent(event, node.nodes[0]);
                        }
                        $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                        $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);
                    }
                }
            }
            //Controls
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateControlsLevelTree() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateControlsLevelTree() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetControlColumnDetails() {
            try {
                return $.ajax({
                    url: "/api/Survey/GetControlsColumnDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { AreaId: SrViewModel.ClickedRiskAreaId() }
                })
                    .success(function (jsonResult, Success) {
                        if (jsonResult != null && jsonResult.length > 0) {
                            if (jsonResult[0].Incident_Description != null && jsonResult[0].Incident_Description.substring(0, 3) == "INC") {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? jsonResult[0].Incident_Description + " - An error occurred. Please contact your Application Administrator."
                                    : jsonResult[0].Incident_Description + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                SrViewModel.ColumnDetails([]);
                                var mappedcolumndetails = $.map(jsonResult, function (result) {
                                    return new ColumnDetailsModel(result);
                                })
                                SrViewModel.ColumnDetails(mappedcolumndetails);
                            }
                        }
                    })
                    .fail(function (fail, error) { });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetControlColumnDetails() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function GetControlResponseData() {
            try {
                $('#LoadingGIFSRDiv').modal('show');

                SrViewModel.BreadCrumbArray([]);
                p = 0;
                var RiskAreaId = SrViewModel.ClickedRiskAreaId();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/GetControlResponseData",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ AreaId: RiskAreaId, Draft: SrViewModel.SurveyId(), RoleId: SrViewModel.RoleId() })
                })
                    .success(function (JsonResult, success) {
                        if (JsonResult != null && JsonResult.ErrorId == -99) {
                            $('#LoadingGIFSRDiv').modal('hide');
                            $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                ? JsonResult.ErrorName + " - An error has occured. Please contact your Administrator."
                                : JsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                    (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? JsonResult.ErrorName + " - Please contact your Administrator."
                                    : JsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            if (JsonResult != null && JsonResult.lstAreaLevelModel != undefined) {
                                var mappeedBreadCrums = $.map(JsonResult.lstAreaLevelModel, function (result) {
                                    return new BreadCrumbsModel(result);
                                })
                                SrViewModel.BreadCrumbArray(mappeedBreadCrums);
                            }
                            if (JsonResult != null && undefined != JsonResult.lstCntrlSurveyResponseModel) {
                                SrViewModel.ControlsResponseData([]);
                                var mappeedControlData = $.map(JsonResult.lstCntrlSurveyResponseModel, function (result) {
                                    return new ControlResponseModel(result);
                                })
                                SrViewModel.ControlsResponseData(mappeedControlData);
                                SrViewModel.SurveyCompletionPercentage(JsonResult.SurveyTotalCompletionPercentage);
                                //disable all responses if node is readonly
                                if (SrViewModel.Is_RefreshEnable() == false) {
                                    for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                                        SrViewModel.ControlsResponseData()[i].IsReadOnly(true);
                                    }
                                }
                                SrViewModel.Query('');
                                setSurveyLevelMandatoryList();
                                BindDynamicHtmlForControls();
                            }

                            $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                            //$('#syncRatingsBtn').prop('disabled', false);
                        }
                    })
                    .fail(function (fail, error) {
                        $('#LoadingGIFSRDiv').modal('hide');
                        $('#loadingImgUser').hide().removeClass("d-inline-flex").addClass("d-none");
                        //$('#syncRatingsBtn').prop('disabled', false);
                        var msg = 'Exception: ' + error + ' | Source: GetControlResponseData() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    });
            }
            catch (e) {
                $('#LoadingGIFSRDiv').modal('hide');
                var msg = 'Exception: ' + e + ' | Source: GetControlResponseData() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function Checkforconditionalquestions(isCheckforBind) {
            try {
                for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                    if (SrViewModel.ControlsResponseData()[i].ParentQuestionId() != 0) {
                        for (var j = 0; j < SrViewModel.ControlsResponseData().length; j++) {
                            if (SrViewModel.ControlsResponseData()[i].ParentQuestionId() == SrViewModel.ControlsResponseData()[j].FactorId()) {
                                for (var g = 0; g < SrViewModel.ControlsResponseData()[j].ResponseList.length; g++) {
                                    var resp = SrViewModel.ControlsResponseData()[i].ParentResponseId().split("|");
                                    for (var k = 0; k < resp.length; k++) {
                                        if (resp[k] != "" && resp[k].length > 0) {
                                            if (resp[k].trim() == SrViewModel.ControlsResponseData()[j].ResponseList[g].Response()) {
                                                SrViewModel.ControlsResponseData()[i].IsConditional(0);
                                                break;
                                            }
                                        }
                                    }
                                    if (SrViewModel.ControlsResponseData()[j].ResponseList[g].ResponseOptionType() == 'C') {
                                        if (SrViewModel.ControlsResponseData()[j].ResponseList[g].SelectedControlResponse().length == 0) { //No option is selected
                                            SrViewModel.ControlsResponseData()[i].IsConditional(1);
                                            SrViewModel.ControlsResponseData()[i].BookmarkFlagQuestion(false);
                                            if (!isCheckforBind) { // true for normal binding call and false for checkbox conditional related call
                                                for (var cl = 0; cl < SrViewModel.ControlsResponseData()[i].ResponseList.length; cl++) {
                                                    SrViewModel.ControlsResponseData()[i].ResponseList[cl].Response(0);
                                                    SrViewModel.ControlsResponseData()[i].ResponseList[cl].BookmarkFlag(false);
                                                    SrViewModel.ControlsResponseData()[i].ResponseList[cl].ResponseInputValue("");
                                                    if (SrViewModel.ControlsResponseData()[i].ResponseList[cl].ResponseOptionType() == 'C') {
                                                        SrViewModel.ControlsResponseData()[i].ResponseList[cl].SelectedControlResponse('');
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            var responsesSelected = SrViewModel.ControlsResponseData()[j].ResponseList[g].SelectedControlResponse().map(String);
                                            for (m = 0; m < responsesSelected.length; m++) {
                                                let respParent = SrViewModel.ControlsResponseData()[i].ParentResponseId().split("|");
                                                if (respParent.filter(x => !responsesSelected.includes(x)).length == 0) {
                                                    SrViewModel.ControlsResponseData()[i].IsConditional(0);
                                                    if (!isCheckforBind) { // true for normal binding call and false for checkbox conditional related call
                                                        // call to construct child RTB type of responses
                                                        for (var rl = 0; rl < SrViewModel.ControlsResponseData()[i].ResponseList.length; rl++) {
                                                            if (SrViewModel.ControlsResponseData()[i].IsConditional() == 0 && SrViewModel.ControlsResponseData()[i].ResponseList[rl].ResponseApplicability() == true && SrViewModel.ControlsResponseData()[i].ResponseList[rl].ResponseOptionType() === 'R')
                                                                showResponseRichText(SrViewModel.ControlsResponseData()[i].QuestionId() + '_' + SrViewModel.ControlsResponseData()[i].ResponseList[rl].ResponseId(), SrViewModel.ControlsResponseData()[i].ResponseList[rl].ResponseInputValue());
                                                        }
                                                    }
                                                }
                                                else {
                                                    SrViewModel.ControlsResponseData()[i].IsConditional(1);
                                                    SrViewModel.ControlsResponseData()[i].BookmarkFlagQuestion(false);
                                                    if (!isCheckforBind) { // true for normal binding call and false for checkbox conditional related call
                                                        for (var cl = 0; cl < SrViewModel.ControlsResponseData()[i].ResponseList.length; cl++) {
                                                            SrViewModel.ControlsResponseData()[i].ResponseList[cl].Response(0);
                                                            SrViewModel.ControlsResponseData()[i].ResponseList[cl].BookmarkFlag(false);
                                                            SrViewModel.ControlsResponseData()[i].ResponseList[cl].ResponseInputValue("");
                                                            if (SrViewModel.ControlsResponseData()[i].ResponseList[cl].ResponseOptionType() == 'C') {
                                                                SrViewModel.ControlsResponseData()[i].ResponseList[cl].SelectedControlResponse('');
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                //$('.Multi_').multiselect({});
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: Checkforconditionalquestions() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function BindDynamicHtmlForControls() {
            try {
                Checkforconditionalquestions(true);

                var ControlsDynamicHTML = "";
                if (SrViewModel.ControlsResponseData().length === 0) {
                    ControlsDynamicHTML += '<span id="lblNoResponseComment" class="nodatamessage" style="display:block; data-bind="html: (!$root.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoQuestionsMessage\') == -1) ? \'There are no Questions available\' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoQuestionsMessage\')].Name"></span>';
                }
                else {
                    ControlsDynamicHTML += '<div id="accordion">';
                    ControlsDynamicHTML += '<div class="header-card">';

                    for (var ol = 0; ol < SrViewModel.ControlsResponseData().length; ol++) {
                        //dead node - last question with no headers
                        if (SrViewModel.ControlsResponseData()[ol].IsHeader() === 0 && SrViewModel.ControlsResponseData()[ol].hFactorId() === SrViewModel.ControlsResponseData()[ol].FactorId()) {
                            ControlsDynamicHTML += BuildControlsQuestionsHTML(ol);
                        }
                        //main headers
                        else if (SrViewModel.ControlsResponseData()[ol].IsHeader() === 1 && SrViewModel.ControlsResponseData()[ol].hFactorId() === SrViewModel.ControlsResponseData()[ol].FactorId()) {
                            ControlsDynamicHTML += '<div data-bind="if: $root.ControlsResponseData()[' + ol + '].IsVisibleforSearch">';
                            ControlsDynamicHTML += '<div  class="card-header">';
                            ControlsDynamicHTML += '<span class="cp_assessment">';
                            ControlsDynamicHTML += '<a id= "accControlHeaderID_' + SrViewModel.ControlsResponseData()[ol].FactorId() + '" href= "#accControlHeader_' + SrViewModel.ControlsResponseData()[ol].FactorId() + '" data-toggle="collapse" data-parent="#accordion" aria-expanded="true" class="arrow-switch">';
                            ControlsDynamicHTML += '<i class="fa fa-fw fa-caret-accordion"></i> <span data-bind="html: $root.ControlsResponseData()[' + ol + '].QuestionText"></span>';

                            // Header Level Sync Ratings Code
                            ControlsDynamicHTML += '<!-- ko if: ($root.AccessFlagSyncRatingsControls()) -->';
                            ControlsDynamicHTML += '<!-- ko if: ($root.ControlsResponseData()[' + ol + '].ShowFlag == 1) -->';
                            ControlsDynamicHTML += '<span class="threshold-cell hsync-rat" data-bind="text: $root.ControlsResponseData()[' + ol + '].ScoreDescription, css: $root.ControlsResponseData()[' + ol + '].ScoreCSS, attr: {' + 'title: $root.ControlsResponseData()[' + ol + '].Score}"></span>';
                            ControlsDynamicHTML += '<!-- /ko -->';
                            ControlsDynamicHTML += '<!-- /ko -->';

                            ControlsDynamicHTML += '</a>';
                            ControlsDynamicHTML += '</span>';
                            ControlsDynamicHTML += '</div>';
                            ControlsDynamicHTML += '</div>';
                        }
                        //sub headers
                        else if (SrViewModel.ControlsResponseData()[ol].IsHeader() === 1 && SrViewModel.ControlsResponseData()[ol].hFactorId() !== SrViewModel.ControlsResponseData()[ol].FactorId()) {
                            if (SrViewModel.ControlsResponseData()[ol].hFactorId() === SrViewModel.ControlsResponseData()[ol - 1].FactorId()) {
                                ControlsDynamicHTML += '<div class="collapse show pl-header" id="accControlHeader_' + SrViewModel.ControlsResponseData()[ol].hFactorId() + '">';
                            }
                            ControlsDynamicHTML += '<div data-bind="if: $root.ControlsResponseData()[' + ol + '].IsVisibleforSearch">';
                            ControlsDynamicHTML += '<div  class="card-header">';
                            ControlsDynamicHTML += '<span class="cp_assessment">';
                            ControlsDynamicHTML += '<a id= "accControlHeaderID_' + SrViewModel.ControlsResponseData()[ol].FactorId() + '" href= "#accControlHeader_' + SrViewModel.ControlsResponseData()[ol].FactorId() + '" data-toggle="collapse" data-parent="#accordion" aria-expanded="true" class="arrow-switch">';
                            ControlsDynamicHTML += '<i class="fa fa-fw fa-caret-accordion"></i> <span data-bind="html: $root.ControlsResponseData()[' + ol + '].QuestionText"></span>';

                            // Sub-Header Level Sync Ratings Code
                            ControlsDynamicHTML += '<!-- ko if: ($root.AccessFlagSyncRatingsControls()) -->';
                            ControlsDynamicHTML += '<!-- ko if: ($root.ControlsResponseData()[' + ol + '].ShowFlag == 1) -->';
                            ControlsDynamicHTML += '<span class="threshold-cell hsync-rat" data-bind="text: $root.ControlsResponseData()[' + ol + '].ScoreDescription, css: $root.ControlsResponseData()[' + ol + '].ScoreCSS, attr: {' + 'title: $root.ControlsResponseData()[' + ol + '].Score}"></span>';
                            ControlsDynamicHTML += '<!-- /ko -->';
                            ControlsDynamicHTML += '<!-- /ko -->';

                            ControlsDynamicHTML += '</a>';
                            ControlsDynamicHTML += '</span>';
                            ControlsDynamicHTML += '</div>';
                            ControlsDynamicHTML += '</div>';

                            //logic to close divs if no child questions exists
                            var childCheck = ko.utils.arrayFilter(SrViewModel.ControlsResponseData(), function (arr) {
                                if (arr.hFactorId() === SrViewModel.ControlsResponseData()[ol].FactorId())
                                    return arr;
                            });

                            if (childCheck.length === 0) {
                                ControlsDynamicHTML += '</div>';
                                // loop to add div close tags
                                var headerIdVar_sh = SrViewModel.ControlsResponseData()[ol].hFactorId();
                                subHeaderGoto:
                                for (var sh = 0; sh < SrViewModel.ControlsResponseData().length; sh++) {
                                    if (SrViewModel.ControlsResponseData()[sh].IsHeader() === 1 && SrViewModel.ControlsResponseData()[sh].FactorId() === headerIdVar_sh && SrViewModel.ControlsResponseData()[sh].FactorId() !== SrViewModel.ControlsResponseData()[sh].hFactorId()) {
                                        ControlsDynamicHTML += '</div>';
                                        headerIdVar_sh = SrViewModel.ControlsResponseData()[sh].hFactorId();
                                        sh = -1;
                                        continue subHeaderGoto;
                                    }
                                }
                            }
                        }
                        //dead node - last question with headers
                        else if (SrViewModel.ControlsResponseData()[ol].IsHeader() === 0 && SrViewModel.ControlsResponseData()[ol].hFactorId() !== SrViewModel.ControlsResponseData()[ol].FactorId()) {
                            if (SrViewModel.ControlsResponseData()[ol].hFactorId() === SrViewModel.ControlsResponseData()[ol - 1].FactorId()) {
                                ControlsDynamicHTML += '<div class="collapse show" id="accControlHeader_' + SrViewModel.ControlsResponseData()[ol].hFactorId() + '">';
                            }
                            ControlsDynamicHTML += '<div class="question-card">';
                            ControlsDynamicHTML += BuildControlsQuestionsHTML(ol);
                            ControlsDynamicHTML += '</div>';

                            // assuming the questions are sent in order from backend
                            if ((ol === SrViewModel.ControlsResponseData().length - 1) || (ol < SrViewModel.ControlsResponseData().length - 1 && SrViewModel.ControlsResponseData()[ol].hFactorId() !== SrViewModel.ControlsResponseData()[ol + 1].hFactorId())) {
                                ControlsDynamicHTML += '</div>';  // closing dead/child questions div

                                // header of current question
                                var headerIdVar = SrViewModel.ControlsResponseData()[ol].hFactorId();

                                // header of current question's header
                                for (var dq = 0; dq < SrViewModel.ControlsResponseData().length; dq++) {
                                    if (SrViewModel.ControlsResponseData()[dq].IsHeader() === 1 && SrViewModel.ControlsResponseData()[dq].FactorId() === headerIdVar) {
                                        headerIdVar = SrViewModel.ControlsResponseData()[dq].hFactorId();
                                        break;
                                    }
                                }
                                // logic to loop till hFactoId = FactorId and adding div close tags
                                childQuestionGoto:
                                for (var cq = 0; cq < SrViewModel.ControlsResponseData().length; cq++) {
                                    if (SrViewModel.ControlsResponseData()[cq].IsHeader() === 1 && SrViewModel.ControlsResponseData()[cq].FactorId() === headerIdVar) {
                                        headerIdVar = SrViewModel.ControlsResponseData()[cq].hFactorId();
                                        if ((ol === SrViewModel.ControlsResponseData().length - 1) || (ol < SrViewModel.ControlsResponseData().length - 1 && SrViewModel.ControlsResponseData()[ol + 1].hFactorId() !== headerIdVar)) {
                                            ControlsDynamicHTML += '</div>';
                                            if (SrViewModel.ControlsResponseData()[cq].FactorId() !== SrViewModel.ControlsResponseData()[cq].hFactorId()) {
                                                cq = -1;
                                                continue childQuestionGoto;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    ControlsDynamicHTML += '</div>'; //card header - for loop
                    ControlsDynamicHTML += '</div>'; //accordian close
                }

                $('#QualContDynamicHTMLDiv').html("");
                $('#QualContDynamicHTMLDiv').html(ControlsDynamicHTML);
                $('#QualContDynamicHTMLDiv').hide();
                var element = $('#QualContDynamicHTMLDiv')[0];
                ko.cleanNode(element);
                ko.applyBindings(SrViewModel, document.getElementById('QualContDynamicHTMLDiv'));
                $('#QualContDynamicHTMLDiv').show();
                $('#TabDataDiv').show();
                $('#MCI_DynamicHTML').html("");
                $('#LoadingGIFSRDiv').modal('hide');
                //rich text box and collapse button show/hide
                var showCollapseQBtn = 0;
                for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                    if (SrViewModel.ControlsResponseData()[i].IsHeader() == 1) {
                        showCollapseQBtn++;
                    }
                    if (SrViewModel.ControlsResponseData()[i].ResponseList != undefined) {
                        for (var k = 0; k < SrViewModel.ControlsResponseData()[i].ResponseList.length; k++) {
                            if (SrViewModel.ControlsResponseData()[i].IsConditional() == 0 && SrViewModel.ControlsResponseData()[i].ResponseList[k].ResponseApplicability() == true && SrViewModel.ControlsResponseData()[i].ResponseList[k].ResponseOptionType() === 'R')
                                showResponseRichText(SrViewModel.ControlsResponseData()[i].QuestionId() + '_' + SrViewModel.ControlsResponseData()[i].ResponseList[k].ResponseId(), SrViewModel.ControlsResponseData()[i].ResponseList[k].ResponseInputValue());
                        }
                    }
                }
                if (showCollapseQBtn > 0) {
                    SrViewModel.hasHeaderQuestions(true);
                    $('#QualContDynamicHTMLDiv').removeClass("mt-4");
                }
                else {
                    SrViewModel.hasHeaderQuestions(false);
                    $('#QualContDynamicHTMLDiv').addClass("mt-4");
                }
            }
            catch (e) {
                $('#LoadingGIFSRDiv').modal('hide');
                var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForControls() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function BuildControlsQuestionsHTML(countVar) {
            try {
                var controlsQuestionBox = "";
                var data = '$root.ControlsResponseData()[' + countVar + ']';

                controlsQuestionBox += '<div id= "question-Section_' + SrViewModel.ControlsResponseData()[countVar].QuestionId() + '" data-bind="attr:{class: ($root.ControlsResponseData()[' + countVar + '].IsConditional() == 1 || $root.ControlsResponseData()[' + countVar + '].IsReadOnly() == 1 || $root.ControlsResponseData()[' + countVar + '].IsReadOnly() == 2)? \'card sq-disabled-box\' : \'card\' }">'; //question_section div open
                controlsQuestionBox += '<div data-bind="if: $root.ControlsResponseData()[' + countVar + '].IsVisibleforSearch">';  // IsVisibleforSearch div open
                controlsQuestionBox += '<div class="card-body">';  // card-body div open

                controlsQuestionBox += '<div class="pl-4 row" data-bind="visible: $root.ControlsResponseData()[' + countVar + '].IsHeader() == 0">'; // responses div open
                var qlistCount = 0;
                for (var i = 0; i < SrViewModel.ColumnDetails().length; i++) {
                    var CQRespList = SrViewModel.ControlsResponseData()[countVar].ResponseList[i];
                    if (CQRespList != undefined && CQRespList.ResponseApplicability() == 1) {
                        var ID = '$root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].SelectedOptionsList()';
                        var valueId = '$root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].Response';
                        var UniqueID = '$root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].UniqueID()';
                        var ValueInputId = '$root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].ResponseInputValue';
                        var MultiPreselectedValue = '$root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].SelectedControlResponse';

                        var IsReadOnly = '$root.ControlsResponseData()[' + countVar + '].IsReadOnly()';
                        var IsConditional = '$root.ControlsResponseData()[' + countVar + '].IsConditional()';
                        var IsHeader = '$root.ControlsResponseData()[' + countVar + '].IsHeader()';
                        var IsParentQuestion = '$root.ControlsResponseData()[' + countVar + '].IsParentQuestion()';
                        var QuestionId = '$root.ControlsResponseData()[' + countVar + '].QuestionId()';
                        var QuestionIdVM = SrViewModel.ControlsResponseData()[countVar].QuestionId();

                        if (qlistCount == 0) {
                            controlsQuestionBox += '<div class="col-md-11 pr-0">';
                            controlsQuestionBox += '<sup><i class="text-danger fa fa-asterisk mr-2 font-xsmall" data-bind="visible: $root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].Is_ResponseMandatory_RT() && $root.ControlsResponseData()[' + countVar + '].IsSaveClicked_Response() && $root.ControlsResponseData()[' + countVar + '].IsConditional() == 0 && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup>';
                            controlsQuestionBox += '<span class="card-title question-text" data-bind="html: $root.ControlsResponseData()[' + countVar + '].QuestionsList()[' + qlistCount + ']"></span>';
                            controlsQuestionBox += '</div>';
                            controlsQuestionBox += '<div class="col-md-1"><label for="bmFlag_' + QuestionIdVM + '" class="pull-right" data-bind="visible: $root.ShowBookmarkFlags(), event: {change: function(data,event) {$root.BookmarkFlagChangeEvent(' + data + ', event)} }"><input id="bmFlag_' + QuestionIdVM + '" type="checkbox" class="flagbox" data-bind="checked: $root.ControlsResponseData()[' + countVar + '].BookmarkFlagQuestion, disable: ' + IsReadOnly + ' == 1 || ' + IsConditional + ' == 1 || ' + IsReadOnly + ' == 2 || $root.DisableControl() || !$root.appsecurity.WriteAccess()"><span class="flag"><i class="fa fa-flag"></i></span></label></div>';
                        }
                        else {
                            controlsQuestionBox += '<div class="col-md-11 pr-0">';
                            controlsQuestionBox += '<sup><i class="text-danger fa fa-asterisk mr-2 font-xsmall" data-bind="visible: $root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].Is_ResponseMandatory_RT() && $root.ControlsResponseData()[' + countVar + '].IsSaveClicked_Response() && $root.ControlsResponseData()[' + countVar + '].IsConditional() == 0 && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup>';
                            controlsQuestionBox += '<span class="card-title question-text" data-bind="html: $root.ControlsResponseData()[' + countVar + '].QuestionsList()[' + qlistCount + ']"></span>';
                            controlsQuestionBox += '</div>';
                        }

                        qlistCount++;

                        // responses div col-11 start
                        if (qlistCount == 0) {
                            controlsQuestionBox += '<div class="col-md-11 pr-0 mt-1">';
                        }

                        else {
                            controlsQuestionBox += '<div class="col-md-11 pr-0 mt-2">';
                        }

                        if (SrViewModel.ColumnDetails().length > 1) {
                            controlsQuestionBox += '<h6 class="card-subtitle text-muted mb-1" data-bind="html: $root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].ResponseName"></h6>';
                        }

                        // this block of code should be removed after implementing set functionality of all response-option types
                        if (CQRespList.ResponseOptionType() == '-') {
                            if (CQRespList.SelectedOptionsList().length > 0) {
                                controlsQuestionBox += '<select class="form-control" data-bind="options:' + ID + ', value: ' + valueId + ',optionsCaption:\'Select\',optionsText :\'SelectResposneOption\',optionsValue:\'SelectResponseId\',disable: ' + IsConditional + '==1 || ' + IsReadOnly + '==1 || ' + IsReadOnly + ' == 2 || $root.DisableControl()  || !$root.appsecurity.WriteAccess(),event: {change: ' + IsParentQuestion + '== 1 ? function(data,event) {$root.ConditionQuestionchangeControl(' + data + ', event, ' + QuestionId + ')} :  function(data,event) {$root.ValuesChangeEvent(' + data + ', event, ' + QuestionId + ')}  },attr:{\'id\':' + UniqueID + ' }"></select>';
                            }

                            else if (CQRespList.SelectedOptionsList().length === 0) {
                                controlsQuestionBox += '<input class="form-control" type="text" data-bind="attr:{placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\') == -1 )? \'Type Response\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\')].Name}, value:' + ValueInputId + ',disable: ' + IsConditional + '==1 || ' + IsReadOnly + '==1 || ' + IsReadOnly + ' == 2  || $root.DisableControl()  || !$root.appsecurity.WriteAccess() , event: {change: function(data,event) {$root.ValuesChangeEvent(' + data + ', event, ' + QuestionId + ')}  }"></input>';
                            }
                        }
                        // this block of code should be removed after implementing set functionality of all response-option types

                        // For OptionType - Single Dropdown
                        else if (CQRespList.ResponseOptionType() == 'D') {
                            controlsQuestionBox += '<select class="form-control" data-bind="options:' + ID + ', value: ' + valueId + ',optionsCaption:\'Select\',optionsText :\'SelectResposneOption\',optionsValue:\'SelectResponseId\',disable:' + IsConditional + '==1 || ' + IsReadOnly + '==1 || ' + IsReadOnly + ' == 2  || $root.DisableControl()  || !$root.appsecurity.WriteAccess(),event: {change: ' + IsParentQuestion + '== 1 ? function(data,event) {$root.ConditionQuestionchangeControl(' + data + ', event, ' + QuestionId + ')} :  function(data,event) {$root.ValuesChangeEvent(' + data + ', event, ' + QuestionId + ')}  },attr:{\'id\':' + UniqueID + ' }"></select>';
                        }

                        // For OptionType - Multiple Checkbox
                        else if (CQRespList.ResponseOptionType() == 'C') {
                            controlsQuestionBox += '<div>';
                            controlsQuestionBox += '<!--ko foreach: ' + ID + ' -->';
                            controlsQuestionBox += '<div class="control-label">';
                            controlsQuestionBox += '<input type="checkbox" data-bind="attr:{\'id\':' + UniqueID + ' }, checkedValue: SelectResponseId, checked: ' + MultiPreselectedValue + ', disable: ' + IsConditional + '==1 || ' + IsReadOnly + '== 1 || ' + IsReadOnly + ' == 2  || $root.DisableControl()  || !$root.appsecurity.WriteAccess(), event: {change: function(data,event) { $root.MultiselectResponsechangeCtrl(' + data + ', event, ' + QuestionId + ')} }">';
                            controlsQuestionBox += '<span data-bind="html: SelectResposneOption"></span>';
                            controlsQuestionBox += '</div>';
                            controlsQuestionBox += '<!--/ko-->';
                            controlsQuestionBox += '</div>';
                        }

                        // For OptionType - Radio Buttons
                        else if (CQRespList.ResponseOptionType() == 'B') {
                            controlsQuestionBox += '<div>';
                            controlsQuestionBox += '<!--ko foreach: ' + ID + ' -->';
                            controlsQuestionBox += '<div class="control-label">';
                            controlsQuestionBox += '<input type="radio" data-bind="attr:{\'id\':' + UniqueID + ' }, checkedValue: SelectResponseId, checked: $root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].Response, disable:  ' + IsConditional + '==1 || ' + IsReadOnly + '== 1 || ' + IsReadOnly + ' == 2  || $root.DisableControl()  || !$root.appsecurity.WriteAccess(),event: {change: ' + IsParentQuestion + '== 1 ? function(data,event) {$root.ConditionQuestionchangeControl(' + data + ', event, ' + QuestionId + ')} :  function(data,event) {$root.ValuesChangeEvent(' + data + ', event, ' + QuestionId + ')}  }">';
                            controlsQuestionBox += '<span data-bind="html: SelectResposneOption"></span>';
                            controlsQuestionBox += '</div>';
                            controlsQuestionBox += '<!--/ko-->';
                            controlsQuestionBox += '</div>';
                        }

                        // For OptionType - Horizontal Radio Buttons
                        else if (CQRespList.ResponseOptionType() == 'HB') {
                            controlsQuestionBox += '<div>';
                            for (var hb = 0; hb < SrViewModel.ControlsResponseData()[countVar].ResponseList[i].SelectedOptionsList().length; hb++) {
                                var SelectResponseId = '$root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].SelectedOptionsList()[' + hb + '].SelectResponseId';
                                var SelectResposneOption = '$root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].SelectedOptionsList()[' + hb + '].SelectResposneOption';
                                var ResponseValue = '$root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].Response';
                                if (hb % 2 === 0) {
                                    controlsQuestionBox += '<div class="col-12 nd-flex pl-0 pr-0">';
                                }
                                controlsQuestionBox += '<div class="control-label col-6 pl-0 pr-0">';
                                controlsQuestionBox += '<input type="radio" data-bind="attr:{\'id\':' + UniqueID + ' }, checkedValue: ' + SelectResponseId + ', checked: ' + ResponseValue + ', disable:  ' + IsConditional + '==1 || ' + IsReadOnly + '== 1 || ' + IsReadOnly + ' == 2  || $root.DisableControl()  || !$root.appsecurity.WriteAccess(),event: {change: ' + IsParentQuestion + '== 1 ? function(data,event) {$root.ConditionQuestionchangeControl(' + data + ', event, ' + QuestionId + ')} :  function(data,event) {$root.ValuesChangeEvent(' + data + ', event, ' + QuestionId + ')}  }">';
                                controlsQuestionBox += '<span data-bind="html: ' + SelectResposneOption + '"></span>';
                                controlsQuestionBox += '</div>';
                                if (hb % 2 === 1 || hb === SrViewModel.ControlsResponseData()[countVar].ResponseList[i].SelectedOptionsList().length - 1) {
                                    controlsQuestionBox += '</div>';
                                }
                            }
                            controlsQuestionBox += '</div>';
                        }

                        // For OptionType - Text Box
                        else if (CQRespList.ResponseOptionType() == 'T') {
                            controlsQuestionBox += '<input class="form-control" type="text" data-bind="attr:{placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\') == -1 )? \'Type Response\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\')].Name}, value:' + ValueInputId + ',disable:' + IsConditional + ' == 1 || ' + IsReadOnly + '==1 || ' + IsReadOnly + ' == 2  || $root.DisableControl()  || !$root.appsecurity.WriteAccess(), event: {change: function(data,event) {$root.ValuesChangeEvent(' + data + ', event, ' + QuestionId + ')}  }"></input>';
                        }

                        // For OptionType - Rich Text Box
                        else if (CQRespList.ResponseOptionType() == 'R') {
                            controlsQuestionBox += '<!-- ko if: (' + IsConditional + ' == 1 || ' + IsReadOnly + '== 1 || ' + IsReadOnly + ' == 2  || $root.DisableControl()  || !$root.appsecurity.WriteAccess())-->';
                            controlsQuestionBox += '<div class="card-body commentSubBox rtb-disabled" data-bind="html:' + ValueInputId + '"></div>';
                            controlsQuestionBox += '<!--/ko-->';
                            controlsQuestionBox += '<!-- ko if: (' + IsConditional + ' == 0 && ' + IsReadOnly + ' == 0) && (!$root.DisableControl()  || $root.appsecurity.WriteAccess()) -->';
                            controlsQuestionBox += '<textarea id="ResponseType_' + QuestionIdVM + '_' + CQRespList.ResponseId() + '" data-bind="attr:{placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\') == -1 )? \'Type Response\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\')].Name}, html: ' + ValueInputId + '" class="form-control w-100"></textarea>';
                            controlsQuestionBox += '<!--/ko-->';
                        }
                        controlsQuestionBox += '</div>';
                        // responses div col-11 end

                        // Response Level - Sync Ratings code start
                        controlsQuestionBox += '<!-- ko if: ($root.AccessFlagSyncRatingsControls()) -->';
                        controlsQuestionBox += '<!-- ko if: ($root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].ShowFlag == 1) -->';
                        controlsQuestionBox += '<div class="col-md-1"><div class="threshold-cell rsync-rat" data-bind="html: $root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].ScoreDescription, css: $root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].ScoreCSS, attr: {' + 'title: $root.ControlsResponseData()[' + countVar + '].ResponseList[' + i + '].Score}"></div>';
                        controlsQuestionBox += '</div>';
                        controlsQuestionBox += '<!-- /ko -->';
                        controlsQuestionBox += '<!-- /ko -->';
                        // Response Level - Sync Ratings code end

                        var iInc = i + 1;
                        if (iInc < SrViewModel.ColumnDetails().length && SrViewModel.ControlsResponseData()[countVar].ResponseList[iInc] != undefined && SrViewModel.ControlsResponseData()[countVar].ResponseList[iInc].ResponseApplicability() == 1)
                            controlsQuestionBox += '<div style="margin-top:10vh;"></div>';
                    }
                }
                controlsQuestionBox += '</div>'; // responses div close

                controlsQuestionBox += '</div>'; // card-body div close

                controlsQuestionBox += '<div data-bind="visible: ' + IsHeader + ' == 0">'; // menu items div open
                controlsQuestionBox += '<!-- ko if: (' + IsReadOnly + '== 2) -->';
                controlsQuestionBox += '<span class="sq-common"><span class="badge-title"><i class="fa fa-info-circle pr-1"> </i><span class="title-bottom">' + SrViewModel.CQBadgeTitle() + '</span></span>' + SrViewModel.CQBadge() + '</span>';
                controlsQuestionBox += '<!--/ko-->';
                controlsQuestionBox += '<ul class="float-right nav nav-tabs">';
                controlsQuestionBox += '<li class="nav-item">';
                controlsQuestionBox += '<a class="nav-link" data-bind="attr:{ id: \'cmt_Q_Id' + QuestionIdVM + '\', href: $root.ControlsResponseData()[' + countVar + '].cmt_hrefId() }, click:function(data, event) {$root.ShowExtraContent($root.ControlsResponseData()[' + countVar + '].cmtId(),' + data + ', ' + QuestionId + ')}">';
                controlsQuestionBox += '<i class="demo-icon icon-commenting_special"></i>';
                controlsQuestionBox += '<span data-bind="if: $root.ControlsResponseData()[' + countVar + '].CommentCount() > 0">';
                controlsQuestionBox += '<span class="qqount" data-bind="text:$root.ControlsResponseData()[' + countVar + '].CommentCount">0</span>';
                controlsQuestionBox += '</span>';
                controlsQuestionBox += '<span data-bind="visible: $root.ControlsResponseData()[' + countVar + '].IsSaveClicked_Comment() && ' + IsConditional + ' == 0 && $root.Is_RefreshEnable() && !($root.Tick_Flag())">';
                controlsQuestionBox += '<sup><i class="text-danger fa fa-asterisk font-xxsmall"></i></sup>';
                controlsQuestionBox += '</span>';
                controlsQuestionBox += '<span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\') == -1) ? \'Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\')].Name"></span></a></li>';
                controlsQuestionBox += '<li class="nav-item">';
                controlsQuestionBox += '<a class="nav-link" data-bind="attr:{ id: \'atch_Q_Id' + QuestionIdVM + '\', href: $root.ControlsResponseData()[' + countVar + '].attachment_hrefId() }, click:function(data, event) {$root.ShowExtraContent($root.ControlsResponseData()[' + countVar + '].attachmentId(),' + data + ', ' + QuestionId + ')}">';
                controlsQuestionBox += '<i class="demo-icon icon-paperclip_special"></i>';
                controlsQuestionBox += '<span data-bind="if: $root.ControlsResponseData()[' + countVar + '].DocumentCount() > 0">';
                controlsQuestionBox += '<span class="qqount" data-bind="text:$root.ControlsResponseData()[' + countVar + '].DocumentCount">0</span>';
                controlsQuestionBox += '</span>';
                controlsQuestionBox += '<span data-bind="visible: $root.ControlsResponseData()[' + countVar + '].IsSaveClicked_Document() && ' + IsConditional + ' == 0 && $root.Is_RefreshEnable() && !($root.Tick_Flag())">';
                controlsQuestionBox += '<sup><i class="text-danger fa fa-asterisk font-xxsmall"></i></sup>';
                controlsQuestionBox += '</span>';
                controlsQuestionBox += '<span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Attachments\') == -1) ? \'Attachments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Attachments\')].Name"></span></a></li> ';
                controlsQuestionBox += '<li class="nav-item">';
                controlsQuestionBox += '<a class="nav-link" data-bind="attr:{ id: \'hist_Q_Id' + QuestionIdVM + '\', href: $root.ControlsResponseData()[' + countVar + '].hist_hrefId() }, click:function(data, event) {$root.ShowExtraContent($root.ControlsResponseData()[' + countVar + '].histId(),' + data + ', ' + QuestionId + ')}">';
                controlsQuestionBox += '<i class="demo-icon icon-backup_special"></i><span data-bind="html: ((!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoryHeading\') == -1) ? \'History\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoryHeading\')].Name)"></span></a>';
                controlsQuestionBox += '</li>';
                controlsQuestionBox += '<li class="nav-item">';
                controlsQuestionBox += '<a class="nav-link" data-bind="attr:{ id: \'gui_Q_Id' + QuestionIdVM + '\', href: $root.ControlsResponseData()[' + countVar + '].guideline_hrefId() }, click:function(data, event) {$root.ShowExtraContent($root.ControlsResponseData()[' + countVar + '].guidelineId(),' + data + ', ' + QuestionId + ')}">';
                controlsQuestionBox += '<i class="demo-icon icon-document_1_special"></i><span data-bind="html: ((!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesHeading\') == -1) ? \'Guidelines\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesHeading\')].Name)"></span></a>';
                controlsQuestionBox += '</li>';
                controlsQuestionBox += '</ul>';
                controlsQuestionBox += '</div>'; // menu items div close

                ///comments box open
                controlsQuestionBox += '<div  id="' + SrViewModel.ControlsResponseData()[countVar].cmtId() + '" class="actions-box col-lg-12 p-0" style="display:none;">'; // comments box div open
                controlsQuestionBox += '<div class="title"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\') == -1) ? \'Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\')].Name"></span> <button type="button" class="btn float-right" data-bind="click: function(data, event) { $root.HideExtraContent(' + QuestionId + ') }"><span><i class="demo-icon icon-cross_special"></i></span></button></div>';
                controlsQuestionBox += '<div class="card-body">'; // card body inside comments div open
                controlsQuestionBox += '<div data-bind="if: ' + IsReadOnly + '==0 && ' + IsConditional + ' == 0 && ($root.DisableControl() == false || $root.appsecurity.WriteAccess())">'; // conditions binding div open
                controlsQuestionBox += '<h6 class="card-title" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AddCommentHeading\') == -1) ? \'Add Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AddCommentHeading\')].Name"></h6>';
                controlsQuestionBox += '<div class="col-lg-4 pl-0 pb-1">'; // inner comments div open
                controlsQuestionBox += '<select class="form-control h-auto" name="ApplicableControls" id="ResponseId' + QuestionIdVM + '" data-bind="options: $root.ControlsResponseData()[' + countVar + '].ControlsColumnsList, optionsText: \'ColumnName\', optionsValue: \'ColumnId\'"></select>';
                controlsQuestionBox += '</div>'; // inner comments div close
                controlsQuestionBox += '<div class="chars-left"> <span class="chars-left-lbl mr-1" data-bind="text: $root.RemainingChars()"></span><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'RemainingCharactersleft\') == -1) ? \'Characters left\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'RemainingCharactersleft\')].Name"></span></div>';
                controlsQuestionBox += '<textarea id="ResponseTextArea_' + QuestionIdVM + '" data-bind="event: {keydown: $root.OcKeypress, keyup: $root.OcKeyUp}, attr:{placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EnterCommentsPlaceholder\') == -1 )? \'Your Comments\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EnterCommentsPlaceholder\')].Name}" rows="6" class="w-100"></textarea>';
                controlsQuestionBox += '<span class="field-validation-error" id="lblRCError_' + QuestionIdVM + '"></span>';
                controlsQuestionBox += '</div>'; // conditions binding div close

                controlsQuestionBox += '<div>';  // comments secondary div open
                controlsQuestionBox += '<div data-bind="if: ' + IsReadOnly + '==0 && ' + IsConditional + '== 0 && ($root.DisableControl() == false || $root.appsecurity.WriteAccess())">';
                controlsQuestionBox += '<button class="primary-btn" type="submit" data-bind="html: $root.SaveCommentButtonName(), click:function(data, event) { $root.SaveComment(' + QuestionId + ',' + data + ', event)}, disable: ' + IsConditional + ' == 1 || ' + IsReadOnly + ' == 1 || ' + IsReadOnly + ' == 2  || $root.DisableControl() || !$root.appsecurity.WriteAccess()"></button>';
                controlsQuestionBox += '<button class="secondary-btn ml-2" type="submit" data-bind="html:(!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'CancelButton\') == -1) ? \'Cancel\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'CancelButton\')].Name, click:function(data, event) { $root.CancelComment(' + QuestionId + ',' + data + ', event)}, disable: ' + IsConditional + ' == 1 || ' + IsReadOnly + ' == 1 || ' + IsReadOnly + ' == 2  || $root.DisableControl() || !$root.appsecurity.WriteAccess()"></button>';
                controlsQuestionBox += '</div>';
                //sub-nav list - comments open
                controlsQuestionBox += '<div class="hactions">';
                controlsQuestionBox += '<ul class="float-right nav nav-tabs" style="margin-top: -1.4rem !important;">';
                controlsQuestionBox += '<li class="nav-item">';
                controlsQuestionBox += '<a class="nav-link" data-bind="attr:{ href: \'#cmt_Sub_hrefId' + QuestionIdVM + '\', id: \'cmt_Sub_Id' + QuestionIdVM + '\'}, click:function(data, event) { $root.ShowExtraSubContent(' + QuestionId + ', \'cmt_Sub_hrefId' + QuestionIdVM + '\', \'cmt\')}">';
                controlsQuestionBox += '<i class="demo-icon icon-commenting_special"></i>';
                controlsQuestionBox += '<span data-bind="if: $root.ControlsResponseData()[' + countVar + '].CommentCount() > 0">';
                controlsQuestionBox += '<span class="qqount" data-bind="text:$root.ControlsResponseData()[' + countVar + '].CommentCount">0</span>';
                controlsQuestionBox += '</span>';
                controlsQuestionBox += '<span data-bind=" html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\') == -1) ? \'Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\')].Name"></span></a></li>';
                controlsQuestionBox += '<li class="nav-item">';
                controlsQuestionBox += '<a class="nav-link" data-bind="attr:{ href: \'#cmt_Sub_Hist_hrefId' + QuestionIdVM + '\', id: \'cmt_Sub_Hist_Id' + QuestionIdVM + '\'}, click:function(data, event) { $root.ShowExtraSubContent(' + QuestionId + ', \'cmt_Sub_Hist_hrefId' + QuestionIdVM + '\', \'hist\')}">';
                controlsQuestionBox += '<i class="demo-icon icon-backup_special"></i><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoricalCommentsHeading\') == -1) ? \'Historical Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoricalCommentsHeading\')].Name"></span></a>';
                controlsQuestionBox += '</li>';
                controlsQuestionBox += '</ul>';
                controlsQuestionBox += '</div>';
                //sub-nav list - comments close

                //sub-comments box - comments open
                controlsQuestionBox += '<div id="cmt_Sub_hrefId' + QuestionIdVM + '" class="commentSubBox" style="display:none;">';
                controlsQuestionBox += '<div class="" id="cmt_List_' + QuestionIdVM + '"></div>';
                controlsQuestionBox += '</div>';
                //sub-comments box - comments close
                //sub-comments box - Historical comments open
                controlsQuestionBox += '<div id="cmt_Sub_Hist_hrefId' + QuestionIdVM + '" class="commentSubBox" style="display:none;">';
                controlsQuestionBox += '<span class="" id="Hist_cmt_List_' + QuestionIdVM + '"></span>';
                controlsQuestionBox += '</div>';
                //sub-comments box - Historical comments close

                controlsQuestionBox += '</div>';  // comments secondary div close
                controlsQuestionBox += '</div>';  // card body inside comments div close
                controlsQuestionBox += '</div>'; // comments box div close
                ///comments box close

                ///attahement box open
                controlsQuestionBox += '<div id="' + SrViewModel.ControlsResponseData()[countVar].attachmentId() + '" class="actions-box col-lg-12 p-0" style="display:none;">'; // attachement box div open
                controlsQuestionBox += '<div class="title"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Attachments\') == -1) ? \'Attachments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Attachments\')].Name"></span> <button type="button" class="btn float-right" data-bind="click:function(data, event) { $root.HideExtraContent(' + QuestionId + ') }"><span>';
                controlsQuestionBox += '<i class="demo-icon icon-cross_special"></i></span></button></div>';

                controlsQuestionBox += '<div data-bind="if: ' + IsReadOnly + '==0 && ' + IsConditional + '== 0 && ($root.DisableControl() == false || $root.appsecurity.WriteAccess())">'; // conditions binding attachements div open
                controlsQuestionBox += ' <div class="card-body">'; // card body inside attachements div open
                controlsQuestionBox += ' <h6 class="card-title" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadDocumentsHeading\') == -1) ? \'Upload Documents\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadDocumentsHeading\')].Name"></h6>';
                controlsQuestionBox += ' <div class="col-lg-4 pl-0 pb-1">';
                controlsQuestionBox += ' <input type="file" class="form-control" id="FileUploaderForDocuments_' + QuestionIdVM + '" data-bind="disable: ' + IsConditional + ' == 1 || ' + IsReadOnly + ' == 1 || ' + IsReadOnly + ' == 2  || $root.DisableControl() || !$root.appsecurity.WriteAccess()" placeholder="Select File(s)" />';
                controlsQuestionBox += ' </div>';
                controlsQuestionBox += ' <div class="chars-left"> <span class="chars-left-lbl mr-1" data-bind="text: $root.RemainingChars()"></span><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'RemainingCharactersleft\') == -1) ? \'Characters left\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'RemainingCharactersleft\')].Name"></span></div>';
                controlsQuestionBox += ' <textarea class="w-100" id="UploadTextArea_' + QuestionIdVM + '" data-bind="event: {keydown: $root.OcKeypress, keyup: $root.OcKeyUp}, attr:{placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EnterCommentsPlaceholder\') == -1 )? \'Your Comments\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EnterCommentsPlaceholder\')].Name}" rows="6"></textarea>';
                controlsQuestionBox += ' <div id="ProgressBarMainDiv_' + QuestionIdVM + '" class="col-md-5" style="display:none">';
                controlsQuestionBox += '<div id="ProgressBarDiv" class="progressbar-control">';
                controlsQuestionBox += '<span id="ProgressBar" class="item-bar blue" data-bind="style:{width: $root.ProgressPercent}, text: $root.ProgressPercent"></span>';
                controlsQuestionBox += '</div>';
                controlsQuestionBox += '<p id="lblProgressMsg_' + QuestionIdVM + '" text: $root.ProgressMessage"></p>';
                controlsQuestionBox += '</div>';
                controlsQuestionBox += '<div class="col-lg-12 field-validation-error" id="lblRDError_' + QuestionIdVM + '"></div>';

                controlsQuestionBox += ' <button class="secondary-btn" type="submit" data-bind="attr: {title: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadDocumentPlacholder\') == -1 )? \'Upload Document\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadDocumentPlacholder\')].Name}, click:function(data, event) { $root.UploadDocument(' + data + ')}, disable: ' + IsConditional + ' == 1 || ' + IsReadOnly + ' == 1 || ' + IsReadOnly + ' == 2  || $root.DisableControl() || !$root.appsecurity.WriteAccess()">';
                controlsQuestionBox += ' <i class="fa fa-upload"></i><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadButton\') == -1) ? \'Upload\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadButton\')].Name"></span></button>';

                controlsQuestionBox += ' </div>'; // card body inside attachements div close
                controlsQuestionBox += '</div>'; // conditions binding attachements div close

                //subDoccomments
                controlsQuestionBox += ' <div class="card-footer text-muted">';
                controlsQuestionBox += '<div id="doc_cmt_sec_' + QuestionIdVM + '">';
                controlsQuestionBox += '<div class="" id="doc_cmt_List_' + QuestionIdVM + '"></div>';
                controlsQuestionBox += ' </div>';
                controlsQuestionBox += ' </div>';
                //subDoccomments
                controlsQuestionBox += ' </div>'; // attachement box div close
                ///attachments box close

                //history & guidelines
                controlsQuestionBox += '<div data-bind="attr:{ id: $root.ControlsResponseData()[' + countVar + '].histId() }" class="card card col-lg-12 p-0" style="display:none;">';
                controlsQuestionBox += '<div class="box user-content pt-0 pb-0">';
                controlsQuestionBox += '<div class="title"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoryHeading\') == -1) ? \'History\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoryHeading\')].Name"></span><button type="button" class="btn float-right" data-bind="click:function(data, event) { $root.HideExtraContent(' + QuestionId + ') }"><span>';
                controlsQuestionBox += '<i class="demo-icon icon-cross_special"></i></span></button></div>';
                controlsQuestionBox += '</div>';
                controlsQuestionBox += '<div class="card-body text-muted">';
                controlsQuestionBox += '<span data-bind="attr:{id: \'htmlHist_\' + $root.ControlsResponseData()[' + countVar + '].histId() }"></span>';
                controlsQuestionBox += '</div>';
                controlsQuestionBox += '</div>';
                controlsQuestionBox += '<div data-bind="attr:{ id: $root.ControlsResponseData()[' + countVar + '].guidelineId() }" class="card card col-lg-12 p-0" style="display:none;">';
                controlsQuestionBox += '<div class="box user-content pt-0 pb-0">';
                controlsQuestionBox += '<div class="title"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesHeading\') == -1) ? \'Guidelines\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesHeading\')].Name"></span> <button type="button" class="btn float-right" data-bind="click:function(data, event) { $root.HideExtraContent(' + QuestionId + ') }"><span>';
                controlsQuestionBox += '<i class="demo-icon icon-cross_special"></i></span></button></div>';
                controlsQuestionBox += '</div>';
                controlsQuestionBox += '<div class="card-body">';
                if (SrViewModel.ControlsResponseData()[countVar].InfoGuidelineComment() === '')
                    controlsQuestionBox += '<span class="nodatamessage" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoGuidelinesMessage\') == -1) ? \'There are no Guidelines available\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoGuidelinesMessage\')].Name"></span>';
                else if (SrViewModel.ControlsResponseData()[countVar].InfoGuidelineComment() !== '')
                    controlsQuestionBox += '<span>' + SrViewModel.ControlsResponseData()[countVar].InfoGuidelineComment() + '</span>';
                controlsQuestionBox += '</div>';
                controlsQuestionBox += '</div>';
                //history & guidelines

                controlsQuestionBox += '</div>'; // IsVisibleforSearch div close
                controlsQuestionBox += '</div>'; //question_section div close

                return controlsQuestionBox;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BuildControlsQuestionsHTML() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ConditionQuestionchangeControl(data, event) {
            try {
                //var scroll = $(window).scrollTop();
                FillRTBInputValues();
                var element = $('#QualContDynamicHTMLDiv')[0];
                ko.cleanNode(element);
                var selectedvalue = "";

                var columnId = "",
                    splitColumnId = "";
                if (event != undefined) {
                    columnId = event.currentTarget.id;
                }
                if (columnId != undefined && columnId != "") {
                    splitColumnId = columnId.split("_");
                }
                var responseId = "",
                    currentQuestionId = "";
                if (splitColumnId != undefined && splitColumnId.length > 1) {
                    responseId = splitColumnId[1];
                    currentQuestionId = splitColumnId[0];
                }

                for (var j = 0; j < data.ResponseList.length; j++) {
                    if (parseInt(responseId) == data.ResponseList[j].ResponseId()) {
                        selectedvalue = data.ResponseList[j].Response()
                    }
                }
                SrViewModel.ValuesChanged(true);
                if (selectedvalue === undefined || selectedvalue === null)
                    selectedvalue = -1;
                for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                    var resp = SrViewModel.ControlsResponseData()[i].ParentResponseId().split("|");
                    for (var g = 0; g < resp.length; g++) {
                        if (data.FactorId() == SrViewModel.ControlsResponseData()[i].ParentQuestionId()) {
                            if (SrViewModel.ControlsResponseData()[i].ParentResponseId().toString().includes(selectedvalue.toString())) {
                                SrViewModel.ControlsResponseData()[i].IsConditional(0);
                                break;
                            }
                            else {
                                SrViewModel.ControlsResponseData()[i].IsConditional(1);
                                SrViewModel.ControlsResponseData()[i].BookmarkFlagQuestion(false);
                                for (var h = 0; h < SrViewModel.ControlsResponseData()[i].ResponseList.length; h++) {
                                    SrViewModel.ControlsResponseData()[i].ResponseList[h].Response(0);
                                    SrViewModel.ControlsResponseData()[i].ResponseList[h].BookmarkFlag(false);
                                    SrViewModel.ControlsResponseData()[i].ResponseList[h].ResponseInputValue("");
                                    if (SrViewModel.ControlsResponseData()[i].ResponseList[h].ResponseOptionType() == 'C') {
                                        SrViewModel.ControlsResponseData()[i].ResponseList[h].SelectedControlResponse('');
                                    }
                                }
                            }
                        }
                    }
                }
                BindDynamicHtmlForControls();
                //$(window).scrollTop(scroll);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ConditionQuestionchangeControl() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function MultiselectResponsechangeCtrl(data, event, questionId) {
            try {
                FillRTBInputValues();
                var columnId = "",
                    splitColumnId = "";
                if (event != undefined) {
                    columnId = event.currentTarget.id;
                }
                if (columnId != undefined && columnId !== "") {
                    splitColumnId = columnId.split("_");
                }
                var responseId = "",
                    prevResponseOptionValue = $('#' + columnId).val(),
                    currentQuestionId = "";
                if (splitColumnId !== undefined && splitColumnId.length > 1) {
                    responseId = splitColumnId[1];
                    currentQuestionId = splitColumnId[0];
                }

                var SeparateResponse;
                for (var i = 0; i < data.ResponseList.length; i++) {
                    if (data.ResponseList[i].ResponseId().toString() === responseId) {
                        SeparateResponse = data.ResponseList[i].SelectedControlResponse();
                    }
                }
                var updatedResponseId = MakePipeDelimited(SeparateResponse);

                SrViewModel.ValuesChanged(true);

                if (SrViewModel.SurveyTypeId() === 'CDR') {
                    for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                        if (SrViewModel.ControlsResponseData()[i].QuestionId() == currentQuestionId) {
                            for (var j = 0; j < SrViewModel.ControlsResponseData()[i].ResponseList.length; j++) {
                                if (SrViewModel.ControlsResponseData()[i].ResponseList[j].ResponseId() == responseId) {
                                    SrViewModel.ControlsResponseData()[i].ResponseList[j].ResponseInputValue(updatedResponseId);
                                    break;
                                }
                            }
                            break;
                        }
                    }
                }
                if (data.IsParentQuestion() == 1)
                    Checkforconditionalquestions(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: MultiselectResponsechangeCtrl() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ControlResponseModel(item) {
            try {
                var self = this;
                self.QuestionText = ko.observable(item.QuestionText);
                self.QuestionTextPlain = ko.observable($('<div/>').html(item.QuestionText).text());
                self.QuestionId = ko.observable(item.QuestionId);
                self.FactorId = ko.observable(item.FactorId);
                SrViewModel.Quesitonidtemp(item.QuestionId);
                self.SerialNo = ko.observable(item.SerialNo);
                self.DisplayRank = ko.observable(item.DisplayRank);
                self.CommentCount = ko.observable(item.CommentCount);
                self.DocumentCount = ko.observable(item.DocumentCount);
                self.ShowQuestionMandatoryFlag = ko.observable(item.ShowQuestionMandatoryFlag);
                self.IsConditional = ko.observable(item.IsConditional);
                self.IsHeader = ko.observable(item.IsHeader);

                self.hFactorId = ko.observable(item.HeaderFactorId);

                self.cmt_hrefId = ko.observable('#cmt_' + item.QuestionId);
                self.attachment_hrefId = ko.observable('#atch_' + item.QuestionId);
                self.guideline_hrefId = ko.observable('#gui_' + item.QuestionId);
                self.hist_hrefId = ko.observable('#hist_' + item.QuestionId);

                self.cmtId = ko.observable('cmt_' + item.QuestionId);
                self.attachmentId = ko.observable('atch_' + item.QuestionId);
                self.guidelineId = ko.observable('gui_' + item.QuestionId);
                self.histId = ko.observable('hist_' + item.QuestionId);

                self.IsReadOnly = ko.observable(item.IsReadOnly);
                self.ParentQuestionId = ko.observable(item.ParentQuestionId);
                self.ParentResponseId = ko.observable(item.ParentResponseId);
                self.IsParentQuestion = ko.observable(item.IsParentQuestion);
                self.AlwaysVisible = ko.observable(item.AlwaysVisible);
                self.Is_CommentMandatory = ko.observable(item.Is_CommentMandatory);
                self.Is_DocumentMandatory = ko.observable(item.Is_DocumentMandatory);
                self.Is_ResponseMandatory = ko.observable(item.Is_ResponseMandatory);
                self.Has_HistoricalComments = ko.observable(item.Has_HistoricalComments);
                self.Has_HistoricalResponses = ko.observable(item.Has_HistoricalResponses);
                self.Is_MultiselectQuestion = ko.observable(item.IsMultiSelect);
                self.IsVisibleforSearch = ko.observable(true);
                self.Level = ko.observable(item.Level);
                //self.IsConditionalEnable = ko.observable(0);
                self.ParentResponseType = ko.observable(item.ParentResponseType);
                self.BarPercentage = ko.observable(item.BarPercentage);
                self.InfoGuidelineComment = ko.observable(item.InfoGuidelineComment);

                if (item.Score != undefined)
                    self.Score = ko.observable(item.Score);
                else
                    self.Score = "";

                if (item.ScoreCSS != undefined) {
                    self.ScoreCSS = ko.observable(item.ScoreCSS);
                }
                else {
                    self.ScoreCSS = "";
                }

                if (item.ScoreDescription != undefined) {
                    self.ScoreDescription = ko.observable(item.ScoreDescription);
                }
                else {
                    self.ScoreDescription = "";
                }

                self.ShowFlag = (item.ShowFlag != undefined) ? item.ShowFlag : 0;

                SrViewModel.BarWidth(item.BarPercentage);

                var mappedResposneList = $.map(item.ResposneObejct, function (result) {
                    return new ControlResponseObject(result);
                });

                self.ResponseList = mappedResposneList;
                self.IsSaveClicked_Response = ko.observable(false);
                self.IsSaveClicked_Comment = ko.observable(false);
                self.IsSaveClicked_Document = ko.observable(false);
                var QuestionsArray = [];
                var QuestionSplit = self.QuestionText().split("<br/>");
                for (var i = 0; i < QuestionSplit.length - 1; i++) {
                    QuestionsArray.push(QuestionSplit[i]);
                }
                self.QuestionsList = ko.observableArray(QuestionsArray);
                self.ControlsColumnsList = ko.observableArray(item.ControlsColumnsList);
                self.BookmarkFlagQuestion = ko.observable(item.BookmarkFlagQuestion);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ControlResponseModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ControlResponseObject(item) {
            try {
                var self = this;
                self.ResponseId = ko.observable(item.ResponseId);
                self.Response = ko.observable(parseInt(item.Response));
                self.ResponseName = ko.observable($('<div/>').html(item.ResponseName).text());
                self.ResponseInputValue = ko.observable(item.ResponseInputValue);
                self.ResponseApplicability = ko.observable(item.ResponseApplicability);
                self.ResponseOptionType = ko.observable(item.ResponseOptionType);
                var mappedResposneList = $.map(item.ModelObject, function (result) {
                    return new ControlResposneSelectObject(result);
                });
                self.SelectedOptionsList = ko.observableArray(mappedResposneList);
                self.SelectedControlResponse = DecodePipeDelimited(item.ResponseInputValue);
                self.UniqueID = ko.observable(SrViewModel.Quesitonidtemp() + '_' + item.ResponseId);
                self.BookmarkFlag = ko.observable(item.BookmarkFlag);
                self.Is_ResponseMandatory_RT = ko.observable(item.Is_ResponseMandatory_RT);
                if (item.Score != undefined)
                    self.Score = ko.observable(item.Score);
                else
                    self.Score = "";

                if (item.ScoreCSS != undefined) {
                    self.ScoreCSS = ko.observable(item.ScoreCSS);
                }
                else {
                    self.ScoreCSS = "";
                }

                if (item.ScoreDescription != undefined) {
                    self.ScoreDescription = ko.observable(item.ScoreDescription);
                }
                else {
                    self.ScoreDescription = "";
                }

                self.ShowFlag = (item.ShowFlag != undefined) ? item.ShowFlag : 0;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ControlResponseObject() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ControlResposneSelectObject(item) {
            try {
                var self = this;
                self.SelectResponseId = ko.observable(item.SelectResponseId);
                self.SelectResposneOption = ko.observable($('<div/>').html(item.SelectResposneOption).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ControlSelectResponseModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Quantitative - Methods

        function InitiateQuantitativeLevelTree() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/GetAllSurveyQuantAreaLevels",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ "SurveyProfile": SrViewModel.SurveyProfileId(), "BusinessUnitId": SrViewModel.BusinessUnitId() })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateQualitativeLevelTree() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            //Quantitative
            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    if (jsonResult.ErrorID == -99) {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                            ? jsonResult.Incident_Description + " - An error has occured. Please contact your Administrator."
                            : jsonResult.Incident_Description + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                            [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                ? jsonResult.Incident_Description + " - Please contact your Administrator."
                                : jsonResult.Incident_Description + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    }
                    else {
                        //implement js tree logic here
                        SrViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);
                        var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                            return new jsTreeModel(result);
                        });

                        var NewMappedTreeSturcture = filterJsTree(MappedJsTreeList);
                        $('#jsTreeAreaLevel').treeview({
                            data: NewMappedTreeSturcture,
                            onNodeSelected: nodeClickEvent
                        });

                        var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0;
                        SrViewModel.hasChildNodes(hasChildNodes);

                        if (!SrViewModel.isSaveResponseClick()) {
                            $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                        }
                        else {
                            if (SrViewModel.selectedTreeNode() != undefined && SrViewModel.selectedTreeNode().length > 0) {
                                $('#jsTreeAreaLevel').treeview('selectNode', [SrViewModel.selectedTreeNode()[0].nodeId, { silent: true }]);
                                $('#jsTreeAreaLevel').treeview('revealNode', [SrViewModel.selectedTreeNode()[0].nodeId, { silent: true }]);
                            }
                            SrViewModel.isSaveResponseClick(false);
                        }
                    }
                }
            }
            //Quantitative
            function filterJsTree(TreeStructure) {
                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes != undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }
                        if (item.showLevel == 1)
                            return true;
                        else
                            return false;
                    }
                );
            }
            //Quantitative
            function nodeClickEvent(event, node) {
                if (node.dead_node == 1) {
                    if (SrViewModel.DashboardVM.RoutedFrom() === "Dashboard" && !SrViewModel.IsSurveyPending() && !SrViewModel.IsSurveyCompleted() && SrViewModel.ValuesChanged()) {
                        CheckForDirtyDataTreeVw(node, event);
                    }
                    else {
                        $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);
                        $('#DynamicHTMLDiv').html("");
                        $('#QualContDynamicHTMLDiv').html("");
                        $('#MCI_DynamicHTML').html("");
                        SrViewModel.SavechangedvalueSubTab(null);
                        SrViewModel.ClickedRiskFactorId(parseInt(node.id));
                        SrViewModel.ClickedRiskFactorName($('<div/>').html(node.text).text());
                        SrViewModel.ClickedRiskFactorGuidelines($('<div/>').html(node.categoryGuidelines).text());
                        SrViewModel.Is_RefreshEnable(node.Is_RefreshEnable);
                        SrViewModel.Tick_Flag(node.Tick_Flag);
                        SrViewModel.ClickedRiskAreaId(node.ParentAreaId);
                        SrViewModel.ClickedRiskAreaName(node.ParentAreaName);
                        SrViewModel.ClickedRiskAreaCategoryGuidelines(node.ParentGuidelines);
                        SrViewModel.SelectedNode(node);
                        $('#LoadingGIFSRDiv').modal('show');
                        if (node.nodeId === 0 && (parseInt(node.id) === -1000 || parseInt(node.id) === -998)) {
                            SrViewModel.MCILevel(true);
                            GetMCI_LevelDetails();
                        } else {
                            SrViewModel.MCILevel(false);
                            GetQuanColumnDetails().then(function () {
                                BindQuantiativeTable();
                            });
                            GetInstructions(SrViewModel.ClickedRiskFactorId());
                        }
                        $(window).scrollTop(0);
                    }
                } else {
                    //recursively opening until the dead_node arrives.
                    if (!(node.state.expanded)) {
                        if (node.nodeId === node.Level - 1)
                            nodeClickEvent(event, node.nodes[0]);
                    }
                    $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                    $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);
                }
            }
            //Quantitative
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateQuantitativeLevelTree() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateQuantitativeLevelTree() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetQuanColumnDetails() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                return $.ajax({
                    url: "/api/Survey/GetQuanColumnDetails",
                    headers: headers,
                    type: "POST",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        "FactorId": SrViewModel.ClickedRiskFactorId(),
                        "Draft": SrViewModel.SurveyId(),
                    })
                })
                    .success(function (JsonResult, Success) {
                        if (JsonResult != null) {
                            if (JsonResult.length > 0 && JsonResult[0].Incident_Description != null && JsonResult[0].Incident_Description.substring(0, 3) == "INC") {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? JsonResult[0].Incident_Description + " - An error occurred. Please contact your Application Administrator."
                                    : JsonResult[0].Incident_Description + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                SrViewModel.QuanColumnDetails([]);
                                var MappedColumnObject = $.map(JsonResult, function (result) {
                                    return new QuanColumnDetailsModel(result);
                                });
                                SrViewModel.QuanColumnDetails(MappedColumnObject);
                            }
                        }
                    })
                    .fail(function (Error, fail) { });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQuanColumnDetails() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function BindQuantiativeTable() {
            try {
                $('#LoadingGIFSRDiv').modal('show');

                SrViewModel.BreadCrumbArray([]);
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/Survey/GetQuanResponseData",
                    headers: headers,
                    type: "POST",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        "FactorId": SrViewModel.ClickedRiskFactorId(),
                        "Draft": SrViewModel.SurveyId(),
                    })
                })
                    .success(function (JsonResult, Success) {
                        if (JsonResult != null && JsonResult.ErrorID == -99) {
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                ? JsonResult.ErrorName + " - An error has occured. Please contact your Administrator."
                                : JsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                    (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? JsonResult.ErrorName + " - Please contact your Administrator."
                                    : JsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            if (JsonResult != null && JsonResult.lstAreaLevelModel != undefined) {
                                var mappeedBreadCrums = $.map(JsonResult.lstAreaLevelModel, function (result) {
                                    return new BreadCrumbsModel(result);
                                })
                                SrViewModel.BreadCrumbArray(mappeedBreadCrums);
                            }

                            SrViewModel.MaxCount(0);
                            var MappedRankCount = $.map(JsonResult.QuanResponseModel, function (result) {
                                return result.RankCount;
                            });
                            var Distinct = ko.computed(function () {
                                return ko.utils.arrayGetDistinctValues(MappedRankCount).sort();
                            });
                            if (Distinct().length > 1) {
                                SrViewModel.Difference(Distinct().length);
                            }
                            else {
                                SrViewModel.Difference(Distinct().length);
                            }
                            var MappedResponses = $.map(JsonResult.QuanResponseModel, function (result) {
                                if (SrViewModel.MaxCount() < result.RankCount) {
                                    SrViewModel.MaxCount(result.RankCount);
                                }
                                return new QuantitativeResponseModel(result);
                            });
                            SrViewModel.QuanResponseObject(MappedResponses);
                            setSurveyLevelMandatoryList();
                            BindDynamicHtmlQuantitative();
                            $('#LoadingGIFSRDiv').modal('hide');
                        }
                    })
                    .fail(function (fail, error) {
                        $('#LoadingGIFSRDiv').modal('hide');
                    });
            }
            catch (e) {
                $('#LoadingGIFSRDiv').modal('hide');
                var msg = 'Exception: ' + e + ' | Source: BindQuantiativeTable() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function BindDynamicHtmlQuantitative() {
            try {
                var DynamicHTML = "";
                SrViewModel.hasHeaderQuestions(false);
                DynamicHTML += '<div id="accordionQuant">'; // accordion open

                DynamicHTML += '<div  class="card-header header-card">'; // header - factor open
                DynamicHTML += '<span class="cp_assessment">';
                DynamicHTML += '<a id="accHeaderMain_' + SrViewModel.ClickedRiskFactorId() + '" href="#accHeader_' + SrViewModel.ClickedRiskFactorId() + '" data-toggle="collapse" data-parent="#accordionQuant" aria-expanded="true" class="arrow-switch">';
                DynamicHTML += '<i class="fa fa-fw fa-caret-accordion"></i> <span data-bind="html: $root.ClickedRiskFactorName"></span></a>';
                //DynamicHTML += '<i class="fa fa-info-circle cursor-pointer" data-bind="click: function() { $root.SubCategoryInfoClick(\'factor\')}" title="Click here to view the Description" style="color:#00A3E0"></i>';
                DynamicHTML += '</span>';
                //DynamicHTML += '<span class="threshold-cell heatmap-green sync-rat">Low</span>';
                DynamicHTML += '</div>'; // header - factor close

                DynamicHTML += '<div class="collapse show" id="accHeader_' + SrViewModel.ClickedRiskFactorId() + '" >'; // collapse acc. open
                DynamicHTML += '<div class="question-card">'; // question-card table open
                DynamicHTML += '<div class="card card-body">'; // card table open;
                DynamicHTML += '<label class="field-validation-error" id="QuantSurveyError" style="display: none;"></label>';
                DynamicHTML += '<table id="tblQuanResponseResponse" class="table table-bordered table-condensed dataTable qtable">';
                DynamicHTML += '<thead>';
                DynamicHTML += '<tr><th class="site_name " rowspan="1" colspan="1" style="display:none;">#</th>';
                DynamicHTML += '<th style="display:none" class="site_name " rowspan="1" colspan="1">QuestionId</th>';
                DynamicHTML += '<th class="site_name " rowspan="1" colspan="1"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Question\') == -1 )? \'Question\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Question\')].Name"></span></th>';
                //var width = 40 / SrViewModel.QuanColumnDetails().length;
                for (var i = 0; i < SrViewModel.QuanColumnDetails().length; i++) {
                    if (SrViewModel.QuanColumnDetails()[i].OptionType() !== 'T' && SrViewModel.QuanColumnDetails()[i].OptionType() !== 'TH')
                        DynamicHTML += '<th class="site_name sorting_disabled" rowspan="1" colspan="1" >' + SrViewModel.QuanColumnDetails()[i].ColumnName() + '</th>';
                }
                DynamicHTML += '<th class="site_name sorting_disabled" rowspan="1" colspan="1" style=" text-align: center;width: 35px !important;"><div class="alable"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'ActionsHeading\') == -1 )? \'Actions\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'ActionsHeading\')].Name"></span></div></th></tr>';

                DynamicHTML += '<tr>';
                DynamicHTML += '<th rowspan="1" colspan="1" style="display:none"></th>';
                DynamicHTML += '<th rowspan="1" colspan="1" style="display:none"></th>';
                DynamicHTML += '<th class="td-label" rowspan="1" colspan="1"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TotalHeading\') == -1 )? \'Total\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TotalHeading\')].Name"></span></th>';
                for (var i = 0; i < SrViewModel.QuanColumnDetails().length; i++) {
                    if (SrViewModel.QuanColumnDetails()[i].OptionType() !== 'T' && SrViewModel.QuanColumnDetails()[i].OptionType() !== 'TH')
                        DynamicHTML += '<th class="text-right td-label" data-bind="text: $root.QuanColumnDetails()[' + i + '].ColumnTotal" rowspan="1" colspan="1"></th>';
                }
                DynamicHTML += '<th rowspan="1" colspan="1"></th>';
                DynamicHTML += '</tr>';
                DynamicHTML += '</thead>';

                DynamicHTML += '<tbody>';
                DynamicHTML += '<!-- ko foreach: $root.QuanResponseObject -->';
                DynamicHTML += '<!-- ko if: (QuestionType() != \'T\' && QuestionType() != \'TH\') -->';
                DynamicHTML += '<tr  data-bind="if:  IsVisibleforSearch(), css: { GreyBackground : Is_Header() == 1}">';
                DynamicHTML += '<!-- ko if: (IndentationValue() == 0 || IndentationValue() == 1) --> <td style="display:none;"><div class="qid-class"><sup><i class="text-danger fa fa-asterisk mr-1 font-xsmall" data-bind="visible: IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup><label data-bind="text:DisplayRank"></label></div></td><!-- /ko -->';
                DynamicHTML += '<!-- ko if: (IndentationValue() == 2) --> <td style="display:none; padding-left:' + 1.5 + 'em !important;" ><div class="qid-class"><sup><i class="text-danger fa fa-asterisk mr-1 font-xsmall" data-bind="visible: IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup><label data-bind="text:DisplayRank"></label></div></td><!-- /ko -->';
                DynamicHTML += '<!-- ko if: (IndentationValue() == 3) --> <td style="display:none; padding-left:' + 2.5 + 'em !important;" ><div class="qid-class"><sup><i class="text-danger fa fa-asterisk mr-1 font-xsmall" data-bind="visible: IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup><label data-bind="text:DisplayRank"></label></div></td><!-- /ko -->';
                DynamicHTML += '<!-- ko if: (IndentationValue() == 4) --> <td style="display:none; padding-left:' + 3.5 + 'em !important;" ><div class="qid-class"><sup><i class="text-danger fa fa-asterisk mr-1 font-xsmall" data-bind="visible: IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup><label data-bind="text:DisplayRank"></label></div></td><!-- /ko -->';
                DynamicHTML += '<!-- ko if: (IndentationValue() == 5) --> <td style="display:none; padding-left:' + 4.5 + 'em !important;" ><div class="qid-class"><sup><i class="text-danger fa fa-asterisk mr-1 font-xsmall" data-bind="visible: IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup><label data-bind="text:DisplayRank"></label></div></td><!-- /ko -->';
                DynamicHTML += '<!-- ko if: (IndentationValue() == 6) --> <td style="display:none; padding-left:' + 5.5 + 'em !important;" ><div class="qid-class"><sup><i class="text-danger fa fa-asterisk mr-1 font-xsmall" data-bind="visible: IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup><label data-bind="text:DisplayRank"></label></div></td><!-- /ko -->';

                DynamicHTML += '<td style="display:none" data-bind="text:QuestionId"></td>';
                DynamicHTML += '<!-- ko if: (IndentationValue() == 0 || IndentationValue() == 1) --> <td ><span><sup><i class="text-danger fa fa-asterisk mr-1 font-xsmall" data-bind="visible: IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup><span data-bind="html:QuestionText"></span></span></td> <!-- /ko -->';
                DynamicHTML += '<!-- ko if: (IndentationValue() == 2) --> <td style="padding-left:' + 1.5 + 'em !important;" ><span><sup><i class="text-danger fa fa-asterisk mr-1 font-xsmall" data-bind="visible: IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup><span data-bind="html:QuestionText"></span></span></td> <!-- /ko -->';
                DynamicHTML += '<!-- ko if: (IndentationValue() == 3) --> <td style="padding-left:' + 2.5 + 'em !important;" ><span><sup><i class="text-danger fa fa-asterisk mr-1 font-xsmall" data-bind="visible: IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup><span data-bind="html:QuestionText"></span></span></td> <!-- /ko -->';
                DynamicHTML += '<!-- ko if: (IndentationValue() == 4) --> <td style="padding-left:' + 3.5 + 'em !important;" ><span><sup><i class="text-danger fa fa-asterisk mr-1 font-xsmall" data-bind="visible: IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup><span data-bind="html:QuestionText"></span></span></td> <!-- /ko -->';
                DynamicHTML += '<!-- ko if: (IndentationValue() == 5) --> <td style="padding-left:' + 4.5 + 'em !important;" ><span><sup><i class="text-danger fa fa-asterisk mr-1 font-xsmall" data-bind="visible: IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup><span data-bind="html:QuestionText"></span></span></td> <!-- /ko -->';
                DynamicHTML += '<!-- ko if: (IndentationValue() == 6) --> <td style="padding-left:' + 5.5 + 'em !important;" ><span><sup><i class="text-danger fa fa-asterisk mr-1 font-xsmall" data-bind="visible: IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup><span data-bind="html:QuestionText"></span></span></td> <!-- /ko -->';
                for (var i = 0; i < SrViewModel.QuanColumnDetails().length; i++) {
                    if (SrViewModel.QuanColumnDetails()[i].OptionType() !== 'T' && SrViewModel.QuanColumnDetails()[i].OptionType() !== 'TH') {
                        DynamicHTML += '<td class="site_name text-center">';
                        DynamicHTML += '<div data-bind="visible : Is_Header() != 1">';
                        DynamicHTML += '<input type="text" data-bind="attr: { class: (IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag()) && ResponseList[' + i + '].Is_ResponseMandatory_RT()) ? \'form-control text-right qinput mand-input\' : \'form-control text-right qinput\'}, value:ResponseList[' + i + '].ResponseValue,disable:($root.DisableControl() || !$root.appsecurity.WriteAccess()), event:{change:$root.ValidateResponse}">';
                        DynamicHTML += '</div>';
                        DynamicHTML += '</td>';
                    }
                }
                DynamicHTML += '<td class="site_name text-center aicon"> <div> <span class="q-aicon" data-bind="visible : Is_Header() != 1">';
                DynamicHTML += '<span class="font-mand"><sup data-bind="visible: IsSaveClicked_Comment() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"><i class="text-danger fa fa-asterisk font-xxsmall" style="font-size: 8px !important;"></i></sup></span>';
                DynamicHTML += '<a class="btn-borderless widget-button" data-bind="attr: {title: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'CommentsButtonTitle\') == -1 )? \'Click to view/save the Comments\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'CommentsButtonTitle\')].Name}, click: $root.ShowCommentsPopUp">';
                DynamicHTML += '<i class="demo-icon icon-commenting_special"></i>';
                DynamicHTML += '<!-- ko if: (CommentCount() == 0) --> <span class="qqount disable" data-bind="text: CommentCount">0</span> <!-- /ko -->';
                DynamicHTML += '<!-- ko if: (CommentCount() > 0) --> <span class="qqount" data-bind="text: CommentCount">0</span> <!-- /ko -->';
                DynamicHTML += '</a></span>';
                DynamicHTML += '<span class="q-aicon" data-bind="visible : Is_Header() != 1">';
                DynamicHTML += '<span class="font-mand"><sup data-bind="visible: IsSaveClicked_Document() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"><i class="text-danger fa fa-asterisk font-xxsmall" style="font-size: 8px !important;"></i></sup></span>';
                DynamicHTML += '<a class="btn-borderless widget-button" data-bind="attr: {title: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AttachmentsButtonTitle\') == -1 )? \'Click to view/upload Attachments\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AttachmentsButtonTitle\')].Name}, click: $root.ShowUploadDocumentsPopUp">';
                DynamicHTML += '<i class="demo-icon icon-paperclip_special"></i>';
                DynamicHTML += '<!-- ko if: (DocumentCount() == 0) --> <span class="qqount disable" data-bind="text: DocumentCount">0</span> <!-- /ko -->';
                DynamicHTML += '<!-- ko if: (DocumentCount() > 0) --> <span class="qqount" data-bind="text: DocumentCount">0</span> <!-- /ko -->';
                DynamicHTML += '</a></span>';
                DynamicHTML += '<span data-bind="visible : Is_Header() != 1">';
                DynamicHTML += '<a class="btn-borderless widget-button" data-bind="attr: {title: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoricalButtonTitle\') == -1 )? \'Click to view Historical Responses and Comments\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoricalButtonTitle\')].Name}, click: $root.ShowHistroyPopUp">' +
                    '<i class="demo-icon icon-backup_special"></i></a>';
                DynamicHTML += '</span>';
                DynamicHTML += '<span data-bind="visible : Is_Header() != 1">';
                DynamicHTML += '<a class="btn-borderless widget-button" data-bind="attr: {title: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesButtonTitle\') == -1 )? \'Click to view Guidelines\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesButtonTitle\')].Name}, click: $root.ShowGuidelinesPopUp">' +
                    '<i class="demo-icon icon-document_1_special"></i></a>';
                DynamicHTML += '</span>';
                DynamicHTML += '<span data-bind="visible : Is_Header() != 1"><label data-bind="attr:{\'for\': bmFlagID}, visible: $root.ShowBookmarkFlags(), event: {change: function(data,event) {$root.BookmarkFlagChangeEvent(data, event)} }"><input type="checkbox" class="flagbox" data-bind="attr:{\'id\': bmFlagID }, checked: BookmarkFlagQuestion, disable: $root.DisableControl() || !$root.appsecurity.WriteAccess()"><span class="flag"><i class="fa fa-flag"></i></span></label>';
                DynamicHTML += '</span></div></td></tr>';
                DynamicHTML += '<!-- /ko -->';
                DynamicHTML += '<!-- /ko -->';
                DynamicHTML += '</tbody>';
                DynamicHTML += '</table>';
                DynamicHTML += '</div>'; // card table close
                DynamicHTML += '</div>'; // question-card table close

                DynamicHTML += '</div>'; // collapse acc. close


                for (hq = 0; hq < SrViewModel.QuanResponseObject().length; hq++) {

                    if (SrViewModel.QuanResponseObject()[hq].QuestionType() == 'TH') {

                        SrViewModel.hasHeaderQuestions(true);
                        DynamicHTML += '<div class="card-header header-card">'; // header - nonQuant Question open
                        DynamicHTML += '<span class="cp_assessment">';
                        DynamicHTML += '<a id="accNQHeaderMain_' + SrViewModel.QuanResponseObject()[hq].HeaderUID() + '" href="#accNQHeader_' + SrViewModel.QuanResponseObject()[hq].HeaderUID() + '" data-toggle="collapse" data-parent="#accordionQuant" aria-expanded="false" class="arrow-switch">';
                        DynamicHTML += '<i class="fa fa-fw fa-caret-accordion"></i>' + SrViewModel.QuanResponseObject()[hq].QuestionText() + '</a > ';
                        DynamicHTML += '</span>';
                        DynamicHTML += '</div>'; // header - nonQuant Question close

                        DynamicHTML += '<div class="collapse show" id="accNQHeader_' + SrViewModel.QuanResponseObject()[hq].HeaderUID() + '" >'; // collapse accNQ. open

                        for (var j = 0; j < SrViewModel.QuanResponseObject().length; j++) {
                            if (SrViewModel.QuanResponseObject()[j].QuestionType() === 'T' && SrViewModel.QuanResponseObject()[j].HeaderUID() == SrViewModel.QuanResponseObject()[hq].HeaderUID()) {

                                DynamicHTML += '<div class="question-card">'; // question-card RTB open
                                DynamicHTML += '<div class="card">'; // card RTB open
                                DynamicHTML += '<div data-bind="if: $root.QuanResponseObject()[' + j + '].IsVisibleforSearch">'; // IsVisible RTB div open

                                for (var k = 0; k < SrViewModel.QuanResponseObject()[j].ResponseList.length; k++) {
                                    for (var h = 0; h < SrViewModel.QuanColumnDetails().length; h++) {
                                        if (SrViewModel.QuanColumnDetails()[h].OptionType() === 'T' &&
                                            SrViewModel.QuanResponseObject()[j].ResponseList[k].ResponseId() === SrViewModel.QuanColumnDetails()[h].ColumnId()) {

                                            DynamicHTML += '<div class="card-body">'; // card-body RTB open
                                            DynamicHTML += '<div class="pl-4 row">'; // pl-4 div open
                                            DynamicHTML += '<div class="col-md-11 pr-0">'; //col-11 div open
                                            DynamicHTML += '<sup><i class="text-danger fa fa-asterisk mr-2 font-xsmall" data-bind="visible: $root.QuanResponseObject()[' + j + '].ResponseList[' + k + '].Is_ResponseMandatory_RT() && $root.QuanResponseObject()[' + j + '].IsSaveClicked_Response() && $root.Is_RefreshEnable() && !($root.Tick_Flag())"></i></sup>';
                                            DynamicHTML += '<span class="card-title question-text">';
                                            DynamicHTML += '<span>' + SrViewModel.QuanResponseObject()[j].QuestionText();
                                            DynamicHTML += '</div>'; //col-11 div colse
                                            DynamicHTML += '<div class="col-md-1"><label for="' + SrViewModel.QuanResponseObject()[j].bmFlagID() + '" class="pull-right" data-bind="visible: $root.ShowBookmarkFlags(), event: {change: function(data,event) {$root.BookmarkFlagChangeEvent($root.QuanResponseObject()[' + j + '], event)} }"><input id="' + SrViewModel.QuanResponseObject()[j].bmFlagID() + '" data-bind="checked: $root.QuanResponseObject()[' + j + '].BookmarkFlagQuestion, disable:  $root.QuanResponseObject()[' + j + '].IsReadOnly() == 1 || $root.DisableControl() || !$root.appsecurity.WriteAccess()" type="checkbox" class="flagbox"><span class="flag"><i class="fa fa-flag"></i></span></label></div>';
                                            DynamicHTML += '</span></span>';
                                            //col-11 for responses div open
                                            DynamicHTML += '<div class="col-md-11 pr-0 mt-2"><h6 class="card-subtitle text-muted mb-1">' + SrViewModel.QuanColumnDetails()[h].ColumnName() + '</h6></div>';
                                            //col-11 for responses div open

                                            if (SrViewModel.QuanResponseObject()[j].ResponseList[k].ResponseOptionType() === 'T') {

                                                var data = '$root.QuanResponseObject()[' + j + ']';
                                                var QuestionId = SrViewModel.QuanResponseObject()[j].QuestionId();
                                                var cmtId = SrViewModel.QuanResponseObject()[j].cmtId();
                                                var attachmentId = SrViewModel.QuanResponseObject()[j].attachmentId();
                                                var histId = SrViewModel.QuanResponseObject()[j].histId();
                                                var guidelineId = SrViewModel.QuanResponseObject()[j].guidelineId();
                                                var ResponseIdVM = SrViewModel.QuanResponseObject()[j].ResponseList[k].ResponseId();

                                                var cmt_hrefId = SrViewModel.QuanResponseObject()[j].cmt_hrefId();
                                                var attachment_hrefId = SrViewModel.QuanResponseObject()[j].attachment_hrefId();
                                                var hist_hrefId = SrViewModel.QuanResponseObject()[j].hist_hrefId();
                                                var guideline_hrefId = SrViewModel.QuanResponseObject()[j].guideline_hrefId();

                                                DynamicHTML += '<div class="col-md-11 pr-0 mt-1">'; // RTB open

                                                DynamicHTML += '<!-- ko if: ($root.DisableControl() || !$root.appsecurity.WriteAccess())-->';
                                                DynamicHTML += '<textarea rows="2" class="ta-disabled" disabled data-bind="attr:{id: \'ResponseType_' + QuestionId + '_' + ResponseIdVM + '\'}, value: $root.QuanResponseObject()[' + j + '].ResponseList[' + k + '].ResponseValue"></textarea>';
                                                DynamicHTML += '<!--/ko-->';

                                                DynamicHTML += '<!-- ko if: (!$root.DisableControl() || $root.appsecurity.WriteAccess())-->';
                                                DynamicHTML += '<textarea data-bind="attr:{id: \'ResponseType_' + QuestionId + '_' + ResponseIdVM + '\', placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\') == -1 )? \'Type Response\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'TypeResponsePlaceholder\')].Name}, value: $root.QuanResponseObject()[' + j + '].ResponseList[' + k + '].ResponseValue" class="form-control w-100"></textarea>';
                                                DynamicHTML += '<!--/ko-->';
                                                DynamicHTML += '</div>'; // RTB close


                                                DynamicHTML += '</div>'; // pl-4 div close
                                                DynamicHTML += '</div>'; // card-body RTB close

                                                DynamicHTML += '<div>'; // menu items div open
                                                DynamicHTML += '<ul class="float-right nav nav-tabs">';
                                                DynamicHTML += '<li class="nav-item">';
                                                DynamicHTML += '<a class="nav-link" data-bind="attr:{ id: \'cmt_Q_Id' + QuestionId + '\', href: \'' + cmt_hrefId + '\' }, click:function(data, event) {$root.ShowExtraContent(\'' + cmtId + '\', ' + data + ', \'' + QuestionId + '\') }">';
                                                DynamicHTML += '<i class="demo-icon icon-commenting_special"></i>';
                                                DynamicHTML += '<span data-bind="if: $root.QuanResponseObject()[' + j + '].CommentCount() > 0">';
                                                DynamicHTML += '<span class="qqount" data-bind="text: $root.QuanResponseObject()[' + j + '].CommentCount">0</span>';
                                                DynamicHTML += '</span>';
                                                DynamicHTML += '<span data-bind="visible: $root.QuanResponseObject()[' + j + '].IsSaveClicked_Comment() && $root.Is_RefreshEnable() && !($root.Tick_Flag())">';
                                                DynamicHTML += '<sup><i class="text-danger fa fa-asterisk font-xxsmall"></i></sup>';
                                                DynamicHTML += '</span>';
                                                DynamicHTML += '<span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\') == -1) ? \'Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\')].Name"></span></a></li>';
                                                DynamicHTML += '<li class="nav-item">';
                                                DynamicHTML += '<a class="nav-link" data-bind="attr:{ id: \'atch_Q_Id' + QuestionId + '\', href: \'' + attachment_hrefId + '\' }, click:function(data, event) {$root.ShowExtraContent(\'' + attachmentId + '\', ' + data + ', \'' + QuestionId + '\') }">';
                                                DynamicHTML += '<i class="demo-icon icon-paperclip_special"></i>';
                                                DynamicHTML += '<span data-bind="if: $root.QuanResponseObject()[' + j + '].DocumentCount() > 0">';
                                                DynamicHTML += '<span class="qqount" data-bind="text: $root.QuanResponseObject()[' + j + '].DocumentCount">0</span>';
                                                DynamicHTML += '</span>';
                                                DynamicHTML += '<span data-bind="visible: $root.QuanResponseObject()[' + j + '].IsSaveClicked_Document()  && $root.Is_RefreshEnable() && !($root.Tick_Flag())">';
                                                DynamicHTML += '<sup><i class="text-danger fa fa-asterisk font-xxsmall"></i></sup>';
                                                DynamicHTML += '</span>';
                                                DynamicHTML += '<span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Attachments\') == -1) ? \'Attachments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Attachments\')].Name"></span></a></li> ';
                                                DynamicHTML += '<li class="nav-item">';
                                                DynamicHTML += '<a class="nav-link" data-bind="attr:{ id: \'hist_Q_Id' + QuestionId + '\', href: \'' + hist_hrefId + '\' }, click:function(data, event) {$root.ShowExtraContent(\'' + histId + '\', ' + data + ', \'' + QuestionId + '\') }"><i class="demo-icon icon-backup_special"></i><span data-bind="html: ((!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoryHeading\') == -1) ? \'History\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoryHeading\')].Name)"></span></a>';
                                                DynamicHTML += '</li>';
                                                DynamicHTML += '<li class="nav-item">';
                                                DynamicHTML += '<a class="nav-link" data-bind="attr:{ id: \'gui_Q_Id' + QuestionId + '\', href: \'' + guideline_hrefId + '\' }, click:function(data, event) {$root.ShowExtraContent(\'' + guidelineId + '\', ' + data + ', \'' + QuestionId + '\') }"><i class="demo-icon icon-document_1_special"></i><span data-bind="html: ((!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesHeading\') == -1) ? \'Guidelines\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesHeading\')].Name)"></span></a>';
                                                DynamicHTML += '</li>';
                                                DynamicHTML += '</ul>';
                                                DynamicHTML += '</div>'; // menu items div close

                                                // comments box open
                                                DynamicHTML += '<div data-bind="attr:{ id: \'' + cmtId + '\' }" class="actions-box col-lg-12 p-0" style="display:none;" >'; // comments box div open
                                                DynamicHTML += '<div class="title"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\') == -1) ? \'Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\')].Name"></span> <button type="button" class="btn float-right" data-bind="click:$root.HideExtraContent(\'' + QuestionId + '\')"><span><i class="demo-icon icon-cross_special"></i></span></button></div>';
                                                DynamicHTML += '<div class="card-body">';  // card body inside comments div open

                                                DynamicHTML += '<div data-bind="if: $root.QuanResponseObject()[' + j + '].IsReadOnly()==0 && ($root.DisableControl() == false || $root.appsecurity.WriteAccess())">'; // conditions binding div open
                                                DynamicHTML += '<h6 class="card-title" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AddCommentHeading\') == -1) ? \'Add Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AddCommentHeading\')].Name"></h6>';
                                                //DynamicHTML += '<div class="col-lg-4 pl-0 pb-1">';
                                                //DynamicHTML += '<select id="ResponseId" class="form-control h-auto"  name="Applicable" data-bind="options: $root.QualColumnDetailsDropDown, optionsText: \'ColumnName\', optionsValue: \'ColumnId\', value:$root.SelectedColumnId"></select>'
                                                //DynamicHTML += '</div>';
                                                DynamicHTML += '<span style="display: none;" data-bind="text: $root.QuanResponseObject()[' + j + '].ResponseList[' + k + '].ResponseId()"></span>';
                                                DynamicHTML += '<div class="chars-left"> <span class="chars-left-lbl mr-1" data-bind="text: $root.RemainingChars()"></span><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'RemainingCharactersleft\') == -1) ? \'Characters left\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'RemainingCharactersleft\')].Name"></span></div>';
                                                DynamicHTML += '<textarea data-bind="attr:{id: \'ResponseTextArea_' + QuestionId + '\', placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EnterCommentsPlaceholder\') == -1 )? \'Your Comments\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EnterCommentsPlaceholder\')].Name}, event: {keydown: $root.OcKeypress, keyup: $root.OcKeyUp}" rows="6" class="w-100"></textarea>';
                                                DynamicHTML += '<span class="field-validation-error" data-bind="attr:{id: \'lblRCError_' + QuestionId + '\'}"></span>';
                                                DynamicHTML += '</div>'; // conditions binding div close

                                                DynamicHTML += '<div>'; // comments secondary div open
                                                DynamicHTML += '<div data-bind="if: $root.QuanResponseObject()[' + j + '].IsReadOnly()==0 && ($root.DisableControl() == false || $root.appsecurity.WriteAccess())">';
                                                DynamicHTML += '<button class="primary-btn" type="submit" data-bind="html: $root.SaveCommentButtonName(), click:function(data, event) { $root.SaveComment(\'' + QuestionId + '\',' + data + ', event)}, attr:{id: \'saveCommentBtn_' + QuestionId + '\'}, disable: $root.QuanResponseObject()[' + j + '].IsReadOnly() == 1"></button>';
                                                DynamicHTML += '<button class="secondary-btn ml-2"  type="submit" data-bind=" html:(!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'CancelButton\') == -1) ? \'Cancel\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'CancelButton\')].Name, click:function(data, event) { $root.CancelComment(\'' + QuestionId + '\',' + data + ', event)}, attr:{id: \'cancelCommentBtn_' + QuestionId + '\'}, disable: $root.QuanResponseObject()[' + j + '].IsReadOnly() == 1"></button>';
                                                DynamicHTML += '</div>';

                                                //sub-nav list - comments open
                                                DynamicHTML += '<div class="hactions">';
                                                DynamicHTML += '<ul class="float-right nav nav-tabs" style="margin-top: -1.4rem !important;">';
                                                DynamicHTML += '<li class="nav-item">';
                                                DynamicHTML += '<a class="nav-link" data-bind="attr:{ href: \'#cmt_Sub_hrefId' + QuestionId + '\', id: \'cmt_Sub_Id' + QuestionId + '\' }, click:function(data, event) { $root.ShowExtraSubContent(\'' + QuestionId + '\', \'cmt_Sub_hrefId' + QuestionId + '\', \'cmt\')}"> <i class="demo-icon icon-commenting_special"></i>';
                                                DynamicHTML += '<span data-bind="if: $root.QuanResponseObject()[' + j + '].CommentCount() > 0">';
                                                DynamicHTML += '<span class="qqount" data-bind="text: $root.QuanResponseObject()[' + j + '].CommentCount">0</span>';
                                                DynamicHTML += '</span>';
                                                DynamicHTML += '<span data-bind=" html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\') == -1) ? \'Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Comments\')].Name"></span></a></li>';
                                                DynamicHTML += '<li class="nav-item">';
                                                DynamicHTML += '<a class="nav-link" data-bind="attr:{ href: \'#cmt_Sub_Hist_hrefId' + QuestionId + '\', id: \'cmt_Sub_Hist_Id' + QuestionId + '\' }, click:function(data, event) { $root.ShowExtraSubContent(\'' + QuestionId + '\', \'cmt_Sub_Hist_hrefId' + QuestionId + '\', \'hist\')}"><i class="demo-icon icon-backup_special"></i><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoricalCommentsHeading\') == -1) ? \'Historical Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoricalCommentsHeading\')].Name"></span></a>';
                                                DynamicHTML += '</li>';
                                                DynamicHTML += '</ul>';
                                                DynamicHTML += '</div>';
                                                //sub-nav list - comments close

                                                //sub-comments box - comments open
                                                DynamicHTML += '<div data-bind="attr:{ id: \'cmt_Sub_hrefId' + QuestionId + '\' }" class="commentSubBox" style="display:none;">';
                                                DynamicHTML += '<div class="c-box" data-bind="attr:{ id: \'cmt_List_' + QuestionId + '\' }"></div>';
                                                DynamicHTML += '</div>';
                                                //sub-comments box - comments close
                                                //sub-comments box - Historical comments open
                                                DynamicHTML += '<div data-bind="attr:{ id: \'cmt_Sub_Hist_hrefId' + QuestionId + '\' }" class="commentSubBox" style="display:none;">';
                                                DynamicHTML += '<span class="" data-bind="attr:{ id: \'Hist_cmt_List_' + QuestionId + '\' }" ></span>';
                                                DynamicHTML += '</div>';
                                                //sub-comments box - Historical comments close

                                                DynamicHTML += '</div>'; // comments secondary div close
                                                DynamicHTML += '</div>'; // card body inside comments div close
                                                DynamicHTML += '</div>'; // comments box div close

                                                ///attahement box open
                                                DynamicHTML += ' <div data-bind="attr:{ id: \'' + attachmentId + '\' }" class="actions-box col-lg-12 p-0" style="display:none;">';// attachement box div open
                                                DynamicHTML += ' <div class="title"> <span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Attachments\') == -1) ? \'Attachments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'Attachments\')].Name"></span> <button type="button" class="btn float-right" data-bind="click:$root.HideExtraContent(\'' + QuestionId + '\')"><span><i class="demo-icon icon-cross_special"></i></span></button></div>';
                                                DynamicHTML += '<div data-bind="if: $root.QuanResponseObject()[' + j + '].IsReadOnly()==0 && ($root.DisableControl() == false || $root.appsecurity.WriteAccess())">'; // conditions binding attachements div open
                                                DynamicHTML += ' <div class="card-body">';// card body inside attachements div open
                                                DynamicHTML += ' <h6 class="card-title" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadDocumentsHeading\') == -1) ? \'Upload Documents\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadDocumentsHeading\')].Name"></h6>';
                                                DynamicHTML += ' <div class="col-lg-4 pl-0 pb-1">';
                                                DynamicHTML += ' <input type="file" class="form-control" data-bind="attr:{ id: \'FileUploaderForDocuments_' + QuestionId + '\' }, disable:  $root.QuanResponseObject()[' + j + '].IsReadOnly() == 1" placeholder="Select File(s)" />';
                                                DynamicHTML += ' </div>';
                                                DynamicHTML += ' <div class="chars-left"> <span class="chars-left-lbl mr-1" data-bind="text: $root.RemainingChars()"></span><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'RemainingCharactersleft\') == -1) ? \'Characters left\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'RemainingCharactersleft\')].Name"></span></div>';
                                                DynamicHTML += ' <textarea class="w-100" data-bind="attr:{ id: \'UploadTextArea_' + QuestionId + '\', placeholder: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EnterCommentsPlaceholder\') == -1 )? \'Your Comments\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EnterCommentsPlaceholder\')].Name}, event: {keydown: $root.OcKeypress, keyup: $root.OcKeyUp}" rows="6"></textarea>';
                                                DynamicHTML += ' <div data-bind="attr:{ id: \'ProgressBarMainDiv_' + QuestionId + '\' }" class="col-md-5" style="display:none">';
                                                //DynamicHTML += '<div id="ProgressBarDiv" class="progressbar-control">'
                                                //DynamicHTML += '<span id="ProgressBar" class="item-bar blue" data-bind="style:{width: $root.ProgressPercent}, text: $root.ProgressPercent"></span>'
                                                //DynamicHTML += '</div>'
                                                DynamicHTML += '<p data-bind="attr:{ id: \'lblProgressMsg_' + QuestionId + '\' }, text: $root.ProgressMessage"></p>';
                                                DynamicHTML += '</div>';
                                                DynamicHTML += '<div class="col-lg-12 field-validation-error" data-bind="attr:{ id: \'lblRDError_' + QuestionId + '\' }"></div>';
                                                DynamicHTML += ' <button id="UploadDocuments" class="secondary-btn" type="submit" data-bind="attr: {title: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadDocumentPlacholder\') == -1 )? \'Upload Document\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadDocumentPlacholder\')].Name}, click:function(data, event) { $root.UploadDocument(' + data + ')}, disable:  $root.QuanResponseObject()[' + j + '].IsReadOnly() == 1 || ($root.DisableControl() || !$root.appsecurity.WriteAccess())">';
                                                DynamicHTML += ' <i class="fa fa-upload"></i> <span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadButton\') == -1) ? \'Upload\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'UploadButton\')].Name"></span></button>';

                                                DynamicHTML += ' </div>'; // card body inside attachements div close
                                                DynamicHTML += '</div>'; // conditions binding attachements div close

                                                //subDoccomments
                                                DynamicHTML += ' <div class="card-footer text-muted">';
                                                DynamicHTML += '<div data-bind="attr:{ id: \'doc_cmt_sec_' + QuestionId + '\' }">';
                                                DynamicHTML += '<div class="" data-bind="attr:{ id: \'doc_cmt_List_' + QuestionId + '\' }"></div>';
                                                DynamicHTML += ' </div>';
                                                DynamicHTML += ' </div>';
                                                //subDoccomments
                                                DynamicHTML += ' </div>'; // attachement box div close
                                                //attachments box close

                                                //history & guidelines
                                                DynamicHTML += '<div data-bind="attr:{ id: \'' + histId + '\' }" class="card card col-lg-12 p-0" style="display:none;">';
                                                DynamicHTML += '<div class="box user-content pt-0 pb-0">';
                                                DynamicHTML += '<div class="title"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoryHeading\') == -1) ? \'History\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistoryHeading\')].Name"></span><button type="button" class="btn float-right" data-bind="click:$root.HideExtraContent(\'' + QuestionId + '\')"><span><i class="demo-icon icon-cross_special"></i></span></button></div>';
                                                DynamicHTML += '</div>';
                                                DynamicHTML += '<div class="card-body text-muted">';
                                                DynamicHTML += '<span data-bind="attr:{id: \'htmlHist_' + histId + '\' }"></span>';
                                                DynamicHTML += '</div>';
                                                DynamicHTML += '</div>';
                                                DynamicHTML += '<div data-bind="attr:{ id: \'' + guidelineId + '\' }" class="card card col-lg-12 p-0" style="display:none;">';
                                                DynamicHTML += '<div class="box user-content pt-0 pb-0">';
                                                DynamicHTML += '<div class="title"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesHeading\') == -1) ? \'Guidelines\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'GuidelinesHeading\')].Name"></span><button type="button" class="btn float-right" data-bind="click:$root.HideExtraContent(\'' + QuestionId + '\')"><span><i class="demo-icon icon-cross_special"></i></span></button></div>';
                                                DynamicHTML += '</div>';
                                                DynamicHTML += '<div class="card-body">';
                                                if (SrViewModel.QuanResponseObject()[j].InfoGuidelineComment() === '')
                                                    DynamicHTML += '<span class="nodatamessage" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoGuidelinesMessage\') == -1) ? \'There are no Guidelines available\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoGuidelinesMessage\')].Name"></span>';
                                                else if (SrViewModel.QuanResponseObject()[j].InfoGuidelineComment() !== '')
                                                    DynamicHTML += '<span data-bind="text: $root.QuanResponseObject()[' + j + '].InfoGuidelineComment()"></span>';
                                                DynamicHTML += '</div>';
                                                DynamicHTML += '</div>';
                                                //history & guidelines
                                            }
                                        }
                                    }
                                }
                                DynamicHTML += '</div>'; // IsVisible RTB div close
                                DynamicHTML += '</div>'; // card RTB close
                                DynamicHTML += '</div>'; //question-card RTB close
                            }
                        }

                        DynamicHTML += '</div>'; // collapse accNQ. close
                    }
                }
                DynamicHTML += '</div>'; //accordian close

                $('#DynamicHTMLDiv').html("");
                $('#DynamicHTMLDiv').html(DynamicHTML);
                var element = $('#DynamicHTMLDiv')[0];
                ko.cleanNode(element);
                ko.applyBindings(SrViewModel, document.getElementById('DynamicHTMLDiv'));
                $('#DynamicHTMLDiv').show();
                $('#LoadingGIFSRDiv').modal('hide');

                let scrollHeight = "auto";
                var Dtable = $("#tblQuanResponseResponse").DataTable({
                    "aLengthMenu": false,
                    "aLengthChange": false,
                    "bResponsive": true,
                    "searching": false,
                    "bPaginate": false,
                    "paging": false,
                    "stateSave": true,
                    "ordering": false,
                    "order": [],
                    "aaSorting": [],
                    "info": false,
                });
                CalculateTotalResponse();

                for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                    // for rich text box
                    if (SrViewModel.QuanResponseObject()[i].ResponseList !== undefined) {
                        if (SrViewModel.QuanResponseObject()[i].QuestionType() === 'T') {
                            for (var k = 0; k < SrViewModel.QuanResponseObject()[i].ResponseList.length; k++) {
                                if (SrViewModel.QuanResponseObject()[i].ResponseList[k].ResponseOptionType() === 'T')
                                    showResponseRichText(SrViewModel.QuanResponseObject()[i].QuestionId() + '_' + SrViewModel.QuanResponseObject()[i].ResponseList[k].ResponseId(), SrViewModel.QuanResponseObject()[i].ResponseList[k].ResponseValue());
                            }
                        }
                    }
                }
            }
            catch (e) {
                $('#LoadingGIFSRDiv').modal('hide');
                var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlQuantitative() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ValidateResponse() {
            try {
                ValidateQuantResponseData();
                CalculateTotalResponse();
                SrViewModel.ValuesChanged(true);
                RefreshSession();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidateResponse() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ValidateQuantResponseData() {
            try {
                $('#QuantSurveyError').hide();
                $("#QuantSurveyError").html("");
                var flag = 0;
                var MainList = [];
                SrViewModel.QuanResponseObject();
                for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                    for (var j = 0; j < SrViewModel.QuanResponseObject()[i].ResponseList.length; j++) {
                        if (SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseOptionType() !== 'T') {
                            if (SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseValue() === null) {
                                var tempObject = {
                                    SurveyProfileRelId: SrViewModel.SurveyId(), QuestionId: SrViewModel.QuanResponseObject()[i].QuestionId(),
                                    ResponseId: SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseId(),
                                    ResponseText: SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseValue(),
                                    ResponseOptionType: SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseOptionType(),
                                    BookmarkFlag: SrViewModel.QuanResponseObject()[i].ResponseList[j].BookmarkFlag() ? 1 : 0
                                };
                                MainList.push(tempObject);
                            }
                            else if (!isNaN(SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseValue().replace(/[,()]/g, ''))) {
                                var value = SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseValue();
                                var valueLength = value.length;
                                if (SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseValue()[0] === '(' && SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseValue()[valueLength - 1] === ')')
                                    value = '-' + value.replace(/[()]/g, '');
                                var tempObject = {
                                    SurveyProfileRelId: SrViewModel.SurveyId(), QuestionId: SrViewModel.QuanResponseObject()[i].QuestionId(),
                                    ResponseId: SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseId(),
                                    ResponseText: value.replace(/[,()]/g, ''),
                                    ResponseOptionType: SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseOptionType(),
                                    BookmarkFlag: SrViewModel.QuanResponseObject()[i].ResponseList[j].BookmarkFlag() ? 1 : 0
                                };
                                MainList.push(tempObject);
                            }
                            else {
                                flag = 1;
                                $('#QuantSurveyError').show();
                                $("#QuantSurveyError").html(((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidDataMessage') == -1) ? 'Please enter valid data.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidDataMessage')].Name()).toString());
                                //have to show error mesage in front end
                                MainList = [];
                                SrViewModel.SaveResponseList([]);
                                break;
                            }
                        }
                        else { // === 'T' - Text Type
                            var ckeComment = '';
                            var tempText = CKEDITOR.instances["ResponseType_" + SrViewModel.QuanResponseObject()[i].QuestionId() + '_' + SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseId()].getData();
                            if ($(tempText).text().trim() != "")
                                ckeComment = tempText;

                            var tempObject = {
                                SurveyProfileRelId: SrViewModel.SurveyId(), QuestionId: SrViewModel.QuanResponseObject()[i].QuestionId(),
                                ResponseId: SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseId(),
                                ResponseText: ckeComment, //SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseValue(),
                                ResponseOptionType: SrViewModel.QuanResponseObject()[i].ResponseList[j].ResponseOptionType(),
                                BookmarkFlag: SrViewModel.QuanResponseObject()[i].ResponseList[j].BookmarkFlag() ? 1 : 0
                            };
                            MainList.push(tempObject);
                        }
                    }
                }
                if (flag === 0) {
                    SrViewModel.SaveResponseList(MainList);
                    return true;
                }
                else {
                    return false;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidateQuantResponseData() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function CalculateTotalResponse() {
            try {
                for (var i = 0; i < SrViewModel.QuanColumnDetails().length; i++) {
                    var sum = 0;
                    for (var j = 0; j < SrViewModel.QuanResponseObject().length; j++) {
                        for (var k = 0; k < SrViewModel.QuanResponseObject()[j].ResponseList.length; k++) {
                            if (SrViewModel.QuanResponseObject()[j].ResponseList[k].ResponseId() === SrViewModel.QuanColumnDetails()[i].ColumnId())
                                if (SrViewModel.QuanResponseObject()[j].ResponseList[k].ResponseValue() === null)
                                    sum += 0;
                                else if (!isNaN(parseFloat(SrViewModel.QuanResponseObject()[j].ResponseList[k].ResponseValue().replace(/[,()]/g, '')))) {
                                    var value = SrViewModel.QuanResponseObject()[j].ResponseList[k].ResponseValue();
                                    var valueLength = value.length;
                                    if (SrViewModel.QuanResponseObject()[j].ResponseList[k].ResponseValue()[0] === '(' && SrViewModel.QuanResponseObject()[j].ResponseList[k].ResponseValue()[valueLength - 1] === ')')
                                        value = '-' + value.replace(/[()]/g, '');
                                    sum += parseFloat(value.replace(/[,()]/g, ''));
                                }
                        }
                    }

                    if (sum % 1 != 0) {
                        SrViewModel.QuanColumnDetails()[i].ColumnTotal((sum.toFixed(2)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
                    }

                    else {
                        SrViewModel.QuanColumnDetails()[i].ColumnTotal((sum.toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
                    }
                    //SrViewModel.QuanColumnDetails()[i].ColumnTotal(sum);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CalculateTotalResponse() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ShowCommentsPopUp(data, event) {
            try {
                SrViewModel.ClickedRiskSubFactorName(data.QuestionText());
                $('#lblNoResponseComment').hide();
                SrViewModel.IsCommentPopUp(true);
                SrViewModel.SelectedQuestion(data);
                SrViewModel.SelectedQuestionId(data.QuestionId());
                $('#lblRCError_' + data.QuestionId()).hide();
                SrViewModel.ResponseCommentsList([]);
                //showCommentsRichText(SrViewModel.SelectedQuestionId(), 'cmt');
                SrViewModel.ResponseComment('');
                SrViewModel.IsReadOnlyQuestion(data.IsReadOnly());
                if (data.IsReadOnly() != 1 && (SrViewModel.DisableControl() == false || SrViewModel.appsecurity.WriteAccess())) {
                    document.getElementById("ResponseTextArea_" + data.QuestionId()).value = '';
                }
                SrViewModel.RemainingChars(SrViewModel.CommentCharsLimit());
                GetCommentsPopUp(data.QuestionId(), "RC", null).then(function () {
                    $('#ResponseCommentPopUp').modal('show');
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowCommentsPopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function GetQuantitativeTableCommentCount() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/GetQuanResponseData",
                    headers: headers,
                    type: "POST",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        "FactorId": SrViewModel.ClickedRiskFactorId(),
                        "Draft": SrViewModel.SurveyId(),
                    })
                })
                    .success(function (JsonResult, Success) {
                        if (JsonResult != null) {
                            if (JsonResult.ErrorID == -99) {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? JsonResult.ErrorName + " - An error occurred. Please contact your Application Administrator."
                                    : JsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                var MappedResponses = $.map(JsonResult.QuanResponseModel, function (result) {
                                    return new QuantitativeResponseModel(result);
                                });
                                //SrViewModel.QuanResponseObject(MappedResponses);
                                for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                                    for (var j = 0; j < MappedResponses.length; j++)
                                        if (SrViewModel.QuanResponseObject()[i].QuestionId() == MappedResponses[j].QuestionId()) {
                                            SrViewModel.QuanResponseObject()[i].CommentCount(MappedResponses[j].CommentCount());
                                        }
                                }
                                setSurveyLevelMandatoryList();
                            }
                        }
                    })
                    .fail(function (fail, error) {
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQuantitativeTableCommentCount() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ShowUploadDocumentsPopUp(data, event) {
            try {
                SrViewModel.ClickedRiskSubFactorName(data.QuestionText());
                $('#lblRDError_' + data.QuestionId()).text('');
                $('#lblNoResponseDocument').hide();
                SrViewModel.IsDocumentPopUp(true);
                SrViewModel.SelectedQuestion(data);
                SrViewModel.SelectedQuestionId(data.QuestionId());
                SrViewModel.UploadDocumentsList([]);
                //showCommentsRichText(SrViewModel.SelectedQuestionId(), 'atch');
                if (data.IsReadOnly() != 1 && (SrViewModel.DisableControl() == false || SrViewModel.appsecurity.WriteAccess())) {
                    document.getElementById('FileUploaderForDocuments_' + data.QuestionId()).value = '';
                    document.getElementById("UploadTextArea_" + data.QuestionId()).value = '';
                }
                SrViewModel.UploadComment('');
                SrViewModel.IsReadOnlyQuestion(data.IsReadOnly());
                SrViewModel.RemainingChars(SrViewModel.CommentCharsLimit());
                GetCommentsPopUp(data.QuestionId(), "RD", null).then(function () {
                    $('#UploadDocumentPopUp').modal('show');
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowUploadDocumentsPopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ShowHistroyPopUp(data, event) {
            try {
                SrViewModel.ClickedRiskSubFactorName(data.QuestionText());
                SrViewModel.IsHistoryPopUp(true);
                $('#NoHistoryResponses').hide();
                $('#NoHistoryComments').hide();
                GetSurveyPrevResponses(data.QuestionId());
                GetHistoricalComments(data.QuestionId(), "RC", null);
                $('#ResponseHistoryPopUp').modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowHistroyPopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ShowGuidelinesPopUp(data, event) {
            try {
                SrViewModel.ClickedRiskSubFactorName(data.QuestionText());
                if (data.InfoGuidelineComment() !== "") {
                    $('#lblNoResponseGuideline').hide();
                    SrViewModel.GuidelineCommentPopUp(data.InfoGuidelineComment());
                    $('#PopUpGuidelineCommentDiv').show();
                }
                else {
                    $('#lblNoResponseGuideline').show();
                    $('#PopUpGuidelineCommentDiv').hide();
                }

                $('#ResponseGuidelinePopUp').modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowGuidelinesPopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function QuanColumnDetailsModel(item) {
            try {
                var self = this;
                self.ColumnId = ko.observable(item.ColumnId);
                self.ColumnName = ko.observable($('<div/>').html(item.ColumnName).text());
                self.ColumnTotal = ko.observable(0);
                self.OptionType = ko.observable(item.OptionType);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QuanColumnDetailsModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function QuantitativeResponseModel(item) {
            try {
                var self = this;
                self.DisplayRank = ko.observable(item.DisplayRank);
                self.SortOrder = ko.observable(item.DisplayRank);
                self.Is_Header = ko.observable(item.Is_Header);
                self.HeaderUID = ko.observable(item.HeaderUID);
                self.QuestionId = ko.observable(item.QuestionId);
                SrViewModel.Quesitonidtemp(item.QuestionId);
                self.QuestionType = ko.observable(item.QuestionType);
                self.FactorId = ko.observable(item.FactorId);
                self.IsReadOnly = ko.observable(0); // No ReadOnly flag is present in Backend. Coded to facilitate ReadOnly functionality if required in future.
                self.QuestionText = ko.observable(item.QuestionText);
                self.QuestionTextPlain = ko.observable($('<div/>').html(item.QuestionText).text());
                self.CommentCount = ko.observable(item.CommentCount);
                self.DocumentCount = ko.observable(item.DocumentCount);
                self.RankCount = ko.observable(item.RankCount);
                self.IsVisibleforSearch = ko.observable(true);
                self.InfoGuidelineComment = ko.observable(item.InfoGuidelineComment); // (item.InfoGuidelineComment);
                self.cmt_hrefId = ko.observable('#cmt_' + item.QuestionId);
                self.attachment_hrefId = ko.observable('#atch_' + item.QuestionId);
                self.guideline_hrefId = ko.observable('#gui_' + item.QuestionId);
                self.hist_hrefId = ko.observable('#hist_' + item.QuestionId);

                self.cmtId = ko.observable('cmt_' + item.QuestionId);
                self.attachmentId = ko.observable('atch_' + item.QuestionId);
                self.guidelineId = ko.observable('gui_' + item.QuestionId);
                self.histId = ko.observable('hist_' + item.QuestionId);

                self.Is_CommentMandatory = ko.observable(item.Is_CommentMandatory);
                self.Is_DocumentMandatory = ko.observable(item.Is_DocumentMandatory);
                self.Is_ResponseMandatory = ko.observable(item.Is_ResponseMandatory);
                self.IndentationValue = ko.observable(item.IndentationValue);
                var mappedResposneList = $.map(item.ResponseModelObject, function (result) {
                    return ResponseObject = new ResponseListModel(result);
                });
                self.ResponseList = mappedResposneList;
                self.ShowQuestionMandatoryFlag = ko.observable(item.ShowQuestionMandatoryFlag);
                self.IsSaveClicked_Response = ko.observable(false);
                self.IsSaveClicked_Comment = ko.observable(false);
                self.IsSaveClicked_Document = ko.observable(false);
                self.bmFlagID = ko.observable('bmFlag_' + item.QuestionId);
                self.BookmarkFlagQuestion = ko.observable(item.BookmarkFlagQuestion);
                self.IsParentMapped = ko.observable(0);
                var QuestionsArray = [];
                var QuestionSplit = self.QuestionText().split("<br/>");
                for (var i = 0; i < QuestionSplit.length; i++) {
                    QuestionsArray.push(QuestionSplit[i]);
                }
                self.QuestionsList = ko.observableArray(QuestionsArray);
                var mappedIRL = $.map(item.IRLDetailsList, function (row) {
                    return new IRLDetailsModel(row);
                });
                self.IRLDetails = ko.observableArray(mappedIRL);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QuantitativeResponseModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ResponseListModel(item) {
            try {
                var self = this;
                self.ResponseId = ko.observable(item.ResponseId);
                self.ResponseValue = ko.observable(item.ResponseValue);
                self.ResponseOptionType = ko.observable(item.ResponseOptionType);
                self.BookmarkFlag = ko.observable(item.BookmarkFlag);
                self.Is_ResponseMandatory_RT = ko.observable(item.Is_ResponseMandatory_RT);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponseListModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function QuanOptionsListModel(item) {
            try {
                var self = this;
                self.ResponseOptionId = ko.observable(item.ResponseOptionId);
                self.ResponseOptionText = ko.observable(item.ResponseOptionText);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QuanOptionsListModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function IRLDetailsModel(item) {
            try {
                var self = this;
                self.RiskScore = ko.observable(item.RiskScore);
                self.RiskDesc = ko.observable(item.RiskDesc);
                self.CssColor = ko.observable(item.CssColor);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: IRLDetailsModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Quan, Qual Control Save and other save related common Methods

        function SaveResponse(data) {
            try {
                ClearSearchText();
                $('#LoadingGIFSRDiv').modal('show');
                SrViewModel.isSaveResponseClick(true);
                SrViewModel.EnableMandatoryFlags(true);
                SrViewModel.saveEventId(event.currentTarget.id);
                SrViewModel.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                if (SrViewModel.SurveyTypeId().toUpperCase() == "QTDR") {
                    if (ValidateQuantResponseData()) {
                        $('#QualContDynamicHTMLDiv').html("");
                        $('#DynamicHTMLDiv').html("");
                        $('#MCI_DynamicHTML').html("");
                        SaveQuantResposne().then(function () {
                            if (SrViewModel.NavigateToDashboardBoolean()) {
                                SrViewModel.isSaveResponseClick(false);
                                SrViewModel.DashboardVM.NavigatedFrom('Response');
                                router.navigate('Landing', true);
                            }
                            else {
                                if (SrViewModel.saveEventId() === "onPageSavebtn") {
                                    ReloadTabafterSaveMain(data);
                                    SrViewModel.saveEventId('');
                                }
                                else
                                    ReloadTabafterDirtyCheckSave(data);
                            }
                        });
                    }
                    else {
                        $('#LoadingGIFSRDiv').modal('hide');
                    }
                }
                else if (SrViewModel.SurveyTypeId().toUpperCase() == "QLDR") {
                    $('#QualContDynamicHTMLDiv').html("");
                    $('#DynamicHTMLDiv').html("");
                    $('#MCI_DynamicHTML').html("");
                    SetQualResponse(SrViewModel.PreClickedRiskAreaId()).then(function () {
                        if (SrViewModel.NavigateToDashboardBoolean()) {
                            SrViewModel.isSaveResponseClick(false);
                            SrViewModel.DashboardVM.NavigatedFrom('Response');
                            router.navigate('Landing', true);
                        }
                        else {
                            if (SrViewModel.saveEventId() === "onPageSavebtn") {
                                ReloadTabafterSaveMain(data);
                                SrViewModel.saveEventId('');
                            }
                            else
                                ReloadTabafterDirtyCheckSave(data);
                        }
                    });
                }
                else {
                    $('#QualContDynamicHTMLDiv').html("");
                    $('#DynamicHTMLDiv').html("");
                    $('#MCI_DynamicHTML').html("");
                    SetControlResponse().then(function () {
                        if (SrViewModel.NavigateToDashboardBoolean()) {
                            SrViewModel.isSaveResponseClick(false);
                            SrViewModel.DashboardVM.NavigatedFrom('Response');
                            router.navigate('Landing', true);
                        }
                        else {
                            if (SrViewModel.saveEventId() === "onPageSavebtn") {
                                ReloadTabafterSaveMain(data);
                                SrViewModel.saveEventId('');
                            }
                            else
                                ReloadTabafterDirtyCheckSave(data);
                        }
                    });
                }
                SrViewModel.ValuesChanged(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveResponse() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ResetResponse(data) {
            try {
                ClearSearchText();
                $('#QualContDynamicHTMLDiv').html("");
                $('#DynamicHTMLDiv').html("");
                $('#MCI_DynamicHTML').html("");
                if (SrViewModel.SurveyTypeId().toUpperCase() == "QLDR") {
                    GetQualColumnDetails().then(function () {
                        GetQualResponseDetails();
                        GetQualResponseMultiselect();
                    })
                }
                else {
                    GetControlColumnDetails().then(function () {
                        GetControlResponseData();
                        GetControlResponseMultiselect();
                    })
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetResponse() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SaveQuantResposne(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/SetQuantSurveyResponse",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: ko.toJSON({
                        lstSurveyResponseDataModel: SrViewModel.SaveResponseList(),
                        Area_Uid: SrViewModel.ClickedRiskAreaId()
                    })
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult != null) {
                            if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                    ? jsonResult + " - An error occurred. Please contact your Application Administrator."
                                    : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else if (!isNaN(jsonResult) && parseInt(jsonResult) <= 0) {
                                var redirectBack = confirm((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetFailMessage') == -1) ? 'You are no longer allowed to perform Save/Edit operation. The Survey is either moved to another state or picked by another user. You will be redirected to Landing Page.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetFailMessage')].Name);
                                if (redirectBack === true) {
                                    SrViewModel.DashboardVM.NavigatedFrom('Response');
                                    router.navigate("landing", true);
                                }
                                else {
                                    app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage') == -1) ? 'The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click \'OK\' to redirect to Landing Page.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage') == -1) ? 'Action cannot be performed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString()], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                        .then(function (option) {
                                            if (option === " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString()) {
                                                SrViewModel.DashboardVM.NavigatedFrom('Response');
                                                router.navigate("landing", true);
                                            }
                                        });
                                }
                            }
                            else {
                                logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetSuccessMessage') == -1) ? 'Responses have been saved successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                                //BindQuantiativeTable();
                            }
                        }
                        else {
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                    })
                    .fail(function (fail, error) {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveQuantResposne() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SetQualResponse(AreaId) {
            try {
                var JsonList = ConstructQualJsonList();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/SetQualSurveyResponseData",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: ko.toJSON({
                        lstSurveyResponseDataModel: JsonList,
                        Area_Uid: AreaId
                        //Area_Uid: SrViewModel.ClickedRiskAreaId()
                    })
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult != null) {
                            if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                    ? jsonResult + "An error occurred. Please contact your Application Administrator.'"
                                    : jsonResult + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else if (!isNaN(jsonResult) && parseInt(jsonResult) <= 0) {
                                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage') == -1) ? 'The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click \'OK\' to redirect to Landing Page.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage') == -1) ? 'Action cannot be performed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                    .then(function (option) {
                                        if (option === " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()) {
                                            SrViewModel.DashboardVM.NavigatedFrom('Response');
                                            router.navigate("landing", true);
                                        }
                                    });
                            }
                            else {
                                //if (SrViewModel.SavechangedvalueTab() !== "-9999")
                                //    GetQualResponseDetails();
                                //GetQualResponseMultiselect();SurveyResponseSetSuccessMessage
                                logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetSuccessMessage') == -1) ? 'Responses have been saved successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                            }
                        }
                        else {
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                    })
                    .fail(function (fail, error) {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    });
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetQualResponse() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ConstructQualJsonList() {
            try {
                var MainList = [];
                var ResponseTextValue = '';
                SrViewModel.QualResponseListData();
                for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                    for (var j = 0; j < SrViewModel.QualResponseListData()[i].ResponseList.length; j++) {
                        if (SrViewModel.QualResponseListData()[i].ResponseList[j].ResponseOptionType() === "R" && SrViewModel.QualResponseListData()[i].IsConditional() === 0 && SrViewModel.QualResponseListData()[i].IsReadOnly() === 0)  // Rick Text Box Response
                        {
                            var tempText = CKEDITOR.instances["ResponseType_" + SrViewModel.QualResponseListData()[i].QuestionId() + '_' + SrViewModel.QualResponseListData()[i].ResponseList[j].ResponseId()].getData();
                            if ($(tempText).text().trim() != "")
                                ResponseTextValue = tempText;
                            else
                                ResponseTextValue = '';
                        }
                        else if (SrViewModel.QualResponseListData()[i].IsConditional() === 1)
                            ResponseTextValue = '';
                        else
                            ResponseTextValue = SrViewModel.QualResponseListData()[i].ResponseList[j].ResponseInputValue();

                        if (SrViewModel.QualResponseListData()[i].ResponseList[j].ResponseValue() == undefined || SrViewModel.QualResponseListData()[i].IsConditional() === 1) {
                            var tempObject = {
                                SurveyProfileRelId: SrViewModel.SurveyId(), QuestionId: SrViewModel.QualResponseListData()[i].QuestionId(), ResponseId: SrViewModel.QualResponseListData()[i].ResponseList[j].ResponseId(),
                                ResponseValue: null, ResponseText: ResponseTextValue, BookmarkFlag: SrViewModel.QualResponseListData()[i].ResponseList[j].BookmarkFlag() ? 1 : 0
                            }
                            MainList.push(tempObject)
                        }
                        else {
                            var tempObject = {
                                SurveyProfileRelId: SrViewModel.SurveyId(), QuestionId: SrViewModel.QualResponseListData()[i].QuestionId(), ResponseId: SrViewModel.QualResponseListData()[i].ResponseList[j].ResponseId(),
                                ResponseValue: SrViewModel.QualResponseListData()[i].ResponseList[j].ResponseValue(), ResponseText: ResponseTextValue, BookmarkFlag: SrViewModel.QualResponseListData()[i].ResponseList[j].BookmarkFlag() ? 1 : 0
                            }
                            MainList.push(tempObject)
                        }
                    }
                }
                return MainList;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ConstructJsonList() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SetControlResponse() {
            try {
                var List = ConstructControlsJson();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/SetControlSurveyResponse",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: ko.toJSON({
                        lstSurveyResponseDataModel: List,
                        Area_Uid: SrViewModel.ClickedRiskAreaId()
                    })
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult != null) {
                            if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? jsonResult + " - An error occurred. Please contact your Application Administrator." : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else if (!isNaN(jsonResult) && parseInt(jsonResult) <= 0) {
                                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage') == -1) ? 'The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click \'OK\' to redirect to Landing Page.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage') == -1) ? 'Action cannot be performed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                    .then(function (option) {
                                        if (option === " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()) {
                                            SrViewModel.DashboardVM.NavigatedFrom('Response');
                                            router.navigate("landing", true);
                                        }
                                    });
                            }
                            else {
                                //GetControlResponseData();
                                logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetSuccessMessage') == -1) ? 'Responses have been saved successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true)
                            }
                        }
                        else {
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                    })
                    .fail(function (fail, error) {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetControlResponse() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ConstructControlsJson() {
            try {
                var MainList = [];
                var ResponseTextValue = '';
                for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                    for (var j = 0; j < SrViewModel.ControlsResponseData()[i].ResponseList.length; j++) {
                        if (SrViewModel.ControlsResponseData()[i].ResponseList[j].ResponseOptionType() === "R" && SrViewModel.ControlsResponseData()[i].IsConditional() === 0 && SrViewModel.ControlsResponseData()[i].IsReadOnly() === 0) // Rick Text Box Response
                        {
                            var tempText = CKEDITOR.instances["ResponseType_" + SrViewModel.ControlsResponseData()[i].QuestionId() + '_' + SrViewModel.ControlsResponseData()[i].ResponseList[j].ResponseId()].getData();
                            if ($(tempText).text().trim() != "")
                                ResponseTextValue = tempText;
                            else
                                ResponseTextValue = '';
                        }
                        else if (SrViewModel.ControlsResponseData()[i].IsConditional() === 1)
                            ResponseTextValue = '';
                        else
                            ResponseTextValue = SrViewModel.ControlsResponseData()[i].ResponseList[j].ResponseInputValue();

                        if (SrViewModel.ControlsResponseData()[i].ResponseList[j].Response() == undefined || SrViewModel.ControlsResponseData()[i].IsConditional() === 1) {
                            var tempObject = {
                                SurveyProfileRelId: SrViewModel.SurveyId(), QuestionId: SrViewModel.ControlsResponseData()[i].QuestionId(),
                                ResponseId: SrViewModel.ControlsResponseData()[i].ResponseList[j].ResponseId(), ResponseValue: null,
                                ResponseText: ResponseTextValue, BookmarkFlag: SrViewModel.ControlsResponseData()[i].ResponseList[j].BookmarkFlag() ? 1 : 0
                            }
                            MainList.push(tempObject);
                        }
                        else {
                            var tempObject = {
                                SurveyProfileRelId: SrViewModel.SurveyId(), QuestionId: SrViewModel.ControlsResponseData()[i].QuestionId(),
                                ResponseId: SrViewModel.ControlsResponseData()[i].ResponseList[j].ResponseId(),
                                ResponseValue: SrViewModel.ControlsResponseData()[i].ResponseList[j].Response(),
                                ResponseText: ResponseTextValue, BookmarkFlag: SrViewModel.ControlsResponseData()[i].ResponseList[j].BookmarkFlag() ? 1 : 0
                            }
                            MainList.push(tempObject);
                        }
                    }
                }
                return MainList;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ConstructControlsJson() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ReloadTabafterDirtyCheckSave(node) {
            $('#DynamicHTMLDiv').html("");
            $('#QualContDynamicHTMLDiv').html("");
            $('#MCI_DynamicHTML').html("");
            SrViewModel.ClickedRiskArea(node);

            if (SrViewModel.SurveyTypeId() == "QTDR") {
                if (node.dead_node == 1) {
                    //select node explicitly in case of recursive calling activity.
                    $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);
                    $('#DynamicHTMLDiv').html("");
                    $('#QualContDynamicHTMLDiv').html("");
                    $('#MCI_DynamicHTML').html("");

                    SrViewModel.ClickedRiskFactorId(parseInt(node.id));
                    SrViewModel.ClickedRiskFactorName($('<div/>').html(node.text).text());
                    SrViewModel.ClickedRiskFactorGuidelines($('<div/>').html(node.categoryGuidelines).text());
                    SrViewModel.ClickedRiskAreaId(node.ParentAreaId);
                    SrViewModel.ClickedRiskAreaName(node.ParentAreaName);
                    SrViewModel.ClickedRiskAreaCategoryGuidelines(node.ParentGuidelines);

                    SrViewModel.Is_RefreshCopyProfile(node.Is_RefreshProfile);
                    SrViewModel.Is_RefreshEnable(node.Is_RefreshEnable);

                    if (node.nodeId === 0 && (parseInt(node.id) === -1000 || parseInt(node.id) === -998)) {
                        GetMCI_LevelDetails();
                    } else {
                        SrViewModel.MCILevel(false);

                        GetQuanColumnDetails().then(function () {
                            BindQuantiativeTable();
                            InitiateQuantitativeLevelTree();
                            RefreshSession();
                        });
                    }
                    $(window).scrollTop(0);
                }
                else {
                    //recursively opening until the dead_node arrives.
                    if (!(node.state.expanded))
                        //nodeExtraClickEvent(event, node.nodes[0]);
                        $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                    $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);
                }
            }
            else if (SrViewModel.SurveyTypeId() == "QLDR") {
                if (node.dead_node == 1) {
                    //select node explicitly in case of recursive calling activity.
                    $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);
                    $('#DynamicHTMLDiv').html("");
                    $('#QualContDynamicHTMLDiv').html("");
                    $('#MCI_DynamicHTML').html("");
                    SrViewModel.ClickedRiskAreaId(parseInt(node.id));
                    SrViewModel.PreClickedRiskAreaId(parseInt(node.id));
                    SrViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());
                    SrViewModel.ClickedRiskAreaCategoryGuidelines(node.categoryGuidelines);
                    SrViewModel.Is_RefreshCopyProfile(node.Is_RefreshProfile);
                    SrViewModel.Is_RefreshEnable(node.Is_RefreshEnable);

                    if (node.nodeId === 0 && (parseInt(node.id) === -1000 || parseInt(node.id) === -998)) {
                        SrViewModel.MCILevel(true);
                        GetMCI_LevelDetails();
                    } else {
                        SrViewModel.MCILevel(false);
                        GetQualColumnDetails().then(function () {
                            GetQualResponseDetails();
                            InitiateQualitativeLevelTree();
                            RefreshSession();
                        });
                    }
                    $(window).scrollTop(0);
                } else {
                    //recursively opening until the dead_node arrives.
                    if (!(node.state.expanded))
                        //nodeExtraClickEvent(event, node.nodes[0]);
                        $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                    $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);
                }
            }
            else {
                if (node.dead_node == 1) {
                    //select node explicitly in case of recursive calling activity.
                    $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);
                    $('#DynamicHTMLDiv').html("");
                    $('#QualContDynamicHTMLDiv').html("");
                    $('#MCI_DynamicHTML').html("");

                    SrViewModel.ClickedRiskAreaId(parseInt(node.id));
                    SrViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());
                    SrViewModel.ClickedRiskAreaCategoryGuidelines(node.categoryGuidelines);

                    SrViewModel.Is_RefreshCopyProfile(node.Is_RefreshProfile);
                    SrViewModel.Is_RefreshEnable(node.Is_RefreshEnable);

                    if (node.nodeId === 0 && (parseInt(node.id) === -1000 || parseInt(node.id) === -998)) {
                        GetMCI_LevelDetails();
                    } else {
                        SrViewModel.MCILevel(false);
                        GetControlColumnDetails().then(function () {
                            GetControlResponseData();
                            InitiateControlsLevelTree();
                            RefreshSession();
                        });
                    }
                    $(window).scrollTop(0);
                } else {
                    //recursively opening until the dead_node arrives.
                    if (!(node.state.expanded))
                        //nodeExtraClickEvent(event, node.nodes[0]);
                        $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                    $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);
                }
            }
        }

        function ReloadTabafterSaveMain(data) {
            try {
                if (SrViewModel.SurveyTypeId() == "QTDR") {
                    SrViewModel.ClickedRiskArea(data);
                    if (SrViewModel.SavechangedvalueTab() != null) {
                        SrViewModel.ClickedRiskAreaId(SrViewModel.SavechangedvalueTab());
                        SrViewModel.SavechangedvalueTab(null);
                        SrViewModel.ClickedRiskArea(data);
                    }
                    SrViewModel.MCILevel(false);
                    GetQuanColumnDetails().then(function () {
                        BindQuantiativeTable();

                        InitiateQuantitativeLevelTree();
                        RefreshSession();
                    });
                }
                else if (SrViewModel.SurveyTypeId() == "QLDR") {
                    $('#DynamicHTMLDiv').html("");
                    SrViewModel.ClickedRiskArea(data);
                    if (SrViewModel.SavechangedvalueTab() != null) {
                        SrViewModel.ClickedRiskAreaId(SrViewModel.SavechangedvalueTab());
                        SrViewModel.SavechangedvalueTab(null);
                    }
                    SrViewModel.MCILevel(false);
                    GetQualColumnDetails().then(function () {
                        GetQualResponseDetails();

                        InitiateQualitativeLevelTree();
                        RefreshSession();
                    });
                }
                else {
                    $('#DynamicHTMLDiv').html("");
                    SrViewModel.ClickedRiskArea(data);
                    if (SrViewModel.SavechangedvalueTab() != null) {
                        SrViewModel.ClickedRiskAreaId(SrViewModel.SavechangedvalueTab());
                        SrViewModel.SavechangedvalueTab(null);
                    }
                    GetControlColumnDetails().then(function () {
                        GetControlResponseData();

                        InitiateControlsLevelTree();
                        RefreshSession();
                    });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ReloadTabafterSaveMain() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function CheckForDirtyDataTreeVw(node, event) {
            try {
                if (SrViewModel.DashboardVM.RoutedFrom() === "Dashboard" && !SrViewModel.IsSurveyPending() && !SrViewModel.IsSurveyCompleted() && SrViewModel.ValuesChanged() && node.dead_node == 1) {
                    app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyDataCheckAreaTab') == -1) ? 'Please save the data before moving to another tab, otherwise the changes made will be lost.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyDataCheckAreaTab')].Name, "Warning", [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name], true, { buttonClass: "fa fa-check btn", primaryButtonClass: "primary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                        .then(function (option) {
                            SrViewModel.ValuesChanged(false);
                            SrViewModel.isSaveResponseClick(false);
                            if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name)()) {
                                SrViewModel.SavechangedvalueTab(null);
                                if (SrViewModel.MCILevel() == true) {
                                    SetMCI_LevelDetails();
                                } else {
                                    SaveResponse(node);
                                }
                            }
                            else {//when option=cancel
                                SrViewModel.ValuesChanged(false);
                                SrViewModel.ClickedRiskAreaId(node.id);
                                SrViewModel.SavechangedvalueTab(null);
                                // ReloadTabafterDirtyCheckSave(data);
                                if (SrViewModel.SurveyTypeId() == "QLDR") {
                                    if (node.dead_node == 1) {
                                        //select node explicitly in case of recursive calling activity.
                                        $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);
                                        $('#DynamicHTMLDiv').html("");
                                        $('#QualContDynamicHTMLDiv').html("");
                                        $('#MCI_DynamicHTML').html("");
                                        SrViewModel.ClickedRiskAreaId(parseInt(node.id));
                                        SrViewModel.PreClickedRiskAreaId(parseInt(node.id));
                                        SrViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());
                                        SrViewModel.ClickedRiskAreaCategoryGuidelines(node.categoryGuidelines);
                                        SrViewModel.Is_RefreshCopyProfile(node.Is_RefreshProfile);
                                        SrViewModel.Is_RefreshEnable(node.Is_RefreshEnable);

                                        if (node.nodeId === 0 && (parseInt(node.id) === -1000 || parseInt(node.id) === -998)) {
                                            SrViewModel.MCILevel(true);
                                            GetMCI_LevelDetails();
                                        } else {
                                            SrViewModel.MCILevel(false);
                                            GetQualColumnDetails().then(function () {
                                                GetQualResponseDetails();
                                            });
                                        }
                                    } else {
                                        //recursively opening until the dead_node arrives.
                                        if (!(node.state.expanded))
                                            ////nodeExtraClickEvent(event, node.nodes[0]);
                                            $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                                        $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);
                                    }
                                }
                                else if (SrViewModel.SurveyTypeId() == "CDR") {
                                    if (node.dead_node == 1) {
                                        //select node explicitly in case of recursive calling activity.
                                        $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);
                                        $('#DynamicHTMLDiv').html("");
                                        $('#QualContDynamicHTMLDiv').html("");
                                        $('#MCI_DynamicHTML').html("");

                                        SrViewModel.ClickedRiskAreaId(parseInt(node.id));
                                        SrViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());
                                        SrViewModel.ClickedRiskAreaCategoryGuidelines(node.categoryGuidelines);

                                        SrViewModel.Is_RefreshCopyProfile(node.Is_RefreshProfile);
                                        SrViewModel.Is_RefreshEnable(node.Is_RefreshEnable);

                                        if (node.nodeId === 0 && (parseInt(node.id) === -1000 || parseInt(node.id) === -998)) {
                                            GetMCI_LevelDetails();
                                        } else {
                                            SrViewModel.MCILevel(false);

                                            GetControlColumnDetails().then(function () {
                                                GetControlResponseData();
                                            });
                                        }
                                    }
                                    else {
                                        //recursively opening until the dead_node arrives.
                                        if (!(node.state.expanded))
                                            //nodeExtraClickEvent(event, node.nodes[0]);
                                            $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                                        $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);
                                    }
                                }
                                else {
                                    if (node.dead_node == 1) {
                                        //select node explicitly in case of recursive calling activity.
                                        $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);
                                        $('#DynamicHTMLDiv').html("");
                                        $('#QualContDynamicHTMLDiv').html("");
                                        $('#MCI_DynamicHTML').html("");

                                        SrViewModel.ClickedRiskFactorId(parseInt(node.id));
                                        SrViewModel.ClickedRiskFactorName($('<div/>').html(node.text).text());
                                        SrViewModel.ClickedRiskFactorGuidelines($('<div/>').html(node.categoryGuidelines).text());
                                        SrViewModel.ClickedRiskAreaId(node.ParentAreaId);
                                        SrViewModel.ClickedRiskAreaName(node.ParentAreaName);
                                        SrViewModel.ClickedRiskAreaCategoryGuidelines(node.ParentGuidelines);

                                        SrViewModel.Is_RefreshCopyProfile(node.Is_RefreshProfile);
                                        SrViewModel.Is_RefreshEnable(node.Is_RefreshEnable);

                                        if (node.nodeId === 0 && (parseInt(node.id) === -1000 || parseInt(node.id) === -998)) {
                                            GetMCI_LevelDetails();
                                        } else {
                                            SrViewModel.MCILevel(false);

                                            GetQuanColumnDetails().then(function () {
                                                BindQuantiativeTable();
                                            });
                                        }
                                    }
                                    else {
                                        //recursively opening until the dead_node arrives.
                                        if (!(node.state.expanded))
                                            //nodeExtraClickEvent(event, node.nodes[0]);
                                            $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                                        $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);
                                    }
                                }
                            }
                        });
                }
                else {
                    //recursively opening until the dead_node arrives.
                    if (!(node.state.expanded))
                        //nodeExtraClickEvent(event, node.nodes[0]);
                        $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                    $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CheckForDirtyDataTreeVw() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Areas of change Methods

        function GetMCI_LevelDetails() {
            try {
                SrViewModel.MCILevel(true);
                $.ajax({
                    url: "/api/Survey/GetAreasMCI",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { Draft: SrViewModel.SurveyId() }
                })
                    .success(function (JsonResult, Success) {
                        if (JsonResult != null) {
                            if (JsonResult.ErrorID == -99) {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                    ? jsonResult.Incident_Description + " - An error has occured. Please contact your Administrator."
                                    : jsonResult.Incident_Description + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                        (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                        ? jsonResult.Incident_Description + " - Please contact your Administrator."
                                        : jsonResult.Incident_Description + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                SrViewModel.MCILevels([]);
                                SrViewModel.MCIMaxLevel(JsonResult.MaxLevel);

                                SrViewModel.MCIRawLevels([]);
                                SrViewModel.MCIRawLevels(JsonResult.AreaLevelRawData);

                                var MappedJsTreeList = $.map(JsonResult.AreaLevelsData["#"], function (result) {
                                    return new jsTreeModelMCI(result);
                                });
                                var NewMappedTreeSturcture = filterJsTreeMCI(MappedJsTreeList);
                                SrViewModel.MCILevels([]);
                                SrViewModel.MCILevelsDup([]);

                                SrViewModel.MCILevels(NewMappedTreeSturcture);
                                SrViewModel.MCILevelsDup(NewMappedTreeSturcture);
                                GetAoCInstructions().then(function () {
                                    BindDynamicHtmlMCI();
                                });
                            }
                        }
                    })
                    .fail(function (error, fail) {
                        $('#LoadingGIFSRDiv').modal('hide');
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetMCI_LevelDetails() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            function filterJsTreeMCI(TreeStructure) {
                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes != undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTreeMCI(item.nodes);
                        }
                        if (item.showLevel == 1)
                            return true;
                        else
                            return false;
                    });
            }
        }

        function jsTreeModelMCI(item) {
            var self = this;
            self.id = item.AreaLevelId.toString();
            self.parentId = item.ParentAreaLevelId.toString();
            self.isComplete = item.CompletionPercentage;
            if (SrViewModel.AreaLeveljstree()[self.id].length > 0) {
                self.nodes = $.map(SrViewModel.AreaLeveljstree()[self.id], function (result) {
                    if (result.DeadNode == 0) {
                        return new jsTreeModelMCI(result);
                    } else {
                        if (result.AvailableLowestLevel == 1)
                            return new jsTreeModelMCI(result);
                    }
                });
            }
            self.showLevel = item.AvailableLowestLevel;
            if (self.showLevel == 0 && self.nodes != undefined && self.nodes != undefined && ko.utils.arrayFilter(self.nodes, function (i) { if (i.showLevel == 1) { return i; } }).length > 0) {
                self.showLevel = 1;
            }

            self.state = { expanded: false };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.categoryGuidelines = item.AreaLevelName;
            self.Is_RefreshProfile = item.Is_RefreshProfile;
            self.Is_RefreshEnable = item.Is_RefreshEnable;
            self.Is_LevelChecked = item.Is_LevelChecked;
            self.Level = item.AreaLevel;
            if (item.Is_RefreshEnable == false) {
                self.color = "lightgray";
            } else {
                self.color = undefined;
            }
            self.IsVisibleforSearchMCI = ko.observable(true);
        }

        function GetAoCInstructions() {
            try {
                $('#AocInstructionsDiv').hide();
                $('#AreaInstructionsDiv').hide();
                $('#MCI_DynamicHTML').removeClass("mt-2");

                return $.ajax({
                    url: "/api/Survey/GetAoCInstructions",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { Draft: SrViewModel.SurveyId() }
                })
                    .success(function (JsonResult, Success) {
                        SrViewModel.AoCHeaderMessage('');
                        SrViewModel.AoCInstructions('');
                        if (JsonResult !== null && JsonResult.length !== 0) {
                            if (JsonResult.ErrorId == -99) {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                    ? jsonResult.ErrorName + " - An error has occured. Please contact your Administrator."
                                    : jsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                        (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                        ? jsonResult.ErrorName + " - Please contact your Administrator."
                                        : jsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                for (var i = 0; i < JsonResult.length; i++) {
                                    if (JsonResult[i].Type === 'AH')
                                        SrViewModel.AoCHeaderMessage(JsonResult[i]);
                                    else if (JsonResult[i].Type === 'AI')
                                        SrViewModel.AoCInstructions(JsonResult[i]);
                                }
                                $('#AocInstructionsDiv').show();
                                $('#MCI_DynamicHTML').addClass("mt-2");
                            }
                        }
                    })
                    .fail(function (error, fail) {
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAoCInstructions() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function BindDynamicHtmlMCI() {
            try {
                var MCIDynamicHTML = "";
                MCIDynamicHTML += '<div class="bg-white d-flex no-margin">';
                MCIDynamicHTML += '<div class="mainQualResponses col-md-12 mt-3 mb-3">';

                for (var i = 0; i < SrViewModel.MCILevels().length; i++) {
                    if (SrViewModel.MCILevels()[i].nodes != undefined) {
                        MCIDynamicHTML += '<div class="col-md-12" style="">';
                        MCIDynamicHTML += '<span class="col-md-12" id="NarTheme" style="font-size: 16px;">' + SrViewModel.MCILevels()[i].categoryGuidelines + '</span>';

                        MCIDynamicHTML += '<div style="margin-left:4rem;margin-bottom: 1.5rem;">';
                        if (SrViewModel.MCILevels()[i].nodes.length > 0) {
                            for (var j = 0; j < SrViewModel.MCILevels()[i].nodes.length; j++) {
                                MCIDynamicHTML += BuilDynamicMCICheckBoxList(SrViewModel.MCILevels()[i].nodes[j], SrViewModel.MCILevels()[i].id);
                            }
                        }//i node undefined

                        MCIDynamicHTML += '</div>';
                        MCIDynamicHTML += '</div>';
                    }//i node length
                    else {
                        MCIDynamicHTML += BuilDynamicMCICheckBoxList(SrViewModel.MCILevels()[i], SrViewModel.MCILevels()[i].parentId);
                    }
                }
                MCIDynamicHTML += '</div>';
                if (SrViewModel.AoCInstructions() !== '') {
                    MCIDynamicHTML += '<div class="AoCQualInstructions col-md-4 p-2">';

                    MCIDynamicHTML += '<div class="col-md-12 alert alert-warning-aoc config-box border-dark" style="background-color:' + SrViewModel.AoCInstructions().BackgroundColor + ';">';
                    MCIDynamicHTML += '<span style="color:' + SrViewModel.AoCInstructions().Color + ';">' + SrViewModel.AoCInstructions().Instruction + '</span>';
                    MCIDynamicHTML += '</div>';

                    MCIDynamicHTML += '</div>';
                }
                MCIDynamicHTML += '</div>';

                $('#MCI_DynamicHTML').html("");
                $('#MCI_DynamicHTML').html(MCIDynamicHTML);
                var element = $('#MCI_DynamicHTML')[0];
                ko.cleanNode(element);
                ko.applyBindings(SrViewModel, document.getElementById('MCI_DynamicHTML'));
                $('#RfTabResponse').show();
                $('#DynamicHTMLDiv').show();
                $('#MCI_DynamicHTML').show();
                $('#TabDataDiv').show();
                $("#QualContDynamicHTMLDiv").hide();
                $('#DynamicHTMLDiv').hide();
                $('#LoadingGIFSRDiv').modal('hide');

                SetCheckBoxMCI();

                SrViewModel.ValuesChanged(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlMCI() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SetCheckBoxMCI() {
            try {
                if (SrViewModel != undefined && SrViewModel.MCIRawLevels() != null && SrViewModel.MCIRawLevels().length > 0) {
                    for (var i = 0; i < SrViewModel.MCIRawLevels().length; i++) {
                        if (SrViewModel.MCIRawLevels()[i].DeadNode == 1) {
                            var chkIdObj = SrViewModel.MCIRawLevels()[i];
                            var chkPId = chkIdObj.ParentAreaLevelId == '#' ? 'area' : chkIdObj.ParentAreaLevelId;
                            if (SrViewModel.MCIRawLevels()[i].Is_LevelChecked == true)
                                $('#ChkBox_' + chkPId + '_' + chkIdObj.AreaLevelId).prop("checked", true);
                            else {
                                $('#ChkBox_' + chkPId + '_' + chkIdObj.AreaLevelId).prop("checked", false);
                            }
                            if (SrViewModel.MCIRawLevels()[i].Is_Editable == 0 || (SrViewModel.DisableControl() || !SrViewModel.appsecurity.WriteAccess()))
                                $('#ChkBox_' + chkPId + '_' + chkIdObj.AreaLevelId).attr("disabled", true);
                            else
                                $('#ChkBox_' + chkPId + '_' + chkIdObj.AreaLevelId).attr("disabled", false);
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetCheckBoxMCI() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function BuilDynamicMCICheckBoxList(nodeObj, topLevelNode) {
            var MCIDynamicBoxHtml = "";
            if (nodeObj.nodes != undefined) {
                if (nodeObj.nodes.length > 0) {
                    MCIDynamicBoxHtml += '<span class="col-md-12" id="NarCategory" style="font-size: 14px;font-weight: 700;">' + nodeObj.categoryGuidelines + '</span>'
                    for (var j = 0; j < nodeObj.nodes.length; j++) {
                        MCIDynamicBoxHtml += BuilDynamicMCICheckBoxList(nodeObj.nodes[j], topLevelNode);
                    }
                }
            } else {
                if (SrViewModel.MCIMaxLevel() == nodeObj.Level) {
                    var parentId = nodeObj.parentId == '#' ? 'area' : nodeObj.parentId;
                    MCIDynamicBoxHtml += '<div class="col-lg-12" data-bind="visible:' + nodeObj.IsVisibleforSearchMCI() + '">'
                    MCIDynamicBoxHtml += '<span class="cc-checkbox">'
                    MCIDynamicBoxHtml += '<input id="ChkBox_' + parentId + '_' + nodeObj.id + '" type="checkbox" data-bind="event: {change : $root.CheckMCILevel}, checked: ' + nodeObj.Is_LevelChecked + '" />'
                    MCIDynamicBoxHtml += '<span class="cc-facet-result-text tag-text">' + nodeObj.categoryGuidelines + '</span>'
                    MCIDynamicBoxHtml += '</span>'
                    MCIDynamicBoxHtml += '</div>'
                }
            }

            return MCIDynamicBoxHtml;
        }

        function CheckMCILevel(data, event) {
            try {
                var self = this;

                SrViewModel.ValuesChanged(true);
                var chkBoxItem = "";
                splitColumnIds = "";
                topNode = "",
                    bottomNode = "";

                if (event != undefined) {
                    chkBoxItem = event.currentTarget.id;
                }
                if (chkBoxItem != undefined && chkBoxItem != "") {
                    splitColumnIds = chkBoxItem.split("_");
                }

                if (splitColumnIds != undefined && splitColumnIds.length > 1) {
                    topNode = splitColumnIds[1];
                    bottomNode = splitColumnIds[2];
                }

                if (SrViewModel != undefined && SrViewModel.MCIRawLevels() != null && SrViewModel.MCIRawLevels().length > 0) {
                    for (var i = 0; i < SrViewModel.MCIRawLevels().length; i++) {
                        if (SrViewModel.MCIRawLevels()[i].DeadNode == 1) {
                            if (SrViewModel.MCIRawLevels()[i].AreaLevelId == bottomNode) {
                                if (SrViewModel.MCIRawLevels()[i].Is_LevelChecked == true)
                                    SrViewModel.MCIRawLevels()[i].Is_LevelChecked = false;
                                else {
                                    SrViewModel.MCIRawLevels()[i].Is_LevelChecked = true;
                                }
                                break;
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CheckMCILevel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SetMCI_LevelDetails() {
            try {
                SrViewModel.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                var JsonList = SrViewModel.MCIRawLevels();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/SaveMCILevelDetails?Draft=" + SrViewModel.SurveyId(),
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(JsonList)
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult == null || jsonResult == "-1") {
                            app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage') == -1) ? 'The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click \'OK\' to redirect to Landing Page.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage') == -1) ? 'Action cannot be performed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                .then(function (option) {
                                    if (option === " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()) {
                                        SrViewModel.DashboardVM.NavigatedFrom('Response');
                                        router.navigate("landing", true);
                                    }
                                });
                        }
                        else if (jsonResult != null && isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? jsonResult + " - An error occurred. Please contact your Application Administrator." : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            if (SrViewModel.NavigateToDashboardBoolean()) {
                                SrViewModel.DashboardVM.NavigatedFrom('Response');
                                router.navigate('Landing', true);
                            } else {
                                SegregatorBasedOnSurveyType();
                                GetMCI_LevelDetails();
                                logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SavedSuccessfullyMessage') == -1) ? 'Saved successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SavedSuccessfullyMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                            }
                        }
                    })
                    .fail(function (fail, error) {
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetMCI_LevelDetails() method in SurveyResponse.js';
                logger.logMessage(msg);
            }
        }

        function ResetMCIContent() {
            try {
                $('#searchFeatureMCI').val('');
                $('#QualContDynamicHTMLDiv').html("");
                $('#DynamicHTMLDiv').html("");
                $('#MCI_DynamicHTML').html("");
                GetMCI_LevelDetails();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetMCIContent() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SaveSelectionResponse(data) {
            try {
                SrViewModel.isSaveResponseClick(true);

                //if (SrViewModel.ValuesChanged()) {
                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyCheckMCI') == -1) ? 'Please check the changes made before saving, otherwise the earlier changes will be lost.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyCheckMCI')].Name, "Warning", [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name()).toString(), (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name], true, { buttonClass: "fa fa-check btn", primaryButtonClass: "primary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                    .then(function (option) {
                        SrViewModel.ValuesChanged(false);
                        SrViewModel.isSaveResponseClick(false);
                        if (option == " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name()).toString()) {
                            $('#searchFeatureMCI').val('');
                            $('#QualContDynamicHTMLDiv').html("");
                            $('#DynamicHTMLDiv').html("");
                            $('#MCI_DynamicHTML').html("");
                            SetMCI_LevelDetails();
                        } else {
                            // SrViewModel.ValuesChanged(true);
                        }
                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveSelectionResponse() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SearchResultMCI() {
            try {
                if (SrViewModel.SurveyTypeId() == "QLDR") {
                    var searchedList = ko.computed(function () {
                        var q = SrViewModel.QueryMCI();
                        //MCIRawLevels
                        if (q != "") {
                            return SrViewModel.MCIRawLevels().filter(function (i) {
                                return i.CategoryGuidelines.toLowerCase().indexOf(q.toLowerCase()) >= 0;
                            });
                        }
                    });

                    if (SrViewModel != undefined && SrViewModel.MCILevels() != null && SrViewModel.MCILevels().length > 0) {
                        for (var i = 0; i < SrViewModel.MCILevels().length; i++) {
                            if (SrViewModel.MCILevels()[i].dead_node != 1)
                                SetSearchFlagforNodesMCI(SrViewModel.MCILevels()[i], false, i, undefined);
                        }
                    }

                    if (SrViewModel.QueryMCI() != undefined && SrViewModel.QueryMCI() == "") {
                        //for empty keyboard input
                        for (var i = 0; i < SrViewModel.MCILevels().length; i++) {
                            if (SrViewModel.MCILevels()[i].dead_node != 1)
                                SetSearchFlagforNodesMCI(SrViewModel.MCILevels()[i], true, i, undefined);
                        }
                    }
                    if (searchedList() != undefined) {
                        for (var j = 0; j < searchedList().length; j++) {
                            for (var i = 0; i < SrViewModel.MCILevels().length; i++) {
                                if (SrViewModel.MCILevels()[i].dead_node != 1)
                                    SetSearchFlagforNodesMCI(SrViewModel.MCILevels()[i], true, i, searchedList()[j]);
                            }
                        }
                    }
                }
                else if (SrViewModel.SurveyTypeId() == "CDR") {
                }

                BindDynamicHtmlMCI();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResultMCI() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function SetSearchFlagforNodesMCI(nodeObj, flag, i, searchedList) {
                try {
                    var counter = 0;
                    if (nodeObj.nodes != undefined) {
                        if (nodeObj.nodes.length > 0) {
                            for (var j = 0; j < nodeObj.nodes.length; j++) {
                                if (nodeObj.nodes[j].dead_node != 1) {
                                    SetSearchFlagforNodesMCI(nodeObj.nodes[j], flag, j, searchedList);
                                    counter++;
                                } else {
                                    if (searchedList != undefined) {
                                        if (nodeObj.nodes[j].dead_node == 1 && nodeObj.nodes[j].id == searchedList.AreaLevelId) {
                                            nodeObj.nodes[j].IsVisibleforSearchMCI(flag);
                                            SrViewModel.MCILevels()[i].nodes[j].nodes[counter].IsVisibleforSearchMCI(true);
                                        }
                                    }
                                    else if (searchedList == undefined) {
                                        nodeObj.IsVisibleforSearchMCI(flag);
                                        for (var k = 0; k < nodeObj.nodes.length; k++) {
                                            SrViewModel.MCILevels()[i].nodes[j].nodes[k].IsVisibleforSearchMCI(false);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: SetSearchFlagforNodesMCI() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function ResetSearchMCI() {
            try {
                $('#searchFeatureMCI').val('');
                if (SrViewModel != undefined && SrViewModel.MCILevels() != null && SrViewModel.MCILevels().length > 0) {
                    for (var i = 0; i < SrViewModel.MCILevels().length; i++) {
                        if (SrViewModel.MCILevels()[i].dead_node != 1)
                            SetSearchFlagforNodesMCI(SrViewModel.MCILevels()[i], true, undefined);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetSearchMCI() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Finalize PopUp Methods, Models and Click Events

        function finalizeQuestionnaire(data, event) {
            try {
                if (!SrViewModel.FinalizePopUpFlag())
                    GetUsersRoleWFDetails();
                if (SrViewModel.DisableControl() == false || SrViewModel.appsecurity.WriteAccess()) {
                    if (SrViewModel.ShowBookmarkFlags()) {
                        CheckBookmarksatSurveyLevel().then(function () {
                            if (SrViewModel.SruveyLevelBookmarkFlag())
                                preFinalizePopUp(data, event);
                            else
                                finalizeQuestionnairePopUp(data, event);
                        });
                    }
                    else {
                        finalizeQuestionnairePopUp(data, event);
                    }
                }
                else {
                    finalizeQuestionnairePopUp(data, event);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: finalizeQuestionnaire() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function preFinalizePopUp(data, event) {
            try {
                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ReviewFlaggedQuestionMessage') == -1) ? 'Please review the flagged questions before finalizing the survey.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ReviewFlaggedQuestionMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ReviewFlaggedQuestionsHeading') == -1) ? 'Review Flagged Questions' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ReviewFlaggedQuestionsHeading')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ReviewButton') == -1) ? 'Review' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ReviewButton')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyFinalizeHeading') == -1) ? 'Finalize' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyFinalizeHeading')].Name], false, { buttonClass: "btn", primaryButtonClass: "secondary-btn", secondaryButtonClass: "primary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                    .then(function (option) {
                        if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyFinalizeHeading') == -1) ? 'Finalize' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyFinalizeHeading')].Name)()) {
                            finalizeQuestionnairePopUp(data, event);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: preFinalizePopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function CheckBookmarksatSurveyLevel() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/CheckBookmarksatSurveyLevel",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: SrViewModel.SurveyId(), SurveyType: SrViewModel.SurveyTypeId() })
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult == null || jsonResult == "0")
                            SrViewModel.SruveyLevelBookmarkFlag(false);
                        else if (jsonResult.substring(0, 3) == "INC")
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                ? jsonResult + " - An error has occured. Please contact your Administrator."
                                : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                    (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? jsonResult + " - Please contact your Administrator."
                                    : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        else if (jsonResult == "1")
                            SrViewModel.SruveyLevelBookmarkFlag(true);
                        else
                            SrViewModel.SruveyLevelBookmarkFlag(false);
                    })
                    .fail(function (error, status) {
                        try {
                            if (error.status === 401) {
                                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                            navigation.unauthorized();
                                    });
                            }
                            else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CheckBookmarksatSurveyLevel() method in SurveyResponsePage.js';
                                logger.logMessage(msg);
                            }
                        } catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxFail in CheckBookmarksatSurveyLevel() method in SurveyResponsePage.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CheckBookmarksatSurveyLevel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function finalizeQuestionnairePopUp(data, event) {
            try {
                SrViewModel.PushbackComment('');
                SrViewModel.TimelineCommentsFlag(true);
                $('#showCmpltTimelineBtn').hide();
                $('#showLessTimelineBtn').show();
                SrViewModel.SurveyTimelineComments([]);
                $('#divActionError').hide();
                SrViewModel.RemainingChars(SrViewModel.CommentCharsLimit());

                if (SrViewModel.DashboardVM.RoutedFrom() === "Dashboard" && !SrViewModel.IsSurveyPending() && !SrViewModel.IsSurveyCompleted() && SrViewModel.ValuesChanged() && (SrViewModel.DisableControl() == false || SrViewModel.appsecurity.WriteAccess())) {
                    app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyDataCheckActionPerform') == -1) ? 'Please save the data before performing this action, otherwise the changes made will be lost.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyDataCheckActionPerform')].Name, "Warning", [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name], true, { buttonClass: "fa fa-check btn", primaryButtonClass: "primary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                        .then(function (option) {
                            if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name)()) {
                                $('#SurveyTimelinePopUp').modal('hide');
                                SrViewModel.SavechangedvalueTab(null);
                                SrViewModel.SavechangedvalueSubTab(null);
                                if (SrViewModel.MCILevel() === true) {
                                    SetMCI_LevelDetails();
                                } else {
                                    SaveResponse(SrViewModel.SelectedNode());
                                }
                            }
                            GetSurveyAction().then(function () {
                                $('#FinalizeValidations').hide();
                                $('#SurveyTimelinePopUp').modal('show');
                            });
                        });
                }
                else {
                    if (SrViewModel.DisableControl() == false || SrViewModel.appsecurity.WriteAccess()) {
                        GetSurveyAction().then(function () {
                            $('#FinalizeValidations').hide();
                            $('#SurveyTimelinePopUp').modal('show');
                        });
                    }
                    else
                        GetSurveyLevelComments("PBC").then(function () {
                            $('#FinalizeValidations').hide();
                            $('#SurveyTimelinePopUp').modal('show');
                        });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: finalizeQuestionnairePopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function GetUsersRoleWFDetails() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    url: "/api/Configuration/GetRoleUserDetailsForBUSocializationWorkFLow",
                    data: ko.toJSON({
                        "Draft": SrViewModel.SurveyId(),
                        "Survey_type": SrViewModel.SurveyClassification()
                    }),
                    type: "POST",
                    headers: headers
                })
                    .success(function (jsonResult, success) {
                        SrViewModel.UsersRoleWFList([]);
                        if (jsonResult != null && jsonResult.length > 0) {
                            if (jsonResult[0].RoleID == -99) {
                                logger.logError(jsonResult[0].RoleName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                $('#UsersRoleWFChevrons').show();
                                SrViewModel.UsersRoleWFList(jsonResult);
                                SrViewModel.FinalizePopUpFlag(true);
                            }
                        }
                        else {
                            $('#UsersRoleWFChevrons').hide();
                        }
                    })
                    .fail(function (error, status) {
                        try {
                            if (error.status === 401) {
                                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                            navigation.unauthorized();
                                    });
                            }
                            else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUsersRoleWFDetails() method in SurveyResponsePage.js';
                                logger.logMessage(msg);
                            }
                        } catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetUsersRoleWFDetails() method in SurveyResponsePage.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in GetUsersRoleWFDetails() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function GetSurveyAction() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/GetActionsList",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: SrViewModel.SurveyId(), RoleId: SrViewModel.RoleId() })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetSurveyAction() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    SrViewModel.SurveyActionsList([]);
                    $('#divActionError').hide();
                    if (jsonResult != null) {
                        if (jsonResult.length > 0 && jsonResult[0].ErrorId == -99) {
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                ? jsonResult[0].ErrorName + " - An error has occured. Please contact your Administrator."
                                : jsonResult[0].ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                    (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? jsonResult[0].ErrorName + " - Please contact your Administrator."
                                    : jsonResult[0].ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            var mappedActionsList = $.map(jsonResult, function (result) {
                                return new SurveyActionsModel(result);
                            });
                            SrViewModel.SurveyActionsList(mappedActionsList);
                            if (jsonResult.length === 1 && jsonResult[0].EventId === 0 && !SrViewModel.IsSurveyCompleted()) {
                                document.getElementById('lblActionError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoActionsAvailableMessage') == -1) ? 'No Actions are available.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoActionsAvailableMessage')].Name();
                                $('#divActionError').show();
                            }
                            $('#FinalizeCommentDiv').html("");
                            $('#FinalizeCommentDiv').html($('#FinalizeCommentsBlock').html());
                            $('#FinalizeCommentDiv').show();
                        }
                    }
                    else {
                        $('#FinalizeCommentDiv').hide();
                    }
                    GetSurveyLevelComments("PBC");
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetSurveyAction() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyAction() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSurveyAction() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetSurveyLevelComments(commentType) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/GetSurveyLevelComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: SrViewModel.SurveyId(), SurveyType: SrViewModel.SurveyClassification(), CommentType: commentType, AssessmentProfileId: parseInt(SrViewModel.CurrentProfileOfAssessmentId()) })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyLevelComments() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult != "" && isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                            ? jsonResult + " - An error has occurred while syncing the ratings."
                            : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                            [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                ? jsonResult + " - Please contact your Administrator."
                                : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    }
                    else {
                        if (commentType == "PBC") {
                            SrViewModel.SurveyTimelineComments([]);
                            if (jsonResult != "") {
                                var convertedObj = JSON.parse(jsonResult);
                                var mappedList = ko.mapping.fromJS(convertedObj.Comments)();
                                SrViewModel.SurveyTimelineComments(mappedList);
                            }
                            else {
                                $('#showCmpltTimelineBtn').hide();
                                $('#showLessTimelineBtn').hide();
                            }
                        }
                        else if (commentType == "SN") {
                            if (jsonResult != "") {
                                var summaryObj = JSON.parse(jsonResult);
                                var summaryComment = ko.mapping.fromJS(summaryObj.Comments)();
                                SrViewModel.SurveySummaryCommentId(summaryComment[0].CommentId());
                                SrViewModel.SurveySummaryComment("");
                                SrViewModel.SurveySummaryComment(summaryComment[0].CommentText());
                                SrViewModel.SummaryCommentBy(summaryComment[0].UserName());
                                SrViewModel.SummaryCommentCreatedDate(summaryComment[0].CreateDate());
                                SrViewModel.SummaryPopUpFlag(true);
                            }
                            else {
                                SrViewModel.SurveySummaryCommentId(0);
                                SrViewModel.SurveySummaryComment('');
                                SrViewModel.SummaryCommentBy('');
                                SrViewModel.SummaryCommentCreatedDate('');
                            }
                        }
                        else if (commentType == "SND") {
                            SrViewModel.SummaryDocumentsList([]);
                            if (jsonResult != "") {
                                var docObj = JSON.parse(jsonResult);
                                var mappedDocList = ko.mapping.fromJS(docObj.Comments)();
                                SrViewModel.SummaryDocumentsList(mappedDocList);
                                SrViewModel.SummaryPopUpFlag(true);
                            }
                        }
                        //RefreshSession();
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetSurveyLevelComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyLevelComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSurveyLevelComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function PerformFinalizeAction(data, event) {
            try {
                RefreshSession();
                SrViewModel.SelectedActionEventId('');
                if ($('input[name=rdbAction]:checked').val() === undefined) {
                    document.getElementById('lblActionError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SelectActionValidationMessage') == -1) ? 'Please select an action to perform.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SelectActionValidationMessage')].Name();
                    $('#divActionError').show();
                }
                else if (SrViewModel.PushbackComment().trim() === "" || SrViewModel.PushbackComment() === undefined) {
                    document.getElementById('lblActionError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FinalizeCommentErrorMessage') == -1) ? 'Please enter survey finalize comment.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FinalizeCommentErrorMessage')].Name();
                    $('#divActionError').show();
                }
                else {
                    if (SrViewModel.PushbackComment().length > SrViewModel.CommentCharsLimit()) {
                        document.getElementById('lblActionError').innerHTML = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitBegin') == -1) ? 'Comment cannot exceed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitBegin')].Name()).toString() + ' ' + SrViewModel.CommentCharsLimit() + ' ' + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitEnd') == -1) ? 'characters.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitEnd')].Name()).toString();
                        $('#divActionError').show();
                        return;
                    }

                    var selectedAction = ko.utils.arrayFilter(SrViewModel.SurveyActionsList(), function (param) {
                        return param.EventId() === $('input[name=rdbAction]:checked').val();
                    });
                    SrViewModel.SelectedActionEventId(selectedAction[0].EventId());
                    var selectedOption = $('input[name=rdbAction]:checked').closest('label').text();
                    if (selectedAction[0] && selectedAction[0].ShowValidatePopup()) {
                        if (SrViewModel.IsRefreshProfileGlobalFlag()) {
                            for (var i = 0; i < SrViewModel.AreaLeveljstree()["#"].length; i++) {
                                if (SrViewModel.AreaLeveljstree()["#"][i].Is_RefreshEnable === true && SrViewModel.AreaLeveljstree()["#"][i].Tick_Flag === false) {
                                    var ErrorMessage = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RefreshFinalizeValidationMessage') == -1) ? 'Please save Areas of Change and the questionnaire for all the enabled areas.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RefreshFinalizeValidationMessage')].Name();
                                    if (SrViewModel.SurveyTypeId() === 'QLDR')
                                        ErrorMessage = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RefreshFinalizeCommonValidationMessage') == -1) ? 'Please save Areas of Change, Common Questionnaire (if there are any) and the questionnaire for all the enabled areas.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RefreshFinalizeCommonValidationMessage')].Name();
                                    document.getElementById('lblActionError').innerHTML = ErrorMessage;
                                    $('#divActionError').show();
                                    return false;
                                }
                            }
                        }
                        $('#divActionError').hide();
                        ValidateSurvey(selectedAction);
                    }
                    else {
                        $('#divActionError').hide();
                        SetSurveyLevelComments("PBC");
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PerformFinalizeAction() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ValidateSurvey(selectedAction) {
            try {
                $.ajax({
                    url: "/api/Survey/ValidateSurvey",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { Draft: SrViewModel.SurveyId(), Type: SrViewModel.SurveyTypeId() }
                })
                    .success(function (JsonResult, Success) {
                        ValidationTblObj = $('#FinalizeValidationTable').DataTable();
                        ValidationTblObj.destroy();
                        $("#FinalizeValidationTable tbody tr").remove();
                        SrViewModel.FinalizeValidationList([]);
                        if (JsonResult != null) {
                            if (JsonResult.length > 0 && JsonResult[0].Incident_Description != null && JsonResult[0].Incident_Description.substring(0, 3) == "INC") {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                    ? jsonResult[0].Incident_Description + " - An error has occurred while syncing the ratings."
                                    : jsonResult[0].Incident_Description + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                        (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                        ? jsonResult[0].Incident_Description + " - Please contact your Administrator."
                                        : jsonResult[0].Incident_Description + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                if (JsonResult.length > 0) {
                                    var mappedValidationList = $.map(JsonResult, function (result) {
                                        return new ValidationListObject(result);
                                    });
                                    SrViewModel.FinalizeValidationList(mappedValidationList);

                                    $('#FinalizeValidationTable').DataTable({
                                        "aLengthMenu": [5, 10, 25, "All"],
                                        "iDisplayLength": 5,
                                        "aoColumnDefs": [{
                                            "width": "15%",
                                            "bSortable": true,
                                            "orderable": true
                                        },
                                        {
                                            "width": "70%",
                                            "bSortable": true,
                                            "orderable": true
                                        },
                                        {
                                            "width": "10%",
                                            "bSortable": true,
                                            "orderable": true
                                        }]
                                    });
                                }
                                if (SrViewModel.FinalizeValidationList().length > 0 && selectedAction[0].ShowValidatePopup() === true) {
                                    $('#FinalizeValidations').show();
                                    $('#ValidationAccordainClick').removeClass('collapsed');
                                    $('#validationTableDiv').addClass('show');
                                    SrViewModel.SurveyLevelMandatoryList([]);
                                    var arrayObjectMain = [];
                                    for (var i = 0; i < SrViewModel.FinalizeValidationList().length; i++) {
                                        arrayObjectMain.push({ QuestionId_Mandatory: SrViewModel.FinalizeValidationList()[i].QuestionId(), Flag_Type: SrViewModel.FinalizeValidationList()[i].MandatoryFieldFlag() });
                                    }
                                    SrViewModel.SurveyLevelMandatoryList(arrayObjectMain);
                                    if (SrViewModel.ClickedRiskAreaId() !== -999) {
                                        setMandatoryFlags();
                                    }
                                }
                                else {
                                    $('#divActionError').hide();
                                    $('#FinalizeValidations').hide();
                                    SetSurveyLevelComments("PBC");
                                }
                            }
                        }
                    })
                    .fail(function (error, fail) {
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidateSurvey() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function showWFDescription(data, event) {
            try {
                if ($('#WFDescDiv').is(':visible')) {
                    $('#WFDescDiv').hide();
                    $('#showWFDescBtn').show();
                    $('#showWFDescBtn').addClass('nd-flex');
                    $('#hideWFDescBtn').removeClass('nd-flex');
                    $('#hideWFDescBtn').hide();
                }
                else {
                    $('#WFDescDiv').show();
                    $('#hideWFDescBtn').show();
                    $('#hideWFDescBtn').addClass('nd-flex');
                    $('#showWFDescBtn').removeClass('nd-flex');
                    $('#showWFDescBtn').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showWFDescription() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function showTimelineComments(data, event) {
            try {
                if ($('#showCmpltTimelineBtn').is(':visible')) {
                    SrViewModel.TimelineCommentsFlag(true);
                    $('#showCmpltTimelineBtn').hide();
                    $('#showLessTimelineBtn').show();
                }
                else {
                    SrViewModel.TimelineCommentsFlag(false);
                    $('#showCmpltTimelineBtn').show();
                    $('#showLessTimelineBtn').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showTimelineComments() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function setSurveyLevelMandatoryList() {
            try {
                if (SrViewModel.EnableMandatoryFlags()) {
                    if (SrViewModel.SurveyTypeId() === 'QLDR') {
                        var arrayObjectQual = SrViewModel.SurveyLevelMandatoryList();
                        for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                            // Responses
                            var rowCheck = [];
                            rowCheck = ko.utils.arrayFilter(arrayObjectQual, function (arr) {
                                if (arr.QuestionId_Mandatory === SrViewModel.QualResponseListData()[i].QuestionId() && arr.Flag_Type === 'R')
                                    return arr;
                            });
                            if (SrViewModel.QualResponseListData()[i].ShowQuestionMandatoryFlag()) {
                                if (rowCheck.length === 0)
                                    arrayObjectQual.push({ QuestionId_Mandatory: SrViewModel.QualResponseListData()[i].QuestionId(), Flag_Type: 'R' });
                            }
                            else {
                                if (rowCheck.length > 0)
                                    ko.utils.arrayRemoveItem(arrayObjectQual, rowCheck[0]);
                            }
                            // Comments
                            rowCheck = [];
                            rowCheck = ko.utils.arrayFilter(arrayObjectQual, function (arr) {
                                if (arr.QuestionId_Mandatory === SrViewModel.QualResponseListData()[i].QuestionId() && arr.Flag_Type === 'C')
                                    return arr;
                            });
                            if (SrViewModel.QualResponseListData()[i].Is_CommentMandatory() && SrViewModel.QualResponseListData()[i].CommentCount() === 0 && SrViewModel.QualResponseListData()[i].IsReadOnly() === 0) {
                                if (rowCheck.length === 0)
                                    arrayObjectQual.push({ QuestionId_Mandatory: SrViewModel.QualResponseListData()[i].QuestionId(), Flag_Type: 'C' });
                            }
                            else {
                                if (rowCheck.length > 0)
                                    ko.utils.arrayRemoveItem(arrayObjectQual, rowCheck[0]);
                            }
                            // Documents
                            rowCheck = [];
                            rowCheck = ko.utils.arrayFilter(arrayObjectQual, function (arr) {
                                if (arr.QuestionId_Mandatory === SrViewModel.QualResponseListData()[i].QuestionId() && arr.Flag_Type === 'D')
                                    return arr;
                            });
                            if (SrViewModel.QualResponseListData()[i].Is_DocumentMandatory() && SrViewModel.QualResponseListData()[i].DocumentCount() === 0 && SrViewModel.QualResponseListData()[i].IsReadOnly() === 0) {
                                if (rowCheck.length === 0)
                                    arrayObjectQual.push({ QuestionId_Mandatory: SrViewModel.QualResponseListData()[i].QuestionId(), Flag_Type: 'D' });
                            }
                            else {
                                if (rowCheck.length > 0)
                                    ko.utils.arrayRemoveItem(arrayObjectQual, rowCheck[0]);
                            }
                        }
                        SrViewModel.SurveyLevelMandatoryList(arrayObjectQual);
                    }

                    else if (SrViewModel.SurveyTypeId() === 'CDR') {
                        var arrayObjectControls = SrViewModel.SurveyLevelMandatoryList();
                        for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                            // Responses
                            var rowCheck = [];
                            rowCheck = ko.utils.arrayFilter(arrayObjectControls, function (arr) {
                                if (arr.QuestionId_Mandatory === SrViewModel.ControlsResponseData()[i].QuestionId() && arr.Flag_Type === 'R')
                                    return arr;
                            });
                            if (SrViewModel.ControlsResponseData()[i].ShowQuestionMandatoryFlag()) {
                                if (rowCheck.length === 0)
                                    arrayObjectControls.push({ QuestionId_Mandatory: SrViewModel.ControlsResponseData()[i].QuestionId(), Flag_Type: 'R' });
                            }
                            else {
                                if (rowCheck.length > 0)
                                    ko.utils.arrayRemoveItem(arrayObjectControls, rowCheck[0]);
                            }
                            // Comments
                            rowCheck = [];
                            rowCheck = ko.utils.arrayFilter(arrayObjectControls, function (arr) {
                                if (arr.QuestionId_Mandatory === SrViewModel.ControlsResponseData()[i].QuestionId() && arr.Flag_Type === 'C')
                                    return arr;
                            });
                            if (SrViewModel.ControlsResponseData()[i].Is_CommentMandatory() && SrViewModel.ControlsResponseData()[i].CommentCount() === 0 && SrViewModel.ControlsResponseData()[i].IsReadOnly() === 0) {
                                if (rowCheck.length === 0)
                                    arrayObjectControls.push({ QuestionId_Mandatory: SrViewModel.ControlsResponseData()[i].QuestionId(), Flag_Type: 'C' });
                            }
                            else {
                                if (rowCheck.length > 0)
                                    ko.utils.arrayRemoveItem(arrayObjectControls, rowCheck[0]);
                            }
                            // Documents
                            rowCheck = [];
                            rowCheck = ko.utils.arrayFilter(arrayObjectControls, function (arr) {
                                if (arr.QuestionId_Mandatory === SrViewModel.ControlsResponseData()[i].QuestionId() && arr.Flag_Type === 'D')
                                    return arr;
                            });
                            if (SrViewModel.ControlsResponseData()[i].Is_DocumentMandatory() && SrViewModel.ControlsResponseData()[i].DocumentCount() === 0 && SrViewModel.ControlsResponseData()[i].IsReadOnly() === 0) {
                                if (rowCheck.length === 0)
                                    arrayObjectControls.push({ QuestionId_Mandatory: SrViewModel.ControlsResponseData()[i].QuestionId(), Flag_Type: 'D' });
                            }
                            else {
                                if (rowCheck.length > 0)
                                    ko.utils.arrayRemoveItem(arrayObjectControls, rowCheck[0]);
                            }
                        }
                        SrViewModel.SurveyLevelMandatoryList(arrayObjectControls);
                    }

                    else if (SrViewModel.SurveyTypeId() === 'QTDR') {
                        var arrayObjectQuan = SrViewModel.SurveyLevelMandatoryList();
                        for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                            if (SrViewModel.QuanResponseObject()[i].Is_Header() !== 1) {
                                // Responses
                                var rowCheck = [];
                                rowCheck = ko.utils.arrayFilter(arrayObjectQuan, function (arr) {
                                    if (arr.QuestionId_Mandatory === SrViewModel.QuanResponseObject()[i].QuestionId() && arr.Flag_Type === 'R')
                                        return arr;
                                });
                                if (SrViewModel.QuanResponseObject()[i].ShowQuestionMandatoryFlag()) {
                                    if (rowCheck.length === 0)
                                        arrayObjectQuan.push({ QuestionId_Mandatory: SrViewModel.QuanResponseObject()[i].QuestionId(), Flag_Type: 'R' });
                                }
                                else {
                                    if (rowCheck.length > 0)
                                        ko.utils.arrayRemoveItem(arrayObjectQuan, rowCheck[0]);
                                }
                                // Comments
                                rowCheck = [];
                                rowCheck = ko.utils.arrayFilter(arrayObjectQuan, function (arr) {
                                    if (arr.QuestionId_Mandatory === SrViewModel.QuanResponseObject()[i].QuestionId() && arr.Flag_Type === 'C')
                                        return arr;
                                });
                                if (SrViewModel.QuanResponseObject()[i].Is_CommentMandatory() && SrViewModel.QuanResponseObject()[i].CommentCount() === 0 && SrViewModel.QuanResponseObject()[i].IsReadOnly() === 0) {
                                    if (rowCheck.length === 0)
                                        arrayObjectQuan.push({ QuestionId_Mandatory: SrViewModel.QuanResponseObject()[i].QuestionId(), Flag_Type: 'C' });
                                }
                                else {
                                    if (rowCheck.length > 0)
                                        ko.utils.arrayRemoveItem(arrayObjectQuan, rowCheck[0]);
                                }
                                // Documents
                                rowCheck = [];
                                rowCheck = ko.utils.arrayFilter(arrayObjectQuan, function (arr) {
                                    if (arr.QuestionId_Mandatory === SrViewModel.QuanResponseObject()[i].QuestionId() && arr.Flag_Type === 'D')
                                        return arr;
                                });
                                if (SrViewModel.QuanResponseObject()[i].Is_DocumentMandatory() && SrViewModel.QuanResponseObject()[i].DocumentCount() === 0 && SrViewModel.QuanResponseObject()[i].IsReadOnly() === 0) {
                                    if (rowCheck.length === 0)
                                        arrayObjectQuan.push({ QuestionId_Mandatory: SrViewModel.QuanResponseObject()[i].QuestionId(), Flag_Type: 'D' });
                                }
                                else {
                                    if (rowCheck.length > 0)
                                        ko.utils.arrayRemoveItem(arrayObjectQuan, rowCheck[0]);
                                }
                            }
                        }
                        SrViewModel.SurveyLevelMandatoryList(arrayObjectQuan);
                    }
                    setMandatoryFlags();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: setSurveyLevelMandatoryList() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function setMandatoryFlags() {
            try {
                if (SrViewModel.SurveyTypeId() === 'QLDR') {
                    for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                        SrViewModel.QualResponseListData()[i].IsSaveClicked_Response(false);
                        SrViewModel.QualResponseListData()[i].IsSaveClicked_Comment(false);
                        SrViewModel.QualResponseListData()[i].IsSaveClicked_Document(false);
                        for (var h = 0; h < SrViewModel.SurveyLevelMandatoryList().length; h++) {
                            if (SrViewModel.SurveyLevelMandatoryList()[h].QuestionId_Mandatory === SrViewModel.QualResponseListData()[i].QuestionId() && SrViewModel.SurveyLevelMandatoryList()[h].Flag_Type === 'R')
                                SrViewModel.QualResponseListData()[i].IsSaveClicked_Response(true);
                            if (SrViewModel.SurveyLevelMandatoryList()[h].QuestionId_Mandatory === SrViewModel.QualResponseListData()[i].QuestionId() && SrViewModel.SurveyLevelMandatoryList()[h].Flag_Type === 'C')
                                SrViewModel.QualResponseListData()[i].IsSaveClicked_Comment(true);
                            if (SrViewModel.SurveyLevelMandatoryList()[h].QuestionId_Mandatory === SrViewModel.QualResponseListData()[i].QuestionId() && SrViewModel.SurveyLevelMandatoryList()[h].Flag_Type === 'D')
                                SrViewModel.QualResponseListData()[i].IsSaveClicked_Document(true);
                        }
                    }
                }
                else if (SrViewModel.SurveyTypeId() === 'CDR') {
                    for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                        SrViewModel.ControlsResponseData()[i].IsSaveClicked_Response(false);
                        SrViewModel.ControlsResponseData()[i].IsSaveClicked_Comment(false);
                        SrViewModel.ControlsResponseData()[i].IsSaveClicked_Document(false);
                        for (var h = 0; h < SrViewModel.SurveyLevelMandatoryList().length; h++) {
                            if (SrViewModel.SurveyLevelMandatoryList()[h].QuestionId_Mandatory === SrViewModel.ControlsResponseData()[i].QuestionId() && SrViewModel.SurveyLevelMandatoryList()[h].Flag_Type === 'R')
                                SrViewModel.ControlsResponseData()[i].IsSaveClicked_Response(true);
                            if (SrViewModel.SurveyLevelMandatoryList()[h].QuestionId_Mandatory === SrViewModel.ControlsResponseData()[i].QuestionId() && SrViewModel.SurveyLevelMandatoryList()[h].Flag_Type === 'C')
                                SrViewModel.ControlsResponseData()[i].IsSaveClicked_Comment(true);
                            if (SrViewModel.SurveyLevelMandatoryList()[h].QuestionId_Mandatory === SrViewModel.ControlsResponseData()[i].QuestionId() && SrViewModel.SurveyLevelMandatoryList()[h].Flag_Type === 'D')
                                SrViewModel.ControlsResponseData()[i].IsSaveClicked_Document(true);
                        }
                    }
                }
                else if (SrViewModel.SurveyTypeId() === 'QTDR') {
                    for (var i = 0; i < SrViewModel.QuanResponseObject().length; i++) {
                        SrViewModel.QuanResponseObject()[i].IsSaveClicked_Response(false);
                        SrViewModel.QuanResponseObject()[i].IsSaveClicked_Comment(false);
                        SrViewModel.QuanResponseObject()[i].IsSaveClicked_Document(false);
                        for (var h = 0; h < SrViewModel.SurveyLevelMandatoryList().length; h++) {
                            if (SrViewModel.SurveyLevelMandatoryList()[h].QuestionId_Mandatory === SrViewModel.QuanResponseObject()[i].QuestionId() && SrViewModel.SurveyLevelMandatoryList()[h].Flag_Type === 'R')
                                SrViewModel.QuanResponseObject()[i].IsSaveClicked_Response(true);
                            if (SrViewModel.SurveyLevelMandatoryList()[h].QuestionId_Mandatory === SrViewModel.QuanResponseObject()[i].QuestionId() && SrViewModel.SurveyLevelMandatoryList()[h].Flag_Type === 'C')
                                SrViewModel.QuanResponseObject()[i].IsSaveClicked_Comment(true);
                            if (SrViewModel.SurveyLevelMandatoryList()[h].QuestionId_Mandatory === SrViewModel.QuanResponseObject()[i].QuestionId() && SrViewModel.SurveyLevelMandatoryList()[h].Flag_Type === 'D')
                                SrViewModel.QuanResponseObject()[i].IsSaveClicked_Document(true);
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: setMandatoryFlags() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SetSurveyLevelComments(commentType) {
            try {
                var eventId = -1;
                var commentId = -1;
                var commentText = '';

                if (commentType === 'PBC') {
                    eventId = parseInt(SrViewModel.SelectedActionEventId());
                    commentText = SrViewModel.PushbackComment();
                }
                if (commentType === 'SN') {
                    commentText = CKEDITOR.instances["NarrationTextArea"].getData();
                    commentId = parseInt(SrViewModel.SurveySummaryCommentId());
                }

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/SetSurveyLevelComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        Draft: SrViewModel.SurveyId(), AssessmentProfileId: parseInt(SrViewModel.CurrentProfileOfAssessmentId()),
                        EventId: eventId, CommentId: commentId, RoleId: SrViewModel.RoleId(), CommentText: commentText,
                        CommentType: commentType, SurveyType: SrViewModel.SurveyClassification()
                    }),
                    type: "POST",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetSurveyLevelComments() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult.substring(0, 3) == "INC") {
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                ? jsonResult + " - An error has occured. Please contact your Administrator."
                                : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                    (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? jsonResult + " - Please contact your Administrator."
                                    : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else if (commentType === 'PBC') {
                            if (parseInt(jsonResult) === -999) {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage') == -1) ? 'An error occurred while saving Comments. Because Comment contain some invalid characters.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            } else if (parseInt(jsonResult) > 0)
                                PerformSurveyAction();
                            else {
                                document.getElementById('lblActionError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveCommentErrorMessage') == -1) ? 'Error occurred while saving comments. Please try again.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveCommentErrorMessage')].Name();
                                $('#divActionError').show();
                                //logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage') == -1) ? 'The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click \'OK\' to redirect to Landing Page.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage') == -1) ? 'Action cannot be performed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                    .then(function (option) {
                                        if (option === " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()) {
                                            SrViewModel.DashboardVM.NavigatedFrom('Response');
                                            router.navigate("landing", true);
                                        }
                                    });
                            }
                        }
                        else if (commentType === 'SN') {
                            if (parseInt(jsonResult) === -999) {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage') == -1) ? 'An error occurred while saving Comments. Because Comment contain some invalid characters.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            } else if (parseInt(jsonResult) > 0) {
                                logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SummaryDetailsSaveSuccessMessage') == -1) ? 'Summary details saved successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SummaryDetailsSaveSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                                GetSurveyLevelComments(commentType);
                            }
                            else {
                                //logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage') == -1) ? 'The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click \'OK\' to redirect to Landing Page.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage') == -1) ? 'Action cannot be performed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                    .then(function (option) {
                                        if (option === " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()) {
                                            SrViewModel.DashboardVM.NavigatedFrom('Response');
                                            router.navigate("landing", true);
                                        }
                                    });
                            }
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SetSurveyLevelComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetSurveyLevelComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in SetSurveyLevelComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function PerformSurveyAction() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/SetPerformAction",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ EventId: $('input[name=rdbAction]:checked').val(), Draft: SrViewModel.SurveyId() })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in PerformSurveyAction() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (jsonResult != null) {
                        if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                ? jsonResult + " - An error has occured. Please contact your Administrator."
                                : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                    (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? jsonResult + " - Please contact your Administrator."
                                    : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        if (!isNaN(jsonResult) && parseInt(jsonResult) > 0) {
                            logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyActionSuccessMessage') == -1) ? 'Survey action performed successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyActionSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                            SrViewModel.DashboardVM.NavigatedFrom('Response');
                            setTimeout(router.navigate('Landing', true), 200);
                        }
                        else if (!isNaN(jsonResult) && parseInt(jsonResult) < 0)
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyActionErrorMessage') == -1) ? 'An error occurred while performing selected survey action.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyActionErrorMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    }
                    else
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyActionErrorMessage') == -1) ? 'An error occurred while performing selected survey action.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyActionErrorMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in PerformSurveyAction() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (error.status === 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in PerformSurveyAction() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in PerformSurveyAction() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function SurveyActionsModel(item) {
            try {
                var self = this;
                self.EventId = ko.observable(item.EventId);
                self.EventName = ko.observable($('<div/>').html(item.EventName).text());
                self.NextState = ko.observable($('<div/>').html(item.NextState).text());
                self.ShowValidatePopup = ko.observable(item.ShowValidatePopup);
                self.IsMessage = ko.observable(item.IsMessage);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyActionsModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ValidationListObject(item) {
            try {
                var self = this;
                self.QuestionId = ko.observable(item.QuestionId);
                self.DisplayRank = ko.observable(item.DisplayRank);
                self.AreaName = ko.observable($('<div/>').html(item.AreaName).text());
                self.QuestionText = ko.observable(item.QuestionText);
                self.MandatoryFieldType = ko.observable($('<div/>').html(item.MandatoryFieldType).text());
                self.MandatoryFieldFlag = ko.observable(item.MandatoryFieldFlag);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidationListObject() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Comments, Attachments, History, Guidelines and Overall Summary Methods

        //Comments, Attachments, History, Guidelines and Overall Summary
        //related all methods - get, set and delete

        function ShowExtraContent(sectionId, data, questionId) {
            try {
                $("#cmt_" + questionId).hide();
                $("#atch_" + questionId).hide();
                $("#gui_" + questionId).hide();
                $("#hist_" + questionId).hide();

                $("#cmt_Q_Id" + questionId).removeClass("active");
                $("#atch_Q_Id" + questionId).removeClass("active");
                $("#gui_Q_Id" + questionId).removeClass("active");
                $("#hist_Q_Id" + questionId).removeClass("active");
                if (data.IsReadOnly() == 0 && (SrViewModel.DisableControl() == false || SrViewModel.appsecurity.WriteAccess())) {
                    if (SrViewModel.SurveyTypeId() === 'QTDR') {
                        document.getElementById("UploadTextArea_" + questionId).value = null;
                        document.getElementById("ResponseTextArea_" + questionId).value = null;
                    }
                    else if (SrViewModel.SurveyTypeId() !== 'QTDR' && data.IsConditional() != 1) {
                        document.getElementById("UploadTextArea_" + questionId).value = null;
                        document.getElementById("ResponseTextArea_" + questionId).value = null;
                    }
                }
                SrViewModel.RemainingChars(SrViewModel.CommentCharsLimit());
                $("#" + sectionId).show();
                SrViewModel.IsCommentPopUp(false);
                SrViewModel.IsDocumentPopUp(false);
                SrViewModel.IsHistoryPopUp(false);
                SrViewModel.SelectedQuestionId(questionId);
                SrViewModel.IsReadOnlyQuestion(data.IsReadOnly());
                if (SrViewModel.SurveyTypeId() !== 'QTDR')
                    SrViewModel.IsConditionalQuestion(data.IsConditional());
                else
                    SrViewModel.IsConditionalQuestion(0);

                if (sectionId.includes('cmt_')) {
                    $('#lblRCError_' + questionId).text('');
                    $("#cmt_Q_Id" + questionId).addClass("active");
                    //showCommentsRichText(questionId, 'cmt');
                    ShowCommentsSRP(questionId, "RC", data);
                }
                else if (sectionId.includes('atch_')) {
                    $('#lblRDError_' + questionId).text('');
                    //document.getElementById('FileUploaderForDocuments_' + questionId).value = '';
                    $("#atch_Q_Id" + questionId).addClass("active");
                    SrViewModel.UploadComment('');
                    //showCommentsRichText(questionId, 'atch');
                    GetComments(questionId, "RD", null);
                }
                else if (sectionId.includes('hist_')) {
                    $("#hist_Q_Id" + questionId).addClass("active");
                    GetSurveyPrevResponses(questionId);
                }
                else // guidelines
                    $("#gui_Q_Id" + questionId).addClass("active");
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowExtraContent() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function HideExtraContent(questionId) {
            try {
                $("#cmt_" + questionId).hide();
                $("#atch_" + questionId).hide();
                $("#gui_" + questionId).hide();
                $("#hist_" + questionId).hide();

                $("#cmt_Q_Id" + questionId).removeClass("active");
                $("#atch_Q_Id" + questionId).removeClass("active");
                $("#gui_Q_Id" + questionId).removeClass("active");
                $("#hist_Q_Id" + questionId).removeClass("active");
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: HideExtraContent() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ShowExtraSubContent(questionId, sectionId, type) {
            try {
                SrViewModel.IsHistoryPopUp(false);
                $("#cmt_Sub_hrefId" + questionId).hide();
                $("#cmt_Sub_Hist_hrefId" + questionId).hide();
                $("#cmt_Sub_Id" + questionId).removeClass("active");
                $("#cmt_Sub_Hist_Id" + questionId).removeClass("active");

                $("#" + sectionId).show();

                if (type === 'cmt') {
                    $("#cmt_Sub_Id" + questionId).addClass("active");
                    GetComments(questionId, "RC", null).then(function () {
                        //SrViewModel.SelectedColumnId($("#ResponseId" + questionId).val());
                    });
                } else {
                    $("#cmt_Sub_Hist_Id" + questionId).addClass("active");
                    GetHistoricalComments(questionId, "RC", null);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowExtraSubContent() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#region Comments and Historical Comments section

        function ShowCommentsSRP(questionId, Type, data) {
            try {
                SrViewModel.PopOverCommentList([]);
                SrViewModel.SelectedFullQuestion(data);
                SrViewModel.RemainingChars(SrViewModel.CommentCharsLimit());
                SrViewModel.ResponseComment('');
                SrViewModel.CommentType(Type);
                SrViewModel.IsReadOnlyQuestion(data.IsReadOnly());
                SrViewModel.SelectedQuestionId(questionId);
                var applicableColumnDetails = [];

                if (SrViewModel.SurveyTypeId() === 'QLDR') {
                    ShowExtraSubContent(questionId, 'cmt_Sub_hrefId' + questionId, 'cmt');
                }
                else if (SrViewModel.SurveyTypeId() === 'CDR') {
                    ShowExtraSubContent(questionId, 'cmt_Sub_hrefId' + questionId, 'cmt');
                }
                else { //QTDR
                    if (!SrViewModel.IsCommentPopUp())
                        ShowExtraSubContent(questionId, 'cmt_Sub_hrefId' + questionId, 'cmt');
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowCommentsSRP() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function GetComments(QuestionId, Type, ResponseId) {
            try {
                return $.ajax({
                    url: "/api/Survey/GetSurveyComments",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { QuestionId: QuestionId, Draft: SrViewModel.SurveyId(), ResponseId: ResponseId, CommentType: Type, SurveyType: SrViewModel.SurveyTypeId().toUpperCase() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetComments() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    SrViewModel.SaveCommentButtonName((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name);
                    SrViewModel.DocumentListFinal([]);
                    SrViewModel.CurrentCommentID([]);
                    $('#ResponseId' + QuestionId).attr('disabled', false);
                    if (jsonResult == null) {
                        // no comments fetched
                    }
                    else if (jsonResult.surveyCommentModel.length == 0) {
                        SrViewModel.SurveyCompletionPercentage(jsonResult.SurveyCompletionPercentage);
                        if (Type == 'RD') {
                            var noDocText = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoAttachmentsMessage') == -1) ? 'There are no Attachments available' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoAttachmentsMessage')].Name)();
                            var docListPopUp = "";
                            docListPopUp += '<span id="lbldocResponseComment" class="nodatamessage">' + noDocText + '</span>';

                            $('#doc_cmt_List_' + QuestionId).html("");
                            $('#doc_cmt_List_' + QuestionId).html(docListPopUp);
                        }
                        var noCmtText = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoCommentsMessage') == -1) ? 'There are no Comments available' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoCommentsMessage')].Name)();
                        var commentListPopUp = "";
                        commentListPopUp += '<span id="lblNoResponseComment" class="nodatamessage">' + noCmtText + '</span>';

                        $('#cmt_List_' + QuestionId).html("");
                        $('#cmt_List_' + QuestionId).html(commentListPopUp);
                    }
                    else if (jsonResult != null && jsonResult.surveyCommentModel.length != 0) {
                        if (jsonResult.ErrorId == -99) {
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                ? jsonResult.ErrorName + " - An error has occured. Please contact your Administrator."
                                : jsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                    (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? jsonResult.ErrorName + " - Please contact your Administrator."
                                    : jsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            if (Type == 'RD') {
                                SrViewModel.SurveyCompletionPercentage(jsonResult.SurveyCompletionPercentage);

                                var Mapped = $.map(jsonResult.surveyCommentModel, function (result) {
                                    return new DocumentCommentModel(result);
                                });
                                SrViewModel.DocumentListFinal(Mapped);
                                if (SrViewModel.DocumentListFinal().length > 0) {
                                    var documentListPopUp = "";
                                    documentListPopUp += ' <h6 class="card-title" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AllAttachmentsHeading\') == -1) ? \'All Attachments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AllAttachmentsHeading\')].Name"></h6>';
                                    for (k = 0; k < SrViewModel.DocumentListFinal().length > 0; k++) {
                                        documentListPopUp += '<div class="col-lg-12 atachmentSubBox">';
                                        documentListPopUp += '<span><i class="demo-icon icon-paperclip_special"></i> ' + SrViewModel.DocumentListFinal()[k].DocumentName() + '</span>';

                                        documentListPopUp += '<p class="bg-white col-lg-12 mb-1">' + SrViewModel.DocumentListFinal()[k].DCommentText() + '</p>';
                                        documentListPopUp += '<input type="text" id="copydoccmtBox_' + SrViewModel.DocumentListFinal()[k].DCommentId() + '" style="display:none;" value="' + SrViewModel.DocumentListFinal()[k].DCommentText() + '">';
                                        documentListPopUp += '<span class="font-weight-bold mr-2 mb-3">' + SrViewModel.DocumentListFinal()[k].DUploadedBy() + '</span>'
                                        documentListPopUp += ' on  <span>' + SrViewModel.DocumentListFinal()[k].DUploadedDate() + '</span>';

                                        var downloadTitle = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DownloadDocumentTitle') == -1) ? 'Click to Download the Document' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DownloadDocumentTitle')].Name)();
                                        var downloadButton = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DownloadButton') == -1) ? 'Download' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DownloadButton')].Name)();
                                        var copyTitle = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyDocCommentToClipboardTitle') == -1) ? 'Copy Document Comment to Clipboard' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyDocCommentToClipboardTitle')].Name)();
                                        var copyButton = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyToClipboardButton') == -1) ? 'Copy to Clipboard' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyToClipboardButton')].Name)();
                                        var deleteTitle = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteDocumentTitle') == -1) ? 'Delete Document' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteDocumentTitle')].Name)();
                                        var deleteButton = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteButton') == -1) ? 'Delete' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteButton')].Name)();

                                        documentListPopUp += '<span class="c-actions" title="' + downloadTitle + '" id= "downdoc_' + SrViewModel.DocumentListFinal()[k].DCommentId() + '" data-bind="click: function (data,event) { $root.DownloadDocument}"><i class="demo-icon icon-download_special"></i>' + downloadButton + '</span>';
                                        documentListPopUp += '<span class="c-actions" title="' + copyTitle + '" id= "copydoccmt_' + SrViewModel.DocumentListFinal()[k].DCommentId() + '" data-bind="click: function (data,event) { $root.CopyComment}"><i class="demo-icon icon-copy_special"></i>' + copyButton + '</span>';
                                        if (SrViewModel.DocumentListFinal()[k].DIsCurrentUser() === "1" && SrViewModel.IsReadOnlyQuestion() === 0 && SrViewModel.IsConditionalQuestion() == 0 && (!SrViewModel.DisableControl() || SrViewModel.appsecurity.WriteAccess())) {
                                            documentListPopUp += '<span class="c-actions" title="' + deleteTitle + '" id= "deldoc_' + SrViewModel.DocumentListFinal()[k].DCommentId() + '" data-bind="click: function (data,event)  { $root.DeleteDocument($root.DocumentListFinal()[' + k + '] ,\'RD\') }"><i class="demo-icon icon-bin_special"></i>' + deleteButton + '</span>';
                                        }
                                        documentListPopUp += '</div>';
                                    }

                                    $('#doc_cmt_List_' + QuestionId).html("");
                                    $('#doc_cmt_List_' + QuestionId).html(documentListPopUp);

                                    for (k = 0; k < SrViewModel.DocumentListFinal().length > 0; k++) {
                                        ko.applyBindingsToNode($('#downdoc_' + SrViewModel.DocumentListFinal()[k].DCommentId()), { click: SrViewModel.DownloadDocument }, SrViewModel.DocumentListFinal()[k]);
                                        ko.applyBindingsToNode($('#copydoccmt_' + SrViewModel.DocumentListFinal()[k].DCommentId()), { click: SrViewModel.CopyComment }, 'copydoccmtBox_' + SrViewModel.DocumentListFinal()[k].DCommentId());
                                        if (SrViewModel.DocumentListFinal()[k].DIsCurrentUser() === "1" && SrViewModel.IsReadOnlyQuestion() === 0 && SrViewModel.IsConditionalQuestion() == 0 && (!SrViewModel.DisableControl() || SrViewModel.appsecurity.WriteAccess())) {
                                            ko.applyBindingsToNode($('#deldoc_' + SrViewModel.DocumentListFinal()[k].DCommentId()), { click: SrViewModel.DeleteDocument }, SrViewModel.DocumentListFinal()[k]);
                                        }
                                    }
                                }
                            }
                            else {
                                var MappedColumnObject = $.map(jsonResult.surveyCommentModel, function (result) {
                                    return new CommentModel(result);
                                })
                                if (Type === 'RC')
                                    SrViewModel.SurveyCompletionPercentage(jsonResult.SurveyCompletionPercentage);

                                SrViewModel.PopOverCommentList([]);
                                SrViewModel.PopOverCommentList(MappedColumnObject);
                                var commentListPopUp = "";
                                if (SrViewModel.PopOverCommentList().length == 0)
                                    commentListPopUp += '<span id="lblNoResponseComment" class="nodatamessage" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoCommentsMessage\') == -1) ? \'There are no Comments available\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoCommentsMessage\')].Name"></span>';
                                else {
                                    commentListPopUp += ' <h6 class="card-title" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AllCommentsHeading\') == -1) ? \'All Comments\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AllCommentsHeading\')].Name"></h6>';
                                    for (k = 0; k < SrViewModel.PopOverCommentList().length > 0; k++) {
                                        commentListPopUp += '<div class="comment-view"><div class="cbox"><span class="tip tip-down"></span><div class="message">'
                                        commentListPopUp += SrViewModel.PopOverCommentList()[k].CommentText();
                                        commentListPopUp += '</div></div></div>'

                                        var commentText = SrViewModel.PopOverCommentList()[k].CommentText().substring(SrViewModel.PopOverCommentList()[k].CommentText().indexOf(":") + 1);
                                        commentText = $('<div/>').html(commentText).text().trim();
                                        var copyTitle = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyCommentToClipboardTitle') == -1) ? 'Copy Comment to Clipboard' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyCommentToClipboardTitle')].Name)();
                                        var copyButton = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyToClipboardButton') == -1) ? 'Copy to Clipboard' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyToClipboardButton')].Name)();
                                        var editTitle = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditCommentTitle') == -1) ? 'Edit Comment' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditCommentTitle')].Name)();
                                        var editButton = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditButton') == -1) ? 'Edit' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditButton')].Name)();
                                        var deleteTitle = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteCommentTitle') == -1) ? 'Delete Comment' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteCommentTitle')].Name)();
                                        var deleteButton = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteButton') == -1) ? 'Delete' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteButton')].Name)();

                                        commentListPopUp += '<input type="text" id="copycmtBox_' + SrViewModel.PopOverCommentList()[k].CommentId() + '" style="display:none;" value="' + commentText + '">';
                                        commentListPopUp += '<span class="commenter">' + SrViewModel.PopOverCommentList()[k].UploadedBy() + '</span>';
                                        commentListPopUp += ' on <span class="cdate">' + SrViewModel.PopOverCommentList()[k].UploadedDate() + '</span>';
                                        commentListPopUp += '<span class="c-actions" title="' + copyTitle + '" id= "copycmt_' + SrViewModel.PopOverCommentList()[k].CommentId() + '" data-bind="click: function (data,event) { $root.CopyComment}"><i class="demo-icon icon-copy_special"></i>' + copyButton + '</span>';
                                        if (SrViewModel.PopOverCommentList()[k].IsCurrentUser() === "1" && SrViewModel.IsReadOnlyQuestion() === 0 && SrViewModel.IsConditionalQuestion() == 0 && (!SrViewModel.DisableControl() || SrViewModel.appsecurity.WriteAccess())) {
                                            commentListPopUp += '<span class="c-actions" title="' + editTitle + '" id= "editcmt_' + SrViewModel.PopOverCommentList()[k].CommentId() + '" data-bind="click: function (data,event) { $root.EditQuestionComment}"><i class="demo-icon icon-file_edit_special"></i>' + editButton + '</span>';
                                            commentListPopUp += '<span class="c-actions" title="' + deleteTitle + '" id= "deletecmt_' + SrViewModel.PopOverCommentList()[k].CommentId() + '" data-bind="click: function (data,event) { $root.DeleteQuestionComment}"><i class="demo-icon icon-bin_special"></i>' + deleteButton + '</span>';
                                        }
                                    }
                                }
                                $('#cmt_List_' + QuestionId).html("");
                                $('#cmt_List_' + QuestionId).html(commentListPopUp);

                                for (k = 0; k < SrViewModel.PopOverCommentList().length > 0; k++) {
                                    ko.applyBindingsToNode($('#copycmt_' + SrViewModel.PopOverCommentList()[k].CommentId()), { click: SrViewModel.CopyComment }, 'copycmtBox_' + SrViewModel.PopOverCommentList()[k].CommentId());
                                    if (SrViewModel.PopOverCommentList()[k].IsCurrentUser() === "1" && SrViewModel.IsReadOnlyQuestion() === 0 && SrViewModel.IsConditionalQuestion() == 0 && (!SrViewModel.DisableControl() || SrViewModel.appsecurity.WriteAccess())) {
                                        ko.applyBindingsToNode($('#editcmt_' + SrViewModel.PopOverCommentList()[k].CommentId()), { click: SrViewModel.EditQuestionComment }, SrViewModel.PopOverCommentList()[k]);
                                        ko.applyBindingsToNode($('#deletecmt_' + SrViewModel.PopOverCommentList()[k].CommentId()), { click: SrViewModel.DeleteQuestionComment }, SrViewModel.PopOverCommentList()[k]);
                                    }
                                }
                                $('#ResponseId' + QuestionId).prop('selectedIndex', 0);

                                if (SrViewModel.SurveyTypeId().toUpperCase() == "QLDR" || SrViewModel.SurveyTypeId().toUpperCase() == "CDR") {
                                    $('#question-Section_' + QuestionId)[0].scrollTop = $('#question-Section_' + QuestionId)[0].scrollHeight;
                                }
                            }
                            SrViewModel.RemainingChars(SrViewModel.CommentCharsLimit());
                        }
                    }
                    else
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }

        function GetCommentsPopUp(QuestionId, Type, ResponseId) {
            try {
                SrViewModel.CurrentCommentID('');
                return $.ajax({
                    url: "/api/Survey/GetSurveyComments",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { QuestionId: QuestionId, Draft: SrViewModel.SurveyId(), ResponseId: ResponseId, CommentType: Type, SurveyType: SrViewModel.SurveyTypeId().toUpperCase() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetCommentsPopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== null) {
                        if (Type === "RC") {
                            SrViewModel.ResponseCommentsList([]);
                            if (jsonResult.surveyCommentModel.length !== 0) {
                                var MappedColumnObject = $.map(jsonResult.surveyCommentModel, function (result) {
                                    return new CommentModel(result);
                                });
                                SrViewModel.ResponseCommentsList(MappedColumnObject);
                            }
                            else {
                                $('#lblNoResponseComment').show();
                            }
                        }
                        else if (Type === "RD") {
                            SrViewModel.UploadDocumentsList([]);
                            if (jsonResult.surveyCommentModel.length !== 0) {
                                var MappedDColumnObject = $.map(jsonResult.surveyCommentModel, function (result) {
                                    return new DocumentCommentModel(result);
                                });
                                SrViewModel.UploadDocumentsList(MappedDColumnObject);
                            }
                            else {
                                $('#lblNoResponseDocument').show();
                            }
                        }
                    }
                    else {
                        if (Type === "RC")
                            $('#lblNoResponseComment').show();
                        else if (Type === "RD")
                            $('#lblNoResponseDocument').show();
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetCommentsPopUp() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetCommentsPopUp() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetCommentsPopUp() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetHistoricalComments(QuestionId, Type, ResponseId) {
            try {
                return $.ajax({
                    url: "/api/Survey/GetSurveyHistComments",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        QuestionId: QuestionId, Draft: SrViewModel.SurveyId(), ResponseId: ResponseId, CommentType: Type, SurveyType: SrViewModel.SurveyTypeId().toUpperCase()
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetHistoricalComments() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    SrViewModel.SaveCommentButtonName((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name);
                    $('#ResponseId' + QuestionId).attr('disabled', false);

                    SrViewModel.HistoricalCommentList([]);
                    if (jsonResult != null) {
                        if (jsonResult.length != 0) {
                            if (jsonResult[0].ErrorID == -99) {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                    ? jsonResult[0].ErrorName + " - An error has occured. Please contact your Administrator."
                                    : jsonResult[0].ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                        (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                        ? jsonResult[0].ErrorName + " - Please contact your Administrator."
                                        : jsonResult[0].ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                var MappedColumnObject = $.map(jsonResult, function (result) {
                                    return new HistoricalCommentModel(result);
                                })

                                SrViewModel.HistoricalCommentList(MappedColumnObject);

                                if (!SrViewModel.IsHistoryPopUp()) {
                                    var histCommentList = "";
                                    if (SrViewModel.HistoricalCommentList().length == 0)
                                        histCommentList += '<span id="lblNoResponseComment" class="nodatamessage" data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoHistoricalCommentsMessage\') == -1) ? \'There are no Historical Comments available\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'NoHistoricalCommentsMessage\')].Name"></span>';
                                    else {
                                        histCommentList += ' <h6 class="card-title">Historical Comments</h6>';
                                        for (k = 0; k < SrViewModel.HistoricalCommentList().length > 0; k++) {
                                            var commentText = SrViewModel.HistoricalCommentList()[k].CommentText().substring(SrViewModel.HistoricalCommentList()[k].CommentText().indexOf(":") + 1);
                                            commentText = $('<div/>').html(commentText).text().trim();

                                            histCommentList += '<div class="comment-view"><div class="cbox"><span class="tip tip-down"></span><div class="message">' + SrViewModel.HistoricalCommentList()[k].CommentText() + '</div></div></div>'
                                            histCommentList += '<input type="text" id="copyHistcmtBoxQC_' + SrViewModel.HistoricalCommentList()[k].CommentId() + '" style="display:none;" value="' + commentText + '">';
                                            histCommentList += '<span class="commenter">' + SrViewModel.HistoricalCommentList()[k].UploadedBy() + '</span>'
                                            histCommentList += ' on <span class="cdate">' + SrViewModel.HistoricalCommentList()[k].UploadedDate() + '</span>'
                                            histCommentList += '<span id="copyHistcmt_' + SrViewModel.HistoricalCommentList()[k].CommentId() + '" data-bind="attr: {title: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistCommentCopyTitle\') == -1 )? \'Copy Historical Comment to Clipboard\': $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'HistCommentCopyTitle\')].Name }, click:function(data, event) { $root.CopyComment() }" class="c-actions"><i class="demo-icon icon-copy_special"></i><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'CopyToClipboardButton\') == -1) ? \'Copy to Clipboard\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'CopyToClipboardButton\')].Name"></span></span>';
                                        }
                                        $('#Hist_cmt_List_' + QuestionId).html("");
                                        $('#Hist_cmt_List_' + QuestionId).html(histCommentList);
                                    }

                                    for (k = 0; k < SrViewModel.HistoricalCommentList().length > 0; k++) {
                                        ko.applyBindingsToNode($('#copyHistcmt_' + SrViewModel.HistoricalCommentList()[k].CommentId()), { click: SrViewModel.CopyComment }, 'copyHistcmtBoxQC_' + SrViewModel.HistoricalCommentList()[k].CommentId());
                                    }
                                }
                            }
                        }
                    } else {
                        if (!SrViewModel.IsHistoryPopUp()) {
                            var histCommentList = "";
                            var HistCommentText = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoHistoricalCommentsMessage') == -1) ? 'There are no Historical Comments available' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoHistoricalCommentsMessage')].Name)();

                            histCommentList += '<span id="lblNoResponseComment" class="nodatamessage">' + HistCommentText + '</span>';
                            $('#Hist_cmt_List_' + QuestionId).html("");
                            $('#Hist_cmt_List_' + QuestionId).html(histCommentList);
                        }
                        else {
                            $('#NoHistoryComments').show();
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, {
                            buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login'
                        })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetHistoricalComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetHistoricalComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }

        function DeleteQuestionComment(data) {
            try {
                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteCommentConfirmation') == -1) ? 'Are you sure you want to delete this comment?' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteCommentConfirmation')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteCommentHeading') == -1) ? 'Delete Comment' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteCommentHeading')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name])
                    .then(function (option) {
                        var confirmText = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                        if (option === confirmText) {
                            DeleteComment(data);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteQuestionComment() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function DeleteComment(data) {
            try {
                SrViewModel.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/DeleteDocComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        CommentId: data.CommentId(),
                        QuestionId: SrViewModel.SelectedQuestionId(),
                        Draft: SrViewModel.SurveyId(),
                        CommentType: 'RC',
                        SurveyType: SrViewModel.SurveyClassification()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | DeleteComment() in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {
                    if (result != null && result.substring(0, 3) == "INC") {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                            ? result + " - An error has occured. Please contact your Administrator."
                            : result + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                            [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                ? result + " - Please contact your Administrator."
                                : result + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    }
                    else if (result != null && parseInt(result) >= 0) {
                        if (SrViewModel.SurveyTypeId().toUpperCase() === "QLDR") {
                            ko.utils.arrayFilter(SrViewModel.QualResponseListData(), function (item) {
                                if (item.QuestionId() == SrViewModel.SelectedQuestionId()) {
                                    item.CommentCount(parseInt(result));
                                }
                            });
                            GetComments(SrViewModel.SelectedQuestionId(), "RC", null);
                        }
                        else if (SrViewModel.SurveyTypeId().toUpperCase() === "QTDR") {
                            ko.utils.arrayFilter(SrViewModel.QuanResponseObject(), function (item) {
                                if (item.QuestionId() == SrViewModel.SelectedQuestionId()) {
                                    item.CommentCount(parseInt(result));
                                }
                            });
                            if (SrViewModel.IsCommentPopUp())
                                GetCommentsPopUp(SrViewModel.SelectedQuestionId(), "RC", null);
                            else
                                GetComments(SrViewModel.SelectedQuestionId(), "RC", null);
                        }
                        else if (SrViewModel.SurveyTypeId().toUpperCase() === "CDR") {
                            ko.utils.arrayFilter(SrViewModel.ControlsResponseData(), function (item) {
                                if (item.QuestionId() == SrViewModel.SelectedQuestionId()) {
                                    item.CommentCount(parseInt(result));
                                }
                            });
                            GetComments(SrViewModel.SelectedQuestionId(), "RC", null);
                        }
                        setSurveyLevelMandatoryList();
                        SrViewModel.isSaveResponseClick(true);
                        SegregatorBasedOnSurveyType();
                        logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteCommentLogger') == -1) ? 'Comment deleted successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteCommentLogger')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                    }
                    else if (result == -1) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage') == -1) ? 'The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click \'OK\' to redirect to Landing Page.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage') == -1) ? 'Action cannot be performed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                            .then(function (option) {
                                if (option === " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()) {
                                    SrViewModel.DashboardVM.NavigatedFrom('Response');
                                    router.navigate("landing", true);
                                }
                            });
                    }
                    else
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in DeleteComment() in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteComment() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteComment() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function EditQuestionComment(data) {
            try {
                var commentObject = "",
                    commentText = "",
                    responseId = "",
                    responseText = "";
                SrViewModel.CurrentCommentID(data.CommentId());
                $('#ResponseId' + SrViewModel.SelectedQuestionId()).attr('disabled', true);
                $('#lblRCError_' + SrViewModel.SelectedQuestionId()).hide();
                if (data != undefined && data != null && data.CommentText() != undefined && data.CommentText().trim() != '') {
                    commentObject = data.CommentText().split(':');

                    if (commentObject != undefined && commentObject.length > 1) {
                        responseText = commentObject[0];
                    }

                    if (responseText != undefined && responseText != null && responseText.length > 0) {
                        if (SrViewModel.SurveyTypeId().toUpperCase() == "QLDR") {
                            for (var i = 0; i < SrViewModel.ColumnDetails().length; i++) {
                                if (responseText == SrViewModel.ColumnDetails()[i].ColumnName()) {
                                    responseId = SrViewModel.ColumnDetails()[i].ColumnId();
                                    break;
                                }
                            }
                        }
                        else if (SrViewModel.SurveyTypeId().toUpperCase() == "CDR") {
                            for (var i = 0; i < SrViewModel.ColumnDetails().length; i++) {
                                if (responseText == SrViewModel.ColumnDetails()[i].ColumnName()) {
                                    responseId = SrViewModel.ColumnDetails()[i].ColumnId();
                                    break;
                                }
                            }
                        }
                    }
                }
                if (responseId != "")
                    $('#ResponseId' + SrViewModel.SelectedQuestionId()).val(responseId);

                if (data.CommentText() !== "" && data.CommentText().length > 0) {
                    commentText = data.CommentText().substring(data.CommentText().indexOf(":") + 1);

                    if (commentText !== "" && commentText.length > 0) {
                        var commentVar = $('<div/>').html(commentText).text().trim();
                        $('#ResponseTextArea_' + SrViewModel.SelectedQuestionId()).val(commentVar);
                        $('#ResponseTextArea_' + SrViewModel.SelectedQuestionId()).focus();
                        SrViewModel.SaveCommentButtonName((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UpdateButton') == -1) ? 'Update' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UpdateButton')].Name);
                        SrViewModel.RemainingChars(SrViewModel.CommentCharsLimit() - commentVar.length);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: EditQuestionComment() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function CopyComment(data) {
            try {
                $('#' + data).show();
                var copyText = $('#' + data);
                copyText.focus();
                copyText.select();
                document.execCommand('copy');
                $('#' + data).hide();
                logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyToClipboardSuccessMessage') == -1) ? 'Comment copied to clipboard successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyToClipboardSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CopyComment() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function CancelComment(questionId, data, event) {
            try {
                $('#ResponseId' + questionId).attr('disabled', false);
                $('#ResponseId' + questionId).prop('selectedIndex', 0);
                SrViewModel.CurrentCommentID('');
                if (data.IsReadOnly() == 0 && (SrViewModel.DisableControl() == false || SrViewModel.appsecurity.WriteAccess())) {
                    if (SrViewModel.SurveyTypeId() === 'QTDR') {
                        document.getElementById("ResponseTextArea_" + questionId).value = null;
                    }
                    else if (SrViewModel.SurveyTypeId() !== 'QTDR' && data.IsConditional() != 1) {
                        document.getElementById("ResponseTextArea_" + questionId).value = null;
                    }
                }
                SrViewModel.RemainingChars(SrViewModel.CommentCharsLimit());
                SrViewModel.SaveCommentButtonName((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CancelComment() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SaveComment(questionId, data, event) {
            try {
                //var comment = CKEDITOR.instances["ResponseTextArea_" + questionId].getData();
                //SrViewModel.ResponseComment(comment);

                SrViewModel.ResponseComment($("#ResponseTextArea_" + SrViewModel.SelectedQuestionId()).val().trim());
                var lblRCError = 'lblRCError_' + SrViewModel.SelectedQuestionId();
                if (SrViewModel.ResponseComment() !== "" && SrViewModel.ResponseComment() != undefined) {
                    if (SrViewModel.ResponseComment().length <= SrViewModel.CommentCharsLimit()) {
                        document.getElementById(lblRCError).innerHTML = "";
                        $('#' + lblRCError).hide();
                        if (SrViewModel.SurveyTypeId() === 'QTDR') {
                            SetComments(SrViewModel.SelectedQuestionId(), "RC", SrViewModel.ResponseComment());
                        }
                        else {
                            if ($("#ResponseId" + questionId).val() != undefined) //SrViewModel.SelectedColumnId()
                                SetComments(SrViewModel.SelectedQuestionId(), "RC", SrViewModel.ResponseComment());
                            else {
                                document.getElementById(lblRCError).innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseTypeValidationMessage') == -1) ? 'Please select Response Type' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseTypeValidationMessage')].Name();
                                $('#' + lblRCError).show();
                                //$('#saveCommentBtn_' + questionId).attr('disabled', false);
                            }
                        }
                    }
                    else {
                        document.getElementById(lblRCError).innerHTML = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitBegin') == -1) ? 'Comment cannot exceed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitBegin')].Name()).toString() + ' ' + SrViewModel.CommentCharsLimit() + ' ' + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitEnd') == -1) ? 'characters.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitEnd')].Name()).toString();
                        $('#' + lblRCError).show();
                        //$('#saveCommentBtn_' + questionId).attr('disabled', false);
                    }
                    //showCommentsRichText(SrViewModel.SelectedQuestionId(), 'cmt');
                }
                else {
                    document.getElementById(lblRCError).innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseCommentValidationMessage') == -1) ? 'The response comment cannot be left blank' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseCommentValidationMessage')].Name();
                    $('#' + lblRCError).show();
                    //$('#saveCommentBtn_' + questionId).attr('disabled', false);
                }
                SrViewModel.RemainingChars(SrViewModel.CommentCharsLimit());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveComment() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SetComments(QuestionId, Type, CommentText) {
            try {
                SrViewModel.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                var ResponseId = "";
                var CommentId = 0;
                if (SrViewModel.SurveyTypeId().toUpperCase() == "QTDR") {
                    ResponseId = 0;
                }
                else {
                    ResponseId = $("#ResponseId" + QuestionId).val();
                }
                if (SrViewModel.CurrentCommentID() != null && SrViewModel.CurrentCommentID() != "") {
                    CommentId = SrViewModel.CurrentCommentID();
                }
                if (Type == "NC") {
                    ResponseId = 0;
                }
                SrViewModel.SelectedCommentType(Type);
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/SetSurveyComments",
                    type: "POST",
                    headers: headers,
                    data: {
                        QuestionId: QuestionId, CommentType: Type, CommentText: CommentText, Draft: SrViewModel.SurveyId(),
                        ResponseId: ResponseId, CommentId: CommentId
                    }
                    //async: false
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in SetComments() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    SrViewModel.ResponseComment('');
                    document.getElementById("ResponseTextArea_" + QuestionId).value = null;
                    if (jsonResult != null) {
                        if (jsonResult.substring(0, 3) != "INC") {
                            if (Type === "NC") {
                                logger.logSuccess('Comment saved successfully.', 'Success', system.getModuleId(SrViewModel), true);
                            }
                            if (jsonResult === "-999") {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage') == -1) ? 'An error occurred while saving Comments. Because Comment contain some invalid characters.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            } else if (parseInt(jsonResult) <= 0) {
                                app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage') == -1) ? 'The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click \'OK\' to redirect to Landing Page.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage') == -1) ? 'Action cannot be performed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                    .then(function (option) {
                                        if (option === " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()) {
                                            SrViewModel.DashboardVM.NavigatedFrom('Response');
                                            router.navigate("landing", true);
                                        }
                                    });
                            }
                            else if (jsonResult == "0" && Type != "PBC") {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage') == -1) ? 'An error occurred while saving Comments. Because Comment contain some invalid characters.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                if (Type == "RC" || Type == "RC-CD") {
                                    if (SrViewModel.SurveyTypeId().toUpperCase() === "QTDR") {
                                        logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentSaveSuccessMessage') == -1) ? 'Comments have been saved successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentSaveSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                                        GetQuantitativeTableCommentCount();

                                        if (SrViewModel.IsCommentPopUp())
                                            GetCommentsPopUp(QuestionId, Type, null);
                                        else
                                            GetComments(QuestionId, Type, null);
                                    }
                                    else if (SrViewModel.SurveyTypeId().toUpperCase() === "QLDR") {
                                        logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentSaveSuccessMessage') == -1) ? 'Comments have been saved successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentSaveSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                                        GetQualitativeTableCommentCount();
                                        $("#cmt_Sub_Hist_hrefId" + QuestionId).hide();
                                        $("#cmt_Sub_hrefId" + QuestionId).show();
                                        GetComments(QuestionId, Type, null);
                                    }
                                    else {
                                        logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentSaveSuccessMessage') == -1) ? 'Comments have been saved successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentSaveSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                                        GetControlTableCommentCount();
                                        GetComments(QuestionId, Type, null);
                                    }
                                    SrViewModel.isSaveResponseClick(true);
                                    SegregatorBasedOnSurveyType();
                                }
                            }
                        }
                        else
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                ? jsonResult + "An error occurred. Please contact your Application Administrator."
                                : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    }
                    $('#saveCommentBtn').attr('disabled', false);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SetComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in SetComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }

        function GetQualitativeTableCommentCount() {
            try {
                var RiskAreaId;

                RiskAreaId = SrViewModel.ClickedRiskAreaId();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/GetQualitativeResponseData",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: SrViewModel.SurveyId(), AreaId: RiskAreaId, RoleId: SrViewModel.RoleId() })
                })
                    .success(function (JsonResult, Success) {
                        if (JsonResult != null) {
                            if (JsonResult.ErrorId == -99) {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                    ? JsonResult.ErrorName + " - An error has occured. Please contact your Administrator."
                                    : JsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                        (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                        ? JsonResult.ErrorName + " - Please contact your Administrator."
                                        : JsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                //have to write the dynamic html logic
                                var mappedResponseList = $.map(JsonResult.QualResponseModel, function (result) {
                                    return new QualResponseModel(result);
                                })
                                //SrViewModel.QualResponseListData(mappedResponseList);
                                for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                                    for (var j = 0; j < mappedResponseList.length; j++) {
                                        if (SrViewModel.QualResponseListData()[i].QuestionId() == mappedResponseList[j].QuestionId()) {
                                            SrViewModel.QualResponseListData()[i].CommentCount(mappedResponseList[j].CommentCount());
                                        }
                                    }
                                }
                                setSurveyLevelMandatoryList();
                            }
                        }
                    })
                    .fail(function (error, fail) {
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQualitativeTableCommentCount() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function GetControlTableCommentCount() {
            try {
                $.ajax({
                    url: "/api/Survey/GetControlResponseData",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { AreaId: SrViewModel.ClickedRiskAreaId(), Draft: SrViewModel.SurveyId(), RoleId: SrViewModel.RoleId() }
                })
                    .success(function (JsonResult, success) {
                        if (JsonResult !== null) {
                            if (JsonResult.ErrorId == -99) {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                    ? JsonResult.ErrorName + " - An error has occured. Please contact your Administrator."
                                    : JsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                        (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                        ? JsonResult.ErrorName + " - Please contact your Administrator."
                                        : JsonResult.ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                var mappeedControlData = $.map(JsonResult.lstCntrlSurveyResponseModel, function (result) {
                                    return new ControlResponseModel(result);
                                });
                                for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                                    for (var j = 0; j < mappeedControlData.length; j++) {
                                        if (SrViewModel.ControlsResponseData()[i].QuestionId() === mappeedControlData[j].QuestionId()) {
                                            SrViewModel.ControlsResponseData()[i].CommentCount(mappeedControlData[j].CommentCount());
                                        }
                                    }
                                }
                                setSurveyLevelMandatoryList();
                            }
                        }
                    })
                    .fail(function (fail, error) {
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetControlTableCommentCount() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function CommentModel(item) {
            try {
                var self = this;
                self.CommentText = ko.observable(item.CommentText);
                self.CommentId = ko.observable(item.CommentId);
                self.UploadedBy = ko.observable(item.UploadedBy);
                self.UploadedDate = ko.observable(item.UploadedDate);
                self.IsCurrentUser = ko.observable(item.IsCurrentUser);
                self.SurveyCompletionPercentage = ko.observable(item.SurveyCompletionPercentage);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CommentModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function HistoricalCommentModel(item) {
            try {
                var self = this;
                self.CommentText = ko.observable(item.CommentText);
                self.CommentId = ko.observable(item.CommentId);
                self.UploadedBy = ko.observable(item.UploadedBy);
                self.UploadedDate = ko.observable(item.UploadedDate);
                self.IsCurrentUser = ko.observable(item.IsCurrentUser)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: HistoricalCommentModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function DocumentCommentModel(item) {
            try {
                var self = this;
                self.DCommentText = ko.observable(item.CommentText);
                self.DCommentId = ko.observable(item.CommentId);
                self.DUploadedBy = ko.observable(item.UploadedBy);
                self.DUploadedDate = ko.observable(item.UploadedDate);
                self.DIsCurrentUser = ko.observable(item.IsCurrentUser);
                self.DocumentName = ko.observable(item.DocumentName);
                self.DocumentPath = ko.observable(item.DocumentPath);
                self.SurveyCompletionPercentage = ko.observable(item.SurveyCompletionPercentage);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DocumentCommentModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Documents section

        function UploadDocument(data) {
            try {
                var Filelist = "";
                var FileName = "";
                var errormsgId = "";
                var ProgressBarMainDivId = "";
                var ProgressMsgId = "";

                if (data === 'SND') {
                    SrViewModel.UploadComment($("#SummaryFileTextArea").val().trim());
                    errormsgId = '#lblRDErrorSummary';
                    ProgressBarMainDivId = '#ProgressBarMainDivSummary';
                    ProgressMsgId = '#lblProgressMsgSummary';
                    FileList = document.getElementById('SummaryFileUploader').files;
                    if (FileList.length > 0)
                        FileName = document.getElementById('SummaryFileUploader').files[0].name;
                }
                else {
                    //var editor = CKEDITOR.instances['UploadTextArea_' + data.QuestionId()].getData();
                    //SrViewModel.UploadComment(editor);
                    SrViewModel.UploadComment($("#UploadTextArea_" + data.QuestionId()).val().trim());
                    errormsgId = "#lblRDError_" + data.QuestionId();
                    ProgressBarMainDivId = "#ProgressBarMainDiv_" + data.QuestionId();
                    ProgressMsgId = "#lblProgressMsg_" + data.QuestionId();
                    FileList = document.getElementById('FileUploaderForDocuments_' + data.QuestionId()).files;
                    if (FileList.length > 0)
                        FileName = document.getElementById('FileUploaderForDocuments_' + data.QuestionId()).files[0].name;
                }
                if (FileList.length > 0) {
                    if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PNG'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'JPG'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'JPEG'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'DOCX'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'DOC'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLS'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PDF'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'CSV'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'TXT'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSX'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSM'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'BMP'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'RTF'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PPT'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PPTX'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'MSG') {
                        if (FileList[0].size <= 1073741824) {
                            if (SrViewModel.UploadComment() != "" && SrViewModel.UploadComment() != undefined) {
                                if (SrViewModel.UploadComment().length <= SrViewModel.CommentCharsLimit()) {
                                    $(errormsgId).text("");
                                    $(ProgressMsgId).removeClass('field-validation-error');
                                    var FormDataObj = new FormData();
                                    FormDataObj.append("File1", FileList[0]);
                                    var request = new XMLHttpRequest();
                                    $(ProgressBarMainDivId).show();
                                    request.onreadystatechange = function () {
                                        if (request.readyState == 1) {
                                            SrViewModel.ProgressMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InitializeFileUploadMessage') == -1) ? 'Initializing File Upload...' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InitializeFileUploadMessage')].Name());
                                        }
                                        else if (request.readyState == 4) {
                                            if (request.status == 200) {
                                                if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                                    SrViewModel.ProgressMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage') == -1) ? 'The file has been uploaded successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage')].Name());

                                                    var DocName = "";
                                                    if (data === 'SND') {
                                                        DocName = document.getElementById('SummaryFileUploader').files[0].name;
                                                        SetDocumentComments(-1, "SND", DocName, JSON.parse(request.response), SrViewModel.UploadComment()).then(function () {
                                                            document.getElementById('SummaryFileUploader').value = '';
                                                            document.getElementById('SummaryFileTextArea').value = '';
                                                            GetSurveyLevelComments("SND");
                                                        });
                                                    }
                                                    else {
                                                        DocName = document.getElementById('FileUploaderForDocuments_' + data.QuestionId()).files[0].name;

                                                        SetDocumentComments(data.QuestionId(), "RD", DocName, JSON.parse(request.response), SrViewModel.UploadComment()).then(function () {
                                                            document.getElementById('FileUploaderForDocuments_' + data.QuestionId()).value = '';
                                                            document.getElementById("UploadTextArea_" + data.QuestionId()).value = '';
                                                            //showCommentsRichText(data.QuestionId(), 'atch');
                                                            if (!SrViewModel.IsDocumentPopUp()) {
                                                                GetComments(data.QuestionId(), "RD", null);
                                                            }
                                                            else
                                                                GetCommentsPopUp(data.QuestionId(), "RD", null);
                                                        });
                                                    }
                                                    $(ProgressBarMainDivId).hide();
                                                    SrViewModel.UploadComment("");
                                                    //$('#ProgressBarDiv').hide();
                                                    SrViewModel.ProgressMessage("");
                                                    SrViewModel.RemainingChars(SrViewModel.CommentCharsLimit());
                                                    logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage') == -1) ? 'The file has been uploaded successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                                                }
                                                else {
                                                    $(ProgressBarMainDivId).show();
                                                    $(ProgressMsgId).addClass('field-validation-error');
                                                    SrViewModel.ProgressMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage') == -1) ? 'The file could not be uploaded.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage')].Name());
                                                }
                                            }
                                        }
                                        else
                                            ajaxFail(request, "");
                                    };
                                    request.upload.addEventListener('progress', function (event) {
                                        SrViewModel.ProgressPercent(parseInt((event.loaded / event.total) * 100) + '%');
                                        SrViewModel.ProgressMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UploadingFileStatusMessage') == -1) ? 'Uploading File...' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UploadingFileStatusMessage')].Name());
                                    });
                                    request.withCredentials = true;
                                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                    var headers = appsecurity.getSecurityHeaders();
                                    headers.__RequestVerificationToken = csrfToken;
                                    request.open('POST', '/api/Survey/FileUpload');
                                    request.setRequestHeader('Authorization', headers.Authorization);
                                    request.setRequestHeader('RT', headers.RT);
                                    request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                                    request.send(FormDataObj);
                                    logger.logMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage') == -1) ? 'The file has been uploaded successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage')].Name);
                                    $(ProgressBarMainDivId).hide();
                                }
                                else
                                    $(errormsgId).text(((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitBegin') == -1) ? 'Comment cannot exceed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitBegin')].Name()).toString() + ' ' + SrViewModel.CommentCharsLimit() + ' ' + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitEnd') == -1) ? 'characters.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitEnd')].Name()).toString());
                            }
                            else
                                $(errormsgId).text((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocCommentValidationMessage') == -1) ? 'Please enter some comment related to the uploaded file.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocCommentValidationMessage')].Name());
                        }
                        else
                            $(errormsgId).text(((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageBegin') == -1) ? 'Upload file size cannot exceed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageBegin')].Name()).toString() + ' ' + (SrViewModel.UploadFileSize() / 1048576) + ' ' + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageEnd') == -1) ? 'MB. Please try uploading a file of lesser size.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageEnd')].Name()).toString());
                    }
                    else
                        $(errormsgId).text(((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidFileFormatMessage') == -1) ? 'Please select a valid file to upload.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidFileFormatMessage')].Name()).toString());
                }
                else
                    $(errormsgId).text(((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SelectFileToUploadError') == -1) ? 'Please select a file to upload.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SelectFileToUploadError')].Name()).toString());

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString()) {
                                        SrViewModel.DashboardVM.NavigatedFrom('Response');
                                        router.navigate("Landing", true);
                                    }
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocuments() method in SurveyResponsePage.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocuments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UploadDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SetDocumentComments(QuestionId, CommentType, DocName, DocPath, CommentText) {
            try {
                SrViewModel.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/SetDocumentComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        QuestionId: QuestionId, Draft: SrViewModel.SurveyId(), SurveyType: SrViewModel.SurveyClassification(), CommentType: CommentType, CommentText: CommentText, DocumentPath: DocPath, DocumentName: DocName
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != null && jsonResult === "-999") {
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage') == -1)
                                ? jsonResult + "An error occurred while saving Comments. Because Comment contain some invalid characters."
                                : jsonResult + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else if (jsonResult != null && jsonResult.substring(0, 3) == "INC") {
                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                ? jsonResult + " - An error has occured. Please contact your Administrator."
                                : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                    (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                    ? jsonResult + " - Please contact your Administrator."
                                    : jsonResult + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else if (jsonResult != null && parseInt(jsonResult) < 0) {
                            app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage') == -1) ? 'The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click \'OK\' to redirect to Landing Page.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage') == -1) ? 'Action cannot be performed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                .then(function (option) {
                                    if (option === " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()) {
                                        SrViewModel.DashboardVM.NavigatedFrom('Response');
                                        router.navigate("landing", true);
                                    }
                                });
                        }
                        else {
                            if (CommentType === "RD") {
                                if (SrViewModel.SurveyTypeId().toUpperCase() == "QLDR") {
                                    ko.utils.arrayFilter(SrViewModel.QualResponseListData(), function (item) {
                                        if (item.QuestionId() == QuestionId) {
                                            item.DocumentCount(parseInt(jsonResult));
                                        }
                                    });
                                }
                                else if (SrViewModel.SurveyTypeId().toUpperCase() == "QTDR") {
                                    ko.utils.arrayFilter(SrViewModel.QuanResponseObject(), function (item) {
                                        if (item.QuestionId() == QuestionId) {
                                            item.DocumentCount(parseInt(jsonResult));
                                        }
                                    });
                                }
                                else if (SrViewModel.SurveyTypeId().toUpperCase() == "CDR") {
                                    ko.utils.arrayFilter(SrViewModel.ControlsResponseData(), function (item) {
                                        if (item.QuestionId() == QuestionId) {
                                            item.DocumentCount(parseInt(jsonResult));
                                        }
                                    });
                                }
                                setSurveyLevelMandatoryList();
                                SrViewModel.isSaveResponseClick(true);
                                SegregatorBasedOnSurveyType();
                            }
                            else if (CommentType === 'SND') {
                                //Code flows here
                            }
                        }
                    })
                    .fail(function () {
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetDocumentComments() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function DownloadDocument(data, event) {
            try {
                var DocumentInfo = data;
                var test = $.ajax({
                    url: "/api/Survey/CheckFilePresence",
                    type: "Get",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { CommentId: data.DCommentId(), FilePath: data.DocumentPath(), FileName: data.DocumentName() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in DownloadDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status, xhr) {
                try {
                    if (jsonResult) {
                        var payLoad = {
                            t: appsecurity.getAuthenticationInfo(), FilePath: data.DocumentPath(), FileName: data.DocumentName()
                        };
                        utils.postAndRedirect(rootPath + "/FileDownload/DownloadFile", payLoad, '_blank');
                    }
                    else
                        logger.logError(SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRequestedDocForDownload') == -1) ? 'The requested document is not available for download. Please contact your Application Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRequestedDocForDownload')].Name], 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DownloadDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DownloadDocument() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DownloadDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }

        function DeleteDocument(data, commentType) {
            try {
                if (commentType !== "SND") {
                    commentType = "RD";
                }
                app.showMessage(
                    ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteDocConfirmation') == -1) ? 'Are you sure you want to delete this document?' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteDocConfirmation')].Name)
                    , ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteDocumentHeading') == -1) ? 'Delete Document' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteDocumentHeading')].Name)
                    , [((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name)
                        , ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name)])
                    .then(function (option) {
                        if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString()) {
                            DeleteResponseDocument(data, commentType);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function DeleteResponseDocument(data, commentType) {
            try {
                if (commentType === "RD")
                    SrViewModel.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));
                var DocumentInfo = data;
                var test = $.ajax({
                    url: "/api/Survey/CheckFilePresence",
                    type: "Get",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { CommentId: data.DCommentId(), FilePath: data.DocumentPath(), FileName: data.DocumentName() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteResponseDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status, xhr) {
                try {
                    if (jsonResult) {
                        DeleteDocComments(data, commentType);
                    }
                    else
                        logger.logError(SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRequestedDocForDelete') == -1) ? 'The requested document is not available to delete. Please contact your Application Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRequestedDocForDelete')].Name], 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteResponseDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteResponseDocument() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteResponseDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }

        function DeleteDocComments(data, commentType) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/DeleteDocComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        CommentId: data.DCommentId,
                        QuestionId: SrViewModel.SelectedQuestionId(),
                        Draft: SrViewModel.SurveyId(),
                        CommentType: commentType,
                        SurveyType: SrViewModel.SurveyClassification()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | DeleteDocComments() in SurveyResponse.js'
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {
                    if (result != null && parseInt(result) >= 0) {
                        DeleteFile(data, result, commentType);
                    }
                    else if (result != null && result.substring(0, 3) == "INC") {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                            ? result + " - An error has occured. Please contact your Administrator."
                            : result + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                            [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                ? result + " - Please contact your Administrator."
                                : result + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    }
                    else {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage') == -1) ? 'The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click \'OK\' to redirect to Landing Page.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage') == -1) ? 'Action cannot be performed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                            .then(function (option) {
                                if (option === " " + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString()) {
                                    SrViewModel.DashboardVM.NavigatedFrom('Response');
                                    router.navigate("landing", true);
                                }
                            });
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in DeleteDocComments() in SurveyResponse.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteDocComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteDocComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function DeleteFile(data, DocCount, commentType) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/DeleteFile",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        DocumentPath: data.DocumentPath(),
                        DocumentName: data.DocumentName()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | DeleteFile() in SurveyResponse.js'
                logger.logMessage(msg);
            }

            function ajaxSuccess(result, status) {
                try {
                    if (result != null && result.toUpperCase().substring(0, 3) == "INC") {
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                            ? result + " - An error has occured. Please contact your Administrator."
                            : result + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                            [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                ? result + " - Please contact your Administrator."
                                : result + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    }
                    else if (result.toLowerCase() == 'ok') {
                        logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocDeleteSuccessMessage') == -1) ? 'Document deleted successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocDeleteSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                        if (commentType === 'RD') {
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();

                            if (SrViewModel.SurveyTypeId().toUpperCase() == "QLDR") {
                                ko.utils.arrayFilter(SrViewModel.QualResponseListData(), function (item) {
                                    if (item.QuestionId() == SrViewModel.SelectedQuestionId()) {
                                        item.DocumentCount(DocCount);
                                    }
                                });
                                GetComments(SrViewModel.SelectedQuestionId(), "RD", null);
                            }
                            else if (SrViewModel.SurveyTypeId().toUpperCase() == "QTDR") {
                                ko.utils.arrayFilter(SrViewModel.QuanResponseObject(), function (item) {
                                    if (item.QuestionId() == SrViewModel.SelectedQuestionId()) {
                                        item.DocumentCount(DocCount);
                                    }
                                });
                                if (SrViewModel.IsDocumentPopUp())
                                    GetCommentsPopUp(SrViewModel.SelectedQuestionId(), "RD", null);
                                else
                                    GetComments(SrViewModel.SelectedQuestionId(), "RD", null);
                            }
                            else if (SrViewModel.SurveyTypeId().toUpperCase() == "CDR") {
                                ko.utils.arrayFilter(SrViewModel.ControlsResponseData(), function (item) {
                                    if (item.QuestionId() == SrViewModel.SelectedQuestionId()) {
                                        item.DocumentCount(DocCount);
                                    }
                                });
                                GetComments(SrViewModel.SelectedQuestionId(), "RD", null);
                            }
                            setSurveyLevelMandatoryList();
                            SrViewModel.isSaveResponseClick(true);
                            SegregatorBasedOnSurveyType();
                        }
                        else {
                            GetSurveyLevelComments("SND");
                        }
                    }
                    else
                        logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocDeleteErrorMessage') == -1) ? 'An error occurred while deleting the document.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocDeleteErrorMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in DeleteFile() in SurveyResponse.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteDocComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteFile() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion

        //#region Historical Responses code section

        function GetSurveyPrevResponses(QuestionId) {
            try {
                return $.ajax({
                    url: "/api/Survey/GetSurveyPrevResponses",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { QuestionId: QuestionId, SurveyType: SrViewModel.SurveyTypeId().toUpperCase() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetSurveyPrevResponses() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    SrViewModel.HistoricalResponseList([]);
                    if (jsonResult != null) {
                        if (jsonResult.length != 0) {
                            if (jsonResult[0].ErrorId == -99) {
                                logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1)
                                    ? jsonResult[0].ErrorName + " - An error has occured. Please contact your Administrator."
                                    : jsonResult[0].ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()
                                    [SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name + ' ' +
                                        (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage') == -1)
                                        ? jsonResult[0].ErrorName + " - Please contact your Administrator."
                                        : jsonResult[0].ErrorName + " - " + SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                var MappedColumnObject = $.map(jsonResult, function (result) {
                                    return new HistoricalResponseModel(result);
                                })
                                SrViewModel.HistoricalResponseList(MappedColumnObject);
                            }
                        }
                    }
                    if (!SrViewModel.IsHistoryPopUp())
                        BindDynamicHtmlHistoricalResp(QuestionId);
                    else {
                        if (SrViewModel.HistoricalResponseList().length === 0)
                            $('#NoHistoryResponses').show();
                    }
                }
                catch (e) {
                    logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetSurveyPrevResponses() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyPrevResponses() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSurveyPrevResponses() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }

        function HistoricalResponseModel(item) {
            try {
                var self = this;
                self.OldQuestionId = ko.observable(item.OldQuestionId);
                self.NewQuestionId = ko.observable(item.NewQuestionId);
                self.OldResponseId = ko.observable(item.OldResponseId);
                self.NewResponseId = ko.observable(item.NewResponseId);
                self.OldResponse = ko.observable($('<div/>').html(item.OldResponse).text());
                self.NewResponse = ko.observable($('<div/>').html(item.NewResponse).text());
                self.OldResponseColumnId = ko.observable(item.OldResponseColumnId);
                self.OldResponseColumnName = ko.observable($('<div/>').html(item.OldResponseColumnName).text());
                self.NewResponseTypeId = ko.observable(item.NewResponseTypeId);
                self.NewResponseTypeName = ko.observable($('<div/>').html(item.NewResponseTypeName).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: HistoricalResponseModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function BindDynamicHtmlHistoricalResp(QuestionId) {
            try {
                var RespDynamicHTML = "";

                RespDynamicHTML = '<div class="subContResponses">';
                if (SrViewModel.HistoricalResponseList() != undefined && SrViewModel.HistoricalResponseList().length > 0) {
                    RespDynamicHTML += '<div class="nd-flex col-12 p-0">';
                    RespDynamicHTML += '<div class="col-9 p-0">';
                    for (var i = 0; i < SrViewModel.HistoricalResponseList().length; i++) {
                        var OldResponse = SrViewModel.HistoricalResponseList()[i].OldResponse();
                        var HistoricalTypeName = SrViewModel.HistoricalResponseList()[i].OldResponseColumnName();

                        RespDynamicHTML += '<div>';
                        RespDynamicHTML += '<span class="rtype mr-2" id="HistQuestionType">' + HistoricalTypeName + ': </span>';
                        RespDynamicHTML += '<span class="rtype">' + OldResponse + '</span>';
                        RespDynamicHTML += '</div>';
                    }
                    RespDynamicHTML += '</div>';

                    if ((!SrViewModel.DisableControl() || SrViewModel.appsecurity.WriteAccess()) && SrViewModel.IsReadOnlyQuestion() == 0) {
                        RespDynamicHTML += '<div class="col-3 pr-0">';
                        RespDynamicHTML += '</div>';
                    }
                    RespDynamicHTML += '</div>';
                } else {
                    var HistRespText = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoHistoricalResponsesMessage') == -1) ? 'There are no Historical Responses available' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoHistoricalResponsesMessage')].Name)();

                    RespDynamicHTML += '<span class="nodatamessage pl-2">' + HistRespText + '</span>';
                    $('#CopyHistResponses').css({ 'display': 'none' });
                }
                RespDynamicHTML += '</div>'

                $('#htmlHist_hist_' + QuestionId).html("");
                $('#htmlHist_hist_' + QuestionId).html(RespDynamicHTML);
                $('#htmlHist_hist_' + QuestionId).show();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlHistoricalResp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function CopyResponse(data) {
            try {
                if (SrViewModel == undefined || SrViewModel.HistoricalResponseList() == undefined) {
                    GetSurveyPrevResponses(data);
                }
                if (SrViewModel.HistoricalResponseList() != undefined && SrViewModel.HistoricalResponseList().length > 0) {
                    for (var i = 0; i < SrViewModel.HistoricalResponseList().length; i++) {
                        var updatedResponseId = SrViewModel.HistoricalResponseList()[i].NewResponseId();
                        var currentQuestionId = SrViewModel.HistoricalResponseList()[i].NewQuestionId();
                        var responseId = SrViewModel.HistoricalResponseList()[i].NewResponseTypeId();

                        SrViewModel.ValuesChanged(true);
                        if (SrViewModel.SurveyTypeId() == 'QLDR') {
                            for (var h = 0; h < SrViewModel.QualResponseListData().length; h++) {
                                if (SrViewModel.QualResponseListData()[h].QuestionId() == currentQuestionId) {
                                    for (var j = 0; j < SrViewModel.QualResponseListData()[h].ResponseList.length; j++) {
                                        if (SrViewModel.QualResponseListData()[h].ResponseList[j].ResponseId() == responseId) {
                                            SrViewModel.QualResponseListData()[h].ResponseList[j].ResponseInputValue(updatedResponseId);
                                            SrViewModel.QualResponseListData()[h].ResponseList[j].ResponseValue(updatedResponseId);
                                            break;
                                        }
                                    }
                                }
                            }
                        } else if (SrViewModel.SurveyTypeId() == 'CDR') {
                            for (var h = 0; h < SrViewModel.ControlsResponseData().length; h++) {
                                if (SrViewModel.ControlsResponseData()[h].QuestionId() == currentQuestionId) {
                                    for (var j = 0; j < SrViewModel.ControlsResponseData()[h].ResponseList.length; j++) {
                                        if (SrViewModel.ControlsResponseData()[h].ResponseList[j].ResponseId() == responseId) {
                                            SrViewModel.ControlsResponseData()[h].ResponseList[j].ResponseInputValue(updatedResponseId);
                                            SrViewModel.ControlsResponseData()[h].ResponseList[j].Response(updatedResponseId);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CopyResponses() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Excel Export-Import and SSRS Excels

        function ExportSurveyToExcel(data, event) {
            try {
                if (SrViewModel.BUListString() == "" && SrViewModel.UserList() == "") {
                    GetSurveyCardDetails(SrViewModel.SurveyId()).then(function () {
                        DownloadExcelExport(data, event);
                    });
                }
                else {
                    DownloadExcelExport(data, event);
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ExportSurveyToExcel() in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function DownloadExcelExport(data, event) {
            try {
                var BUNameVar = SrViewModel.BUTitle() + ": " + SrViewModel.BusinessUnitName();
                var BUlistString = SrViewModel.BUListString();
                var UserString = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssignedUsersHeading') == -1) ? 'Assigned Users:' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssignedUsersHeading')].Name)();
                var completionDue = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CompletionDueDate') == -1) ? 'Completion Due Date: ' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CompletionDueDate')].Name)();

                if (SrViewModel.UserList() != null || SrViewModel.UserList() != "")
                    UserString = UserString + SrViewModel.UserList().replace(/(<p>|<\/p>|<strong class='lbl-space'>|<strong>|<\/strong>|<em>|<\/em>|<u>|<\/u>|<ol>|<\/ol>|<ul>|<\/ul>|<li>|<\/li>)/gi, "").replace(/(\r\n|\n|\r)/gm, " ");

                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), BussinessUnitId: SrViewModel.BusinessUnitId(), SurveyID: SrViewModel.SurveyProfileId(),
                    SurveyType: SrViewModel.SurveyProfileName(), SurveyName: $('<div/>').html(SrViewModel.SurveyName()).text(), BUName: BUNameVar.toString(), BUOrgList: BUlistString.toString(), UserList: UserString.toString(), DueDate: completionDue + SrViewModel.DueDate()
                };

                if (SrViewModel.SurveyTypeId() === "QTDR") {
                    utils.postAndRedirect(rootPath + "/FileDownload/ExportExcelSurvey", payLoad, '_blank');
                }
                else if (SrViewModel.SurveyTypeId() === "QLDR") {
                    utils.postAndRedirect(rootPath + "/FileDownload/ExportExcelQualSurvey", payLoad, '_blank');
                }
                else if (SrViewModel.SurveyTypeId() === "CDR") {
                    utils.postAndRedirect(rootPath + "/FileDownload/GetControlsExcel", payLoad, '_blank');
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | DownloadExcelExport() in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ImportExcelPopUp(data, event) {
            try {
                document.getElementById('ImportSurveyError').innerHTML = "";
                document.getElementById('FileUploader').value = '';
                $('#Exportexcel').modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ImportExcelPopUp() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function UploadExcelDocument(data, event) {
            try {
                $('#ImportSurveyError').show();
                var FileList = document.getElementById('FileUploader').files;
                if (FileList.length > 0) {
                    var FileName = document.getElementById('FileUploader').files[0].name;
                    if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() === 'XLSX' || FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() === 'XLSM') {
                        if (FileList[0].size <= 1073741824) {
                            document.getElementById('ImportSurveyError').innerHTML = "";

                            var FormDataObj = new FormData();
                            FormDataObj.append("File1", FileList[0]);
                            var request = new XMLHttpRequest();

                            request.onreadystatechange = function () {
                                if (request.readyState === 1) {
                                    document.getElementById('ImportSurveyError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InitializeFileUploadMessage') == -1) ? 'Initializing File Upload...' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InitializeFileUploadMessage')].Name();
                                    $('#ImportSurveyError').show();
                                }
                                else if (request.readyState === 4) {
                                    if (request.status === 200) {
                                        if (request.responseText !== null && request.responseText !== "" && request.responseText !== "null") {
                                            if (request.responseText === "2") {
                                                document.getElementById('ImportSurveyError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage') == -1) ? 'The file could not be uploaded.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage')].Name();
                                                logger.logWarning((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExcelImportFileErrorMessage') == -1) ? 'Excel format mismatch. Please check and try again.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExcelImportFileErrorMessage')].Name, 'Warning', system.getModuleId(SrViewModel), true);
                                                $('#ImportSurveyError').show();
                                                var DocName = document.getElementById('FileUploader').files[0].name;
                                                document.getElementById('FileUploader').value = '';
                                                $('#Exportexcel').modal('hide');
                                                $('body').removeClass('modal-open');
                                                $('.modal-backdrop').remove();
                                            }
                                            else if (request.responseText === "-1") {
                                                document.getElementById('ImportSurveyError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage') == -1) ? 'The file could not be uploaded.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage')].Name();
                                                logger.logWarning((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('IncorrectImportFileErrorMessage') == -1) ? 'Incorrect Excel file. Please check and try again.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('IncorrectImportFileErrorMessage')].Name, 'Warning', system.getModuleId(SrViewModel), true);
                                                $('#ImportSurveyError').show();
                                                var DocName = document.getElementById('FileUploader').files[0].name;
                                                document.getElementById('FileUploader').value = '';
                                                $('#Exportexcel').modal('hide');
                                                $('body').removeClass('modal-open');
                                                $('.modal-backdrop').remove();
                                            }
                                            else {
                                                document.getElementById('ImportSurveyError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage') == -1) ? 'The file has been uploaded successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage')].Name();
                                                logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExcelImportSuccessMessage') == -1) ? 'Responses Uploaded Successfully' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExcelImportSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                                                $('#ImportSurveyError').show();
                                                var DocName = document.getElementById('FileUploader').files[0].name;
                                                document.getElementById('FileUploader').value = '';

                                                ClearSearchText();
                                                SrViewModel.isSaveResponseClick(true);
                                                SrViewModel.EnableMandatoryFlags(true);
                                                SrViewModel.saveEventId(event.currentTarget.id);
                                                SrViewModel.selectedTreeNode($('#jsTreeAreaLevel').treeview('getSelected'));

                                                if (SrViewModel.ClickedRiskAreaId() !== -1000 && SrViewModel.ClickedRiskAreaId() !== -998) {
                                                    // refreshing the treeview along with new data load
                                                    SrViewModel.ValuesChanged(false);
                                                    $('#QualContDynamicHTMLDiv').html("");
                                                    $('#DynamicHTMLDiv').html("");
                                                    ReloadTabafterSaveMain();
                                                }
                                                else {
                                                    // for MCI - refreshing only the treeview
                                                    SegregatorBasedOnSurveyType();
                                                }

                                                $('#Exportexcel').modal('hide');
                                                $('body').removeClass('modal-open');
                                                $('.modal-backdrop').remove();
                                            }
                                        }
                                        else {
                                            document.getElementById('ImportSurveyError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage') == -1) ? 'The file could not be uploaded.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage')].Name();
                                            logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage') == -1) ? 'The file could not be uploaded.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                                            $('#ImportSurveyError').show();
                                            document.getElementById('FileUploader').value = '';
                                            $('#Exportexcel').modal('hide');
                                            $('body').removeClass('modal-open');
                                            $('.modal-backdrop').remove();
                                        }
                                    }
                                    else {
                                        //ajaxFail(request, "");
                                        if (request.status === 401) {
                                            app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                                .then(function (option) {
                                                    if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString()) {
                                                        SrViewModel.DashboardVM.NavigatedFrom('Response');
                                                        router.navigate("#Landing", true);
                                                    }
                                                });
                                        }
                                        else {
                                            var msg = 'Exception: ' + request.responseText + ' | Source: ajaxFail in UploadDocument() method in SurveyResponsePage.js';
                                            logger.logMessage(msg);
                                        }
                                    }
                                }
                            };
                            request.upload.addEventListener('progress', function (event) {
                                document.getElementById('ImportSurveyError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UploadingFileStatusMessage') == -1) ? 'Uploading File...' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UploadingFileStatusMessage')].Name();
                            });
                            request.withCredentials = true;
                            if (SrViewModel.SurveyTypeId() === "QTDR") {
                                request.open('POST', "/api/Survey/ImportExcelQuanSurvey?SurveyProfileId=" + SrViewModel.SurveyProfileId() + "&BusinessUnitId=" + SrViewModel.BusinessUnitId() + "&SurveyType=" + SrViewModel.SurveyTypeId() + "&RoleId=" + SrViewModel.RoleId() + "&SurveyId=" + SrViewModel.SurveyId());
                            }
                            else if (SrViewModel.SurveyTypeId() === "QLDR") {
                                request.open('POST', "/api/Survey/ImportExcelQualSurvey?SurveyProfileId=" + SrViewModel.SurveyProfileId() + "&BusinessUnitId=" + SrViewModel.BusinessUnitId() + "&SurveyType=" + SrViewModel.SurveyTypeId() + "&RoleId=" + SrViewModel.RoleId() + "&SurveyId=" + SrViewModel.SurveyId());
                            }
                            else if (SrViewModel.SurveyTypeId() === "CDR") {
                                request.open('POST', "/api/Survey/ImportExcelControlsSurvey?SurveyProfileId=" + SrViewModel.SurveyProfileId() + "&BusinessUnitId=" + SrViewModel.BusinessUnitId() + "&SurveyType=" + SrViewModel.SurveyTypeId() + "&RoleId=" + SrViewModel.RoleId() + "&SurveyId=" + SrViewModel.SurveyId());
                            }
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            request.setRequestHeader('Authorization', headers.Authorization);
                            request.setRequestHeader('RT', headers.RT);
                            request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                            request.send(FormDataObj);
                        }
                        else
                            document.getElementById('ImportSurveyError').innerHTML = ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageBegin') == -1) ? 'Upload file size cannot exceed' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageBegin')].Name()).toString() + ' ' + ((SrViewModel.UploadFileSize() / 1048576) + ' ' + (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageEnd') == -1) ? 'MB. Please try uploading a file of lesser size.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageEnd')].Name()).toString();
                    }
                    else
                        document.getElementById('ImportSurveyError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidFileFormatMessage') == -1) ? 'Please select a valid file to upload.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidFileFormatMessage')].Name();
                }

                else
                    document.getElementById('ImportSurveyError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SelectFileToUploadError') == -1) ? 'Please select a file to upload.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SelectFileToUploadError')].Name();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadExcelDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ViewSelectedReport() {
            try {
                var selectedValue = document.getElementById("ReportsDropDown").value;
                var payLoad = "";

                if (selectedValue === "Reports")
                    return;

                else if (selectedValue === "Comments") {
                    payLoad = {
                        t: appsecurity.getAuthenticationInfo(), SurveyType: SrViewModel.SurveyTypeId(), SurveyProfileId: SrViewModel.SurveyProfileId(), BusinessUnitId: SrViewModel.BusinessUnitId(), ClickedRiskAreaId: SrViewModel.ClickedRiskAreaId(), ClickedRiskFactorId: SrViewModel.ClickedRiskFactorId(), BusinessUnitName: SrViewModel.BusinessUnitName()
                    };
                    utils.postAndRedirect(rootPath + "/FileDownload/DownloadSurveyCommentsSSRSExcel", payLoad, '_blank');
                    // Previously called SSRS method - SSRSSurveyCommentsViewer.aspx
                }

                else if (selectedValue === "FlaggedQuestions") {
                    payLoad = {
                        t: appsecurity.getAuthenticationInfo(), SurveyType: SrViewModel.SurveyTypeId(), SurveyProfileId: SrViewModel.SurveyProfileId(), BusinessUnitId: SrViewModel.BusinessUnitId(), ClickedRiskAreaId: SrViewModel.ClickedRiskAreaId(), ClickedRiskFactorId: SrViewModel.ClickedRiskFactorId(), BusinessUnitName: SrViewModel.BusinessUnitName()
                    };
                    utils.postAndRedirect(rootPath + "/FileDownload/DownloadSurveyFlaggedQuestionsSSRSExcel", payLoad, '_blank');
                }

                else if (selectedValue === "Heatmap") {
                    if (SrViewModel.SurveyTypeId() === "CDR") {
                        payLoad = {
                            t: appsecurity.getAuthenticationInfo(), SurveyProfileId: SrViewModel.SurveyId(), UserId: SrViewModel.User()
                        };
                        utils.postAndRedirect(rootPath + "/FileDownload/DownloadControlHeatmapSSRSExcel", payLoad, '_blank');
                        // Previously called SSRS method - SSRSSurveyHeatmapControls.aspx
                    }
                    else if (SrViewModel.SurveyTypeId() === "QLDR") {
                        payLoad = {
                            t: appsecurity.getAuthenticationInfo(), SurveyProfileId: SrViewModel.SurveyId(), UserId: SrViewModel.User()
                        };
                        utils.postAndRedirect(rootPath + "/FileDownload/DownloadInternalHeatmapSSRSExcel", payLoad, '_blank');
                        // Previously called SSRS method - SSRSSurveyHeatmapInternal.aspx
                    }
                }

                else if (selectedValue === "HistoricalResponses") {
                    if (SrViewModel.SurveyTypeId() === "CDR") {
                        payLoad = {
                            t: appsecurity.getAuthenticationInfo(), SurveyProfileId: SrViewModel.SurveyProfileId(), UserId: SrViewModel.User()
                        };
                        utils.postAndRedirect(rootPath + "/FileDownload/DownloadHistoricControlsSSRSExcel", payLoad, '_blank');
                        // Previously called SSRS method - SSRSResponseHistoricControls.aspx
                    }
                    else if (SrViewModel.SurveyTypeId() === "QLDR") {
                        payLoad = {
                            t: appsecurity.getAuthenticationInfo(), SurveyProfileId: SrViewModel.SurveyProfileId(), UserId: SrViewModel.User()
                        };
                        utils.postAndRedirect(rootPath + "/FileDownload/DownloadHistoricInternalSSRSExcel", payLoad, '_blank');
                        // Previously called SSRS method - SSRSResponseHistoricInternal.aspx
                    }
                }
                $('#ReportsDropDown').prop('selectedIndex', 0);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ViewSelectedReport() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Overall Summary

        function showOverallSummaryDiv() {
            try {
                if (!SrViewModel.SummaryPopUpFlag()) {
                    GetSurveyLevelComments("SN").then(function () {
                        GetSurveyLevelComments("SND");
                        BindOverallSummary();
                    });
                }
                else {
                    BindOverallSummary();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showOverallSummaryDiv() method in SurveyResponsePage.js';

                logger.logMessage(msg);
            }
        }

        function BindOverallSummary() {
            try {
                $('#OverallSummaryDiv').modal('show');
                SrViewModel.RemainingChars(SrViewModel.CommentCharsLimit());
                var editor = CKEDITOR.instances['NarrationTextArea'];
                if (editor) {
                    editor.destroy(true);
                }
                CKEDITOR.replace('NarrationTextArea', {
                    removePlugins: SrViewModel.RemovePlugins(),
                    removeButtons: SrViewModel.RemoveButtons(),
                    disableNativeSpellChecker: false
                });
                //CKEDITOR.instances['NarrationTextArea'].on('key', function () {
                //    ckeCharCheck();
                //});
                $('#NarrationTextArea').html(SrViewModel.SurveySummaryComment());
                //ckeCharCheck();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindOverallSummary() method in SurveyResponsePage.js';

                logger.logMessage(msg);
            }
        }

        function SaveSurveySummary() {
            try {
                var ckeComment = CKEDITOR.instances["NarrationTextArea"].getData();

                if (ckeComment == "" || ckeComment == undefined || $(ckeComment).text().trim() == "") {
                    $("#lblNarrationError").show();
                    document.getElementById('lblNarrationError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentValidationErrorMessage') == -1) ? 'Please enter some comment to save.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentValidationErrorMessage')].Name();
                }
                else if (ckeComment.length > 4000) {
                    $("#lblNarrationError").show();
                    document.getElementById('lblNarrationError').innerHTML = (!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Max4000CharsLimit') == -1) ? 'You cannot enter more than 4000 characters.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Max4000CharsLimit')].Name();
                }
                else {
                    $("#lblNarrationError").hide();
                    document.getElementById('lblNarrationError').innerHTML = "";
                    SetSurveyLevelComments("SN");
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveSurveySummary() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#endregion
    });
